import { ResponseContext, RequestContext, HttpFile, HttpInfo } from '../http/http';
import { Configuration, ConfigurationOptions } from '../configuration'
import type { Middleware } from '../middleware';

import { AddContactsInCvDto } from '../models/AddContactsInCvDto';
import { AdminCreateOrderDto } from '../models/AdminCreateOrderDto';
import { AdminLoginRequestDTO } from '../models/AdminLoginRequestDTO';
import { AdminLoginResponseDTO } from '../models/AdminLoginResponseDTO';
import { AdminOrderTransactionsPaginationDTO } from '../models/AdminOrderTransactionsPaginationDTO';
import { ArticleCategory } from '../models/ArticleCategory';
import { Asset } from '../models/Asset';
import { AssignPromoCodeQueryDto } from '../models/AssignPromoCodeQueryDto';
import { AuthProfileSessionCurrentDTO } from '../models/AuthProfileSessionCurrentDTO';
import { AuthProfileSessionDTO } from '../models/AuthProfileSessionDTO';
import { AuthProfileSessionPushDTO } from '../models/AuthProfileSessionPushDTO';
import { AuthProfileTokenDTO } from '../models/AuthProfileTokenDTO';
import { AuthResponseDTO } from '../models/AuthResponseDTO';
import { AuthVerificationCodeDTO } from '../models/AuthVerificationCodeDTO';
import { AuthVerificationResponseDTO } from '../models/AuthVerificationResponseDTO';
import { AuthVerificationVerifyDTO } from '../models/AuthVerificationVerifyDTO';
import { BackgroundCategory } from '../models/BackgroundCategory';
import { BannerFindManyControllerFindMany0200Response } from '../models/BannerFindManyControllerFindMany0200Response';
import { BannerItemContentDTO } from '../models/BannerItemContentDTO';
import { BannerItemContentSourceDTO } from '../models/BannerItemContentSourceDTO';
import { BannerItemCreateDTO } from '../models/BannerItemCreateDTO';
import { BannerItemDTO } from '../models/BannerItemDTO';
import { BannerItemProfileDTO } from '../models/BannerItemProfileDTO';
import { BannerItemUpdateDTO } from '../models/BannerItemUpdateDTO';
import { BannerPaginationResponseDTO } from '../models/BannerPaginationResponseDTO';
import { BannerResponseDTO } from '../models/BannerResponseDTO';
import { CallbackResponseDto } from '../models/CallbackResponseDto';
import { CharacterItem } from '../models/CharacterItem';
import { CharacterItemCategory } from '../models/CharacterItemCategory';
import { Course } from '../models/Course';
import { CreateDepositPassimPayRequestDto } from '../models/CreateDepositPassimPayRequestDto';
import { CreateManyAdminDto } from '../models/CreateManyAdminDto';
import { CreateManyApplicationDto } from '../models/CreateManyApplicationDto';
import { CreateManyArticleCategoryDto } from '../models/CreateManyArticleCategoryDto';
import { CreateManyAssetDto } from '../models/CreateManyAssetDto';
import { CreateManyBackgroundCategoryDto } from '../models/CreateManyBackgroundCategoryDto';
import { CreateManyBackgroundDto } from '../models/CreateManyBackgroundDto';
import { CreateManyCVDto } from '../models/CreateManyCVDto';
import { CreateManyCharacterDto } from '../models/CreateManyCharacterDto';
import { CreateManyCharacterItemCategoryDto } from '../models/CreateManyCharacterItemCategoryDto';
import { CreateManyCharacterItemDto } from '../models/CreateManyCharacterItemDto';
import { CreateManyChatDto } from '../models/CreateManyChatDto';
import { CreateManyChatMessageDto } from '../models/CreateManyChatMessageDto';
import { CreateManyChatMessageUrlDto } from '../models/CreateManyChatMessageUrlDto';
import { CreateManyCommunityDto } from '../models/CreateManyCommunityDto';
import { CreateManyCoverLetterDto } from '../models/CreateManyCoverLetterDto';
import { CreateManyFavouriteFolderDto } from '../models/CreateManyFavouriteFolderDto';
import { CreateManyFeedbackDto } from '../models/CreateManyFeedbackDto';
import { CreateManyGeoDto } from '../models/CreateManyGeoDto';
import { CreateManyGeonameDto } from '../models/CreateManyGeonameDto';
import { CreateManyPageHTMLBlockDto } from '../models/CreateManyPageHTMLBlockDto';
import { CreateManyPersonalPageDto } from '../models/CreateManyPersonalPageDto';
import { CreateManyProfileDto } from '../models/CreateManyProfileDto';
import { CreateManyProposalDto } from '../models/CreateManyProposalDto';
import { CreateManyServiceCategoryDto } from '../models/CreateManyServiceCategoryDto';
import { CreateManySkillDto } from '../models/CreateManySkillDto';
import { CreateManySourceDto } from '../models/CreateManySourceDto';
import { CreateManyStopWordDto } from '../models/CreateManyStopWordDto';
import { CreateManyVacancyDto } from '../models/CreateManyVacancyDto';
import { CreateManyVerticalDto } from '../models/CreateManyVerticalDto';
import { CreateOrderQueryDto } from '../models/CreateOrderQueryDto';
import { CreatePageJsonBlockDto } from '../models/CreatePageJsonBlockDto';
import { CreatePageJsonBlockTranslationDto } from '../models/CreatePageJsonBlockTranslationDto';
import { CreatePassimPayDepositResponseDto } from '../models/CreatePassimPayDepositResponseDto';
import { CreatePassimPayTestDepositResponseDto } from '../models/CreatePassimPayTestDepositResponseDto';
import { CreateProductDTO } from '../models/CreateProductDTO';
import { CreatePromoCodeQueryDto } from '../models/CreatePromoCodeQueryDto';
import { CreateTestDepositPassimPayOptionRequestDto } from '../models/CreateTestDepositPassimPayOptionRequestDto';
import { CreateTestDepositPassimPayRequestDto } from '../models/CreateTestDepositPassimPayRequestDto';
import { GetDepositLinkResponseDto } from '../models/GetDepositLinkResponseDto';
import { GetManyAdminResponseDto } from '../models/GetManyAdminResponseDto';
import { GetManyApplicationResponseDto } from '../models/GetManyApplicationResponseDto';
import { GetManyArticleCategoryResponseDto } from '../models/GetManyArticleCategoryResponseDto';
import { GetManyArticleResponseDto } from '../models/GetManyArticleResponseDto';
import { GetManyAssetResponseDto } from '../models/GetManyAssetResponseDto';
import { GetManyBackgroundCategoryResponseDto } from '../models/GetManyBackgroundCategoryResponseDto';
import { GetManyBackgroundResponseDto } from '../models/GetManyBackgroundResponseDto';
import { GetManyBaseAdminControllerAdmin200Response } from '../models/GetManyBaseAdminControllerAdmin200Response';
import { GetManyBaseApplicationAdminControllerApplication200Response } from '../models/GetManyBaseApplicationAdminControllerApplication200Response';
import { GetManyBaseArticleCategoryAdminControllerArticleCategory200Response } from '../models/GetManyBaseArticleCategoryAdminControllerArticleCategory200Response';
import { GetManyBaseArticleKnowledgeAdminControllerArticle200Response } from '../models/GetManyBaseArticleKnowledgeAdminControllerArticle200Response';
import { GetManyBaseAssetAdminControllerAsset200Response } from '../models/GetManyBaseAssetAdminControllerAsset200Response';
import { GetManyBaseBackgroundAdminControllerBackground200Response } from '../models/GetManyBaseBackgroundAdminControllerBackground200Response';
import { GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response } from '../models/GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response';
import { GetManyBaseCVAdminControllerCV200Response } from '../models/GetManyBaseCVAdminControllerCV200Response';
import { GetManyBaseCharacterAdminControllerCharacter200Response } from '../models/GetManyBaseCharacterAdminControllerCharacter200Response';
import { GetManyBaseCharacterItemAdminControllerCharacterItem200Response } from '../models/GetManyBaseCharacterItemAdminControllerCharacterItem200Response';
import { GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response } from '../models/GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response';
import { GetManyBaseChatAdminControllerChat200Response } from '../models/GetManyBaseChatAdminControllerChat200Response';
import { GetManyBaseChatMessageAdminControllerChatMessage200Response } from '../models/GetManyBaseChatMessageAdminControllerChatMessage200Response';
import { GetManyBaseChatMessageUrlControllerChatMessageUrl200Response } from '../models/GetManyBaseChatMessageUrlControllerChatMessageUrl200Response';
import { GetManyBaseCommunityAdminControllerCommunity200Response } from '../models/GetManyBaseCommunityAdminControllerCommunity200Response';
import { GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response } from '../models/GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response';
import { GetManyBaseCourseBlockAdminControllerCourseBlock200Response } from '../models/GetManyBaseCourseBlockAdminControllerCourseBlock200Response';
import { GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response } from '../models/GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response';
import { GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response } from '../models/GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response';
import { GetManyBaseCourseModuleAdminControllerCourseModule200Response } from '../models/GetManyBaseCourseModuleAdminControllerCourseModule200Response';
import { GetManyBaseCoverLetterAdminControllerCoverLetter200Response } from '../models/GetManyBaseCoverLetterAdminControllerCoverLetter200Response';
import { GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response } from '../models/GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response';
import { GetManyBaseFeedbackAdminControllerFeedback200Response } from '../models/GetManyBaseFeedbackAdminControllerFeedback200Response';
import { GetManyBaseGeoAdminControllerGeo200Response } from '../models/GetManyBaseGeoAdminControllerGeo200Response';
import { GetManyBaseLocationAdminControllerGeoname200Response } from '../models/GetManyBaseLocationAdminControllerGeoname200Response';
import { GetManyBaseManagerAdminControllerProfile200Response } from '../models/GetManyBaseManagerAdminControllerProfile200Response';
import { GetManyBasePageAdminControllerPageHTMLBlock200Response } from '../models/GetManyBasePageAdminControllerPageHTMLBlock200Response';
import { GetManyBasePaymentAdminControllerPaymentTransaction200Response } from '../models/GetManyBasePaymentAdminControllerPaymentTransaction200Response';
import { GetManyBasePersonalPageAdminControllerPersonalPage200Response } from '../models/GetManyBasePersonalPageAdminControllerPersonalPage200Response';
import { GetManyBaseProposalAdminControllerProposal200Response } from '../models/GetManyBaseProposalAdminControllerProposal200Response';
import { GetManyBaseServiceCategoryAdminControllerServiceCategory200Response } from '../models/GetManyBaseServiceCategoryAdminControllerServiceCategory200Response';
import { GetManyBaseSkillAdminControllerSkill200Response } from '../models/GetManyBaseSkillAdminControllerSkill200Response';
import { GetManyBaseSourceAdminControllerSource200Response } from '../models/GetManyBaseSourceAdminControllerSource200Response';
import { GetManyBaseStopWordAdminControllerStopWord200Response } from '../models/GetManyBaseStopWordAdminControllerStopWord200Response';
import { GetManyBaseStoryAdminControllerStory200Response } from '../models/GetManyBaseStoryAdminControllerStory200Response';
import { GetManyBaseStoryBlockAdminControllerStoryBlock200Response } from '../models/GetManyBaseStoryBlockAdminControllerStoryBlock200Response';
import { GetManyBaseVerticalAdminControllerVertical200Response } from '../models/GetManyBaseVerticalAdminControllerVertical200Response';
import { GetManyCVResponseDto } from '../models/GetManyCVResponseDto';
import { GetManyCharacterItemCategoryResponseDto } from '../models/GetManyCharacterItemCategoryResponseDto';
import { GetManyCharacterItemResponseDto } from '../models/GetManyCharacterItemResponseDto';
import { GetManyCharacterResponseDto } from '../models/GetManyCharacterResponseDto';
import { GetManyChatFolderResponseDto } from '../models/GetManyChatFolderResponseDto';
import { GetManyChatMessageResponseDto } from '../models/GetManyChatMessageResponseDto';
import { GetManyChatMessageUrlResponseDto } from '../models/GetManyChatMessageUrlResponseDto';
import { GetManyChatResponseDto } from '../models/GetManyChatResponseDto';
import { GetManyCommunityResponseDto } from '../models/GetManyCommunityResponseDto';
import { GetManyCourseAuthorResponseDto } from '../models/GetManyCourseAuthorResponseDto';
import { GetManyCourseBlockResponseDto } from '../models/GetManyCourseBlockResponseDto';
import { GetManyCourseBlockStepAnswerResponseDto } from '../models/GetManyCourseBlockStepAnswerResponseDto';
import { GetManyCourseBlockStepResponseDto } from '../models/GetManyCourseBlockStepResponseDto';
import { GetManyCourseModuleResponseDto } from '../models/GetManyCourseModuleResponseDto';
import { GetManyCourseResponseDto } from '../models/GetManyCourseResponseDto';
import { GetManyCoverLetterResponseDto } from '../models/GetManyCoverLetterResponseDto';
import { GetManyFavouriteFolderResponseDto } from '../models/GetManyFavouriteFolderResponseDto';
import { GetManyFeedbackResponseDto } from '../models/GetManyFeedbackResponseDto';
import { GetManyGeoResponseDto } from '../models/GetManyGeoResponseDto';
import { GetManyGeonameResponseDto } from '../models/GetManyGeonameResponseDto';
import { GetManyPageHTMLBlockResponseDto } from '../models/GetManyPageHTMLBlockResponseDto';
import { GetManyPaymentTransactionResponseDto } from '../models/GetManyPaymentTransactionResponseDto';
import { GetManyPersonalPageResponseDto } from '../models/GetManyPersonalPageResponseDto';
import { GetManyProfileResponseDto } from '../models/GetManyProfileResponseDto';
import { GetManyProposalResponseDto } from '../models/GetManyProposalResponseDto';
import { GetManyServiceCategoryResponseDto } from '../models/GetManyServiceCategoryResponseDto';
import { GetManySkillResponseDto } from '../models/GetManySkillResponseDto';
import { GetManySourceResponseDto } from '../models/GetManySourceResponseDto';
import { GetManyStopWordResponseDto } from '../models/GetManyStopWordResponseDto';
import { GetManyStoryBlockResponseDto } from '../models/GetManyStoryBlockResponseDto';
import { GetManyStoryResponseDto } from '../models/GetManyStoryResponseDto';
import { GetManyVacancyResponseDto } from '../models/GetManyVacancyResponseDto';
import { GetManyVerticalResponseDto } from '../models/GetManyVerticalResponseDto';
import { GetPaymentMethodsRequestDto } from '../models/GetPaymentMethodsRequestDto';
import { GetPaymentMethodsResponseDto } from '../models/GetPaymentMethodsResponseDto';
import { GetTransactionTotalAmountRequestDto } from '../models/GetTransactionTotalAmountRequestDto';
import { GetTransactionTotalAmountResponseDto } from '../models/GetTransactionTotalAmountResponseDto';
import { GiftPromotionAvailabilityDTO } from '../models/GiftPromotionAvailabilityDTO';
import { HealthControllerCheck0200Response } from '../models/HealthControllerCheck0200Response';
import { HealthControllerCheck0200ResponseInfoValue } from '../models/HealthControllerCheck0200ResponseInfoValue';
import { HealthControllerCheck0503Response } from '../models/HealthControllerCheck0503Response';
import { InfluenceCategoryControllerPaginate0200Response } from '../models/InfluenceCategoryControllerPaginate0200Response';
import { InfluenceCategoryDTO } from '../models/InfluenceCategoryDTO';
import { InfluenceDirectionControllerPaginate0200Response } from '../models/InfluenceDirectionControllerPaginate0200Response';
import { InfluenceDirectionDTO } from '../models/InfluenceDirectionDTO';
import { InfluencePlatformControllerPaginate0200Response } from '../models/InfluencePlatformControllerPaginate0200Response';
import { InfluencePlatformDTO } from '../models/InfluencePlatformDTO';
import { InfluenceResumeChannelCategoryDTO } from '../models/InfluenceResumeChannelCategoryDTO';
import { InfluenceResumeChannelDTO } from '../models/InfluenceResumeChannelDTO';
import { InfluenceResumeChannelDestroyDTO } from '../models/InfluenceResumeChannelDestroyDTO';
import { InfluenceResumeChannelMutableDTO } from '../models/InfluenceResumeChannelMutableDTO';
import { InfluenceResumeChannelPlatformDTO } from '../models/InfluenceResumeChannelPlatformDTO';
import { InfluenceResumeChannelPriceDTO } from '../models/InfluenceResumeChannelPriceDTO';
import { InfluenceResumeChannelPriceDestroyDTO } from '../models/InfluenceResumeChannelPriceDestroyDTO';
import { InfluenceResumeChannelPriceMutableDTO } from '../models/InfluenceResumeChannelPriceMutableDTO';
import { InfluenceResumeContactsDTO } from '../models/InfluenceResumeContactsDTO';
import { InfluenceResumeDTO } from '../models/InfluenceResumeDTO';
import { InfluenceResumePaginateControllerPaginate0200Response } from '../models/InfluenceResumePaginateControllerPaginate0200Response';
import { InfluenceResumeStatisticDTO } from '../models/InfluenceResumeStatisticDTO';
import { ManagerCreateDTO } from '../models/ManagerCreateDTO';
import { ManagerResponseDTO } from '../models/ManagerResponseDTO';
import { ManagerUpdateDTO } from '../models/ManagerUpdateDTO';
import { NotificationCustomContentDTO } from '../models/NotificationCustomContentDTO';
import { NotificationProfileCategoryDTO } from '../models/NotificationProfileCategoryDTO';
import { NotificationProfileCategorySettingsDTO } from '../models/NotificationProfileCategorySettingsDTO';
import { NotificationProfileDTO } from '../models/NotificationProfileDTO';
import { NotificationProfileProviderDTO } from '../models/NotificationProfileProviderDTO';
import { NotificationProfileProviderGenerateDTO } from '../models/NotificationProfileProviderGenerateDTO';
import { NotificationProfileProviderSettingsDTO } from '../models/NotificationProfileProviderSettingsDTO';
import { NotificationProfileProviderUnLinkDTO } from '../models/NotificationProfileProviderUnLinkDTO';
import { NotificationProfileReadDTO } from '../models/NotificationProfileReadDTO';
import { NotificationProfileRootDTO } from '../models/NotificationProfileRootDTO';
import { OrderEntity } from '../models/OrderEntity';
import { OrderTransactionEntity } from '../models/OrderTransactionEntity';
import { PageHTMLBlock } from '../models/PageHTMLBlock';
import { PageJsonBlock } from '../models/PageJsonBlock';
import { PageJsonBlockTranslation } from '../models/PageJsonBlockTranslation';
import { PaginationResponseDTO } from '../models/PaginationResponseDTO';
import { PaymentMethodDto } from '../models/PaymentMethodDto';
import { PaymentSystemDto } from '../models/PaymentSystemDto';
import { ProductEntity } from '../models/ProductEntity';
import { ProductEntityContents } from '../models/ProductEntityContents';
import { ProductLocalizationDTO } from '../models/ProductLocalizationDTO';
import { ProductLocalizationFeatureDTO } from '../models/ProductLocalizationFeatureDTO';
import { ProductProfileContentDTO } from '../models/ProductProfileContentDTO';
import { ProductVacancyContentDTO } from '../models/ProductVacancyContentDTO';
import { ProfileAdminFindManyControllerFindMany0200Response } from '../models/ProfileAdminFindManyControllerFindMany0200Response';
import { ProfileCityDTO } from '../models/ProfileCityDTO';
import { ProfileCountryDTO } from '../models/ProfileCountryDTO';
import { ProfileItemDTO } from '../models/ProfileItemDTO';
import { ProfileResponseDTO } from '../models/ProfileResponseDTO';
import { ProfileStatsDTO } from '../models/ProfileStatsDTO';
import { ProfileStatsDTONewCVsCount } from '../models/ProfileStatsDTONewCVsCount';
import { ProfileStatsDTONewVacanciesCount } from '../models/ProfileStatsDTONewVacanciesCount';
import { ProfileStatsDTOResponsesCount } from '../models/ProfileStatsDTOResponsesCount';
import { ProfileStatsDTOViewsCount } from '../models/ProfileStatsDTOViewsCount';
import { ProfileUpdateDTO } from '../models/ProfileUpdateDTO';
import { PromoCodeListQueryPaginationDTO } from '../models/PromoCodeListQueryPaginationDTO';
import { PromoCodeListResponseDto } from '../models/PromoCodeListResponseDto';
import { PromoCodeResponseDto } from '../models/PromoCodeResponseDto';
import { QueryFilterDTO } from '../models/QueryFilterDTO';
import { QuerySortDTO } from '../models/QuerySortDTO';
import { ServiceCategory } from '../models/ServiceCategory';
import { UpdatePageJsonBlockDto } from '../models/UpdatePageJsonBlockDto';
import { UpdateProductDTO } from '../models/UpdateProductDTO';
import { UpdatePromoCodeQueryDto } from '../models/UpdatePromoCodeQueryDto';
import { UtilsProfileCompletedDTO } from '../models/UtilsProfileCompletedDTO';
import { VacancyBodyDTO } from '../models/VacancyBodyDTO';
import { VacancyPaginationDTO } from '../models/VacancyPaginationDTO';
import { VacancyQueryManyDTO } from '../models/VacancyQueryManyDTO';
import { VacancyQueryStatsDTO } from '../models/VacancyQueryStatsDTO';

import { ObservableADMINAdminUsersApi } from "./ObservableAPI";
import { ADMINAdminUsersApiRequestFactory, ADMINAdminUsersApiResponseProcessor} from "../apis/ADMINAdminUsersApi";

export interface ADMINAdminUsersApiCreateManyBaseAdminControllerAdminRequest {
    /**
     * 
     * @type CreateManyAdminDto
     * @memberof ADMINAdminUsersApicreateManyBaseAdminControllerAdmin
     */
    createManyAdminDto: CreateManyAdminDto
}

export interface ADMINAdminUsersApiCreateOneBaseAdminControllerAdminRequest {
    /**
     * 
     * @type any
     * @memberof ADMINAdminUsersApicreateOneBaseAdminControllerAdmin
     */
    body: any
}

export interface ADMINAdminUsersApiDeleteOneBaseAdminControllerAdminRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApideleteOneBaseAdminControllerAdmin
     */
    id: number
}

export interface ADMINAdminUsersApiGetManyBaseAdminControllerAdminRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetManyBaseAdminControllerAdmin
     */
    cache?: number
}

export interface ADMINAdminUsersApiGetOneBaseAdminControllerAdminRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetOneBaseAdminControllerAdmin
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetOneBaseAdminControllerAdmin
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAdminUsersApigetOneBaseAdminControllerAdmin
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApigetOneBaseAdminControllerAdmin
     */
    cache?: number
}

export interface ADMINAdminUsersApiReplaceOneBaseAdminControllerAdminRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApireplaceOneBaseAdminControllerAdmin
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINAdminUsersApireplaceOneBaseAdminControllerAdmin
     */
    body: any
}

export interface ADMINAdminUsersApiUpdateOneBaseAdminControllerAdminRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAdminUsersApiupdateOneBaseAdminControllerAdmin
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINAdminUsersApiupdateOneBaseAdminControllerAdmin
     */
    body: any
}

export class ObjectADMINAdminUsersApi {
    private api: ObservableADMINAdminUsersApi

    public constructor(configuration: Configuration, requestFactory?: ADMINAdminUsersApiRequestFactory, responseProcessor?: ADMINAdminUsersApiResponseProcessor) {
        this.api = new ObservableADMINAdminUsersApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Admins
     * @param param the request object
     */
    public createManyBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiCreateManyBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseAdminControllerAdminWithHttpInfo(param.createManyAdminDto,  options).toPromise();
    }

    /**
     * Create multiple Admins
     * @param param the request object
     */
    public createManyBaseAdminControllerAdmin(param: ADMINAdminUsersApiCreateManyBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseAdminControllerAdmin(param.createManyAdminDto,  options).toPromise();
    }

    /**
     * Create a single Admin
     * @param param the request object
     */
    public createOneBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiCreateOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseAdminControllerAdminWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Admin
     * @param param the request object
     */
    public createOneBaseAdminControllerAdmin(param: ADMINAdminUsersApiCreateOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseAdminControllerAdmin(param.body,  options).toPromise();
    }

    /**
     * Delete a single Admin
     * @param param the request object
     */
    public deleteOneBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiDeleteOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseAdminControllerAdminWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Admin
     * @param param the request object
     */
    public deleteOneBaseAdminControllerAdmin(param: ADMINAdminUsersApiDeleteOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseAdminControllerAdmin(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Admins
     * @param param the request object
     */
    public getManyBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiGetManyBaseAdminControllerAdminRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseAdminControllerAdmin200Response>> {
        return this.api.getManyBaseAdminControllerAdminWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Admins
     * @param param the request object
     */
    public getManyBaseAdminControllerAdmin(param: ADMINAdminUsersApiGetManyBaseAdminControllerAdminRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseAdminControllerAdmin200Response> {
        return this.api.getManyBaseAdminControllerAdmin(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Admin
     * @param param the request object
     */
    public getOneBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiGetOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseAdminControllerAdminWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Admin
     * @param param the request object
     */
    public getOneBaseAdminControllerAdmin(param: ADMINAdminUsersApiGetOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseAdminControllerAdmin(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Admin
     * @param param the request object
     */
    public replaceOneBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiReplaceOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseAdminControllerAdminWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Admin
     * @param param the request object
     */
    public replaceOneBaseAdminControllerAdmin(param: ADMINAdminUsersApiReplaceOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseAdminControllerAdmin(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Admin
     * @param param the request object
     */
    public updateOneBaseAdminControllerAdminWithHttpInfo(param: ADMINAdminUsersApiUpdateOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseAdminControllerAdminWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Admin
     * @param param the request object
     */
    public updateOneBaseAdminControllerAdmin(param: ADMINAdminUsersApiUpdateOneBaseAdminControllerAdminRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseAdminControllerAdmin(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINApplicationItemsApi } from "./ObservableAPI";
import { ADMINApplicationItemsApiRequestFactory, ADMINApplicationItemsApiResponseProcessor} from "../apis/ADMINApplicationItemsApi";

export interface ADMINApplicationItemsApiCreateManyBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * @type CreateManyApplicationDto
     * @memberof ADMINApplicationItemsApicreateManyBaseApplicationAdminControllerApplication
     */
    createManyApplicationDto: CreateManyApplicationDto
}

export interface ADMINApplicationItemsApiCreateOneBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * @type any
     * @memberof ADMINApplicationItemsApicreateOneBaseApplicationAdminControllerApplication
     */
    body: any
}

export interface ADMINApplicationItemsApiDeleteOneBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApideleteOneBaseApplicationAdminControllerApplication
     */
    id: number
}

export interface ADMINApplicationItemsApiGetManyBaseApplicationAdminControllerApplicationRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetManyBaseApplicationAdminControllerApplication
     */
    cache?: number
}

export interface ADMINApplicationItemsApiGetOneBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetOneBaseApplicationAdminControllerApplication
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetOneBaseApplicationAdminControllerApplication
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINApplicationItemsApigetOneBaseApplicationAdminControllerApplication
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApigetOneBaseApplicationAdminControllerApplication
     */
    cache?: number
}

export interface ADMINApplicationItemsApiReplaceOneBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApireplaceOneBaseApplicationAdminControllerApplication
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINApplicationItemsApireplaceOneBaseApplicationAdminControllerApplication
     */
    body: any
}

export interface ADMINApplicationItemsApiUpdateOneBaseApplicationAdminControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINApplicationItemsApiupdateOneBaseApplicationAdminControllerApplication
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINApplicationItemsApiupdateOneBaseApplicationAdminControllerApplication
     */
    body: any
}

export class ObjectADMINApplicationItemsApi {
    private api: ObservableADMINApplicationItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINApplicationItemsApiRequestFactory, responseProcessor?: ADMINApplicationItemsApiResponseProcessor) {
        this.api = new ObservableADMINApplicationItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Applications
     * @param param the request object
     */
    public createManyBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiCreateManyBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseApplicationAdminControllerApplicationWithHttpInfo(param.createManyApplicationDto,  options).toPromise();
    }

    /**
     * Create multiple Applications
     * @param param the request object
     */
    public createManyBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiCreateManyBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseApplicationAdminControllerApplication(param.createManyApplicationDto,  options).toPromise();
    }

    /**
     * Create a single Application
     * @param param the request object
     */
    public createOneBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiCreateOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseApplicationAdminControllerApplicationWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Application
     * @param param the request object
     */
    public createOneBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiCreateOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseApplicationAdminControllerApplication(param.body,  options).toPromise();
    }

    /**
     * Delete a single Application
     * @param param the request object
     */
    public deleteOneBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiDeleteOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseApplicationAdminControllerApplicationWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Application
     * @param param the request object
     */
    public deleteOneBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiDeleteOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseApplicationAdminControllerApplication(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Applications
     * @param param the request object
     */
    public getManyBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiGetManyBaseApplicationAdminControllerApplicationRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseApplicationAdminControllerApplication200Response>> {
        return this.api.getManyBaseApplicationAdminControllerApplicationWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Applications
     * @param param the request object
     */
    public getManyBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiGetManyBaseApplicationAdminControllerApplicationRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseApplicationAdminControllerApplication200Response> {
        return this.api.getManyBaseApplicationAdminControllerApplication(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Application
     * @param param the request object
     */
    public getOneBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiGetOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseApplicationAdminControllerApplicationWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Application
     * @param param the request object
     */
    public getOneBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiGetOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseApplicationAdminControllerApplication(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Application
     * @param param the request object
     */
    public replaceOneBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiReplaceOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseApplicationAdminControllerApplicationWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Application
     * @param param the request object
     */
    public replaceOneBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiReplaceOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseApplicationAdminControllerApplication(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Application
     * @param param the request object
     */
    public updateOneBaseApplicationAdminControllerApplicationWithHttpInfo(param: ADMINApplicationItemsApiUpdateOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseApplicationAdminControllerApplicationWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Application
     * @param param the request object
     */
    public updateOneBaseApplicationAdminControllerApplication(param: ADMINApplicationItemsApiUpdateOneBaseApplicationAdminControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseApplicationAdminControllerApplication(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINArticleCategoriesApi } from "./ObservableAPI";
import { ADMINArticleCategoriesApiRequestFactory, ADMINArticleCategoriesApiResponseProcessor} from "../apis/ADMINArticleCategoriesApi";

export interface ADMINArticleCategoriesApiCreateManyBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type CreateManyArticleCategoryDto
     * @memberof ADMINArticleCategoriesApicreateManyBaseArticleCategoryAdminControllerArticleCategory
     */
    createManyArticleCategoryDto: CreateManyArticleCategoryDto
}

export interface ADMINArticleCategoriesApiCreateOneBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoriesApicreateOneBaseArticleCategoryAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoriesApiDeleteOneBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApideleteOneBaseArticleCategoryAdminControllerArticleCategory
     */
    id: number
}

export interface ADMINArticleCategoriesApiGetManyBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetManyBaseArticleCategoryAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoriesApiGetOneBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetOneBaseArticleCategoryAdminControllerArticleCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetOneBaseArticleCategoryAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoriesApigetOneBaseArticleCategoryAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApigetOneBaseArticleCategoryAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoriesApiReplaceOneBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApireplaceOneBaseArticleCategoryAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoriesApireplaceOneBaseArticleCategoryAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoriesApiUpdateOneBaseArticleCategoryAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoriesApiupdateOneBaseArticleCategoryAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoriesApiupdateOneBaseArticleCategoryAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export class ObjectADMINArticleCategoriesApi {
    private api: ObservableADMINArticleCategoriesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleCategoriesApiRequestFactory, responseProcessor?: ADMINArticleCategoriesApiResponseProcessor) {
        this.api = new ObservableADMINArticleCategoriesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiCreateManyBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ArticleCategory>>> {
        return this.api.createManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiCreateManyBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<Array<ArticleCategory>> {
        return this.api.createManyBaseArticleCategoryAdminControllerArticleCategory(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiCreateOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.createOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.articleCategory,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiCreateOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.createOneBaseArticleCategoryAdminControllerArticleCategory(param.articleCategory,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiDeleteOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiDeleteOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleCategoryAdminControllerArticleCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiGetManyBaseArticleCategoryAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        return this.api.getManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiGetManyBaseArticleCategoryAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.api.getManyBaseArticleCategoryAdminControllerArticleCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiGetOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.getOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiGetOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.getOneBaseArticleCategoryAdminControllerArticleCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiReplaceOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.replaceOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiReplaceOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.replaceOneBaseArticleCategoryAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoriesApiUpdateOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.updateOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryAdminControllerArticleCategory(param: ADMINArticleCategoriesApiUpdateOneBaseArticleCategoryAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.updateOneBaseArticleCategoryAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

}

import { ObservableADMINArticleCategoryKnowledgeApi } from "./ObservableAPI";
import { ADMINArticleCategoryKnowledgeApiRequestFactory, ADMINArticleCategoryKnowledgeApiResponseProcessor} from "../apis/ADMINArticleCategoryKnowledgeApi";

export interface ADMINArticleCategoryKnowledgeApiCreateManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type CreateManyArticleCategoryDto
     * @memberof ADMINArticleCategoryKnowledgeApicreateManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    createManyArticleCategoryDto: CreateManyArticleCategoryDto
}

export interface ADMINArticleCategoryKnowledgeApiCreateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryKnowledgeApicreateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoryKnowledgeApiDeleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApideleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    id: number
}

export interface ADMINArticleCategoryKnowledgeApiGetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoryKnowledgeApiGetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryKnowledgeApigetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApigetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoryKnowledgeApiReplaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApireplaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryKnowledgeApireplaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoryKnowledgeApiUpdateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryKnowledgeApiupdateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryKnowledgeApiupdateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export class ObjectADMINArticleCategoryKnowledgeApi {
    private api: ObservableADMINArticleCategoryKnowledgeApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleCategoryKnowledgeApiRequestFactory, responseProcessor?: ADMINArticleCategoryKnowledgeApiResponseProcessor) {
        this.api = new ObservableADMINArticleCategoryKnowledgeApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiCreateManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ArticleCategory>>> {
        return this.api.createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiCreateManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<Array<ArticleCategory>> {
        return this.api.createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiCreateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.articleCategory,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiCreateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.articleCategory,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiDeleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiDeleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiGetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        return this.api.getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiGetManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.api.getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiGetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiGetOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiReplaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiReplaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryKnowledgeApiUpdateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param: ADMINArticleCategoryKnowledgeApiUpdateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

}

import { ObservableADMINArticleCategoryNewsApi } from "./ObservableAPI";
import { ADMINArticleCategoryNewsApiRequestFactory, ADMINArticleCategoryNewsApiResponseProcessor} from "../apis/ADMINArticleCategoryNewsApi";

export interface ADMINArticleCategoryNewsApiCreateManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type CreateManyArticleCategoryDto
     * @memberof ADMINArticleCategoryNewsApicreateManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    createManyArticleCategoryDto: CreateManyArticleCategoryDto
}

export interface ADMINArticleCategoryNewsApiCreateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryNewsApicreateOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoryNewsApiDeleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApideleteOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    id: number
}

export interface ADMINArticleCategoryNewsApiGetManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetManyBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoryNewsApiGetOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleCategoryNewsApigetOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApigetOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINArticleCategoryNewsApiReplaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApireplaceOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryNewsApireplaceOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINArticleCategoryNewsApiUpdateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleCategoryNewsApiupdateOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINArticleCategoryNewsApiupdateOneBaseArticleCategoryNewsAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export class ObjectADMINArticleCategoryNewsApi {
    private api: ObservableADMINArticleCategoryNewsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleCategoryNewsApiRequestFactory, responseProcessor?: ADMINArticleCategoryNewsApiResponseProcessor) {
        this.api = new ObservableADMINArticleCategoryNewsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiCreateManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ArticleCategory>>> {
        return this.api.createManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiCreateManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<Array<ArticleCategory>> {
        return this.api.createManyBaseArticleCategoryNewsAdminControllerArticleCategory(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiCreateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.createOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.articleCategory,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiCreateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.createOneBaseArticleCategoryNewsAdminControllerArticleCategory(param.articleCategory,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiDeleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiDeleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleCategoryNewsAdminControllerArticleCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiGetManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        return this.api.getManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiGetManyBaseArticleCategoryNewsAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.api.getManyBaseArticleCategoryNewsAdminControllerArticleCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiGetOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.getOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiGetOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.getOneBaseArticleCategoryNewsAdminControllerArticleCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiReplaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.replaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiReplaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.replaceOneBaseArticleCategoryNewsAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param: ADMINArticleCategoryNewsApiUpdateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.updateOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryNewsAdminControllerArticleCategory(param: ADMINArticleCategoryNewsApiUpdateOneBaseArticleCategoryNewsAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.updateOneBaseArticleCategoryNewsAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

}

import { ObservableADMINArticleItemsApi } from "./ObservableAPI";
import { ADMINArticleItemsApiRequestFactory, ADMINArticleItemsApiResponseProcessor} from "../apis/ADMINArticleItemsApi";

export interface ADMINArticleItemsApiGetManyBaseArticleAdminControllerArticleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetManyBaseArticleAdminControllerArticle
     */
    cache?: number
}

export interface ADMINArticleItemsApiGetOneBaseArticleAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetOneBaseArticleAdminControllerArticle
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetOneBaseArticleAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleItemsApigetOneBaseArticleAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleItemsApigetOneBaseArticleAdminControllerArticle
     */
    cache?: number
}

export class ObjectADMINArticleItemsApi {
    private api: ObservableADMINArticleItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleItemsApiRequestFactory, responseProcessor?: ADMINArticleItemsApiResponseProcessor) {
        this.api = new ObservableADMINArticleItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleAdminControllerArticleWithHttpInfo(param: ADMINArticleItemsApiGetManyBaseArticleAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        return this.api.getManyBaseArticleAdminControllerArticleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleAdminControllerArticle(param: ADMINArticleItemsApiGetManyBaseArticleAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.api.getManyBaseArticleAdminControllerArticle(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleAdminControllerArticleWithHttpInfo(param: ADMINArticleItemsApiGetOneBaseArticleAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseArticleAdminControllerArticleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleAdminControllerArticle(param: ADMINArticleItemsApiGetOneBaseArticleAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseArticleAdminControllerArticle(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableADMINArticleKnowledgeApi } from "./ObservableAPI";
import { ADMINArticleKnowledgeApiRequestFactory, ADMINArticleKnowledgeApiResponseProcessor} from "../apis/ADMINArticleKnowledgeApi";

export interface ADMINArticleKnowledgeApiCreateOneBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * 
     * @type any
     * @memberof ADMINArticleKnowledgeApicreateOneBaseArticleKnowledgeAdminControllerArticle
     */
    body: any
}

export interface ADMINArticleKnowledgeApiDeleteOneBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApideleteOneBaseArticleKnowledgeAdminControllerArticle
     */
    id: number
}

export interface ADMINArticleKnowledgeApiGetManyBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetManyBaseArticleKnowledgeAdminControllerArticle
     */
    cache?: number
}

export interface ADMINArticleKnowledgeApiGetOneBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetOneBaseArticleKnowledgeAdminControllerArticle
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetOneBaseArticleKnowledgeAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleKnowledgeApigetOneBaseArticleKnowledgeAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApigetOneBaseArticleKnowledgeAdminControllerArticle
     */
    cache?: number
}

export interface ADMINArticleKnowledgeApiReplaceOneBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApireplaceOneBaseArticleKnowledgeAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINArticleKnowledgeApireplaceOneBaseArticleKnowledgeAdminControllerArticle
     */
    body: any
}

export interface ADMINArticleKnowledgeApiUpdateOneBaseArticleKnowledgeAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleKnowledgeApiupdateOneBaseArticleKnowledgeAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINArticleKnowledgeApiupdateOneBaseArticleKnowledgeAdminControllerArticle
     */
    body: any
}

export class ObjectADMINArticleKnowledgeApi {
    private api: ObservableADMINArticleKnowledgeApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleKnowledgeApiRequestFactory, responseProcessor?: ADMINArticleKnowledgeApiResponseProcessor) {
        this.api = new ObservableADMINArticleKnowledgeApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiCreateOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiCreateOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseArticleKnowledgeAdminControllerArticle(param.body,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiDeleteOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiDeleteOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleKnowledgeAdminControllerArticle(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiGetManyBaseArticleKnowledgeAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        return this.api.getManyBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiGetManyBaseArticleKnowledgeAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.api.getManyBaseArticleKnowledgeAdminControllerArticle(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiGetOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiGetOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseArticleKnowledgeAdminControllerArticle(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiReplaceOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiReplaceOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseArticleKnowledgeAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param: ADMINArticleKnowledgeApiUpdateOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleKnowledgeAdminControllerArticle(param: ADMINArticleKnowledgeApiUpdateOneBaseArticleKnowledgeAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseArticleKnowledgeAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINArticleNewsApi } from "./ObservableAPI";
import { ADMINArticleNewsApiRequestFactory, ADMINArticleNewsApiResponseProcessor} from "../apis/ADMINArticleNewsApi";

export interface ADMINArticleNewsApiCreateOneBaseArticleNewsAdminControllerArticleRequest {
    /**
     * 
     * @type any
     * @memberof ADMINArticleNewsApicreateOneBaseArticleNewsAdminControllerArticle
     */
    body: any
}

export interface ADMINArticleNewsApiDeleteOneBaseArticleNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApideleteOneBaseArticleNewsAdminControllerArticle
     */
    id: number
}

export interface ADMINArticleNewsApiGetManyBaseArticleNewsAdminControllerArticleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetManyBaseArticleNewsAdminControllerArticle
     */
    cache?: number
}

export interface ADMINArticleNewsApiGetOneBaseArticleNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetOneBaseArticleNewsAdminControllerArticle
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetOneBaseArticleNewsAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINArticleNewsApigetOneBaseArticleNewsAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApigetOneBaseArticleNewsAdminControllerArticle
     */
    cache?: number
}

export interface ADMINArticleNewsApiReplaceOneBaseArticleNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApireplaceOneBaseArticleNewsAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINArticleNewsApireplaceOneBaseArticleNewsAdminControllerArticle
     */
    body: any
}

export interface ADMINArticleNewsApiUpdateOneBaseArticleNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINArticleNewsApiupdateOneBaseArticleNewsAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINArticleNewsApiupdateOneBaseArticleNewsAdminControllerArticle
     */
    body: any
}

export class ObjectADMINArticleNewsApi {
    private api: ObservableADMINArticleNewsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINArticleNewsApiRequestFactory, responseProcessor?: ADMINArticleNewsApiResponseProcessor) {
        this.api = new ObservableADMINArticleNewsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiCreateOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiCreateOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseArticleNewsAdminControllerArticle(param.body,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiDeleteOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiDeleteOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleNewsAdminControllerArticle(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiGetManyBaseArticleNewsAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        return this.api.getManyBaseArticleNewsAdminControllerArticleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiGetManyBaseArticleNewsAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.api.getManyBaseArticleNewsAdminControllerArticle(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiGetOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiGetOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseArticleNewsAdminControllerArticle(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiReplaceOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiReplaceOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseArticleNewsAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param: ADMINArticleNewsApiUpdateOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseArticleNewsAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleNewsAdminControllerArticle(param: ADMINArticleNewsApiUpdateOneBaseArticleNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseArticleNewsAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINAssetItemsApi } from "./ObservableAPI";
import { ADMINAssetItemsApiRequestFactory, ADMINAssetItemsApiResponseProcessor} from "../apis/ADMINAssetItemsApi";

export interface ADMINAssetItemsApiCreateManyBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * @type CreateManyAssetDto
     * @memberof ADMINAssetItemsApicreateManyBaseAssetAdminControllerAsset
     */
    createManyAssetDto: CreateManyAssetDto
}

export interface ADMINAssetItemsApiCreateOneBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * @type Asset
     * @memberof ADMINAssetItemsApicreateOneBaseAssetAdminControllerAsset
     */
    asset: Asset
}

export interface ADMINAssetItemsApiDeleteOneBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAssetItemsApideleteOneBaseAssetAdminControllerAsset
     */
    id: string
}

export interface ADMINAssetItemsApiGetManyBaseAssetAdminControllerAssetRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAssetItemsApigetManyBaseAssetAdminControllerAsset
     */
    cache?: number
}

export interface ADMINAssetItemsApiGetOneBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAssetItemsApigetOneBaseAssetAdminControllerAsset
     */
    id: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetOneBaseAssetAdminControllerAsset
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINAssetItemsApigetOneBaseAssetAdminControllerAsset
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINAssetItemsApigetOneBaseAssetAdminControllerAsset
     */
    cache?: number
}

export interface ADMINAssetItemsApiRefresh0Request {
}

export interface ADMINAssetItemsApiReplaceOneBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAssetItemsApireplaceOneBaseAssetAdminControllerAsset
     */
    id: string
    /**
     * 
     * @type Asset
     * @memberof ADMINAssetItemsApireplaceOneBaseAssetAdminControllerAsset
     */
    asset: Asset
}

export interface ADMINAssetItemsApiUpdateOneBaseAssetAdminControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINAssetItemsApiupdateOneBaseAssetAdminControllerAsset
     */
    id: string
    /**
     * 
     * @type Asset
     * @memberof ADMINAssetItemsApiupdateOneBaseAssetAdminControllerAsset
     */
    asset: Asset
}

export interface ADMINAssetItemsApiUpload0Request {
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof ADMINAssetItemsApiupload0
     */
    file?: HttpFile
}

export class ObjectADMINAssetItemsApi {
    private api: ObservableADMINAssetItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINAssetItemsApiRequestFactory, responseProcessor?: ADMINAssetItemsApiResponseProcessor) {
        this.api = new ObservableADMINAssetItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Assets
     * @param param the request object
     */
    public createManyBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiCreateManyBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<Asset>>> {
        return this.api.createManyBaseAssetAdminControllerAssetWithHttpInfo(param.createManyAssetDto,  options).toPromise();
    }

    /**
     * Create multiple Assets
     * @param param the request object
     */
    public createManyBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiCreateManyBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<Array<Asset>> {
        return this.api.createManyBaseAssetAdminControllerAsset(param.createManyAssetDto,  options).toPromise();
    }

    /**
     * Create a single Asset
     * @param param the request object
     */
    public createOneBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiCreateOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.createOneBaseAssetAdminControllerAssetWithHttpInfo(param.asset,  options).toPromise();
    }

    /**
     * Create a single Asset
     * @param param the request object
     */
    public createOneBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiCreateOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.createOneBaseAssetAdminControllerAsset(param.asset,  options).toPromise();
    }

    /**
     * Delete a single Asset
     * @param param the request object
     */
    public deleteOneBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiDeleteOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseAssetAdminControllerAssetWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Asset
     * @param param the request object
     */
    public deleteOneBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiDeleteOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseAssetAdminControllerAsset(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Assets
     * @param param the request object
     */
    public getManyBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiGetManyBaseAssetAdminControllerAssetRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>> {
        return this.api.getManyBaseAssetAdminControllerAssetWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Assets
     * @param param the request object
     */
    public getManyBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiGetManyBaseAssetAdminControllerAssetRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseAssetAdminControllerAsset200Response> {
        return this.api.getManyBaseAssetAdminControllerAsset(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Asset
     * @param param the request object
     */
    public getOneBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiGetOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.getOneBaseAssetAdminControllerAssetWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Asset
     * @param param the request object
     */
    public getOneBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiGetOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.getOneBaseAssetAdminControllerAsset(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public refresh0WithHttpInfo(param: ADMINAssetItemsApiRefresh0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.refresh0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public refresh0(param: ADMINAssetItemsApiRefresh0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.refresh0( options).toPromise();
    }

    /**
     * Replace a single Asset
     * @param param the request object
     */
    public replaceOneBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiReplaceOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.replaceOneBaseAssetAdminControllerAssetWithHttpInfo(param.id, param.asset,  options).toPromise();
    }

    /**
     * Replace a single Asset
     * @param param the request object
     */
    public replaceOneBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiReplaceOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.replaceOneBaseAssetAdminControllerAsset(param.id, param.asset,  options).toPromise();
    }

    /**
     * Update a single Asset
     * @param param the request object
     */
    public updateOneBaseAssetAdminControllerAssetWithHttpInfo(param: ADMINAssetItemsApiUpdateOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.updateOneBaseAssetAdminControllerAssetWithHttpInfo(param.id, param.asset,  options).toPromise();
    }

    /**
     * Update a single Asset
     * @param param the request object
     */
    public updateOneBaseAssetAdminControllerAsset(param: ADMINAssetItemsApiUpdateOneBaseAssetAdminControllerAssetRequest, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.updateOneBaseAssetAdminControllerAsset(param.id, param.asset,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public upload0WithHttpInfo(param: ADMINAssetItemsApiUpload0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.upload0WithHttpInfo(param.file,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public upload0(param: ADMINAssetItemsApiUpload0Request = {}, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.upload0(param.file,  options).toPromise();
    }

}

import { ObservableADMINBackgroundCategoriesApi } from "./ObservableAPI";
import { ADMINBackgroundCategoriesApiRequestFactory, ADMINBackgroundCategoriesApiResponseProcessor} from "../apis/ADMINBackgroundCategoriesApi";

export interface ADMINBackgroundCategoriesApiCreateManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * @type CreateManyBackgroundCategoryDto
     * @memberof ADMINBackgroundCategoriesApicreateManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    createManyBackgroundCategoryDto: CreateManyBackgroundCategoryDto
}

export interface ADMINBackgroundCategoriesApiCreateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * @type BackgroundCategory
     * @memberof ADMINBackgroundCategoriesApicreateOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    backgroundCategory: BackgroundCategory
}

export interface ADMINBackgroundCategoriesApiDeleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApideleteOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    id: number
}

export interface ADMINBackgroundCategoriesApiGetManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetManyBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    cache?: number
}

export interface ADMINBackgroundCategoriesApiGetOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundCategoriesApigetOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApigetOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    cache?: number
}

export interface ADMINBackgroundCategoriesApiReplaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApireplaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    id: number
    /**
     * 
     * @type BackgroundCategory
     * @memberof ADMINBackgroundCategoriesApireplaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    backgroundCategory: BackgroundCategory
}

export interface ADMINBackgroundCategoriesApiUpdateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundCategoriesApiupdateOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    id: number
    /**
     * 
     * @type BackgroundCategory
     * @memberof ADMINBackgroundCategoriesApiupdateOneBaseBackgroundCategoryAdminControllerBackgroundCategory
     */
    backgroundCategory: BackgroundCategory
}

export class ObjectADMINBackgroundCategoriesApi {
    private api: ObservableADMINBackgroundCategoriesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINBackgroundCategoriesApiRequestFactory, responseProcessor?: ADMINBackgroundCategoriesApiResponseProcessor) {
        this.api = new ObservableADMINBackgroundCategoriesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple BackgroundCategories
     * @param param the request object
     */
    public createManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiCreateManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<BackgroundCategory>>> {
        return this.api.createManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.createManyBackgroundCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple BackgroundCategories
     * @param param the request object
     */
    public createManyBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiCreateManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<Array<BackgroundCategory>> {
        return this.api.createManyBaseBackgroundCategoryAdminControllerBackgroundCategory(param.createManyBackgroundCategoryDto,  options).toPromise();
    }

    /**
     * Create a single BackgroundCategory
     * @param param the request object
     */
    public createOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiCreateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<BackgroundCategory>> {
        return this.api.createOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.backgroundCategory,  options).toPromise();
    }

    /**
     * Create a single BackgroundCategory
     * @param param the request object
     */
    public createOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiCreateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<BackgroundCategory> {
        return this.api.createOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param.backgroundCategory,  options).toPromise();
    }

    /**
     * Delete a single BackgroundCategory
     * @param param the request object
     */
    public deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiDeleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single BackgroundCategory
     * @param param the request object
     */
    public deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiDeleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple BackgroundCategories
     * @param param the request object
     */
    public getManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiGetManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response>> {
        return this.api.getManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple BackgroundCategories
     * @param param the request object
     */
    public getManyBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiGetManyBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response> {
        return this.api.getManyBaseBackgroundCategoryAdminControllerBackgroundCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single BackgroundCategory
     * @param param the request object
     */
    public getOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiGetOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<BackgroundCategory>> {
        return this.api.getOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single BackgroundCategory
     * @param param the request object
     */
    public getOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiGetOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<BackgroundCategory> {
        return this.api.getOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single BackgroundCategory
     * @param param the request object
     */
    public replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiReplaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<BackgroundCategory>> {
        return this.api.replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.id, param.backgroundCategory,  options).toPromise();
    }

    /**
     * Replace a single BackgroundCategory
     * @param param the request object
     */
    public replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiReplaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<BackgroundCategory> {
        return this.api.replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param.id, param.backgroundCategory,  options).toPromise();
    }

    /**
     * Update a single BackgroundCategory
     * @param param the request object
     */
    public updateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param: ADMINBackgroundCategoriesApiUpdateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<BackgroundCategory>> {
        return this.api.updateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(param.id, param.backgroundCategory,  options).toPromise();
    }

    /**
     * Update a single BackgroundCategory
     * @param param the request object
     */
    public updateOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param: ADMINBackgroundCategoriesApiUpdateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryRequest, options?: ConfigurationOptions): Promise<BackgroundCategory> {
        return this.api.updateOneBaseBackgroundCategoryAdminControllerBackgroundCategory(param.id, param.backgroundCategory,  options).toPromise();
    }

}

import { ObservableADMINBackgroundItemsApi } from "./ObservableAPI";
import { ADMINBackgroundItemsApiRequestFactory, ADMINBackgroundItemsApiResponseProcessor} from "../apis/ADMINBackgroundItemsApi";

export interface ADMINBackgroundItemsApiCreateManyBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * @type CreateManyBackgroundDto
     * @memberof ADMINBackgroundItemsApicreateManyBaseBackgroundAdminControllerBackground
     */
    createManyBackgroundDto: CreateManyBackgroundDto
}

export interface ADMINBackgroundItemsApiCreateOneBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * @type any
     * @memberof ADMINBackgroundItemsApicreateOneBaseBackgroundAdminControllerBackground
     */
    body: any
}

export interface ADMINBackgroundItemsApiDeleteOneBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApideleteOneBaseBackgroundAdminControllerBackground
     */
    id: number
}

export interface ADMINBackgroundItemsApiGetManyBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetManyBaseBackgroundAdminControllerBackground
     */
    cache?: number
}

export interface ADMINBackgroundItemsApiGetOneBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetOneBaseBackgroundAdminControllerBackground
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetOneBaseBackgroundAdminControllerBackground
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINBackgroundItemsApigetOneBaseBackgroundAdminControllerBackground
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApigetOneBaseBackgroundAdminControllerBackground
     */
    cache?: number
}

export interface ADMINBackgroundItemsApiReplaceOneBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApireplaceOneBaseBackgroundAdminControllerBackground
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINBackgroundItemsApireplaceOneBaseBackgroundAdminControllerBackground
     */
    body: any
}

export interface ADMINBackgroundItemsApiUpdateOneBaseBackgroundAdminControllerBackgroundRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBackgroundItemsApiupdateOneBaseBackgroundAdminControllerBackground
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINBackgroundItemsApiupdateOneBaseBackgroundAdminControllerBackground
     */
    body: any
}

export class ObjectADMINBackgroundItemsApi {
    private api: ObservableADMINBackgroundItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINBackgroundItemsApiRequestFactory, responseProcessor?: ADMINBackgroundItemsApiResponseProcessor) {
        this.api = new ObservableADMINBackgroundItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Backgrounds
     * @param param the request object
     */
    public createManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiCreateManyBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.createManyBackgroundDto,  options).toPromise();
    }

    /**
     * Create multiple Backgrounds
     * @param param the request object
     */
    public createManyBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiCreateManyBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseBackgroundAdminControllerBackground(param.createManyBackgroundDto,  options).toPromise();
    }

    /**
     * Create a single Background
     * @param param the request object
     */
    public createOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiCreateOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Background
     * @param param the request object
     */
    public createOneBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiCreateOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseBackgroundAdminControllerBackground(param.body,  options).toPromise();
    }

    /**
     * Delete a single Background
     * @param param the request object
     */
    public deleteOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiDeleteOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Background
     * @param param the request object
     */
    public deleteOneBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiDeleteOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseBackgroundAdminControllerBackground(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Backgrounds
     * @param param the request object
     */
    public getManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiGetManyBaseBackgroundAdminControllerBackgroundRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseBackgroundAdminControllerBackground200Response>> {
        return this.api.getManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Backgrounds
     * @param param the request object
     */
    public getManyBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiGetManyBaseBackgroundAdminControllerBackgroundRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseBackgroundAdminControllerBackground200Response> {
        return this.api.getManyBaseBackgroundAdminControllerBackground(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Background
     * @param param the request object
     */
    public getOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiGetOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Background
     * @param param the request object
     */
    public getOneBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiGetOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseBackgroundAdminControllerBackground(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Background
     * @param param the request object
     */
    public replaceOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiReplaceOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Background
     * @param param the request object
     */
    public replaceOneBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiReplaceOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseBackgroundAdminControllerBackground(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Background
     * @param param the request object
     */
    public updateOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param: ADMINBackgroundItemsApiUpdateOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Background
     * @param param the request object
     */
    public updateOneBaseBackgroundAdminControllerBackground(param: ADMINBackgroundItemsApiUpdateOneBaseBackgroundAdminControllerBackgroundRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseBackgroundAdminControllerBackground(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINBannerItemsApi } from "./ObservableAPI";
import { ADMINBannerItemsApiRequestFactory, ADMINBannerItemsApiResponseProcessor} from "../apis/ADMINBannerItemsApi";

export interface ADMINBannerItemsApiCreate0Request {
    /**
     * 
     * @type BannerItemCreateDTO
     * @memberof ADMINBannerItemsApicreate0
     */
    bannerItemCreateDTO: BannerItemCreateDTO
}

export interface ADMINBannerItemsApiDestroy0Request {
    /**
     * Unique id of banner to find.
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBannerItemsApidestroy0
     */
    bannerId: number
}

export interface ADMINBannerItemsApiFindMany0Request {
    /**
     * Page.
     * Defaults to: 0
     * @type number
     * @memberof ADMINBannerItemsApifindMany0
     */
    page: number
    /**
     * Amount of items to take.
     * Defaults to: 10
     * @type number
     * @memberof ADMINBannerItemsApifindMany0
     */
    limit: number
    /**
     * Specific language code for query.
     * Defaults to: undefined
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof ADMINBannerItemsApifindMany0
     */
    language?: 'en' | 'ru' | 'uk'
    /**
     * Banner position
     * Defaults to: undefined
     * @type &#39;HERO&#39; | &#39;SIDEBAR&#39; | &#39;TOP&#39; | &#39;LIST&#39;
     * @memberof ADMINBannerItemsApifindMany0
     */
    position?: 'HERO' | 'SIDEBAR' | 'TOP' | 'LIST'
    /**
     * ProfileType
     * Defaults to: undefined
     * @type &#39;employee&#39; | &#39;hirer&#39; | &#39;unknown&#39;
     * @memberof ADMINBannerItemsApifindMany0
     */
    profileType?: 'employee' | 'hirer' | 'unknown'
    /**
     * Search string to filter items.
     * Defaults to: undefined
     * @type string
     * @memberof ADMINBannerItemsApifindMany0
     */
    search?: string
}

export interface ADMINBannerItemsApiFindOne0Request {
    /**
     * Unique id of banner to find.
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBannerItemsApifindOne0
     */
    bannerId: number
}

export interface ADMINBannerItemsApiUpdate0Request {
    /**
     * Unique id of banner to find.
     * Defaults to: undefined
     * @type number
     * @memberof ADMINBannerItemsApiupdate0
     */
    bannerId: number
    /**
     * 
     * @type BannerItemUpdateDTO
     * @memberof ADMINBannerItemsApiupdate0
     */
    bannerItemUpdateDTO: BannerItemUpdateDTO
}

export class ObjectADMINBannerItemsApi {
    private api: ObservableADMINBannerItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINBannerItemsApiRequestFactory, responseProcessor?: ADMINBannerItemsApiResponseProcessor) {
        this.api = new ObservableADMINBannerItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Creates new banner.
     * @param param the request object
     */
    public create0WithHttpInfo(param: ADMINBannerItemsApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerItemDTO>> {
        return this.api.create0WithHttpInfo(param.bannerItemCreateDTO,  options).toPromise();
    }

    /**
     * Creates new banner.
     * @param param the request object
     */
    public create0(param: ADMINBannerItemsApiCreate0Request, options?: ConfigurationOptions): Promise<BannerItemDTO> {
        return this.api.create0(param.bannerItemCreateDTO,  options).toPromise();
    }

    /**
     * Deletes banner.
     * @param param the request object
     */
    public destroy0WithHttpInfo(param: ADMINBannerItemsApiDestroy0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerItemDTO>> {
        return this.api.destroy0WithHttpInfo(param.bannerId,  options).toPromise();
    }

    /**
     * Deletes banner.
     * @param param the request object
     */
    public destroy0(param: ADMINBannerItemsApiDestroy0Request, options?: ConfigurationOptions): Promise<BannerItemDTO> {
        return this.api.destroy0(param.bannerId,  options).toPromise();
    }

    /**
     * Returns a set of banners, according to the given limit, page number and search query.
     * @param param the request object
     */
    public findMany0WithHttpInfo(param: ADMINBannerItemsApiFindMany0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerFindManyControllerFindMany0200Response>> {
        return this.api.findMany0WithHttpInfo(param.page, param.limit, param.language, param.position, param.profileType, param.search,  options).toPromise();
    }

    /**
     * Returns a set of banners, according to the given limit, page number and search query.
     * @param param the request object
     */
    public findMany0(param: ADMINBannerItemsApiFindMany0Request, options?: ConfigurationOptions): Promise<BannerFindManyControllerFindMany0200Response> {
        return this.api.findMany0(param.page, param.limit, param.language, param.position, param.profileType, param.search,  options).toPromise();
    }

    /**
     * Returns banner, according to the given unique id query.
     * @param param the request object
     */
    public findOne0WithHttpInfo(param: ADMINBannerItemsApiFindOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerItemDTO>> {
        return this.api.findOne0WithHttpInfo(param.bannerId,  options).toPromise();
    }

    /**
     * Returns banner, according to the given unique id query.
     * @param param the request object
     */
    public findOne0(param: ADMINBannerItemsApiFindOne0Request, options?: ConfigurationOptions): Promise<BannerItemDTO> {
        return this.api.findOne0(param.bannerId,  options).toPromise();
    }

    /**
     * Updates banner.
     * @param param the request object
     */
    public update0WithHttpInfo(param: ADMINBannerItemsApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerItemDTO>> {
        return this.api.update0WithHttpInfo(param.bannerId, param.bannerItemUpdateDTO,  options).toPromise();
    }

    /**
     * Updates banner.
     * @param param the request object
     */
    public update0(param: ADMINBannerItemsApiUpdate0Request, options?: ConfigurationOptions): Promise<BannerItemDTO> {
        return this.api.update0(param.bannerId, param.bannerItemUpdateDTO,  options).toPromise();
    }

}

import { ObservableADMINCVApprovedApi } from "./ObservableAPI";
import { ADMINCVApprovedApiRequestFactory, ADMINCVApprovedApiResponseProcessor} from "../apis/ADMINCVApprovedApi";

export interface ADMINCVApprovedApiCreateManyBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * @type CreateManyCVDto
     * @memberof ADMINCVApprovedApicreateManyBaseCvApprovedAdminControllerCV
     */
    createManyCVDto: CreateManyCVDto
}

export interface ADMINCVApprovedApiCreateOneBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCVApprovedApicreateOneBaseCvApprovedAdminControllerCV
     */
    body: any
}

export interface ADMINCVApprovedApiDeleteOneBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApideleteOneBaseCvApprovedAdminControllerCV
     */
    id: number
}

export interface ADMINCVApprovedApiGetManyBaseCvApprovedAdminControllerCVRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetManyBaseCvApprovedAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVApprovedApiGetOneBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetOneBaseCvApprovedAdminControllerCV
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetOneBaseCvApprovedAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVApprovedApigetOneBaseCvApprovedAdminControllerCV
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApigetOneBaseCvApprovedAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVApprovedApiReplaceOneBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApireplaceOneBaseCvApprovedAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVApprovedApireplaceOneBaseCvApprovedAdminControllerCV
     */
    body: any
}

export interface ADMINCVApprovedApiUpdateOneBaseCvApprovedAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVApprovedApiupdateOneBaseCvApprovedAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVApprovedApiupdateOneBaseCvApprovedAdminControllerCV
     */
    body: any
}

export class ObjectADMINCVApprovedApi {
    private api: ObservableADMINCVApprovedApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCVApprovedApiRequestFactory, responseProcessor?: ADMINCVApprovedApiResponseProcessor) {
        this.api = new ObservableADMINCVApprovedApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiCreateManyBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCvApprovedAdminControllerCVWithHttpInfo(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiCreateManyBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCvApprovedAdminControllerCV(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiCreateOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCvApprovedAdminControllerCVWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiCreateOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCvApprovedAdminControllerCV(param.body,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiDeleteOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCvApprovedAdminControllerCVWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiDeleteOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCvApprovedAdminControllerCV(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiGetManyBaseCvApprovedAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCvApprovedAdminControllerCVWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiGetManyBaseCvApprovedAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCvApprovedAdminControllerCV(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiGetOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCvApprovedAdminControllerCVWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiGetOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCvApprovedAdminControllerCV(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiReplaceOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCvApprovedAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiReplaceOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCvApprovedAdminControllerCV(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCvApprovedAdminControllerCVWithHttpInfo(param: ADMINCVApprovedApiUpdateOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCvApprovedAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCvApprovedAdminControllerCV(param: ADMINCVApprovedApiUpdateOneBaseCvApprovedAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCvApprovedAdminControllerCV(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCVItemsApi } from "./ObservableAPI";
import { ADMINCVItemsApiRequestFactory, ADMINCVItemsApiResponseProcessor} from "../apis/ADMINCVItemsApi";

export interface ADMINCVItemsApiCreateManyBaseCVAdminControllerCVRequest {
    /**
     * 
     * @type CreateManyCVDto
     * @memberof ADMINCVItemsApicreateManyBaseCVAdminControllerCV
     */
    createManyCVDto: CreateManyCVDto
}

export interface ADMINCVItemsApiCreateOneBaseCVAdminControllerCVRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCVItemsApicreateOneBaseCVAdminControllerCV
     */
    body: any
}

export interface ADMINCVItemsApiDeleteOneBaseCVAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApideleteOneBaseCVAdminControllerCV
     */
    id: number
}

export interface ADMINCVItemsApiGetManyBaseCVAdminControllerCVRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetManyBaseCVAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVItemsApiGetOneBaseCVAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetOneBaseCVAdminControllerCV
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetOneBaseCVAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVItemsApigetOneBaseCVAdminControllerCV
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApigetOneBaseCVAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVItemsApiReplaceOneBaseCVAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApireplaceOneBaseCVAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVItemsApireplaceOneBaseCVAdminControllerCV
     */
    body: any
}

export interface ADMINCVItemsApiUpdateOneBaseCVAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVItemsApiupdateOneBaseCVAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVItemsApiupdateOneBaseCVAdminControllerCV
     */
    body: any
}

export class ObjectADMINCVItemsApi {
    private api: ObservableADMINCVItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCVItemsApiRequestFactory, responseProcessor?: ADMINCVItemsApiResponseProcessor) {
        this.api = new ObservableADMINCVItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiCreateManyBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCVAdminControllerCVWithHttpInfo(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCVAdminControllerCV(param: ADMINCVItemsApiCreateManyBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCVAdminControllerCV(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiCreateOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCVAdminControllerCVWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCVAdminControllerCV(param: ADMINCVItemsApiCreateOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCVAdminControllerCV(param.body,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiDeleteOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCVAdminControllerCVWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCVAdminControllerCV(param: ADMINCVItemsApiDeleteOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCVAdminControllerCV(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiGetManyBaseCVAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCVAdminControllerCV200Response>> {
        return this.api.getManyBaseCVAdminControllerCVWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCVAdminControllerCV(param: ADMINCVItemsApiGetManyBaseCVAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCVAdminControllerCV200Response> {
        return this.api.getManyBaseCVAdminControllerCV(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiGetOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCVAdminControllerCVWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCVAdminControllerCV(param: ADMINCVItemsApiGetOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCVAdminControllerCV(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiReplaceOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCVAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCVAdminControllerCV(param: ADMINCVItemsApiReplaceOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCVAdminControllerCV(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCVAdminControllerCVWithHttpInfo(param: ADMINCVItemsApiUpdateOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCVAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCVAdminControllerCV(param: ADMINCVItemsApiUpdateOneBaseCVAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCVAdminControllerCV(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCVModerationApi } from "./ObservableAPI";
import { ADMINCVModerationApiRequestFactory, ADMINCVModerationApiResponseProcessor} from "../apis/ADMINCVModerationApi";

export interface ADMINCVModerationApiCreateManyBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * @type CreateManyCVDto
     * @memberof ADMINCVModerationApicreateManyBaseCvModerationAdminControllerCV
     */
    createManyCVDto: CreateManyCVDto
}

export interface ADMINCVModerationApiCreateOneBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCVModerationApicreateOneBaseCvModerationAdminControllerCV
     */
    body: any
}

export interface ADMINCVModerationApiDeleteOneBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApideleteOneBaseCvModerationAdminControllerCV
     */
    id: number
}

export interface ADMINCVModerationApiGetManyBaseCvModerationAdminControllerCVRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetManyBaseCvModerationAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVModerationApiGetOneBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetOneBaseCvModerationAdminControllerCV
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetOneBaseCvModerationAdminControllerCV
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCVModerationApigetOneBaseCvModerationAdminControllerCV
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApigetOneBaseCvModerationAdminControllerCV
     */
    cache?: number
}

export interface ADMINCVModerationApiReplaceOneBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApireplaceOneBaseCvModerationAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVModerationApireplaceOneBaseCvModerationAdminControllerCV
     */
    body: any
}

export interface ADMINCVModerationApiUpdateOneBaseCvModerationAdminControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCVModerationApiupdateOneBaseCvModerationAdminControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCVModerationApiupdateOneBaseCvModerationAdminControllerCV
     */
    body: any
}

export class ObjectADMINCVModerationApi {
    private api: ObservableADMINCVModerationApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCVModerationApiRequestFactory, responseProcessor?: ADMINCVModerationApiResponseProcessor) {
        this.api = new ObservableADMINCVModerationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiCreateManyBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCvModerationAdminControllerCVWithHttpInfo(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create multiple CVS
     * @param param the request object
     */
    public createManyBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiCreateManyBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCvModerationAdminControllerCV(param.createManyCVDto,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiCreateOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCvModerationAdminControllerCVWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiCreateOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCvModerationAdminControllerCV(param.body,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiDeleteOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCvModerationAdminControllerCVWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiDeleteOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCvModerationAdminControllerCV(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiGetManyBaseCvModerationAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCvModerationAdminControllerCVWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiGetManyBaseCvModerationAdminControllerCVRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCvModerationAdminControllerCV(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiGetOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCvModerationAdminControllerCVWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiGetOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCvModerationAdminControllerCV(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiReplaceOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCvModerationAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CV
     * @param param the request object
     */
    public replaceOneBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiReplaceOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCvModerationAdminControllerCV(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCvModerationAdminControllerCVWithHttpInfo(param: ADMINCVModerationApiUpdateOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCvModerationAdminControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCvModerationAdminControllerCV(param: ADMINCVModerationApiUpdateOneBaseCvModerationAdminControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCvModerationAdminControllerCV(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCharacterItemCategoriesApi } from "./ObservableAPI";
import { ADMINCharacterItemCategoriesApiRequestFactory, ADMINCharacterItemCategoriesApiResponseProcessor} from "../apis/ADMINCharacterItemCategoriesApi";

export interface ADMINCharacterItemCategoriesApiCreateManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * @type CreateManyCharacterItemCategoryDto
     * @memberof ADMINCharacterItemCategoriesApicreateManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    createManyCharacterItemCategoryDto: CreateManyCharacterItemCategoryDto
}

export interface ADMINCharacterItemCategoriesApiCreateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * @type CharacterItemCategory
     * @memberof ADMINCharacterItemCategoriesApicreateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    characterItemCategory: CharacterItemCategory
}

export interface ADMINCharacterItemCategoriesApiDeleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApideleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    id: number
}

export interface ADMINCharacterItemCategoriesApiGetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    cache?: number
}

export interface ADMINCharacterItemCategoriesApiGetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemCategoriesApigetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApigetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    cache?: number
}

export interface ADMINCharacterItemCategoriesApiReplaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApireplaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    id: number
    /**
     * 
     * @type CharacterItemCategory
     * @memberof ADMINCharacterItemCategoriesApireplaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    characterItemCategory: CharacterItemCategory
}

export interface ADMINCharacterItemCategoriesApiUpdateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemCategoriesApiupdateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    id: number
    /**
     * 
     * @type CharacterItemCategory
     * @memberof ADMINCharacterItemCategoriesApiupdateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory
     */
    characterItemCategory: CharacterItemCategory
}

export class ObjectADMINCharacterItemCategoriesApi {
    private api: ObservableADMINCharacterItemCategoriesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCharacterItemCategoriesApiRequestFactory, responseProcessor?: ADMINCharacterItemCategoriesApiResponseProcessor) {
        this.api = new ObservableADMINCharacterItemCategoriesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple CharacterItemCategories
     * @param param the request object
     */
    public createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiCreateManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<CharacterItemCategory>>> {
        return this.api.createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.createManyCharacterItemCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple CharacterItemCategories
     * @param param the request object
     */
    public createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiCreateManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<Array<CharacterItemCategory>> {
        return this.api.createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.createManyCharacterItemCategoryDto,  options).toPromise();
    }

    /**
     * Create a single CharacterItemCategory
     * @param param the request object
     */
    public createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiCreateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItemCategory>> {
        return this.api.createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.characterItemCategory,  options).toPromise();
    }

    /**
     * Create a single CharacterItemCategory
     * @param param the request object
     */
    public createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiCreateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<CharacterItemCategory> {
        return this.api.createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.characterItemCategory,  options).toPromise();
    }

    /**
     * Delete a single CharacterItemCategory
     * @param param the request object
     */
    public deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiDeleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CharacterItemCategory
     * @param param the request object
     */
    public deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiDeleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CharacterItemCategories
     * @param param the request object
     */
    public getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiGetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response>> {
        return this.api.getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CharacterItemCategories
     * @param param the request object
     */
    public getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiGetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response> {
        return this.api.getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CharacterItemCategory
     * @param param the request object
     */
    public getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiGetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItemCategory>> {
        return this.api.getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CharacterItemCategory
     * @param param the request object
     */
    public getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiGetOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<CharacterItemCategory> {
        return this.api.getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CharacterItemCategory
     * @param param the request object
     */
    public replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiReplaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItemCategory>> {
        return this.api.replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.id, param.characterItemCategory,  options).toPromise();
    }

    /**
     * Replace a single CharacterItemCategory
     * @param param the request object
     */
    public replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiReplaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<CharacterItemCategory> {
        return this.api.replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.id, param.characterItemCategory,  options).toPromise();
    }

    /**
     * Update a single CharacterItemCategory
     * @param param the request object
     */
    public updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param: ADMINCharacterItemCategoriesApiUpdateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItemCategory>> {
        return this.api.updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(param.id, param.characterItemCategory,  options).toPromise();
    }

    /**
     * Update a single CharacterItemCategory
     * @param param the request object
     */
    public updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param: ADMINCharacterItemCategoriesApiUpdateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryRequest, options?: ConfigurationOptions): Promise<CharacterItemCategory> {
        return this.api.updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(param.id, param.characterItemCategory,  options).toPromise();
    }

}

import { ObservableADMINCharacterItemsApi } from "./ObservableAPI";
import { ADMINCharacterItemsApiRequestFactory, ADMINCharacterItemsApiResponseProcessor} from "../apis/ADMINCharacterItemsApi";

export interface ADMINCharacterItemsApiCreateManyBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * @type CreateManyCharacterDto
     * @memberof ADMINCharacterItemsApicreateManyBaseCharacterAdminControllerCharacter
     */
    createManyCharacterDto: CreateManyCharacterDto
}

export interface ADMINCharacterItemsApiCreateManyBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * @type CreateManyCharacterItemDto
     * @memberof ADMINCharacterItemsApicreateManyBaseCharacterItemAdminControllerCharacterItem
     */
    createManyCharacterItemDto: CreateManyCharacterItemDto
}

export interface ADMINCharacterItemsApiCreateOneBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCharacterItemsApicreateOneBaseCharacterAdminControllerCharacter
     */
    body: any
}

export interface ADMINCharacterItemsApiCreateOneBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * @type CharacterItem
     * @memberof ADMINCharacterItemsApicreateOneBaseCharacterItemAdminControllerCharacterItem
     */
    characterItem: CharacterItem
}

export interface ADMINCharacterItemsApiDeleteOneBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApideleteOneBaseCharacterAdminControllerCharacter
     */
    id: number
}

export interface ADMINCharacterItemsApiDeleteOneBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApideleteOneBaseCharacterItemAdminControllerCharacterItem
     */
    id: number
}

export interface ADMINCharacterItemsApiGetManyBaseCharacterAdminControllerCharacterRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterAdminControllerCharacter
     */
    cache?: number
}

export interface ADMINCharacterItemsApiGetManyBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetManyBaseCharacterItemAdminControllerCharacterItem
     */
    cache?: number
}

export interface ADMINCharacterItemsApiGetOneBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterAdminControllerCharacter
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterAdminControllerCharacter
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterAdminControllerCharacter
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterAdminControllerCharacter
     */
    cache?: number
}

export interface ADMINCharacterItemsApiGetOneBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterItemAdminControllerCharacterItem
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterItemAdminControllerCharacterItem
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterItemAdminControllerCharacterItem
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApigetOneBaseCharacterItemAdminControllerCharacterItem
     */
    cache?: number
}

export interface ADMINCharacterItemsApiReplaceOneBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApireplaceOneBaseCharacterAdminControllerCharacter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCharacterItemsApireplaceOneBaseCharacterAdminControllerCharacter
     */
    body: any
}

export interface ADMINCharacterItemsApiReplaceOneBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApireplaceOneBaseCharacterItemAdminControllerCharacterItem
     */
    id: number
    /**
     * 
     * @type CharacterItem
     * @memberof ADMINCharacterItemsApireplaceOneBaseCharacterItemAdminControllerCharacterItem
     */
    characterItem: CharacterItem
}

export interface ADMINCharacterItemsApiUpdateOneBaseCharacterAdminControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApiupdateOneBaseCharacterAdminControllerCharacter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCharacterItemsApiupdateOneBaseCharacterAdminControllerCharacter
     */
    body: any
}

export interface ADMINCharacterItemsApiUpdateOneBaseCharacterItemAdminControllerCharacterItemRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCharacterItemsApiupdateOneBaseCharacterItemAdminControllerCharacterItem
     */
    id: number
    /**
     * 
     * @type CharacterItem
     * @memberof ADMINCharacterItemsApiupdateOneBaseCharacterItemAdminControllerCharacterItem
     */
    characterItem: CharacterItem
}

export class ObjectADMINCharacterItemsApi {
    private api: ObservableADMINCharacterItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCharacterItemsApiRequestFactory, responseProcessor?: ADMINCharacterItemsApiResponseProcessor) {
        this.api = new ObservableADMINCharacterItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Characters
     * @param param the request object
     */
    public createManyBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiCreateManyBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCharacterAdminControllerCharacterWithHttpInfo(param.createManyCharacterDto,  options).toPromise();
    }

    /**
     * Create multiple Characters
     * @param param the request object
     */
    public createManyBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiCreateManyBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCharacterAdminControllerCharacter(param.createManyCharacterDto,  options).toPromise();
    }

    /**
     * Create multiple CharacterItems
     * @param param the request object
     */
    public createManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiCreateManyBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<CharacterItem>>> {
        return this.api.createManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.createManyCharacterItemDto,  options).toPromise();
    }

    /**
     * Create multiple CharacterItems
     * @param param the request object
     */
    public createManyBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiCreateManyBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<Array<CharacterItem>> {
        return this.api.createManyBaseCharacterItemAdminControllerCharacterItem(param.createManyCharacterItemDto,  options).toPromise();
    }

    /**
     * Create a single Character
     * @param param the request object
     */
    public createOneBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiCreateOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCharacterAdminControllerCharacterWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Character
     * @param param the request object
     */
    public createOneBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiCreateOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCharacterAdminControllerCharacter(param.body,  options).toPromise();
    }

    /**
     * Create a single CharacterItem
     * @param param the request object
     */
    public createOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiCreateOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItem>> {
        return this.api.createOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.characterItem,  options).toPromise();
    }

    /**
     * Create a single CharacterItem
     * @param param the request object
     */
    public createOneBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiCreateOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<CharacterItem> {
        return this.api.createOneBaseCharacterItemAdminControllerCharacterItem(param.characterItem,  options).toPromise();
    }

    /**
     * Delete a single Character
     * @param param the request object
     */
    public deleteOneBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiDeleteOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCharacterAdminControllerCharacterWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Character
     * @param param the request object
     */
    public deleteOneBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiDeleteOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCharacterAdminControllerCharacter(param.id,  options).toPromise();
    }

    /**
     * Delete a single CharacterItem
     * @param param the request object
     */
    public deleteOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiDeleteOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CharacterItem
     * @param param the request object
     */
    public deleteOneBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiDeleteOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCharacterItemAdminControllerCharacterItem(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Characters
     * @param param the request object
     */
    public getManyBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiGetManyBaseCharacterAdminControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCharacterAdminControllerCharacter200Response>> {
        return this.api.getManyBaseCharacterAdminControllerCharacterWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Characters
     * @param param the request object
     */
    public getManyBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiGetManyBaseCharacterAdminControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCharacterAdminControllerCharacter200Response> {
        return this.api.getManyBaseCharacterAdminControllerCharacter(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CharacterItems
     * @param param the request object
     */
    public getManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiGetManyBaseCharacterItemAdminControllerCharacterItemRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCharacterItemAdminControllerCharacterItem200Response>> {
        return this.api.getManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CharacterItems
     * @param param the request object
     */
    public getManyBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiGetManyBaseCharacterItemAdminControllerCharacterItemRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCharacterItemAdminControllerCharacterItem200Response> {
        return this.api.getManyBaseCharacterItemAdminControllerCharacterItem(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Character
     * @param param the request object
     */
    public getOneBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiGetOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCharacterAdminControllerCharacterWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Character
     * @param param the request object
     */
    public getOneBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiGetOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCharacterAdminControllerCharacter(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CharacterItem
     * @param param the request object
     */
    public getOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiGetOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItem>> {
        return this.api.getOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CharacterItem
     * @param param the request object
     */
    public getOneBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiGetOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<CharacterItem> {
        return this.api.getOneBaseCharacterItemAdminControllerCharacterItem(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Character
     * @param param the request object
     */
    public replaceOneBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiReplaceOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCharacterAdminControllerCharacterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Character
     * @param param the request object
     */
    public replaceOneBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiReplaceOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCharacterAdminControllerCharacter(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CharacterItem
     * @param param the request object
     */
    public replaceOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiReplaceOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItem>> {
        return this.api.replaceOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.id, param.characterItem,  options).toPromise();
    }

    /**
     * Replace a single CharacterItem
     * @param param the request object
     */
    public replaceOneBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiReplaceOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<CharacterItem> {
        return this.api.replaceOneBaseCharacterItemAdminControllerCharacterItem(param.id, param.characterItem,  options).toPromise();
    }

    /**
     * Update a single Character
     * @param param the request object
     */
    public updateOneBaseCharacterAdminControllerCharacterWithHttpInfo(param: ADMINCharacterItemsApiUpdateOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCharacterAdminControllerCharacterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Character
     * @param param the request object
     */
    public updateOneBaseCharacterAdminControllerCharacter(param: ADMINCharacterItemsApiUpdateOneBaseCharacterAdminControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCharacterAdminControllerCharacter(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CharacterItem
     * @param param the request object
     */
    public updateOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param: ADMINCharacterItemsApiUpdateOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItem>> {
        return this.api.updateOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(param.id, param.characterItem,  options).toPromise();
    }

    /**
     * Update a single CharacterItem
     * @param param the request object
     */
    public updateOneBaseCharacterItemAdminControllerCharacterItem(param: ADMINCharacterItemsApiUpdateOneBaseCharacterItemAdminControllerCharacterItemRequest, options?: ConfigurationOptions): Promise<CharacterItem> {
        return this.api.updateOneBaseCharacterItemAdminControllerCharacterItem(param.id, param.characterItem,  options).toPromise();
    }

}

import { ObservableADMINChatItemsApi } from "./ObservableAPI";
import { ADMINChatItemsApiRequestFactory, ADMINChatItemsApiResponseProcessor} from "../apis/ADMINChatItemsApi";

export interface ADMINChatItemsApiCreateManyBaseChatAdminControllerChatRequest {
    /**
     * 
     * @type CreateManyChatDto
     * @memberof ADMINChatItemsApicreateManyBaseChatAdminControllerChat
     */
    createManyChatDto: CreateManyChatDto
}

export interface ADMINChatItemsApiCreateOneBaseChatAdminControllerChatRequest {
    /**
     * 
     * @type any
     * @memberof ADMINChatItemsApicreateOneBaseChatAdminControllerChat
     */
    body: any
}

export interface ADMINChatItemsApiDeleteOneBaseChatAdminControllerChatRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApideleteOneBaseChatAdminControllerChat
     */
    id: number
}

export interface ADMINChatItemsApiGetManyBaseChatAdminControllerChatRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetManyBaseChatAdminControllerChat
     */
    cache?: number
}

export interface ADMINChatItemsApiGetOneBaseChatAdminControllerChatRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetOneBaseChatAdminControllerChat
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetOneBaseChatAdminControllerChat
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatItemsApigetOneBaseChatAdminControllerChat
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApigetOneBaseChatAdminControllerChat
     */
    cache?: number
}

export interface ADMINChatItemsApiReplaceOneBaseChatAdminControllerChatRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApireplaceOneBaseChatAdminControllerChat
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatItemsApireplaceOneBaseChatAdminControllerChat
     */
    body: any
}

export interface ADMINChatItemsApiUpdateOneBaseChatAdminControllerChatRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatItemsApiupdateOneBaseChatAdminControllerChat
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatItemsApiupdateOneBaseChatAdminControllerChat
     */
    body: any
}

export class ObjectADMINChatItemsApi {
    private api: ObservableADMINChatItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINChatItemsApiRequestFactory, responseProcessor?: ADMINChatItemsApiResponseProcessor) {
        this.api = new ObservableADMINChatItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Chats
     * @param param the request object
     */
    public createManyBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiCreateManyBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseChatAdminControllerChatWithHttpInfo(param.createManyChatDto,  options).toPromise();
    }

    /**
     * Create multiple Chats
     * @param param the request object
     */
    public createManyBaseChatAdminControllerChat(param: ADMINChatItemsApiCreateManyBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseChatAdminControllerChat(param.createManyChatDto,  options).toPromise();
    }

    /**
     * Create a single Chat
     * @param param the request object
     */
    public createOneBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiCreateOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseChatAdminControllerChatWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Chat
     * @param param the request object
     */
    public createOneBaseChatAdminControllerChat(param: ADMINChatItemsApiCreateOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseChatAdminControllerChat(param.body,  options).toPromise();
    }

    /**
     * Delete a single Chat
     * @param param the request object
     */
    public deleteOneBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiDeleteOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseChatAdminControllerChatWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Chat
     * @param param the request object
     */
    public deleteOneBaseChatAdminControllerChat(param: ADMINChatItemsApiDeleteOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseChatAdminControllerChat(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Chats
     * @param param the request object
     */
    public getManyBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiGetManyBaseChatAdminControllerChatRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseChatAdminControllerChat200Response>> {
        return this.api.getManyBaseChatAdminControllerChatWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Chats
     * @param param the request object
     */
    public getManyBaseChatAdminControllerChat(param: ADMINChatItemsApiGetManyBaseChatAdminControllerChatRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseChatAdminControllerChat200Response> {
        return this.api.getManyBaseChatAdminControllerChat(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Chat
     * @param param the request object
     */
    public getOneBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiGetOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseChatAdminControllerChatWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Chat
     * @param param the request object
     */
    public getOneBaseChatAdminControllerChat(param: ADMINChatItemsApiGetOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseChatAdminControllerChat(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Chat
     * @param param the request object
     */
    public replaceOneBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiReplaceOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseChatAdminControllerChatWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Chat
     * @param param the request object
     */
    public replaceOneBaseChatAdminControllerChat(param: ADMINChatItemsApiReplaceOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseChatAdminControllerChat(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Chat
     * @param param the request object
     */
    public updateOneBaseChatAdminControllerChatWithHttpInfo(param: ADMINChatItemsApiUpdateOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseChatAdminControllerChatWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Chat
     * @param param the request object
     */
    public updateOneBaseChatAdminControllerChat(param: ADMINChatItemsApiUpdateOneBaseChatAdminControllerChatRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseChatAdminControllerChat(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINChatMessagesApi } from "./ObservableAPI";
import { ADMINChatMessagesApiRequestFactory, ADMINChatMessagesApiResponseProcessor} from "../apis/ADMINChatMessagesApi";

export interface ADMINChatMessagesApiCreateManyBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * @type CreateManyChatMessageDto
     * @memberof ADMINChatMessagesApicreateManyBaseChatMessageAdminControllerChatMessage
     */
    createManyChatMessageDto: CreateManyChatMessageDto
}

export interface ADMINChatMessagesApiCreateManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * @type CreateManyChatMessageUrlDto
     * @memberof ADMINChatMessagesApicreateManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    createManyChatMessageUrlDto: CreateManyChatMessageUrlDto
}

export interface ADMINChatMessagesApiCreateOneBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApicreateOneBaseChatMessageAdminControllerChatMessage
     */
    body: any
}

export interface ADMINChatMessagesApiCreateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApicreateOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    body: any
}

export interface ADMINChatMessagesApiDeleteOneBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApideleteOneBaseChatMessageAdminControllerChatMessage
     */
    id: number
}

export interface ADMINChatMessagesApiDeleteOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApideleteOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    id: number
}

export interface ADMINChatMessagesApiGetManyBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageAdminControllerChatMessage
     */
    cache?: number
}

export interface ADMINChatMessagesApiGetManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetManyBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    cache?: number
}

export interface ADMINChatMessagesApiGetOneBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageAdminControllerChatMessage
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageAdminControllerChatMessage
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageAdminControllerChatMessage
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageAdminControllerChatMessage
     */
    cache?: number
}

export interface ADMINChatMessagesApiGetOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApigetOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    cache?: number
}

export interface ADMINChatMessagesApiReplaceOneBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApireplaceOneBaseChatMessageAdminControllerChatMessage
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApireplaceOneBaseChatMessageAdminControllerChatMessage
     */
    body: any
}

export interface ADMINChatMessagesApiReplaceOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApireplaceOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApireplaceOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    body: any
}

export interface ADMINChatMessagesApiUpdateOneBaseChatMessageAdminControllerChatMessageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApiupdateOneBaseChatMessageAdminControllerChatMessage
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApiupdateOneBaseChatMessageAdminControllerChatMessage
     */
    body: any
}

export interface ADMINChatMessagesApiUpdateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINChatMessagesApiupdateOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINChatMessagesApiupdateOneBaseChatMessageUrlAdminControllerChatMessageUrl
     */
    body: any
}

export class ObjectADMINChatMessagesApi {
    private api: ObservableADMINChatMessagesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINChatMessagesApiRequestFactory, responseProcessor?: ADMINChatMessagesApiResponseProcessor) {
        this.api = new ObservableADMINChatMessagesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ChatMessages
     * @param param the request object
     */
    public createManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiCreateManyBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.createManyChatMessageDto,  options).toPromise();
    }

    /**
     * Create multiple ChatMessages
     * @param param the request object
     */
    public createManyBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiCreateManyBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseChatMessageAdminControllerChatMessage(param.createManyChatMessageDto,  options).toPromise();
    }

    /**
     * Create multiple ChatMessageUrls
     * @param param the request object
     */
    public createManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiCreateManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.createManyChatMessageUrlDto,  options).toPromise();
    }

    /**
     * Create multiple ChatMessageUrls
     * @param param the request object
     */
    public createManyBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiCreateManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseChatMessageUrlAdminControllerChatMessageUrl(param.createManyChatMessageUrlDto,  options).toPromise();
    }

    /**
     * Create a single ChatMessage
     * @param param the request object
     */
    public createOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiCreateOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single ChatMessage
     * @param param the request object
     */
    public createOneBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiCreateOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseChatMessageAdminControllerChatMessage(param.body,  options).toPromise();
    }

    /**
     * Create a single ChatMessageUrl
     * @param param the request object
     */
    public createOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiCreateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single ChatMessageUrl
     * @param param the request object
     */
    public createOneBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiCreateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseChatMessageUrlAdminControllerChatMessageUrl(param.body,  options).toPromise();
    }

    /**
     * Delete a single ChatMessage
     * @param param the request object
     */
    public deleteOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiDeleteOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ChatMessage
     * @param param the request object
     */
    public deleteOneBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiDeleteOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseChatMessageAdminControllerChatMessage(param.id,  options).toPromise();
    }

    /**
     * Delete a single ChatMessageUrl
     * @param param the request object
     */
    public deleteOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiDeleteOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ChatMessageUrl
     * @param param the request object
     */
    public deleteOneBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiDeleteOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseChatMessageUrlAdminControllerChatMessageUrl(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessages
     * @param param the request object
     */
    public getManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiGetManyBaseChatMessageAdminControllerChatMessageRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseChatMessageAdminControllerChatMessage200Response>> {
        return this.api.getManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessages
     * @param param the request object
     */
    public getManyBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiGetManyBaseChatMessageAdminControllerChatMessageRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseChatMessageAdminControllerChatMessage200Response> {
        return this.api.getManyBaseChatMessageAdminControllerChatMessage(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param param the request object
     */
    public getManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiGetManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>> {
        return this.api.getManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param param the request object
     */
    public getManyBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiGetManyBaseChatMessageUrlAdminControllerChatMessageUrlRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response> {
        return this.api.getManyBaseChatMessageUrlAdminControllerChatMessageUrl(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessage
     * @param param the request object
     */
    public getOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiGetOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessage
     * @param param the request object
     */
    public getOneBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiGetOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseChatMessageAdminControllerChatMessage(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param param the request object
     */
    public getOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiGetOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param param the request object
     */
    public getOneBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiGetOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseChatMessageUrlAdminControllerChatMessageUrl(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ChatMessage
     * @param param the request object
     */
    public replaceOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiReplaceOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single ChatMessage
     * @param param the request object
     */
    public replaceOneBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiReplaceOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseChatMessageAdminControllerChatMessage(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single ChatMessageUrl
     * @param param the request object
     */
    public replaceOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiReplaceOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single ChatMessageUrl
     * @param param the request object
     */
    public replaceOneBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiReplaceOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseChatMessageUrlAdminControllerChatMessageUrl(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessage
     * @param param the request object
     */
    public updateOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param: ADMINChatMessagesApiUpdateOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessage
     * @param param the request object
     */
    public updateOneBaseChatMessageAdminControllerChatMessage(param: ADMINChatMessagesApiUpdateOneBaseChatMessageAdminControllerChatMessageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseChatMessageAdminControllerChatMessage(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessageUrl
     * @param param the request object
     */
    public updateOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param: ADMINChatMessagesApiUpdateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessageUrl
     * @param param the request object
     */
    public updateOneBaseChatMessageUrlAdminControllerChatMessageUrl(param: ADMINChatMessagesApiUpdateOneBaseChatMessageUrlAdminControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseChatMessageUrlAdminControllerChatMessageUrl(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCommunityItemsApi } from "./ObservableAPI";
import { ADMINCommunityItemsApiRequestFactory, ADMINCommunityItemsApiResponseProcessor} from "../apis/ADMINCommunityItemsApi";

export interface ADMINCommunityItemsApiCreateManyBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * @type CreateManyCommunityDto
     * @memberof ADMINCommunityItemsApicreateManyBaseCommunityAdminControllerCommunity
     */
    createManyCommunityDto: CreateManyCommunityDto
}

export interface ADMINCommunityItemsApiCreateOneBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCommunityItemsApicreateOneBaseCommunityAdminControllerCommunity
     */
    body: any
}

export interface ADMINCommunityItemsApiDeleteOneBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApideleteOneBaseCommunityAdminControllerCommunity
     */
    id: number
}

export interface ADMINCommunityItemsApiGetManyBaseCommunityAdminControllerCommunityRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetManyBaseCommunityAdminControllerCommunity
     */
    cache?: number
}

export interface ADMINCommunityItemsApiGetOneBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetOneBaseCommunityAdminControllerCommunity
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetOneBaseCommunityAdminControllerCommunity
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCommunityItemsApigetOneBaseCommunityAdminControllerCommunity
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApigetOneBaseCommunityAdminControllerCommunity
     */
    cache?: number
}

export interface ADMINCommunityItemsApiReplaceOneBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApireplaceOneBaseCommunityAdminControllerCommunity
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCommunityItemsApireplaceOneBaseCommunityAdminControllerCommunity
     */
    body: any
}

export interface ADMINCommunityItemsApiUpdateOneBaseCommunityAdminControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCommunityItemsApiupdateOneBaseCommunityAdminControllerCommunity
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCommunityItemsApiupdateOneBaseCommunityAdminControllerCommunity
     */
    body: any
}

export class ObjectADMINCommunityItemsApi {
    private api: ObservableADMINCommunityItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCommunityItemsApiRequestFactory, responseProcessor?: ADMINCommunityItemsApiResponseProcessor) {
        this.api = new ObservableADMINCommunityItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Communities
     * @param param the request object
     */
    public createManyBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiCreateManyBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCommunityAdminControllerCommunityWithHttpInfo(param.createManyCommunityDto,  options).toPromise();
    }

    /**
     * Create multiple Communities
     * @param param the request object
     */
    public createManyBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiCreateManyBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCommunityAdminControllerCommunity(param.createManyCommunityDto,  options).toPromise();
    }

    /**
     * Create a single Community
     * @param param the request object
     */
    public createOneBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiCreateOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCommunityAdminControllerCommunityWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Community
     * @param param the request object
     */
    public createOneBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiCreateOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCommunityAdminControllerCommunity(param.body,  options).toPromise();
    }

    /**
     * Delete a single Community
     * @param param the request object
     */
    public deleteOneBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiDeleteOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCommunityAdminControllerCommunityWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Community
     * @param param the request object
     */
    public deleteOneBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiDeleteOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCommunityAdminControllerCommunity(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Communities
     * @param param the request object
     */
    public getManyBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiGetManyBaseCommunityAdminControllerCommunityRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCommunityAdminControllerCommunity200Response>> {
        return this.api.getManyBaseCommunityAdminControllerCommunityWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Communities
     * @param param the request object
     */
    public getManyBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiGetManyBaseCommunityAdminControllerCommunityRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCommunityAdminControllerCommunity200Response> {
        return this.api.getManyBaseCommunityAdminControllerCommunity(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Community
     * @param param the request object
     */
    public getOneBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiGetOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCommunityAdminControllerCommunityWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Community
     * @param param the request object
     */
    public getOneBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiGetOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCommunityAdminControllerCommunity(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Community
     * @param param the request object
     */
    public replaceOneBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiReplaceOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCommunityAdminControllerCommunityWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Community
     * @param param the request object
     */
    public replaceOneBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiReplaceOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCommunityAdminControllerCommunity(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Community
     * @param param the request object
     */
    public updateOneBaseCommunityAdminControllerCommunityWithHttpInfo(param: ADMINCommunityItemsApiUpdateOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCommunityAdminControllerCommunityWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Community
     * @param param the request object
     */
    public updateOneBaseCommunityAdminControllerCommunity(param: ADMINCommunityItemsApiUpdateOneBaseCommunityAdminControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCommunityAdminControllerCommunity(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseAuthorsApi } from "./ObservableAPI";
import { ADMINCourseAuthorsApiRequestFactory, ADMINCourseAuthorsApiResponseProcessor} from "../apis/ADMINCourseAuthorsApi";

export interface ADMINCourseAuthorsApiCreateOneBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseAuthorsApicreateOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    body: any
}

export interface ADMINCourseAuthorsApiDeleteOneBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApideleteOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    id: number
}

export interface ADMINCourseAuthorsApiGetManyBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetManyBaseCourseAuthorAdminControllerCourseAuthor
     */
    cache?: number
}

export interface ADMINCourseAuthorsApiGetOneBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseAuthorsApigetOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApigetOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    cache?: number
}

export interface ADMINCourseAuthorsApiReplaceOneBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApireplaceOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseAuthorsApireplaceOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    body: any
}

export interface ADMINCourseAuthorsApiUpdateOneBaseCourseAuthorAdminControllerCourseAuthorRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseAuthorsApiupdateOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseAuthorsApiupdateOneBaseCourseAuthorAdminControllerCourseAuthor
     */
    body: any
}

export class ObjectADMINCourseAuthorsApi {
    private api: ObservableADMINCourseAuthorsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseAuthorsApiRequestFactory, responseProcessor?: ADMINCourseAuthorsApiResponseProcessor) {
        this.api = new ObservableADMINCourseAuthorsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseAuthor
     * @param param the request object
     */
    public createOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiCreateOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseAuthor
     * @param param the request object
     */
    public createOneBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiCreateOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseAuthorAdminControllerCourseAuthor(param.body,  options).toPromise();
    }

    /**
     * Delete a single CourseAuthor
     * @param param the request object
     */
    public deleteOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiDeleteOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CourseAuthor
     * @param param the request object
     */
    public deleteOneBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiDeleteOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseAuthorAdminControllerCourseAuthor(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseAuthors
     * @param param the request object
     */
    public getManyBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiGetManyBaseCourseAuthorAdminControllerCourseAuthorRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response>> {
        return this.api.getManyBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseAuthors
     * @param param the request object
     */
    public getManyBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiGetManyBaseCourseAuthorAdminControllerCourseAuthorRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response> {
        return this.api.getManyBaseCourseAuthorAdminControllerCourseAuthor(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseAuthor
     * @param param the request object
     */
    public getOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiGetOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseAuthor
     * @param param the request object
     */
    public getOneBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiGetOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseAuthorAdminControllerCourseAuthor(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CourseAuthor
     * @param param the request object
     */
    public replaceOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiReplaceOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CourseAuthor
     * @param param the request object
     */
    public replaceOneBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiReplaceOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseAuthorAdminControllerCourseAuthor(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseAuthor
     * @param param the request object
     */
    public updateOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param: ADMINCourseAuthorsApiUpdateOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseAuthor
     * @param param the request object
     */
    public updateOneBaseCourseAuthorAdminControllerCourseAuthor(param: ADMINCourseAuthorsApiUpdateOneBaseCourseAuthorAdminControllerCourseAuthorRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseAuthorAdminControllerCourseAuthor(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseBlockApi } from "./ObservableAPI";
import { ADMINCourseBlockApiRequestFactory, ADMINCourseBlockApiResponseProcessor} from "../apis/ADMINCourseBlockApi";

export interface ADMINCourseBlockApiCreateOneBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockApicreateOneBaseCourseBlockAdminControllerCourseBlock
     */
    body: any
}

export interface ADMINCourseBlockApiDeleteOneBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApideleteOneBaseCourseBlockAdminControllerCourseBlock
     */
    id: number
}

export interface ADMINCourseBlockApiGetManyBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetManyBaseCourseBlockAdminControllerCourseBlock
     */
    cache?: number
}

export interface ADMINCourseBlockApiGetOneBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetOneBaseCourseBlockAdminControllerCourseBlock
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetOneBaseCourseBlockAdminControllerCourseBlock
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockApigetOneBaseCourseBlockAdminControllerCourseBlock
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApigetOneBaseCourseBlockAdminControllerCourseBlock
     */
    cache?: number
}

export interface ADMINCourseBlockApiReplaceOneBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApireplaceOneBaseCourseBlockAdminControllerCourseBlock
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockApireplaceOneBaseCourseBlockAdminControllerCourseBlock
     */
    body: any
}

export interface ADMINCourseBlockApiUpdateOneBaseCourseBlockAdminControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockApiupdateOneBaseCourseBlockAdminControllerCourseBlock
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockApiupdateOneBaseCourseBlockAdminControllerCourseBlock
     */
    body: any
}

export class ObjectADMINCourseBlockApi {
    private api: ObservableADMINCourseBlockApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseBlockApiRequestFactory, responseProcessor?: ADMINCourseBlockApiResponseProcessor) {
        this.api = new ObservableADMINCourseBlockApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseBlock
     * @param param the request object
     */
    public createOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiCreateOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseBlock
     * @param param the request object
     */
    public createOneBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiCreateOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseBlockAdminControllerCourseBlock(param.body,  options).toPromise();
    }

    /**
     * Delete a single CourseBlock
     * @param param the request object
     */
    public deleteOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiDeleteOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CourseBlock
     * @param param the request object
     */
    public deleteOneBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiDeleteOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseBlockAdminControllerCourseBlock(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param param the request object
     */
    public getManyBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiGetManyBaseCourseBlockAdminControllerCourseBlockRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCourseBlockAdminControllerCourseBlock200Response>> {
        return this.api.getManyBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param param the request object
     */
    public getManyBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiGetManyBaseCourseBlockAdminControllerCourseBlockRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCourseBlockAdminControllerCourseBlock200Response> {
        return this.api.getManyBaseCourseBlockAdminControllerCourseBlock(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlock
     * @param param the request object
     */
    public getOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiGetOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlock
     * @param param the request object
     */
    public getOneBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiGetOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockAdminControllerCourseBlock(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CourseBlock
     * @param param the request object
     */
    public replaceOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiReplaceOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CourseBlock
     * @param param the request object
     */
    public replaceOneBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiReplaceOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseBlockAdminControllerCourseBlock(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlock
     * @param param the request object
     */
    public updateOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param: ADMINCourseBlockApiUpdateOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlock
     * @param param the request object
     */
    public updateOneBaseCourseBlockAdminControllerCourseBlock(param: ADMINCourseBlockApiUpdateOneBaseCourseBlockAdminControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseBlockAdminControllerCourseBlock(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseBlockStepApi } from "./ObservableAPI";
import { ADMINCourseBlockStepApiRequestFactory, ADMINCourseBlockStepApiResponseProcessor} from "../apis/ADMINCourseBlockStepApi";

export interface ADMINCourseBlockStepApiCreateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepApicreateOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    body: any
}

export interface ADMINCourseBlockStepApiDeleteOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApideleteOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    id: number
}

export interface ADMINCourseBlockStepApiGetManyBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetManyBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    cache?: number
}

export interface ADMINCourseBlockStepApiGetOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepApigetOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApigetOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    cache?: number
}

export interface ADMINCourseBlockStepApiReplaceOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApireplaceOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepApireplaceOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    body: any
}

export interface ADMINCourseBlockStepApiUpdateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepApiupdateOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepApiupdateOneBaseCourseBlockStepAdminControllerCourseBlockStep
     */
    body: any
}

export class ObjectADMINCourseBlockStepApi {
    private api: ObservableADMINCourseBlockStepApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseBlockStepApiRequestFactory, responseProcessor?: ADMINCourseBlockStepApiResponseProcessor) {
        this.api = new ObservableADMINCourseBlockStepApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseBlockStep
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiCreateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseBlockStep
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiCreateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseBlockStepAdminControllerCourseBlockStep(param.body,  options).toPromise();
    }

    /**
     * Delete a single CourseBlockStep
     * @param param the request object
     */
    public deleteOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiDeleteOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CourseBlockStep
     * @param param the request object
     */
    public deleteOneBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiDeleteOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseBlockStepAdminControllerCourseBlockStep(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiGetManyBaseCourseBlockStepAdminControllerCourseBlockStepRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response>> {
        return this.api.getManyBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiGetManyBaseCourseBlockStepAdminControllerCourseBlockStepRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response> {
        return this.api.getManyBaseCourseBlockStepAdminControllerCourseBlockStep(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiGetOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiGetOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockStepAdminControllerCourseBlockStep(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CourseBlockStep
     * @param param the request object
     */
    public replaceOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiReplaceOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CourseBlockStep
     * @param param the request object
     */
    public replaceOneBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiReplaceOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseBlockStepAdminControllerCourseBlockStep(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStep
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param: ADMINCourseBlockStepApiUpdateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStep
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAdminControllerCourseBlockStep(param: ADMINCourseBlockStepApiUpdateOneBaseCourseBlockStepAdminControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseBlockStepAdminControllerCourseBlockStep(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseBlockStepAnswerApi } from "./ObservableAPI";
import { ADMINCourseBlockStepAnswerApiRequestFactory, ADMINCourseBlockStepAnswerApiResponseProcessor} from "../apis/ADMINCourseBlockStepAnswerApi";

export interface ADMINCourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepAnswerApicreateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    body: any
}

export interface ADMINCourseBlockStepAnswerApiDeleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApideleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    id: number
}

export interface ADMINCourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    cache?: number
}

export interface ADMINCourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    cache?: number
}

export interface ADMINCourseBlockStepAnswerApiReplaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApireplaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepAnswerApireplaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    body: any
}

export interface ADMINCourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseBlockStepAnswerApiupdateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseBlockStepAnswerApiupdateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer
     */
    body: any
}

export class ObjectADMINCourseBlockStepAnswerApi {
    private api: ObservableADMINCourseBlockStepAnswerApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseBlockStepAnswerApiRequestFactory, responseProcessor?: ADMINCourseBlockStepAnswerApiResponseProcessor) {
        this.api = new ObservableADMINCourseBlockStepAnswerApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.body,  options).toPromise();
    }

    /**
     * Delete a single CourseBlockStepAnswer
     * @param param the request object
     */
    public deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiDeleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CourseBlockStepAnswer
     * @param param the request object
     */
    public deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiDeleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response>> {
        return this.api.getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response> {
        return this.api.getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CourseBlockStepAnswer
     * @param param the request object
     */
    public replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiReplaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CourseBlockStepAnswer
     * @param param the request object
     */
    public replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiReplaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param: ADMINCourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param: ADMINCourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseCategoriesApi } from "./ObservableAPI";
import { ADMINCourseCategoriesApiRequestFactory, ADMINCourseCategoriesApiResponseProcessor} from "../apis/ADMINCourseCategoriesApi";

export interface ADMINCourseCategoriesApiCreateManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type CreateManyArticleCategoryDto
     * @memberof ADMINCourseCategoriesApicreateManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    createManyArticleCategoryDto: CreateManyArticleCategoryDto
}

export interface ADMINCourseCategoriesApiCreateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCategoriesApicreateOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINCourseCategoriesApiDeleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApideleteOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    id: number
}

export interface ADMINCourseCategoriesApiGetManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetManyBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINCourseCategoriesApiGetOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCategoriesApigetOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApigetOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINCourseCategoriesApiReplaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApireplaceOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCategoriesApireplaceOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINCourseCategoriesApiUpdateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCategoriesApiupdateOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCategoriesApiupdateOneBaseArticleCategoryCourseAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export class ObjectADMINCourseCategoriesApi {
    private api: ObservableADMINCourseCategoriesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseCategoriesApiRequestFactory, responseProcessor?: ADMINCourseCategoriesApiResponseProcessor) {
        this.api = new ObservableADMINCourseCategoriesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiCreateManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ArticleCategory>>> {
        return this.api.createManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiCreateManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<Array<ArticleCategory>> {
        return this.api.createManyBaseArticleCategoryCourseAdminControllerArticleCategory(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiCreateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.createOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.articleCategory,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiCreateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.createOneBaseArticleCategoryCourseAdminControllerArticleCategory(param.articleCategory,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiDeleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiDeleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleCategoryCourseAdminControllerArticleCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiGetManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        return this.api.getManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiGetManyBaseArticleCategoryCourseAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.api.getManyBaseArticleCategoryCourseAdminControllerArticleCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiGetOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.getOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiGetOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.getOneBaseArticleCategoryCourseAdminControllerArticleCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiReplaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.replaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiReplaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.replaceOneBaseArticleCategoryCourseAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCategoriesApiUpdateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.updateOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryCourseAdminControllerArticleCategory(param: ADMINCourseCategoriesApiUpdateOneBaseArticleCategoryCourseAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.updateOneBaseArticleCategoryCourseAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

}

import { ObservableADMINCourseCompilationCategoriesApi } from "./ObservableAPI";
import { ADMINCourseCompilationCategoriesApiRequestFactory, ADMINCourseCompilationCategoriesApiResponseProcessor} from "../apis/ADMINCourseCompilationCategoriesApi";

export interface ADMINCourseCompilationCategoriesApiCreateManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type CreateManyArticleCategoryDto
     * @memberof ADMINCourseCompilationCategoriesApicreateManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    createManyArticleCategoryDto: CreateManyArticleCategoryDto
}

export interface ADMINCourseCompilationCategoriesApiCreateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCompilationCategoriesApicreateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINCourseCompilationCategoriesApiDeleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApideleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    id: number
}

export interface ADMINCourseCompilationCategoriesApiGetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINCourseCompilationCategoriesApiGetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseCompilationCategoriesApigetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApigetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    cache?: number
}

export interface ADMINCourseCompilationCategoriesApiReplaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApireplaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCompilationCategoriesApireplaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export interface ADMINCourseCompilationCategoriesApiUpdateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseCompilationCategoriesApiupdateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    id: number
    /**
     * 
     * @type ArticleCategory
     * @memberof ADMINCourseCompilationCategoriesApiupdateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory
     */
    articleCategory: ArticleCategory
}

export class ObjectADMINCourseCompilationCategoriesApi {
    private api: ObservableADMINCourseCompilationCategoriesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseCompilationCategoriesApiRequestFactory, responseProcessor?: ADMINCourseCompilationCategoriesApiResponseProcessor) {
        this.api = new ObservableADMINCourseCompilationCategoriesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiCreateManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ArticleCategory>>> {
        return this.api.createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ArticleCategories
     * @param param the request object
     */
    public createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiCreateManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<Array<ArticleCategory>> {
        return this.api.createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.createManyArticleCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiCreateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.articleCategory,  options).toPromise();
    }

    /**
     * Create a single ArticleCategory
     * @param param the request object
     */
    public createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiCreateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.articleCategory,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiDeleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ArticleCategory
     * @param param the request object
     */
    public deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiDeleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiGetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        return this.api.getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param param the request object
     */
    public getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiGetManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.api.getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiGetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ArticleCategory
     * @param param the request object
     */
    public getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiGetOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiReplaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Replace a single ArticleCategory
     * @param param the request object
     */
    public replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiReplaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param: ADMINCourseCompilationCategoriesApiUpdateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(param.id, param.articleCategory,  options).toPromise();
    }

    /**
     * Update a single ArticleCategory
     * @param param the request object
     */
    public updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param: ADMINCourseCompilationCategoriesApiUpdateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryRequest, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(param.id, param.articleCategory,  options).toPromise();
    }

}

import { ObservableADMINCourseItemsApi } from "./ObservableAPI";
import { ADMINCourseItemsApiRequestFactory, ADMINCourseItemsApiResponseProcessor} from "../apis/ADMINCourseItemsApi";

export interface ADMINCourseItemsApiCreateOneBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * @type Course
     * @memberof ADMINCourseItemsApicreateOneBaseCourseAdminControllerCourse
     */
    course: Course
}

export interface ADMINCourseItemsApiDeleteOneBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApideleteOneBaseCourseAdminControllerCourse
     */
    id: number
}

export interface ADMINCourseItemsApiGetManyBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetManyBaseCourseAdminControllerCourse
     */
    cache?: number
}

export interface ADMINCourseItemsApiGetOneBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseItemsApigetOneBaseCourseAdminControllerCourse
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetOneBaseCourseAdminControllerCourse
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetOneBaseCourseAdminControllerCourse
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseItemsApigetOneBaseCourseAdminControllerCourse
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApigetOneBaseCourseAdminControllerCourse
     */
    cache?: number
}

export interface ADMINCourseItemsApiReplaceOneBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApireplaceOneBaseCourseAdminControllerCourse
     */
    id: number
    /**
     * 
     * @type Course
     * @memberof ADMINCourseItemsApireplaceOneBaseCourseAdminControllerCourse
     */
    course: Course
}

export interface ADMINCourseItemsApiUpdateOneBaseCourseAdminControllerCourseRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseItemsApiupdateOneBaseCourseAdminControllerCourse
     */
    id: number
    /**
     * 
     * @type Course
     * @memberof ADMINCourseItemsApiupdateOneBaseCourseAdminControllerCourse
     */
    course: Course
}

export class ObjectADMINCourseItemsApi {
    private api: ObservableADMINCourseItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseItemsApiRequestFactory, responseProcessor?: ADMINCourseItemsApiResponseProcessor) {
        this.api = new ObservableADMINCourseItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Course
     * @param param the request object
     */
    public createOneBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiCreateOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<Course>> {
        return this.api.createOneBaseCourseAdminControllerCourseWithHttpInfo(param.course,  options).toPromise();
    }

    /**
     * Create a single Course
     * @param param the request object
     */
    public createOneBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiCreateOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<Course> {
        return this.api.createOneBaseCourseAdminControllerCourse(param.course,  options).toPromise();
    }

    /**
     * Delete a single Course
     * @param param the request object
     */
    public deleteOneBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiDeleteOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseAdminControllerCourseWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Course
     * @param param the request object
     */
    public deleteOneBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiDeleteOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseAdminControllerCourse(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Courses
     * @param param the request object
     */
    public getManyBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiGetManyBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCourseAdminControllerCourseWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Courses
     * @param param the request object
     */
    public getManyBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiGetManyBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCourseAdminControllerCourse(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Course
     * @param param the request object
     */
    public getOneBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiGetOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseAdminControllerCourseWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Course
     * @param param the request object
     */
    public getOneBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiGetOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseAdminControllerCourse(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Course
     * @param param the request object
     */
    public replaceOneBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiReplaceOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<Course>> {
        return this.api.replaceOneBaseCourseAdminControllerCourseWithHttpInfo(param.id, param.course,  options).toPromise();
    }

    /**
     * Replace a single Course
     * @param param the request object
     */
    public replaceOneBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiReplaceOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<Course> {
        return this.api.replaceOneBaseCourseAdminControllerCourse(param.id, param.course,  options).toPromise();
    }

    /**
     * Update a single Course
     * @param param the request object
     */
    public updateOneBaseCourseAdminControllerCourseWithHttpInfo(param: ADMINCourseItemsApiUpdateOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<HttpInfo<Course>> {
        return this.api.updateOneBaseCourseAdminControllerCourseWithHttpInfo(param.id, param.course,  options).toPromise();
    }

    /**
     * Update a single Course
     * @param param the request object
     */
    public updateOneBaseCourseAdminControllerCourse(param: ADMINCourseItemsApiUpdateOneBaseCourseAdminControllerCourseRequest, options?: ConfigurationOptions): Promise<Course> {
        return this.api.updateOneBaseCourseAdminControllerCourse(param.id, param.course,  options).toPromise();
    }

}

import { ObservableADMINCourseModulesApi } from "./ObservableAPI";
import { ADMINCourseModulesApiRequestFactory, ADMINCourseModulesApiResponseProcessor} from "../apis/ADMINCourseModulesApi";

export interface ADMINCourseModulesApiCreateOneBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseModulesApicreateOneBaseCourseModuleAdminControllerCourseModule
     */
    body: any
}

export interface ADMINCourseModulesApiDeleteOneBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApideleteOneBaseCourseModuleAdminControllerCourseModule
     */
    id: number
}

export interface ADMINCourseModulesApiGetManyBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetManyBaseCourseModuleAdminControllerCourseModule
     */
    cache?: number
}

export interface ADMINCourseModulesApiGetOneBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetOneBaseCourseModuleAdminControllerCourseModule
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetOneBaseCourseModuleAdminControllerCourseModule
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseModulesApigetOneBaseCourseModuleAdminControllerCourseModule
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApigetOneBaseCourseModuleAdminControllerCourseModule
     */
    cache?: number
}

export interface ADMINCourseModulesApiReplaceOneBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApireplaceOneBaseCourseModuleAdminControllerCourseModule
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseModulesApireplaceOneBaseCourseModuleAdminControllerCourseModule
     */
    body: any
}

export interface ADMINCourseModulesApiUpdateOneBaseCourseModuleAdminControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseModulesApiupdateOneBaseCourseModuleAdminControllerCourseModule
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseModulesApiupdateOneBaseCourseModuleAdminControllerCourseModule
     */
    body: any
}

export class ObjectADMINCourseModulesApi {
    private api: ObservableADMINCourseModulesApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseModulesApiRequestFactory, responseProcessor?: ADMINCourseModulesApiResponseProcessor) {
        this.api = new ObservableADMINCourseModulesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseModule
     * @param param the request object
     */
    public createOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiCreateOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseModule
     * @param param the request object
     */
    public createOneBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiCreateOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseModuleAdminControllerCourseModule(param.body,  options).toPromise();
    }

    /**
     * Delete a single CourseModule
     * @param param the request object
     */
    public deleteOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiDeleteOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CourseModule
     * @param param the request object
     */
    public deleteOneBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiDeleteOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseModuleAdminControllerCourseModule(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseModules
     * @param param the request object
     */
    public getManyBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiGetManyBaseCourseModuleAdminControllerCourseModuleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCourseModuleAdminControllerCourseModule200Response>> {
        return this.api.getManyBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseModules
     * @param param the request object
     */
    public getManyBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiGetManyBaseCourseModuleAdminControllerCourseModuleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCourseModuleAdminControllerCourseModule200Response> {
        return this.api.getManyBaseCourseModuleAdminControllerCourseModule(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseModule
     * @param param the request object
     */
    public getOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiGetOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseModule
     * @param param the request object
     */
    public getOneBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiGetOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseModuleAdminControllerCourseModule(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CourseModule
     * @param param the request object
     */
    public replaceOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiReplaceOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CourseModule
     * @param param the request object
     */
    public replaceOneBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiReplaceOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseModuleAdminControllerCourseModule(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseModule
     * @param param the request object
     */
    public updateOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param: ADMINCourseModulesApiUpdateOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseModule
     * @param param the request object
     */
    public updateOneBaseCourseModuleAdminControllerCourseModule(param: ADMINCourseModulesApiUpdateOneBaseCourseModuleAdminControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseModuleAdminControllerCourseModule(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCourseNewsApi } from "./ObservableAPI";
import { ADMINCourseNewsApiRequestFactory, ADMINCourseNewsApiResponseProcessor} from "../apis/ADMINCourseNewsApi";

export interface ADMINCourseNewsApiCreateOneBaseCourseNewsAdminControllerArticleRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCourseNewsApicreateOneBaseCourseNewsAdminControllerArticle
     */
    body: any
}

export interface ADMINCourseNewsApiDeleteOneBaseCourseNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApideleteOneBaseCourseNewsAdminControllerArticle
     */
    id: number
}

export interface ADMINCourseNewsApiGetManyBaseCourseNewsAdminControllerArticleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetManyBaseCourseNewsAdminControllerArticle
     */
    cache?: number
}

export interface ADMINCourseNewsApiGetOneBaseCourseNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetOneBaseCourseNewsAdminControllerArticle
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetOneBaseCourseNewsAdminControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCourseNewsApigetOneBaseCourseNewsAdminControllerArticle
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApigetOneBaseCourseNewsAdminControllerArticle
     */
    cache?: number
}

export interface ADMINCourseNewsApiReplaceOneBaseCourseNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApireplaceOneBaseCourseNewsAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseNewsApireplaceOneBaseCourseNewsAdminControllerArticle
     */
    body: any
}

export interface ADMINCourseNewsApiUpdateOneBaseCourseNewsAdminControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCourseNewsApiupdateOneBaseCourseNewsAdminControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCourseNewsApiupdateOneBaseCourseNewsAdminControllerArticle
     */
    body: any
}

export class ObjectADMINCourseNewsApi {
    private api: ObservableADMINCourseNewsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCourseNewsApiRequestFactory, responseProcessor?: ADMINCourseNewsApiResponseProcessor) {
        this.api = new ObservableADMINCourseNewsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiCreateOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiCreateOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseNewsAdminControllerArticle(param.body,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiDeleteOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiDeleteOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCourseNewsAdminControllerArticle(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiGetManyBaseCourseNewsAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        return this.api.getManyBaseCourseNewsAdminControllerArticleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiGetManyBaseCourseNewsAdminControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.api.getManyBaseCourseNewsAdminControllerArticle(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiGetOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiGetOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseNewsAdminControllerArticle(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiReplaceOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiReplaceOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCourseNewsAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param: ADMINCourseNewsApiUpdateOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseNewsAdminControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseCourseNewsAdminControllerArticle(param: ADMINCourseNewsApiUpdateOneBaseCourseNewsAdminControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseNewsAdminControllerArticle(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINCoverLetterItemsApi } from "./ObservableAPI";
import { ADMINCoverLetterItemsApiRequestFactory, ADMINCoverLetterItemsApiResponseProcessor} from "../apis/ADMINCoverLetterItemsApi";

export interface ADMINCoverLetterItemsApiCreateManyBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * @type CreateManyCoverLetterDto
     * @memberof ADMINCoverLetterItemsApicreateManyBaseCoverLetterAdminControllerCoverLetter
     */
    createManyCoverLetterDto: CreateManyCoverLetterDto
}

export interface ADMINCoverLetterItemsApiCreateOneBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * @type any
     * @memberof ADMINCoverLetterItemsApicreateOneBaseCoverLetterAdminControllerCoverLetter
     */
    body: any
}

export interface ADMINCoverLetterItemsApiDeleteOneBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApideleteOneBaseCoverLetterAdminControllerCoverLetter
     */
    id: number
}

export interface ADMINCoverLetterItemsApiGetManyBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetManyBaseCoverLetterAdminControllerCoverLetter
     */
    cache?: number
}

export interface ADMINCoverLetterItemsApiGetOneBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetOneBaseCoverLetterAdminControllerCoverLetter
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetOneBaseCoverLetterAdminControllerCoverLetter
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINCoverLetterItemsApigetOneBaseCoverLetterAdminControllerCoverLetter
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApigetOneBaseCoverLetterAdminControllerCoverLetter
     */
    cache?: number
}

export interface ADMINCoverLetterItemsApiReplaceOneBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApireplaceOneBaseCoverLetterAdminControllerCoverLetter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCoverLetterItemsApireplaceOneBaseCoverLetterAdminControllerCoverLetter
     */
    body: any
}

export interface ADMINCoverLetterItemsApiUpdateOneBaseCoverLetterAdminControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINCoverLetterItemsApiupdateOneBaseCoverLetterAdminControllerCoverLetter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINCoverLetterItemsApiupdateOneBaseCoverLetterAdminControllerCoverLetter
     */
    body: any
}

export class ObjectADMINCoverLetterItemsApi {
    private api: ObservableADMINCoverLetterItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINCoverLetterItemsApiRequestFactory, responseProcessor?: ADMINCoverLetterItemsApiResponseProcessor) {
        this.api = new ObservableADMINCoverLetterItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple CoverLetters
     * @param param the request object
     */
    public createManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiCreateManyBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.createManyCoverLetterDto,  options).toPromise();
    }

    /**
     * Create multiple CoverLetters
     * @param param the request object
     */
    public createManyBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiCreateManyBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseCoverLetterAdminControllerCoverLetter(param.createManyCoverLetterDto,  options).toPromise();
    }

    /**
     * Create a single CoverLetter
     * @param param the request object
     */
    public createOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiCreateOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CoverLetter
     * @param param the request object
     */
    public createOneBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiCreateOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCoverLetterAdminControllerCoverLetter(param.body,  options).toPromise();
    }

    /**
     * Delete a single CoverLetter
     * @param param the request object
     */
    public deleteOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiDeleteOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CoverLetter
     * @param param the request object
     */
    public deleteOneBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiDeleteOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseCoverLetterAdminControllerCoverLetter(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CoverLetters
     * @param param the request object
     */
    public getManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiGetManyBaseCoverLetterAdminControllerCoverLetterRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseCoverLetterAdminControllerCoverLetter200Response>> {
        return this.api.getManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CoverLetters
     * @param param the request object
     */
    public getManyBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiGetManyBaseCoverLetterAdminControllerCoverLetterRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseCoverLetterAdminControllerCoverLetter200Response> {
        return this.api.getManyBaseCoverLetterAdminControllerCoverLetter(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CoverLetter
     * @param param the request object
     */
    public getOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiGetOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CoverLetter
     * @param param the request object
     */
    public getOneBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiGetOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCoverLetterAdminControllerCoverLetter(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single CoverLetter
     * @param param the request object
     */
    public replaceOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiReplaceOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single CoverLetter
     * @param param the request object
     */
    public replaceOneBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiReplaceOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseCoverLetterAdminControllerCoverLetter(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CoverLetter
     * @param param the request object
     */
    public updateOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param: ADMINCoverLetterItemsApiUpdateOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CoverLetter
     * @param param the request object
     */
    public updateOneBaseCoverLetterAdminControllerCoverLetter(param: ADMINCoverLetterItemsApiUpdateOneBaseCoverLetterAdminControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCoverLetterAdminControllerCoverLetter(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINDataVerticalApi } from "./ObservableAPI";
import { ADMINDataVerticalApiRequestFactory, ADMINDataVerticalApiResponseProcessor} from "../apis/ADMINDataVerticalApi";

export interface ADMINDataVerticalApiCreateManyBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * @type CreateManyVerticalDto
     * @memberof ADMINDataVerticalApicreateManyBaseVerticalAdminControllerVertical
     */
    createManyVerticalDto: CreateManyVerticalDto
}

export interface ADMINDataVerticalApiCreateOneBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * @type any
     * @memberof ADMINDataVerticalApicreateOneBaseVerticalAdminControllerVertical
     */
    body: any
}

export interface ADMINDataVerticalApiDeleteOneBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApideleteOneBaseVerticalAdminControllerVertical
     */
    id: number
}

export interface ADMINDataVerticalApiGetManyBaseVerticalAdminControllerVerticalRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetManyBaseVerticalAdminControllerVertical
     */
    cache?: number
}

export interface ADMINDataVerticalApiGetOneBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetOneBaseVerticalAdminControllerVertical
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetOneBaseVerticalAdminControllerVertical
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINDataVerticalApigetOneBaseVerticalAdminControllerVertical
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApigetOneBaseVerticalAdminControllerVertical
     */
    cache?: number
}

export interface ADMINDataVerticalApiReplaceOneBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApireplaceOneBaseVerticalAdminControllerVertical
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINDataVerticalApireplaceOneBaseVerticalAdminControllerVertical
     */
    body: any
}

export interface ADMINDataVerticalApiUpdateOneBaseVerticalAdminControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINDataVerticalApiupdateOneBaseVerticalAdminControllerVertical
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINDataVerticalApiupdateOneBaseVerticalAdminControllerVertical
     */
    body: any
}

export class ObjectADMINDataVerticalApi {
    private api: ObservableADMINDataVerticalApi

    public constructor(configuration: Configuration, requestFactory?: ADMINDataVerticalApiRequestFactory, responseProcessor?: ADMINDataVerticalApiResponseProcessor) {
        this.api = new ObservableADMINDataVerticalApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Verticals
     * @param param the request object
     */
    public createManyBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiCreateManyBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseVerticalAdminControllerVerticalWithHttpInfo(param.createManyVerticalDto,  options).toPromise();
    }

    /**
     * Create multiple Verticals
     * @param param the request object
     */
    public createManyBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiCreateManyBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseVerticalAdminControllerVertical(param.createManyVerticalDto,  options).toPromise();
    }

    /**
     * Create a single Vertical
     * @param param the request object
     */
    public createOneBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiCreateOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseVerticalAdminControllerVerticalWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Vertical
     * @param param the request object
     */
    public createOneBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiCreateOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseVerticalAdminControllerVertical(param.body,  options).toPromise();
    }

    /**
     * Delete a single Vertical
     * @param param the request object
     */
    public deleteOneBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiDeleteOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseVerticalAdminControllerVerticalWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Vertical
     * @param param the request object
     */
    public deleteOneBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiDeleteOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseVerticalAdminControllerVertical(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Verticals
     * @param param the request object
     */
    public getManyBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiGetManyBaseVerticalAdminControllerVerticalRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseVerticalAdminControllerVertical200Response>> {
        return this.api.getManyBaseVerticalAdminControllerVerticalWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Verticals
     * @param param the request object
     */
    public getManyBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiGetManyBaseVerticalAdminControllerVerticalRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseVerticalAdminControllerVertical200Response> {
        return this.api.getManyBaseVerticalAdminControllerVertical(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vertical
     * @param param the request object
     */
    public getOneBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiGetOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseVerticalAdminControllerVerticalWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vertical
     * @param param the request object
     */
    public getOneBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiGetOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseVerticalAdminControllerVertical(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Vertical
     * @param param the request object
     */
    public replaceOneBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiReplaceOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseVerticalAdminControllerVerticalWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Vertical
     * @param param the request object
     */
    public replaceOneBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiReplaceOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseVerticalAdminControllerVertical(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vertical
     * @param param the request object
     */
    public updateOneBaseVerticalAdminControllerVerticalWithHttpInfo(param: ADMINDataVerticalApiUpdateOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseVerticalAdminControllerVerticalWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vertical
     * @param param the request object
     */
    public updateOneBaseVerticalAdminControllerVertical(param: ADMINDataVerticalApiUpdateOneBaseVerticalAdminControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseVerticalAdminControllerVertical(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINFavouriteFoldersApi } from "./ObservableAPI";
import { ADMINFavouriteFoldersApiRequestFactory, ADMINFavouriteFoldersApiResponseProcessor} from "../apis/ADMINFavouriteFoldersApi";

export interface ADMINFavouriteFoldersApiCreateManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * @type CreateManyFavouriteFolderDto
     * @memberof ADMINFavouriteFoldersApicreateManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    createManyFavouriteFolderDto: CreateManyFavouriteFolderDto
}

export interface ADMINFavouriteFoldersApiCreateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * @type any
     * @memberof ADMINFavouriteFoldersApicreateOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    body: any
}

export interface ADMINFavouriteFoldersApiDeleteOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApideleteOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    id: number
}

export interface ADMINFavouriteFoldersApiGetManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetManyBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    cache?: number
}

export interface ADMINFavouriteFoldersApiGetOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFavouriteFoldersApigetOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApigetOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    cache?: number
}

export interface ADMINFavouriteFoldersApiReplaceOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApireplaceOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINFavouriteFoldersApireplaceOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    body: any
}

export interface ADMINFavouriteFoldersApiUpdateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFavouriteFoldersApiupdateOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINFavouriteFoldersApiupdateOneBaseFavouriteFolderAdminControllerFavouriteFolder
     */
    body: any
}

export class ObjectADMINFavouriteFoldersApi {
    private api: ObservableADMINFavouriteFoldersApi

    public constructor(configuration: Configuration, requestFactory?: ADMINFavouriteFoldersApiRequestFactory, responseProcessor?: ADMINFavouriteFoldersApiResponseProcessor) {
        this.api = new ObservableADMINFavouriteFoldersApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple FavouriteFolders
     * @param param the request object
     */
    public createManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiCreateManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.createManyFavouriteFolderDto,  options).toPromise();
    }

    /**
     * Create multiple FavouriteFolders
     * @param param the request object
     */
    public createManyBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiCreateManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseFavouriteFolderAdminControllerFavouriteFolder(param.createManyFavouriteFolderDto,  options).toPromise();
    }

    /**
     * Create a single FavouriteFolder
     * @param param the request object
     */
    public createOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiCreateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single FavouriteFolder
     * @param param the request object
     */
    public createOneBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiCreateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseFavouriteFolderAdminControllerFavouriteFolder(param.body,  options).toPromise();
    }

    /**
     * Delete a single FavouriteFolder
     * @param param the request object
     */
    public deleteOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiDeleteOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single FavouriteFolder
     * @param param the request object
     */
    public deleteOneBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiDeleteOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseFavouriteFolderAdminControllerFavouriteFolder(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param param the request object
     */
    public getManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiGetManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response>> {
        return this.api.getManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param param the request object
     */
    public getManyBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiGetManyBaseFavouriteFolderAdminControllerFavouriteFolderRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response> {
        return this.api.getManyBaseFavouriteFolderAdminControllerFavouriteFolder(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param param the request object
     */
    public getOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiGetOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param param the request object
     */
    public getOneBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiGetOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseFavouriteFolderAdminControllerFavouriteFolder(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single FavouriteFolder
     * @param param the request object
     */
    public replaceOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiReplaceOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single FavouriteFolder
     * @param param the request object
     */
    public replaceOneBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiReplaceOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseFavouriteFolderAdminControllerFavouriteFolder(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single FavouriteFolder
     * @param param the request object
     */
    public updateOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param: ADMINFavouriteFoldersApiUpdateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single FavouriteFolder
     * @param param the request object
     */
    public updateOneBaseFavouriteFolderAdminControllerFavouriteFolder(param: ADMINFavouriteFoldersApiUpdateOneBaseFavouriteFolderAdminControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseFavouriteFolderAdminControllerFavouriteFolder(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINFeedbackItemsApi } from "./ObservableAPI";
import { ADMINFeedbackItemsApiRequestFactory, ADMINFeedbackItemsApiResponseProcessor} from "../apis/ADMINFeedbackItemsApi";

export interface ADMINFeedbackItemsApiCreateManyBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * @type CreateManyFeedbackDto
     * @memberof ADMINFeedbackItemsApicreateManyBaseFeedbackAdminControllerFeedback
     */
    createManyFeedbackDto: CreateManyFeedbackDto
}

export interface ADMINFeedbackItemsApiCreateOneBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * @type any
     * @memberof ADMINFeedbackItemsApicreateOneBaseFeedbackAdminControllerFeedback
     */
    body: any
}

export interface ADMINFeedbackItemsApiDeleteOneBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApideleteOneBaseFeedbackAdminControllerFeedback
     */
    id: number
}

export interface ADMINFeedbackItemsApiGetManyBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetManyBaseFeedbackAdminControllerFeedback
     */
    cache?: number
}

export interface ADMINFeedbackItemsApiGetOneBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetOneBaseFeedbackAdminControllerFeedback
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetOneBaseFeedbackAdminControllerFeedback
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINFeedbackItemsApigetOneBaseFeedbackAdminControllerFeedback
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApigetOneBaseFeedbackAdminControllerFeedback
     */
    cache?: number
}

export interface ADMINFeedbackItemsApiReplaceOneBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApireplaceOneBaseFeedbackAdminControllerFeedback
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINFeedbackItemsApireplaceOneBaseFeedbackAdminControllerFeedback
     */
    body: any
}

export interface ADMINFeedbackItemsApiUpdateOneBaseFeedbackAdminControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINFeedbackItemsApiupdateOneBaseFeedbackAdminControllerFeedback
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINFeedbackItemsApiupdateOneBaseFeedbackAdminControllerFeedback
     */
    body: any
}

export class ObjectADMINFeedbackItemsApi {
    private api: ObservableADMINFeedbackItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINFeedbackItemsApiRequestFactory, responseProcessor?: ADMINFeedbackItemsApiResponseProcessor) {
        this.api = new ObservableADMINFeedbackItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Feedbacks
     * @param param the request object
     */
    public createManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiCreateManyBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.createManyFeedbackDto,  options).toPromise();
    }

    /**
     * Create multiple Feedbacks
     * @param param the request object
     */
    public createManyBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiCreateManyBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseFeedbackAdminControllerFeedback(param.createManyFeedbackDto,  options).toPromise();
    }

    /**
     * Create a single Feedback
     * @param param the request object
     */
    public createOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiCreateOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Feedback
     * @param param the request object
     */
    public createOneBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiCreateOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseFeedbackAdminControllerFeedback(param.body,  options).toPromise();
    }

    /**
     * Delete a single Feedback
     * @param param the request object
     */
    public deleteOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiDeleteOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Feedback
     * @param param the request object
     */
    public deleteOneBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiDeleteOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseFeedbackAdminControllerFeedback(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Feedbacks
     * @param param the request object
     */
    public getManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiGetManyBaseFeedbackAdminControllerFeedbackRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseFeedbackAdminControllerFeedback200Response>> {
        return this.api.getManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Feedbacks
     * @param param the request object
     */
    public getManyBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiGetManyBaseFeedbackAdminControllerFeedbackRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseFeedbackAdminControllerFeedback200Response> {
        return this.api.getManyBaseFeedbackAdminControllerFeedback(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Feedback
     * @param param the request object
     */
    public getOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiGetOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Feedback
     * @param param the request object
     */
    public getOneBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiGetOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseFeedbackAdminControllerFeedback(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Feedback
     * @param param the request object
     */
    public replaceOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiReplaceOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Feedback
     * @param param the request object
     */
    public replaceOneBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiReplaceOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseFeedbackAdminControllerFeedback(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Feedback
     * @param param the request object
     */
    public updateOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param: ADMINFeedbackItemsApiUpdateOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Feedback
     * @param param the request object
     */
    public updateOneBaseFeedbackAdminControllerFeedback(param: ADMINFeedbackItemsApiUpdateOneBaseFeedbackAdminControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseFeedbackAdminControllerFeedback(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINGeoItemsApi } from "./ObservableAPI";
import { ADMINGeoItemsApiRequestFactory, ADMINGeoItemsApiResponseProcessor} from "../apis/ADMINGeoItemsApi";

export interface ADMINGeoItemsApiCreateManyBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * @type CreateManyGeoDto
     * @memberof ADMINGeoItemsApicreateManyBaseGeoAdminControllerGeo
     */
    createManyGeoDto: CreateManyGeoDto
}

export interface ADMINGeoItemsApiCreateOneBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * @type any
     * @memberof ADMINGeoItemsApicreateOneBaseGeoAdminControllerGeo
     */
    body: any
}

export interface ADMINGeoItemsApiDeleteOneBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApideleteOneBaseGeoAdminControllerGeo
     */
    id: number
}

export interface ADMINGeoItemsApiGetManyBaseGeoAdminControllerGeoRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetManyBaseGeoAdminControllerGeo
     */
    cache?: number
}

export interface ADMINGeoItemsApiGetOneBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetOneBaseGeoAdminControllerGeo
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetOneBaseGeoAdminControllerGeo
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINGeoItemsApigetOneBaseGeoAdminControllerGeo
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApigetOneBaseGeoAdminControllerGeo
     */
    cache?: number
}

export interface ADMINGeoItemsApiReplaceOneBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApireplaceOneBaseGeoAdminControllerGeo
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINGeoItemsApireplaceOneBaseGeoAdminControllerGeo
     */
    body: any
}

export interface ADMINGeoItemsApiUpdateOneBaseGeoAdminControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINGeoItemsApiupdateOneBaseGeoAdminControllerGeo
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINGeoItemsApiupdateOneBaseGeoAdminControllerGeo
     */
    body: any
}

export class ObjectADMINGeoItemsApi {
    private api: ObservableADMINGeoItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINGeoItemsApiRequestFactory, responseProcessor?: ADMINGeoItemsApiResponseProcessor) {
        this.api = new ObservableADMINGeoItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Geos
     * @param param the request object
     */
    public createManyBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiCreateManyBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseGeoAdminControllerGeoWithHttpInfo(param.createManyGeoDto,  options).toPromise();
    }

    /**
     * Create multiple Geos
     * @param param the request object
     */
    public createManyBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiCreateManyBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseGeoAdminControllerGeo(param.createManyGeoDto,  options).toPromise();
    }

    /**
     * Create a single Geo
     * @param param the request object
     */
    public createOneBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiCreateOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseGeoAdminControllerGeoWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Geo
     * @param param the request object
     */
    public createOneBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiCreateOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseGeoAdminControllerGeo(param.body,  options).toPromise();
    }

    /**
     * Delete a single Geo
     * @param param the request object
     */
    public deleteOneBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiDeleteOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseGeoAdminControllerGeoWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Geo
     * @param param the request object
     */
    public deleteOneBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiDeleteOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseGeoAdminControllerGeo(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Geos
     * @param param the request object
     */
    public getManyBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiGetManyBaseGeoAdminControllerGeoRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseGeoAdminControllerGeo200Response>> {
        return this.api.getManyBaseGeoAdminControllerGeoWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Geos
     * @param param the request object
     */
    public getManyBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiGetManyBaseGeoAdminControllerGeoRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseGeoAdminControllerGeo200Response> {
        return this.api.getManyBaseGeoAdminControllerGeo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geo
     * @param param the request object
     */
    public getOneBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiGetOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseGeoAdminControllerGeoWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geo
     * @param param the request object
     */
    public getOneBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiGetOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseGeoAdminControllerGeo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Geo
     * @param param the request object
     */
    public replaceOneBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiReplaceOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseGeoAdminControllerGeoWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Geo
     * @param param the request object
     */
    public replaceOneBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiReplaceOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseGeoAdminControllerGeo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Geo
     * @param param the request object
     */
    public updateOneBaseGeoAdminControllerGeoWithHttpInfo(param: ADMINGeoItemsApiUpdateOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseGeoAdminControllerGeoWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Geo
     * @param param the request object
     */
    public updateOneBaseGeoAdminControllerGeo(param: ADMINGeoItemsApiUpdateOneBaseGeoAdminControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseGeoAdminControllerGeo(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINLocationItemsApi } from "./ObservableAPI";
import { ADMINLocationItemsApiRequestFactory, ADMINLocationItemsApiResponseProcessor} from "../apis/ADMINLocationItemsApi";

export interface ADMINLocationItemsApiCreateManyBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * @type CreateManyGeonameDto
     * @memberof ADMINLocationItemsApicreateManyBaseLocationAdminControllerGeoname
     */
    createManyGeonameDto: CreateManyGeonameDto
}

export interface ADMINLocationItemsApiCreateOneBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * @type any
     * @memberof ADMINLocationItemsApicreateOneBaseLocationAdminControllerGeoname
     */
    body: any
}

export interface ADMINLocationItemsApiDeleteOneBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApideleteOneBaseLocationAdminControllerGeoname
     */
    id: number
}

export interface ADMINLocationItemsApiGetManyBaseLocationAdminControllerGeonameRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetManyBaseLocationAdminControllerGeoname
     */
    cache?: number
}

export interface ADMINLocationItemsApiGetOneBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetOneBaseLocationAdminControllerGeoname
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetOneBaseLocationAdminControllerGeoname
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINLocationItemsApigetOneBaseLocationAdminControllerGeoname
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApigetOneBaseLocationAdminControllerGeoname
     */
    cache?: number
}

export interface ADMINLocationItemsApiReplaceOneBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApireplaceOneBaseLocationAdminControllerGeoname
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINLocationItemsApireplaceOneBaseLocationAdminControllerGeoname
     */
    body: any
}

export interface ADMINLocationItemsApiUpdateOneBaseLocationAdminControllerGeonameRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINLocationItemsApiupdateOneBaseLocationAdminControllerGeoname
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINLocationItemsApiupdateOneBaseLocationAdminControllerGeoname
     */
    body: any
}

export class ObjectADMINLocationItemsApi {
    private api: ObservableADMINLocationItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINLocationItemsApiRequestFactory, responseProcessor?: ADMINLocationItemsApiResponseProcessor) {
        this.api = new ObservableADMINLocationItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Geonames
     * @param param the request object
     */
    public createManyBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiCreateManyBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseLocationAdminControllerGeonameWithHttpInfo(param.createManyGeonameDto,  options).toPromise();
    }

    /**
     * Create multiple Geonames
     * @param param the request object
     */
    public createManyBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiCreateManyBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseLocationAdminControllerGeoname(param.createManyGeonameDto,  options).toPromise();
    }

    /**
     * Create a single Geoname
     * @param param the request object
     */
    public createOneBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiCreateOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseLocationAdminControllerGeonameWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Geoname
     * @param param the request object
     */
    public createOneBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiCreateOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseLocationAdminControllerGeoname(param.body,  options).toPromise();
    }

    /**
     * Delete a single Geoname
     * @param param the request object
     */
    public deleteOneBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiDeleteOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseLocationAdminControllerGeonameWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Geoname
     * @param param the request object
     */
    public deleteOneBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiDeleteOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseLocationAdminControllerGeoname(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Geonames
     * @param param the request object
     */
    public getManyBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiGetManyBaseLocationAdminControllerGeonameRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseLocationAdminControllerGeoname200Response>> {
        return this.api.getManyBaseLocationAdminControllerGeonameWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Geonames
     * @param param the request object
     */
    public getManyBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiGetManyBaseLocationAdminControllerGeonameRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseLocationAdminControllerGeoname200Response> {
        return this.api.getManyBaseLocationAdminControllerGeoname(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geoname
     * @param param the request object
     */
    public getOneBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiGetOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseLocationAdminControllerGeonameWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geoname
     * @param param the request object
     */
    public getOneBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiGetOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseLocationAdminControllerGeoname(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Geoname
     * @param param the request object
     */
    public replaceOneBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiReplaceOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseLocationAdminControllerGeonameWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Geoname
     * @param param the request object
     */
    public replaceOneBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiReplaceOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseLocationAdminControllerGeoname(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Geoname
     * @param param the request object
     */
    public updateOneBaseLocationAdminControllerGeonameWithHttpInfo(param: ADMINLocationItemsApiUpdateOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseLocationAdminControllerGeonameWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Geoname
     * @param param the request object
     */
    public updateOneBaseLocationAdminControllerGeoname(param: ADMINLocationItemsApiUpdateOneBaseLocationAdminControllerGeonameRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseLocationAdminControllerGeoname(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINManagerItemsApi } from "./ObservableAPI";
import { ADMINManagerItemsApiRequestFactory, ADMINManagerItemsApiResponseProcessor} from "../apis/ADMINManagerItemsApi";

export interface ADMINManagerItemsApiCreateManyBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * @type CreateManyProfileDto
     * @memberof ADMINManagerItemsApicreateManyBaseManagerAdminControllerProfile
     */
    createManyProfileDto: CreateManyProfileDto
}

export interface ADMINManagerItemsApiCreateOneBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * @type any
     * @memberof ADMINManagerItemsApicreateOneBaseManagerAdminControllerProfile
     */
    body: any
}

export interface ADMINManagerItemsApiDeleteOneBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApideleteOneBaseManagerAdminControllerProfile
     */
    id: number
}

export interface ADMINManagerItemsApiGetManyBaseManagerAdminControllerProfileRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetManyBaseManagerAdminControllerProfile
     */
    cache?: number
}

export interface ADMINManagerItemsApiGetOneBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetOneBaseManagerAdminControllerProfile
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetOneBaseManagerAdminControllerProfile
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINManagerItemsApigetOneBaseManagerAdminControllerProfile
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApigetOneBaseManagerAdminControllerProfile
     */
    cache?: number
}

export interface ADMINManagerItemsApiReplaceOneBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApireplaceOneBaseManagerAdminControllerProfile
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINManagerItemsApireplaceOneBaseManagerAdminControllerProfile
     */
    body: any
}

export interface ADMINManagerItemsApiUpdateOneBaseManagerAdminControllerProfileRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINManagerItemsApiupdateOneBaseManagerAdminControllerProfile
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINManagerItemsApiupdateOneBaseManagerAdminControllerProfile
     */
    body: any
}

export class ObjectADMINManagerItemsApi {
    private api: ObservableADMINManagerItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINManagerItemsApiRequestFactory, responseProcessor?: ADMINManagerItemsApiResponseProcessor) {
        this.api = new ObservableADMINManagerItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Profiles
     * @param param the request object
     */
    public createManyBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiCreateManyBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseManagerAdminControllerProfileWithHttpInfo(param.createManyProfileDto,  options).toPromise();
    }

    /**
     * Create multiple Profiles
     * @param param the request object
     */
    public createManyBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiCreateManyBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseManagerAdminControllerProfile(param.createManyProfileDto,  options).toPromise();
    }

    /**
     * Create a single Profile
     * @param param the request object
     */
    public createOneBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiCreateOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseManagerAdminControllerProfileWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Profile
     * @param param the request object
     */
    public createOneBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiCreateOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseManagerAdminControllerProfile(param.body,  options).toPromise();
    }

    /**
     * Delete a single Profile
     * @param param the request object
     */
    public deleteOneBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiDeleteOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseManagerAdminControllerProfileWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Profile
     * @param param the request object
     */
    public deleteOneBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiDeleteOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseManagerAdminControllerProfile(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Profiles
     * @param param the request object
     */
    public getManyBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiGetManyBaseManagerAdminControllerProfileRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseManagerAdminControllerProfile200Response>> {
        return this.api.getManyBaseManagerAdminControllerProfileWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Profiles
     * @param param the request object
     */
    public getManyBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiGetManyBaseManagerAdminControllerProfileRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseManagerAdminControllerProfile200Response> {
        return this.api.getManyBaseManagerAdminControllerProfile(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Profile
     * @param param the request object
     */
    public getOneBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiGetOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseManagerAdminControllerProfileWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Profile
     * @param param the request object
     */
    public getOneBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiGetOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseManagerAdminControllerProfile(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Profile
     * @param param the request object
     */
    public replaceOneBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiReplaceOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseManagerAdminControllerProfileWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Profile
     * @param param the request object
     */
    public replaceOneBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiReplaceOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseManagerAdminControllerProfile(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Profile
     * @param param the request object
     */
    public updateOneBaseManagerAdminControllerProfileWithHttpInfo(param: ADMINManagerItemsApiUpdateOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseManagerAdminControllerProfileWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Profile
     * @param param the request object
     */
    public updateOneBaseManagerAdminControllerProfile(param: ADMINManagerItemsApiUpdateOneBaseManagerAdminControllerProfileRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseManagerAdminControllerProfile(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINNotificationCreateNotificationApi } from "./ObservableAPI";
import { ADMINNotificationCreateNotificationApiRequestFactory, ADMINNotificationCreateNotificationApiResponseProcessor} from "../apis/ADMINNotificationCreateNotificationApi";

export interface ADMINNotificationCreateNotificationApiCreate0Request {
    /**
     * 
     * @type NotificationCustomContentDTO
     * @memberof ADMINNotificationCreateNotificationApicreate0
     */
    notificationCustomContentDTO: NotificationCustomContentDTO
}

export class ObjectADMINNotificationCreateNotificationApi {
    private api: ObservableADMINNotificationCreateNotificationApi

    public constructor(configuration: Configuration, requestFactory?: ADMINNotificationCreateNotificationApiRequestFactory, responseProcessor?: ADMINNotificationCreateNotificationApiResponseProcessor) {
        this.api = new ObservableADMINNotificationCreateNotificationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public create0WithHttpInfo(param: ADMINNotificationCreateNotificationApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.create0WithHttpInfo(param.notificationCustomContentDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0(param: ADMINNotificationCreateNotificationApiCreate0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.create0(param.notificationCustomContentDTO,  options).toPromise();
    }

}

import { ObservableADMINOrderItemsApi } from "./ObservableAPI";
import { ADMINOrderItemsApiRequestFactory, ADMINOrderItemsApiResponseProcessor} from "../apis/ADMINOrderItemsApi";

export interface ADMINOrderItemsApiCreateOrder0Request {
    /**
     * 
     * Defaults to: &#39;en&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof ADMINOrderItemsApicreateOrder0
     */
    locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderItemsApicreateOrder0
     */
    id: number
    /**
     * 
     * @type AdminCreateOrderDto
     * @memberof ADMINOrderItemsApicreateOrder0
     */
    adminCreateOrderDto: AdminCreateOrderDto
}

export class ObjectADMINOrderItemsApi {
    private api: ObservableADMINOrderItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINOrderItemsApiRequestFactory, responseProcessor?: ADMINOrderItemsApiResponseProcessor) {
        this.api = new ObservableADMINOrderItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create admin order
     * @param param the request object
     */
    public createOrder0WithHttpInfo(param: ADMINOrderItemsApiCreateOrder0Request, options?: ConfigurationOptions): Promise<HttpInfo<OrderEntity | any>> {
        return this.api.createOrder0WithHttpInfo(param.locale, param.id, param.adminCreateOrderDto,  options).toPromise();
    }

    /**
     * Create admin order
     * @param param the request object
     */
    public createOrder0(param: ADMINOrderItemsApiCreateOrder0Request, options?: ConfigurationOptions): Promise<OrderEntity | any> {
        return this.api.createOrder0(param.locale, param.id, param.adminCreateOrderDto,  options).toPromise();
    }

}

import { ObservableADMINOrderTransactionsApi } from "./ObservableAPI";
import { ADMINOrderTransactionsApiRequestFactory, ADMINOrderTransactionsApiResponseProcessor} from "../apis/ADMINOrderTransactionsApi";

export interface ADMINOrderTransactionsApiCancallOrder0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderTransactionsApicancallOrder0
     */
    id: number
}

export interface ADMINOrderTransactionsApiFindAllOrdersOwned0Request {
    /**
     * Array of order IDs
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    orderIds?: Array<number>
    /**
     * Array of user IDs
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    profileIds?: Array<number>
    /**
     * Array of order statuses
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    statuses?: Array<string>
    /**
     * Array of product IDs
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    productIds?: Array<number>
    /**
     * Array of product types
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    productTypes?: Array<string>
    /**
     * Date from
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    dateFrom?: string
    /**
     * Date to
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    dateTo?: string
    /**
     * Limit of orders to return
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    limit?: number
    /**
     * Offset of orders to return
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    offset?: number
    /**
     * Sort method
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    sortMethod?: string
    /**
     * Sort by
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    sortBy?: string
    /**
     * Array of remote order IDs
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    remoteIds?: Array<string>
    /**
     * Array of order IDs
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    orderIds2?: Array<string>
    /**
     * Array of user IDs
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    profileIds2?: Array<string>
    /**
     * Array of order statuses
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    statuses2?: Array<string>
    /**
     * Array of product IDs
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    productIds2?: Array<string>
    /**
     * Array of product types
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    productTypes2?: Array<string>
    /**
     * Date from
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    dateFrom2?: string
    /**
     * Date to
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    dateTo2?: string
    /**
     * Limit of orders to return
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    limit2?: number
    /**
     * Offset of orders to return
     * Defaults to: undefined
     * @type number
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    offset2?: number
    /**
     * Sort method
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    sortMethod2?: string
    /**
     * Sort by
     * Defaults to: undefined
     * @type string
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    sortBy2?: string
    /**
     * Array of remote order IDs
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINOrderTransactionsApifindAllOrdersOwned0
     */
    remoteIds2?: Array<string>
}

export class ObjectADMINOrderTransactionsApi {
    private api: ObservableADMINOrderTransactionsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINOrderTransactionsApiRequestFactory, responseProcessor?: ADMINOrderTransactionsApiResponseProcessor) {
        this.api = new ObservableADMINOrderTransactionsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Refund order
     * @param param the request object
     */
    public cancallOrder0WithHttpInfo(param: ADMINOrderTransactionsApiCancallOrder0Request, options?: ConfigurationOptions): Promise<HttpInfo<OrderEntity>> {
        return this.api.cancallOrder0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Refund order
     * @param param the request object
     */
    public cancallOrder0(param: ADMINOrderTransactionsApiCancallOrder0Request, options?: ConfigurationOptions): Promise<OrderEntity> {
        return this.api.cancallOrder0(param.id,  options).toPromise();
    }

    /**
     * Returns an array orders
     * @param param the request object
     */
    public findAllOrdersOwned0WithHttpInfo(param: ADMINOrderTransactionsApiFindAllOrdersOwned0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<AdminOrderTransactionsPaginationDTO>>> {
        return this.api.findAllOrdersOwned0WithHttpInfo(param.orderIds, param.profileIds, param.statuses, param.productIds, param.productTypes, param.dateFrom, param.dateTo, param.limit, param.offset, param.sortMethod, param.sortBy, param.remoteIds, param.orderIds2, param.profileIds2, param.statuses2, param.productIds2, param.productTypes2, param.dateFrom2, param.dateTo2, param.limit2, param.offset2, param.sortMethod2, param.sortBy2, param.remoteIds2,  options).toPromise();
    }

    /**
     * Returns an array orders
     * @param param the request object
     */
    public findAllOrdersOwned0(param: ADMINOrderTransactionsApiFindAllOrdersOwned0Request = {}, options?: ConfigurationOptions): Promise<Array<AdminOrderTransactionsPaginationDTO>> {
        return this.api.findAllOrdersOwned0(param.orderIds, param.profileIds, param.statuses, param.productIds, param.productTypes, param.dateFrom, param.dateTo, param.limit, param.offset, param.sortMethod, param.sortBy, param.remoteIds, param.orderIds2, param.profileIds2, param.statuses2, param.productIds2, param.productTypes2, param.dateFrom2, param.dateTo2, param.limit2, param.offset2, param.sortMethod2, param.sortBy2, param.remoteIds2,  options).toPromise();
    }

}

import { ObservableADMINPageItemsApi } from "./ObservableAPI";
import { ADMINPageItemsApiRequestFactory, ADMINPageItemsApiResponseProcessor} from "../apis/ADMINPageItemsApi";

export interface ADMINPageItemsApiCreateManyBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * @type CreateManyPageHTMLBlockDto
     * @memberof ADMINPageItemsApicreateManyBasePageAdminControllerPageHTMLBlock
     */
    createManyPageHTMLBlockDto: CreateManyPageHTMLBlockDto
}

export interface ADMINPageItemsApiCreateOneBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * @type PageHTMLBlock
     * @memberof ADMINPageItemsApicreateOneBasePageAdminControllerPageHTMLBlock
     */
    pageHTMLBlock: PageHTMLBlock
}

export interface ADMINPageItemsApiDeleteOneBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApideleteOneBasePageAdminControllerPageHTMLBlock
     */
    id: number
}

export interface ADMINPageItemsApiGetManyBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetManyBasePageAdminControllerPageHTMLBlock
     */
    cache?: number
}

export interface ADMINPageItemsApiGetOneBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetOneBasePageAdminControllerPageHTMLBlock
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetOneBasePageAdminControllerPageHTMLBlock
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPageItemsApigetOneBasePageAdminControllerPageHTMLBlock
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApigetOneBasePageAdminControllerPageHTMLBlock
     */
    cache?: number
}

export interface ADMINPageItemsApiReplaceOneBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApireplaceOneBasePageAdminControllerPageHTMLBlock
     */
    id: number
    /**
     * 
     * @type PageHTMLBlock
     * @memberof ADMINPageItemsApireplaceOneBasePageAdminControllerPageHTMLBlock
     */
    pageHTMLBlock: PageHTMLBlock
}

export interface ADMINPageItemsApiUpdateOneBasePageAdminControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPageItemsApiupdateOneBasePageAdminControllerPageHTMLBlock
     */
    id: number
    /**
     * 
     * @type PageHTMLBlock
     * @memberof ADMINPageItemsApiupdateOneBasePageAdminControllerPageHTMLBlock
     */
    pageHTMLBlock: PageHTMLBlock
}

export class ObjectADMINPageItemsApi {
    private api: ObservableADMINPageItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINPageItemsApiRequestFactory, responseProcessor?: ADMINPageItemsApiResponseProcessor) {
        this.api = new ObservableADMINPageItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple PageHTMLBlocks
     * @param param the request object
     */
    public createManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiCreateManyBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<PageHTMLBlock>>> {
        return this.api.createManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.createManyPageHTMLBlockDto,  options).toPromise();
    }

    /**
     * Create multiple PageHTMLBlocks
     * @param param the request object
     */
    public createManyBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiCreateManyBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<Array<PageHTMLBlock>> {
        return this.api.createManyBasePageAdminControllerPageHTMLBlock(param.createManyPageHTMLBlockDto,  options).toPromise();
    }

    /**
     * Create a single PageHTMLBlock
     * @param param the request object
     */
    public createOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiCreateOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<PageHTMLBlock>> {
        return this.api.createOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.pageHTMLBlock,  options).toPromise();
    }

    /**
     * Create a single PageHTMLBlock
     * @param param the request object
     */
    public createOneBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiCreateOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<PageHTMLBlock> {
        return this.api.createOneBasePageAdminControllerPageHTMLBlock(param.pageHTMLBlock,  options).toPromise();
    }

    /**
     * Delete a single PageHTMLBlock
     * @param param the request object
     */
    public deleteOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiDeleteOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single PageHTMLBlock
     * @param param the request object
     */
    public deleteOneBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiDeleteOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBasePageAdminControllerPageHTMLBlock(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param param the request object
     */
    public getManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiGetManyBasePageAdminControllerPageHTMLBlockRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBasePageAdminControllerPageHTMLBlock200Response>> {
        return this.api.getManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param param the request object
     */
    public getManyBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiGetManyBasePageAdminControllerPageHTMLBlockRequest = {}, options?: ConfigurationOptions): Promise<GetManyBasePageAdminControllerPageHTMLBlock200Response> {
        return this.api.getManyBasePageAdminControllerPageHTMLBlock(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param param the request object
     */
    public getOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiGetOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<PageHTMLBlock>> {
        return this.api.getOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param param the request object
     */
    public getOneBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiGetOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<PageHTMLBlock> {
        return this.api.getOneBasePageAdminControllerPageHTMLBlock(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single PageHTMLBlock
     * @param param the request object
     */
    public replaceOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiReplaceOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<PageHTMLBlock>> {
        return this.api.replaceOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.id, param.pageHTMLBlock,  options).toPromise();
    }

    /**
     * Replace a single PageHTMLBlock
     * @param param the request object
     */
    public replaceOneBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiReplaceOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<PageHTMLBlock> {
        return this.api.replaceOneBasePageAdminControllerPageHTMLBlock(param.id, param.pageHTMLBlock,  options).toPromise();
    }

    /**
     * Update a single PageHTMLBlock
     * @param param the request object
     */
    public updateOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param: ADMINPageItemsApiUpdateOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<PageHTMLBlock>> {
        return this.api.updateOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(param.id, param.pageHTMLBlock,  options).toPromise();
    }

    /**
     * Update a single PageHTMLBlock
     * @param param the request object
     */
    public updateOneBasePageAdminControllerPageHTMLBlock(param: ADMINPageItemsApiUpdateOneBasePageAdminControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<PageHTMLBlock> {
        return this.api.updateOneBasePageAdminControllerPageHTMLBlock(param.id, param.pageHTMLBlock,  options).toPromise();
    }

}

import { ObservableADMINPaymentItemsApi } from "./ObservableAPI";
import { ADMINPaymentItemsApiRequestFactory, ADMINPaymentItemsApiResponseProcessor} from "../apis/ADMINPaymentItemsApi";

export interface ADMINPaymentItemsApiCreateOneBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * 
     * @type any
     * @memberof ADMINPaymentItemsApicreateOneBasePaymentAdminControllerPaymentTransaction
     */
    body: any
}

export interface ADMINPaymentItemsApiDeleteOneBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPaymentItemsApideleteOneBasePaymentAdminControllerPaymentTransaction
     */
    id: string
}

export interface ADMINPaymentItemsApiGetManyBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPaymentItemsApigetManyBasePaymentAdminControllerPaymentTransaction
     */
    cache?: number
}

export interface ADMINPaymentItemsApiGetOneBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPaymentItemsApigetOneBasePaymentAdminControllerPaymentTransaction
     */
    id: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetOneBasePaymentAdminControllerPaymentTransaction
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPaymentItemsApigetOneBasePaymentAdminControllerPaymentTransaction
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPaymentItemsApigetOneBasePaymentAdminControllerPaymentTransaction
     */
    cache?: number
}

export interface ADMINPaymentItemsApiReplaceOneBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPaymentItemsApireplaceOneBasePaymentAdminControllerPaymentTransaction
     */
    id: string
    /**
     * 
     * @type any
     * @memberof ADMINPaymentItemsApireplaceOneBasePaymentAdminControllerPaymentTransaction
     */
    body: any
}

export interface ADMINPaymentItemsApiUpdateOneBasePaymentAdminControllerPaymentTransactionRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPaymentItemsApiupdateOneBasePaymentAdminControllerPaymentTransaction
     */
    id: string
    /**
     * 
     * @type any
     * @memberof ADMINPaymentItemsApiupdateOneBasePaymentAdminControllerPaymentTransaction
     */
    body: any
}

export class ObjectADMINPaymentItemsApi {
    private api: ObservableADMINPaymentItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINPaymentItemsApiRequestFactory, responseProcessor?: ADMINPaymentItemsApiResponseProcessor) {
        this.api = new ObservableADMINPaymentItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single PaymentTransaction
     * @param param the request object
     */
    public createOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiCreateOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single PaymentTransaction
     * @param param the request object
     */
    public createOneBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiCreateOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBasePaymentAdminControllerPaymentTransaction(param.body,  options).toPromise();
    }

    /**
     * Delete a single PaymentTransaction
     * @param param the request object
     */
    public deleteOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiDeleteOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single PaymentTransaction
     * @param param the request object
     */
    public deleteOneBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiDeleteOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBasePaymentAdminControllerPaymentTransaction(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple PaymentTransactions
     * @param param the request object
     */
    public getManyBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiGetManyBasePaymentAdminControllerPaymentTransactionRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBasePaymentAdminControllerPaymentTransaction200Response>> {
        return this.api.getManyBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple PaymentTransactions
     * @param param the request object
     */
    public getManyBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiGetManyBasePaymentAdminControllerPaymentTransactionRequest = {}, options?: ConfigurationOptions): Promise<GetManyBasePaymentAdminControllerPaymentTransaction200Response> {
        return this.api.getManyBasePaymentAdminControllerPaymentTransaction(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PaymentTransaction
     * @param param the request object
     */
    public getOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiGetOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PaymentTransaction
     * @param param the request object
     */
    public getOneBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiGetOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBasePaymentAdminControllerPaymentTransaction(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single PaymentTransaction
     * @param param the request object
     */
    public replaceOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiReplaceOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single PaymentTransaction
     * @param param the request object
     */
    public replaceOneBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiReplaceOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBasePaymentAdminControllerPaymentTransaction(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single PaymentTransaction
     * @param param the request object
     */
    public updateOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param: ADMINPaymentItemsApiUpdateOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single PaymentTransaction
     * @param param the request object
     */
    public updateOneBasePaymentAdminControllerPaymentTransaction(param: ADMINPaymentItemsApiUpdateOneBasePaymentAdminControllerPaymentTransactionRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBasePaymentAdminControllerPaymentTransaction(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINPersonalPageItemsApi } from "./ObservableAPI";
import { ADMINPersonalPageItemsApiRequestFactory, ADMINPersonalPageItemsApiResponseProcessor} from "../apis/ADMINPersonalPageItemsApi";

export interface ADMINPersonalPageItemsApiCreateManyBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * @type CreateManyPersonalPageDto
     * @memberof ADMINPersonalPageItemsApicreateManyBasePersonalPageAdminControllerPersonalPage
     */
    createManyPersonalPageDto: CreateManyPersonalPageDto
}

export interface ADMINPersonalPageItemsApiCreateOneBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * @type any
     * @memberof ADMINPersonalPageItemsApicreateOneBasePersonalPageAdminControllerPersonalPage
     */
    body: any
}

export interface ADMINPersonalPageItemsApiDeleteOneBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApideleteOneBasePersonalPageAdminControllerPersonalPage
     */
    id: number
}

export interface ADMINPersonalPageItemsApiGetManyBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetManyBasePersonalPageAdminControllerPersonalPage
     */
    cache?: number
}

export interface ADMINPersonalPageItemsApiGetOneBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetOneBasePersonalPageAdminControllerPersonalPage
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetOneBasePersonalPageAdminControllerPersonalPage
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINPersonalPageItemsApigetOneBasePersonalPageAdminControllerPersonalPage
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApigetOneBasePersonalPageAdminControllerPersonalPage
     */
    cache?: number
}

export interface ADMINPersonalPageItemsApiReplaceOneBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApireplaceOneBasePersonalPageAdminControllerPersonalPage
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINPersonalPageItemsApireplaceOneBasePersonalPageAdminControllerPersonalPage
     */
    body: any
}

export interface ADMINPersonalPageItemsApiUpdateOneBasePersonalPageAdminControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINPersonalPageItemsApiupdateOneBasePersonalPageAdminControllerPersonalPage
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINPersonalPageItemsApiupdateOneBasePersonalPageAdminControllerPersonalPage
     */
    body: any
}

export class ObjectADMINPersonalPageItemsApi {
    private api: ObservableADMINPersonalPageItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINPersonalPageItemsApiRequestFactory, responseProcessor?: ADMINPersonalPageItemsApiResponseProcessor) {
        this.api = new ObservableADMINPersonalPageItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple PersonalPages
     * @param param the request object
     */
    public createManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiCreateManyBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.createManyPersonalPageDto,  options).toPromise();
    }

    /**
     * Create multiple PersonalPages
     * @param param the request object
     */
    public createManyBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiCreateManyBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBasePersonalPageAdminControllerPersonalPage(param.createManyPersonalPageDto,  options).toPromise();
    }

    /**
     * Create a single PersonalPage
     * @param param the request object
     */
    public createOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiCreateOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single PersonalPage
     * @param param the request object
     */
    public createOneBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiCreateOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBasePersonalPageAdminControllerPersonalPage(param.body,  options).toPromise();
    }

    /**
     * Delete a single PersonalPage
     * @param param the request object
     */
    public deleteOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiDeleteOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single PersonalPage
     * @param param the request object
     */
    public deleteOneBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiDeleteOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBasePersonalPageAdminControllerPersonalPage(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple PersonalPages
     * @param param the request object
     */
    public getManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiGetManyBasePersonalPageAdminControllerPersonalPageRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBasePersonalPageAdminControllerPersonalPage200Response>> {
        return this.api.getManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple PersonalPages
     * @param param the request object
     */
    public getManyBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiGetManyBasePersonalPageAdminControllerPersonalPageRequest = {}, options?: ConfigurationOptions): Promise<GetManyBasePersonalPageAdminControllerPersonalPage200Response> {
        return this.api.getManyBasePersonalPageAdminControllerPersonalPage(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PersonalPage
     * @param param the request object
     */
    public getOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiGetOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PersonalPage
     * @param param the request object
     */
    public getOneBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiGetOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBasePersonalPageAdminControllerPersonalPage(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single PersonalPage
     * @param param the request object
     */
    public replaceOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiReplaceOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single PersonalPage
     * @param param the request object
     */
    public replaceOneBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiReplaceOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBasePersonalPageAdminControllerPersonalPage(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single PersonalPage
     * @param param the request object
     */
    public updateOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param: ADMINPersonalPageItemsApiUpdateOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single PersonalPage
     * @param param the request object
     */
    public updateOneBasePersonalPageAdminControllerPersonalPage(param: ADMINPersonalPageItemsApiUpdateOneBasePersonalPageAdminControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBasePersonalPageAdminControllerPersonalPage(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINProductItemsApi } from "./ObservableAPI";
import { ADMINProductItemsApiRequestFactory, ADMINProductItemsApiResponseProcessor} from "../apis/ADMINProductItemsApi";

export interface ADMINProductItemsApiCreateOne0Request {
    /**
     * 
     * @type CreateProductDTO
     * @memberof ADMINProductItemsApicreateOne0
     */
    createProductDTO: CreateProductDTO
}

export interface ADMINProductItemsApiDeleteOne0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProductItemsApideleteOne0
     */
    id: number
}

export interface ADMINProductItemsApiFindAll0Request {
}

export interface ADMINProductItemsApiFindOne0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProductItemsApifindOne0
     */
    id: number
}

export interface ADMINProductItemsApiUpdateOne0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProductItemsApiupdateOne0
     */
    id: number
    /**
     * 
     * @type UpdateProductDTO
     * @memberof ADMINProductItemsApiupdateOne0
     */
    updateProductDTO: UpdateProductDTO
}

export class ObjectADMINProductItemsApi {
    private api: ObservableADMINProductItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINProductItemsApiRequestFactory, responseProcessor?: ADMINProductItemsApiResponseProcessor) {
        this.api = new ObservableADMINProductItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Creates new product.
     * @param param the request object
     */
    public createOne0WithHttpInfo(param: ADMINProductItemsApiCreateOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProductEntity>> {
        return this.api.createOne0WithHttpInfo(param.createProductDTO,  options).toPromise();
    }

    /**
     * Creates new product.
     * @param param the request object
     */
    public createOne0(param: ADMINProductItemsApiCreateOne0Request, options?: ConfigurationOptions): Promise<ProductEntity> {
        return this.api.createOne0(param.createProductDTO,  options).toPromise();
    }

    /**
     * Deletes an existing product by provided id.
     * @param param the request object
     */
    public deleteOne0WithHttpInfo(param: ADMINProductItemsApiDeleteOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProductEntity>> {
        return this.api.deleteOne0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Deletes an existing product by provided id.
     * @param param the request object
     */
    public deleteOne0(param: ADMINProductItemsApiDeleteOne0Request, options?: ConfigurationOptions): Promise<ProductEntity> {
        return this.api.deleteOne0(param.id,  options).toPromise();
    }

    /**
     * Returns an array of available products to buy by current profile type.
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: ADMINProductItemsApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<ProductEntity>>> {
        return this.api.findAll0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns an array of available products to buy by current profile type.
     * @param param the request object
     */
    public findAll0(param: ADMINProductItemsApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<Array<ProductEntity>> {
        return this.api.findAll0( options).toPromise();
    }

    /**
     * Returns product by provided id.
     * @param param the request object
     */
    public findOne0WithHttpInfo(param: ADMINProductItemsApiFindOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProductEntity>> {
        return this.api.findOne0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Returns product by provided id.
     * @param param the request object
     */
    public findOne0(param: ADMINProductItemsApiFindOne0Request, options?: ConfigurationOptions): Promise<ProductEntity> {
        return this.api.findOne0(param.id,  options).toPromise();
    }

    /**
     * Updates an existing product by provided id.
     * @param param the request object
     */
    public updateOne0WithHttpInfo(param: ADMINProductItemsApiUpdateOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProductEntity>> {
        return this.api.updateOne0WithHttpInfo(param.id, param.updateProductDTO,  options).toPromise();
    }

    /**
     * Updates an existing product by provided id.
     * @param param the request object
     */
    public updateOne0(param: ADMINProductItemsApiUpdateOne0Request, options?: ConfigurationOptions): Promise<ProductEntity> {
        return this.api.updateOne0(param.id, param.updateProductDTO,  options).toPromise();
    }

}

import { ObservableADMINProfilesManagingApi } from "./ObservableAPI";
import { ADMINProfilesManagingApiRequestFactory, ADMINProfilesManagingApiResponseProcessor} from "../apis/ADMINProfilesManagingApi";

export interface ADMINProfilesManagingApiDestroyOne0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProfilesManagingApidestroyOne0
     */
    profileId: number
}

export interface ADMINProfilesManagingApiFindMany0Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0
     */
    filter?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0
     */
    or?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QuerySortDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0
     */
    sort?: Array<QuerySortDTO>
    /**
     * 
     * Defaults to: 10
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0
     */
    limit?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0
     */
    offset?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0
     */
    page?: number
}

export interface ADMINProfilesManagingApiFindMany00Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    filter?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    or?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QuerySortDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    sort?: Array<QuerySortDTO>
    /**
     * 
     * Defaults to: 10
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    limit?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    offset?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_1
     */
    page?: number
}

export interface ADMINProfilesManagingApiFindMany01Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    filter?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    or?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QuerySortDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    sort?: Array<QuerySortDTO>
    /**
     * 
     * Defaults to: 10
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    limit?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    offset?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_2
     */
    page?: number
}

export interface ADMINProfilesManagingApiFindMany02Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    filter?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QueryFilterDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    or?: Array<QueryFilterDTO>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;QuerySortDTO&gt;
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    sort?: Array<QuerySortDTO>
    /**
     * 
     * Defaults to: 10
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    limit?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    offset?: number
    /**
     * 
     * Defaults to: 0
     * @type number
     * @memberof ADMINProfilesManagingApifindMany0_3
     */
    page?: number
}

export interface ADMINProfilesManagingApiFindOne0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProfilesManagingApifindOne0
     */
    profileId: number
}

export interface ADMINProfilesManagingApiUpdateOne0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProfilesManagingApiupdateOne0
     */
    profileId: number
    /**
     * 
     * @type ProfileUpdateDTO
     * @memberof ADMINProfilesManagingApiupdateOne0
     */
    profileUpdateDTO: ProfileUpdateDTO
}

export class ObjectADMINProfilesManagingApi {
    private api: ObservableADMINProfilesManagingApi

    public constructor(configuration: Configuration, requestFactory?: ADMINProfilesManagingApiRequestFactory, responseProcessor?: ADMINProfilesManagingApiResponseProcessor) {
        this.api = new ObservableADMINProfilesManagingApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Deletes an existing profile.
     * @param param the request object
     */
    public destroyOne0WithHttpInfo(param: ADMINProfilesManagingApiDestroyOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.destroyOne0WithHttpInfo(param.profileId,  options).toPromise();
    }

    /**
     * Deletes an existing profile.
     * @param param the request object
     */
    public destroyOne0(param: ADMINProfilesManagingApiDestroyOne0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.destroyOne0(param.profileId,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0WithHttpInfo(param: ADMINProfilesManagingApiFindMany0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        return this.api.findMany0WithHttpInfo(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0(param: ADMINProfilesManagingApiFindMany0Request = {}, options?: ConfigurationOptions): Promise<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.api.findMany0(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_1WithHttpInfo(param: ADMINProfilesManagingApiFindMany00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        return this.api.findMany0_1WithHttpInfo(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_1(param: ADMINProfilesManagingApiFindMany00Request = {}, options?: ConfigurationOptions): Promise<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.api.findMany0_1(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_2WithHttpInfo(param: ADMINProfilesManagingApiFindMany01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        return this.api.findMany0_2WithHttpInfo(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_2(param: ADMINProfilesManagingApiFindMany01Request = {}, options?: ConfigurationOptions): Promise<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.api.findMany0_2(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_3WithHttpInfo(param: ADMINProfilesManagingApiFindMany02Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        return this.api.findMany0_3WithHttpInfo(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns the set of existing profiles.
     * @param param the request object
     */
    public findMany0_3(param: ADMINProfilesManagingApiFindMany02Request = {}, options?: ConfigurationOptions): Promise<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.api.findMany0_3(param.filter, param.or, param.sort, param.limit, param.offset, param.page,  options).toPromise();
    }

    /**
     * Returns an existing profile.
     * @param param the request object
     */
    public findOne0WithHttpInfo(param: ADMINProfilesManagingApiFindOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.findOne0WithHttpInfo(param.profileId,  options).toPromise();
    }

    /**
     * Returns an existing profile.
     * @param param the request object
     */
    public findOne0(param: ADMINProfilesManagingApiFindOne0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.findOne0(param.profileId,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOne0WithHttpInfo(param: ADMINProfilesManagingApiUpdateOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updateOne0WithHttpInfo(param.profileId, param.profileUpdateDTO,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOne0(param: ADMINProfilesManagingApiUpdateOne0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updateOne0(param.profileId, param.profileUpdateDTO,  options).toPromise();
    }

}

import { ObservableADMINProposalItemsApi } from "./ObservableAPI";
import { ADMINProposalItemsApiRequestFactory, ADMINProposalItemsApiResponseProcessor} from "../apis/ADMINProposalItemsApi";

export interface ADMINProposalItemsApiCreateManyBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * @type CreateManyProposalDto
     * @memberof ADMINProposalItemsApicreateManyBaseProposalAdminControllerProposal
     */
    createManyProposalDto: CreateManyProposalDto
}

export interface ADMINProposalItemsApiCreateOneBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * @type any
     * @memberof ADMINProposalItemsApicreateOneBaseProposalAdminControllerProposal
     */
    body: any
}

export interface ADMINProposalItemsApiDeleteOneBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApideleteOneBaseProposalAdminControllerProposal
     */
    id: number
}

export interface ADMINProposalItemsApiGetManyBaseProposalAdminControllerProposalRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetManyBaseProposalAdminControllerProposal
     */
    cache?: number
}

export interface ADMINProposalItemsApiGetOneBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetOneBaseProposalAdminControllerProposal
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetOneBaseProposalAdminControllerProposal
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINProposalItemsApigetOneBaseProposalAdminControllerProposal
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApigetOneBaseProposalAdminControllerProposal
     */
    cache?: number
}

export interface ADMINProposalItemsApiReplaceOneBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApireplaceOneBaseProposalAdminControllerProposal
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINProposalItemsApireplaceOneBaseProposalAdminControllerProposal
     */
    body: any
}

export interface ADMINProposalItemsApiUpdateOneBaseProposalAdminControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINProposalItemsApiupdateOneBaseProposalAdminControllerProposal
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINProposalItemsApiupdateOneBaseProposalAdminControllerProposal
     */
    body: any
}

export class ObjectADMINProposalItemsApi {
    private api: ObservableADMINProposalItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINProposalItemsApiRequestFactory, responseProcessor?: ADMINProposalItemsApiResponseProcessor) {
        this.api = new ObservableADMINProposalItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Proposals
     * @param param the request object
     */
    public createManyBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiCreateManyBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseProposalAdminControllerProposalWithHttpInfo(param.createManyProposalDto,  options).toPromise();
    }

    /**
     * Create multiple Proposals
     * @param param the request object
     */
    public createManyBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiCreateManyBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseProposalAdminControllerProposal(param.createManyProposalDto,  options).toPromise();
    }

    /**
     * Create a single Proposal
     * @param param the request object
     */
    public createOneBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiCreateOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseProposalAdminControllerProposalWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Proposal
     * @param param the request object
     */
    public createOneBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiCreateOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseProposalAdminControllerProposal(param.body,  options).toPromise();
    }

    /**
     * Delete a single Proposal
     * @param param the request object
     */
    public deleteOneBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiDeleteOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseProposalAdminControllerProposalWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Proposal
     * @param param the request object
     */
    public deleteOneBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiDeleteOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseProposalAdminControllerProposal(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Proposals
     * @param param the request object
     */
    public getManyBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiGetManyBaseProposalAdminControllerProposalRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseProposalAdminControllerProposal200Response>> {
        return this.api.getManyBaseProposalAdminControllerProposalWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Proposals
     * @param param the request object
     */
    public getManyBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiGetManyBaseProposalAdminControllerProposalRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseProposalAdminControllerProposal200Response> {
        return this.api.getManyBaseProposalAdminControllerProposal(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Proposal
     * @param param the request object
     */
    public getOneBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiGetOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseProposalAdminControllerProposalWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Proposal
     * @param param the request object
     */
    public getOneBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiGetOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseProposalAdminControllerProposal(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Proposal
     * @param param the request object
     */
    public replaceOneBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiReplaceOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseProposalAdminControllerProposalWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Proposal
     * @param param the request object
     */
    public replaceOneBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiReplaceOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseProposalAdminControllerProposal(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Proposal
     * @param param the request object
     */
    public updateOneBaseProposalAdminControllerProposalWithHttpInfo(param: ADMINProposalItemsApiUpdateOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseProposalAdminControllerProposalWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Proposal
     * @param param the request object
     */
    public updateOneBaseProposalAdminControllerProposal(param: ADMINProposalItemsApiUpdateOneBaseProposalAdminControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseProposalAdminControllerProposal(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINSkillItemsApi } from "./ObservableAPI";
import { ADMINSkillItemsApiRequestFactory, ADMINSkillItemsApiResponseProcessor} from "../apis/ADMINSkillItemsApi";

export interface ADMINSkillItemsApiCreateManyBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * @type CreateManySkillDto
     * @memberof ADMINSkillItemsApicreateManyBaseSkillAdminControllerSkill
     */
    createManySkillDto: CreateManySkillDto
}

export interface ADMINSkillItemsApiCreateOneBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * @type any
     * @memberof ADMINSkillItemsApicreateOneBaseSkillAdminControllerSkill
     */
    body: any
}

export interface ADMINSkillItemsApiDeleteOneBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApideleteOneBaseSkillAdminControllerSkill
     */
    id: number
}

export interface ADMINSkillItemsApiGetManyBaseSkillAdminControllerSkillRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetManyBaseSkillAdminControllerSkill
     */
    cache?: number
}

export interface ADMINSkillItemsApiGetOneBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetOneBaseSkillAdminControllerSkill
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetOneBaseSkillAdminControllerSkill
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApigetOneBaseSkillAdminControllerSkill
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApigetOneBaseSkillAdminControllerSkill
     */
    cache?: number
}

export interface ADMINSkillItemsApiImport0Request {
    /**
     * 
     * @type Array&lt;string&gt;
     * @memberof ADMINSkillItemsApiimport0
     */
    requestBody: Array<string>
}

export interface ADMINSkillItemsApiReplaceOneBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApireplaceOneBaseSkillAdminControllerSkill
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINSkillItemsApireplaceOneBaseSkillAdminControllerSkill
     */
    body: any
}

export interface ADMINSkillItemsApiUpdateOneBaseSkillAdminControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSkillItemsApiupdateOneBaseSkillAdminControllerSkill
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINSkillItemsApiupdateOneBaseSkillAdminControllerSkill
     */
    body: any
}

export class ObjectADMINSkillItemsApi {
    private api: ObservableADMINSkillItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINSkillItemsApiRequestFactory, responseProcessor?: ADMINSkillItemsApiResponseProcessor) {
        this.api = new ObservableADMINSkillItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Skills
     * @param param the request object
     */
    public createManyBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiCreateManyBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseSkillAdminControllerSkillWithHttpInfo(param.createManySkillDto,  options).toPromise();
    }

    /**
     * Create multiple Skills
     * @param param the request object
     */
    public createManyBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiCreateManyBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseSkillAdminControllerSkill(param.createManySkillDto,  options).toPromise();
    }

    /**
     * Create a single Skill
     * @param param the request object
     */
    public createOneBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiCreateOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseSkillAdminControllerSkillWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Skill
     * @param param the request object
     */
    public createOneBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiCreateOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseSkillAdminControllerSkill(param.body,  options).toPromise();
    }

    /**
     * Delete a single Skill
     * @param param the request object
     */
    public deleteOneBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiDeleteOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseSkillAdminControllerSkillWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Skill
     * @param param the request object
     */
    public deleteOneBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiDeleteOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseSkillAdminControllerSkill(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Skills
     * @param param the request object
     */
    public getManyBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiGetManyBaseSkillAdminControllerSkillRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseSkillAdminControllerSkill200Response>> {
        return this.api.getManyBaseSkillAdminControllerSkillWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Skills
     * @param param the request object
     */
    public getManyBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiGetManyBaseSkillAdminControllerSkillRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseSkillAdminControllerSkill200Response> {
        return this.api.getManyBaseSkillAdminControllerSkill(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Skill
     * @param param the request object
     */
    public getOneBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiGetOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseSkillAdminControllerSkillWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Skill
     * @param param the request object
     */
    public getOneBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiGetOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseSkillAdminControllerSkill(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public import0WithHttpInfo(param: ADMINSkillItemsApiImport0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.import0WithHttpInfo(param.requestBody,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public import0(param: ADMINSkillItemsApiImport0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.import0(param.requestBody,  options).toPromise();
    }

    /**
     * Replace a single Skill
     * @param param the request object
     */
    public replaceOneBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiReplaceOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseSkillAdminControllerSkillWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Skill
     * @param param the request object
     */
    public replaceOneBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiReplaceOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseSkillAdminControllerSkill(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Skill
     * @param param the request object
     */
    public updateOneBaseSkillAdminControllerSkillWithHttpInfo(param: ADMINSkillItemsApiUpdateOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseSkillAdminControllerSkillWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Skill
     * @param param the request object
     */
    public updateOneBaseSkillAdminControllerSkill(param: ADMINSkillItemsApiUpdateOneBaseSkillAdminControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseSkillAdminControllerSkill(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINSourceItemsApi } from "./ObservableAPI";
import { ADMINSourceItemsApiRequestFactory, ADMINSourceItemsApiResponseProcessor} from "../apis/ADMINSourceItemsApi";

export interface ADMINSourceItemsApiCreateManyBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * @type CreateManySourceDto
     * @memberof ADMINSourceItemsApicreateManyBaseSourceAdminControllerSource
     */
    createManySourceDto: CreateManySourceDto
}

export interface ADMINSourceItemsApiCreateOneBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * @type any
     * @memberof ADMINSourceItemsApicreateOneBaseSourceAdminControllerSource
     */
    body: any
}

export interface ADMINSourceItemsApiDeleteOneBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApideleteOneBaseSourceAdminControllerSource
     */
    id: number
}

export interface ADMINSourceItemsApiGetManyBaseSourceAdminControllerSourceRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetManyBaseSourceAdminControllerSource
     */
    cache?: number
}

export interface ADMINSourceItemsApiGetOneBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetOneBaseSourceAdminControllerSource
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetOneBaseSourceAdminControllerSource
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINSourceItemsApigetOneBaseSourceAdminControllerSource
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApigetOneBaseSourceAdminControllerSource
     */
    cache?: number
}

export interface ADMINSourceItemsApiReplaceOneBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApireplaceOneBaseSourceAdminControllerSource
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINSourceItemsApireplaceOneBaseSourceAdminControllerSource
     */
    body: any
}

export interface ADMINSourceItemsApiUpdateOneBaseSourceAdminControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINSourceItemsApiupdateOneBaseSourceAdminControllerSource
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINSourceItemsApiupdateOneBaseSourceAdminControllerSource
     */
    body: any
}

export class ObjectADMINSourceItemsApi {
    private api: ObservableADMINSourceItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINSourceItemsApiRequestFactory, responseProcessor?: ADMINSourceItemsApiResponseProcessor) {
        this.api = new ObservableADMINSourceItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Sources
     * @param param the request object
     */
    public createManyBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiCreateManyBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseSourceAdminControllerSourceWithHttpInfo(param.createManySourceDto,  options).toPromise();
    }

    /**
     * Create multiple Sources
     * @param param the request object
     */
    public createManyBaseSourceAdminControllerSource(param: ADMINSourceItemsApiCreateManyBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseSourceAdminControllerSource(param.createManySourceDto,  options).toPromise();
    }

    /**
     * Create a single Source
     * @param param the request object
     */
    public createOneBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiCreateOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseSourceAdminControllerSourceWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Source
     * @param param the request object
     */
    public createOneBaseSourceAdminControllerSource(param: ADMINSourceItemsApiCreateOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseSourceAdminControllerSource(param.body,  options).toPromise();
    }

    /**
     * Delete a single Source
     * @param param the request object
     */
    public deleteOneBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiDeleteOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseSourceAdminControllerSourceWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Source
     * @param param the request object
     */
    public deleteOneBaseSourceAdminControllerSource(param: ADMINSourceItemsApiDeleteOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseSourceAdminControllerSource(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Sources
     * @param param the request object
     */
    public getManyBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiGetManyBaseSourceAdminControllerSourceRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseSourceAdminControllerSource200Response>> {
        return this.api.getManyBaseSourceAdminControllerSourceWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Sources
     * @param param the request object
     */
    public getManyBaseSourceAdminControllerSource(param: ADMINSourceItemsApiGetManyBaseSourceAdminControllerSourceRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseSourceAdminControllerSource200Response> {
        return this.api.getManyBaseSourceAdminControllerSource(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Source
     * @param param the request object
     */
    public getOneBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiGetOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseSourceAdminControllerSourceWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Source
     * @param param the request object
     */
    public getOneBaseSourceAdminControllerSource(param: ADMINSourceItemsApiGetOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseSourceAdminControllerSource(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Source
     * @param param the request object
     */
    public replaceOneBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiReplaceOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseSourceAdminControllerSourceWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Source
     * @param param the request object
     */
    public replaceOneBaseSourceAdminControllerSource(param: ADMINSourceItemsApiReplaceOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseSourceAdminControllerSource(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Source
     * @param param the request object
     */
    public updateOneBaseSourceAdminControllerSourceWithHttpInfo(param: ADMINSourceItemsApiUpdateOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseSourceAdminControllerSourceWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Source
     * @param param the request object
     */
    public updateOneBaseSourceAdminControllerSource(param: ADMINSourceItemsApiUpdateOneBaseSourceAdminControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseSourceAdminControllerSource(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINStopWordItemsApi } from "./ObservableAPI";
import { ADMINStopWordItemsApiRequestFactory, ADMINStopWordItemsApiResponseProcessor} from "../apis/ADMINStopWordItemsApi";

export interface ADMINStopWordItemsApiCreateManyBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * @type CreateManyStopWordDto
     * @memberof ADMINStopWordItemsApicreateManyBaseStopWordAdminControllerStopWord
     */
    createManyStopWordDto: CreateManyStopWordDto
}

export interface ADMINStopWordItemsApiCreateOneBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * @type any
     * @memberof ADMINStopWordItemsApicreateOneBaseStopWordAdminControllerStopWord
     */
    body: any
}

export interface ADMINStopWordItemsApiDeleteOneBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApideleteOneBaseStopWordAdminControllerStopWord
     */
    id: number
}

export interface ADMINStopWordItemsApiGetManyBaseStopWordAdminControllerStopWordRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetManyBaseStopWordAdminControllerStopWord
     */
    cache?: number
}

export interface ADMINStopWordItemsApiGetOneBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetOneBaseStopWordAdminControllerStopWord
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetOneBaseStopWordAdminControllerStopWord
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStopWordItemsApigetOneBaseStopWordAdminControllerStopWord
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApigetOneBaseStopWordAdminControllerStopWord
     */
    cache?: number
}

export interface ADMINStopWordItemsApiReplaceOneBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApireplaceOneBaseStopWordAdminControllerStopWord
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINStopWordItemsApireplaceOneBaseStopWordAdminControllerStopWord
     */
    body: any
}

export interface ADMINStopWordItemsApiUpdateOneBaseStopWordAdminControllerStopWordRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStopWordItemsApiupdateOneBaseStopWordAdminControllerStopWord
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINStopWordItemsApiupdateOneBaseStopWordAdminControllerStopWord
     */
    body: any
}

export class ObjectADMINStopWordItemsApi {
    private api: ObservableADMINStopWordItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINStopWordItemsApiRequestFactory, responseProcessor?: ADMINStopWordItemsApiResponseProcessor) {
        this.api = new ObservableADMINStopWordItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple StopWords
     * @param param the request object
     */
    public createManyBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiCreateManyBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseStopWordAdminControllerStopWordWithHttpInfo(param.createManyStopWordDto,  options).toPromise();
    }

    /**
     * Create multiple StopWords
     * @param param the request object
     */
    public createManyBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiCreateManyBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseStopWordAdminControllerStopWord(param.createManyStopWordDto,  options).toPromise();
    }

    /**
     * Create a single StopWord
     * @param param the request object
     */
    public createOneBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiCreateOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseStopWordAdminControllerStopWordWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single StopWord
     * @param param the request object
     */
    public createOneBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiCreateOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseStopWordAdminControllerStopWord(param.body,  options).toPromise();
    }

    /**
     * Delete a single StopWord
     * @param param the request object
     */
    public deleteOneBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiDeleteOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseStopWordAdminControllerStopWordWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single StopWord
     * @param param the request object
     */
    public deleteOneBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiDeleteOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseStopWordAdminControllerStopWord(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple StopWords
     * @param param the request object
     */
    public getManyBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiGetManyBaseStopWordAdminControllerStopWordRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseStopWordAdminControllerStopWord200Response>> {
        return this.api.getManyBaseStopWordAdminControllerStopWordWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple StopWords
     * @param param the request object
     */
    public getManyBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiGetManyBaseStopWordAdminControllerStopWordRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseStopWordAdminControllerStopWord200Response> {
        return this.api.getManyBaseStopWordAdminControllerStopWord(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single StopWord
     * @param param the request object
     */
    public getOneBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiGetOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseStopWordAdminControllerStopWordWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single StopWord
     * @param param the request object
     */
    public getOneBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiGetOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseStopWordAdminControllerStopWord(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single StopWord
     * @param param the request object
     */
    public replaceOneBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiReplaceOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseStopWordAdminControllerStopWordWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single StopWord
     * @param param the request object
     */
    public replaceOneBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiReplaceOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseStopWordAdminControllerStopWord(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single StopWord
     * @param param the request object
     */
    public updateOneBaseStopWordAdminControllerStopWordWithHttpInfo(param: ADMINStopWordItemsApiUpdateOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseStopWordAdminControllerStopWordWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single StopWord
     * @param param the request object
     */
    public updateOneBaseStopWordAdminControllerStopWord(param: ADMINStopWordItemsApiUpdateOneBaseStopWordAdminControllerStopWordRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseStopWordAdminControllerStopWord(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINStoryItemsApi } from "./ObservableAPI";
import { ADMINStoryItemsApiRequestFactory, ADMINStoryItemsApiResponseProcessor} from "../apis/ADMINStoryItemsApi";

export interface ADMINStoryItemsApiCreateOneBaseStoryAdminControllerStoryRequest {
    /**
     * 
     * @type any
     * @memberof ADMINStoryItemsApicreateOneBaseStoryAdminControllerStory
     */
    body: any
}

export interface ADMINStoryItemsApiDeleteOneBaseStoryAdminControllerStoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApideleteOneBaseStoryAdminControllerStory
     */
    id: number
}

export interface ADMINStoryItemsApiGetManyBaseStoryAdminControllerStoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetManyBaseStoryAdminControllerStory
     */
    cache?: number
}

export interface ADMINStoryItemsApiGetOneBaseStoryAdminControllerStoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetOneBaseStoryAdminControllerStory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetOneBaseStoryAdminControllerStory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINStoryItemsApigetOneBaseStoryAdminControllerStory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApigetOneBaseStoryAdminControllerStory
     */
    cache?: number
}

export interface ADMINStoryItemsApiReplaceOneBaseStoryAdminControllerStoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApireplaceOneBaseStoryAdminControllerStory
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINStoryItemsApireplaceOneBaseStoryAdminControllerStory
     */
    body: any
}

export interface ADMINStoryItemsApiUpdateOneBaseStoryAdminControllerStoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINStoryItemsApiupdateOneBaseStoryAdminControllerStory
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINStoryItemsApiupdateOneBaseStoryAdminControllerStory
     */
    body: any
}

export class ObjectADMINStoryItemsApi {
    private api: ObservableADMINStoryItemsApi

    public constructor(configuration: Configuration, requestFactory?: ADMINStoryItemsApiRequestFactory, responseProcessor?: ADMINStoryItemsApiResponseProcessor) {
        this.api = new ObservableADMINStoryItemsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Story
     * @param param the request object
     */
    public createOneBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiCreateOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseStoryAdminControllerStoryWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Story
     * @param param the request object
     */
    public createOneBaseStoryAdminControllerStory(param: ADMINStoryItemsApiCreateOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseStoryAdminControllerStory(param.body,  options).toPromise();
    }

    /**
     * Delete a single Story
     * @param param the request object
     */
    public deleteOneBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiDeleteOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseStoryAdminControllerStoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Story
     * @param param the request object
     */
    public deleteOneBaseStoryAdminControllerStory(param: ADMINStoryItemsApiDeleteOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseStoryAdminControllerStory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Stories
     * @param param the request object
     */
    public getManyBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiGetManyBaseStoryAdminControllerStoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseStoryAdminControllerStory200Response>> {
        return this.api.getManyBaseStoryAdminControllerStoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Stories
     * @param param the request object
     */
    public getManyBaseStoryAdminControllerStory(param: ADMINStoryItemsApiGetManyBaseStoryAdminControllerStoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseStoryAdminControllerStory200Response> {
        return this.api.getManyBaseStoryAdminControllerStory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Story
     * @param param the request object
     */
    public getOneBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiGetOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseStoryAdminControllerStoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Story
     * @param param the request object
     */
    public getOneBaseStoryAdminControllerStory(param: ADMINStoryItemsApiGetOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseStoryAdminControllerStory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Story
     * @param param the request object
     */
    public replaceOneBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiReplaceOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseStoryAdminControllerStoryWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Story
     * @param param the request object
     */
    public replaceOneBaseStoryAdminControllerStory(param: ADMINStoryItemsApiReplaceOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseStoryAdminControllerStory(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Story
     * @param param the request object
     */
    public updateOneBaseStoryAdminControllerStoryWithHttpInfo(param: ADMINStoryItemsApiUpdateOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseStoryAdminControllerStoryWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Story
     * @param param the request object
     */
    public updateOneBaseStoryAdminControllerStory(param: ADMINStoryItemsApiUpdateOneBaseStoryAdminControllerStoryRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseStoryAdminControllerStory(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINVacancyApprovedApi } from "./ObservableAPI";
import { ADMINVacancyApprovedApiRequestFactory, ADMINVacancyApprovedApiResponseProcessor} from "../apis/ADMINVacancyApprovedApi";

export interface ADMINVacancyApprovedApiCreateManyBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * @type CreateManyVacancyDto
     * @memberof ADMINVacancyApprovedApicreateManyBaseVacancyApprovedAdminControllerVacancy
     */
    createManyVacancyDto: CreateManyVacancyDto
}

export interface ADMINVacancyApprovedApiCreateOneBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * @type any
     * @memberof ADMINVacancyApprovedApicreateOneBaseVacancyApprovedAdminControllerVacancy
     */
    body: any
}

export interface ADMINVacancyApprovedApiDeleteOneBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApideleteOneBaseVacancyApprovedAdminControllerVacancy
     */
    id: number
}

export interface ADMINVacancyApprovedApiGetManyBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetManyBaseVacancyApprovedAdminControllerVacancy
     */
    cache?: number
}

export interface ADMINVacancyApprovedApiGetOneBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetOneBaseVacancyApprovedAdminControllerVacancy
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetOneBaseVacancyApprovedAdminControllerVacancy
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyApprovedApigetOneBaseVacancyApprovedAdminControllerVacancy
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApigetOneBaseVacancyApprovedAdminControllerVacancy
     */
    cache?: number
}

export interface ADMINVacancyApprovedApiReplaceOneBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApireplaceOneBaseVacancyApprovedAdminControllerVacancy
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINVacancyApprovedApireplaceOneBaseVacancyApprovedAdminControllerVacancy
     */
    body: any
}

export interface ADMINVacancyApprovedApiUpdateOneBaseVacancyApprovedAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyApprovedApiupdateOneBaseVacancyApprovedAdminControllerVacancy
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINVacancyApprovedApiupdateOneBaseVacancyApprovedAdminControllerVacancy
     */
    body: any
}

export class ObjectADMINVacancyApprovedApi {
    private api: ObservableADMINVacancyApprovedApi

    public constructor(configuration: Configuration, requestFactory?: ADMINVacancyApprovedApiRequestFactory, responseProcessor?: ADMINVacancyApprovedApiResponseProcessor) {
        this.api = new ObservableADMINVacancyApprovedApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Vacancies
     * @param param the request object
     */
    public createManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiCreateManyBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.createManyVacancyDto,  options).toPromise();
    }

    /**
     * Create multiple Vacancies
     * @param param the request object
     */
    public createManyBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiCreateManyBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseVacancyApprovedAdminControllerVacancy(param.createManyVacancyDto,  options).toPromise();
    }

    /**
     * Create a single Vacancy
     * @param param the request object
     */
    public createOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiCreateOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Vacancy
     * @param param the request object
     */
    public createOneBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiCreateOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseVacancyApprovedAdminControllerVacancy(param.body,  options).toPromise();
    }

    /**
     * Delete a single Vacancy
     * @param param the request object
     */
    public deleteOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiDeleteOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Vacancy
     * @param param the request object
     */
    public deleteOneBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiDeleteOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseVacancyApprovedAdminControllerVacancy(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Vacancies
     * @param param the request object
     */
    public getManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiGetManyBaseVacancyApprovedAdminControllerVacancyRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Vacancies
     * @param param the request object
     */
    public getManyBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiGetManyBaseVacancyApprovedAdminControllerVacancyRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseVacancyApprovedAdminControllerVacancy(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vacancy
     * @param param the request object
     */
    public getOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiGetOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vacancy
     * @param param the request object
     */
    public getOneBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiGetOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseVacancyApprovedAdminControllerVacancy(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Vacancy
     * @param param the request object
     */
    public replaceOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiReplaceOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Vacancy
     * @param param the request object
     */
    public replaceOneBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiReplaceOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseVacancyApprovedAdminControllerVacancy(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vacancy
     * @param param the request object
     */
    public updateOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param: ADMINVacancyApprovedApiUpdateOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vacancy
     * @param param the request object
     */
    public updateOneBaseVacancyApprovedAdminControllerVacancy(param: ADMINVacancyApprovedApiUpdateOneBaseVacancyApprovedAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseVacancyApprovedAdminControllerVacancy(param.id, param.body,  options).toPromise();
    }

}

import { ObservableADMINVacancyModerationApi } from "./ObservableAPI";
import { ADMINVacancyModerationApiRequestFactory, ADMINVacancyModerationApiResponseProcessor} from "../apis/ADMINVacancyModerationApi";

export interface ADMINVacancyModerationApiCreateManyBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * @type CreateManyVacancyDto
     * @memberof ADMINVacancyModerationApicreateManyBaseVacancyModerationAdminControllerVacancy
     */
    createManyVacancyDto: CreateManyVacancyDto
}

export interface ADMINVacancyModerationApiCreateOneBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * @type any
     * @memberof ADMINVacancyModerationApicreateOneBaseVacancyModerationAdminControllerVacancy
     */
    body: any
}

export interface ADMINVacancyModerationApiDeleteOneBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApideleteOneBaseVacancyModerationAdminControllerVacancy
     */
    id: number
}

export interface ADMINVacancyModerationApiGetManyBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetManyBaseVacancyModerationAdminControllerVacancy
     */
    cache?: number
}

export interface ADMINVacancyModerationApiGetOneBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetOneBaseVacancyModerationAdminControllerVacancy
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetOneBaseVacancyModerationAdminControllerVacancy
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ADMINVacancyModerationApigetOneBaseVacancyModerationAdminControllerVacancy
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApigetOneBaseVacancyModerationAdminControllerVacancy
     */
    cache?: number
}

export interface ADMINVacancyModerationApiReplaceOneBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApireplaceOneBaseVacancyModerationAdminControllerVacancy
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINVacancyModerationApireplaceOneBaseVacancyModerationAdminControllerVacancy
     */
    body: any
}

export interface ADMINVacancyModerationApiUpdateOneBaseVacancyModerationAdminControllerVacancyRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ADMINVacancyModerationApiupdateOneBaseVacancyModerationAdminControllerVacancy
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ADMINVacancyModerationApiupdateOneBaseVacancyModerationAdminControllerVacancy
     */
    body: any
}

export class ObjectADMINVacancyModerationApi {
    private api: ObservableADMINVacancyModerationApi

    public constructor(configuration: Configuration, requestFactory?: ADMINVacancyModerationApiRequestFactory, responseProcessor?: ADMINVacancyModerationApiResponseProcessor) {
        this.api = new ObservableADMINVacancyModerationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple Vacancies
     * @param param the request object
     */
    public createManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiCreateManyBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.createManyVacancyDto,  options).toPromise();
    }

    /**
     * Create multiple Vacancies
     * @param param the request object
     */
    public createManyBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiCreateManyBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseVacancyModerationAdminControllerVacancy(param.createManyVacancyDto,  options).toPromise();
    }

    /**
     * Create a single Vacancy
     * @param param the request object
     */
    public createOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiCreateOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Vacancy
     * @param param the request object
     */
    public createOneBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiCreateOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseVacancyModerationAdminControllerVacancy(param.body,  options).toPromise();
    }

    /**
     * Delete a single Vacancy
     * @param param the request object
     */
    public deleteOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiDeleteOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Vacancy
     * @param param the request object
     */
    public deleteOneBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiDeleteOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseVacancyModerationAdminControllerVacancy(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Vacancies
     * @param param the request object
     */
    public getManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiGetManyBaseVacancyModerationAdminControllerVacancyRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Vacancies
     * @param param the request object
     */
    public getManyBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiGetManyBaseVacancyModerationAdminControllerVacancyRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseVacancyModerationAdminControllerVacancy(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vacancy
     * @param param the request object
     */
    public getOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiGetOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vacancy
     * @param param the request object
     */
    public getOneBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiGetOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseVacancyModerationAdminControllerVacancy(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Vacancy
     * @param param the request object
     */
    public replaceOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiReplaceOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Vacancy
     * @param param the request object
     */
    public replaceOneBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiReplaceOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseVacancyModerationAdminControllerVacancy(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vacancy
     * @param param the request object
     */
    public updateOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param: ADMINVacancyModerationApiUpdateOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Vacancy
     * @param param the request object
     */
    public updateOneBaseVacancyModerationAdminControllerVacancy(param: ADMINVacancyModerationApiUpdateOneBaseVacancyModerationAdminControllerVacancyRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseVacancyModerationAdminControllerVacancy(param.id, param.body,  options).toPromise();
    }

}

import { ObservableAdminLoginApi } from "./ObservableAPI";
import { AdminLoginApiRequestFactory, AdminLoginApiResponseProcessor} from "../apis/AdminLoginApi";

export interface AdminLoginApiLogin0Request {
    /**
     * 
     * @type AdminLoginRequestDTO
     * @memberof AdminLoginApilogin0
     */
    adminLoginRequestDTO: AdminLoginRequestDTO
}

export class ObjectAdminLoginApi {
    private api: ObservableAdminLoginApi

    public constructor(configuration: Configuration, requestFactory?: AdminLoginApiRequestFactory, responseProcessor?: AdminLoginApiResponseProcessor) {
        this.api = new ObservableAdminLoginApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public login0WithHttpInfo(param: AdminLoginApiLogin0Request, options?: ConfigurationOptions): Promise<HttpInfo<AdminLoginResponseDTO>> {
        return this.api.login0WithHttpInfo(param.adminLoginRequestDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public login0(param: AdminLoginApiLogin0Request, options?: ConfigurationOptions): Promise<AdminLoginResponseDTO> {
        return this.api.login0(param.adminLoginRequestDTO,  options).toPromise();
    }

}

import { ObservableAdminPromoCodesApi } from "./ObservableAPI";
import { AdminPromoCodesApiRequestFactory, AdminPromoCodesApiResponseProcessor} from "../apis/AdminPromoCodesApi";

export interface AdminPromoCodesApiAssignToProfiles0Request {
    /**
     * 
     * @type AssignPromoCodeQueryDto
     * @memberof AdminPromoCodesApiassignToProfiles0
     */
    assignPromoCodeQueryDto: AssignPromoCodeQueryDto
}

export interface AdminPromoCodesApiCreate0Request {
    /**
     * 
     * @type CreatePromoCodeQueryDto
     * @memberof AdminPromoCodesApicreate0
     */
    createPromoCodeQueryDto: CreatePromoCodeQueryDto
}

export interface AdminPromoCodesApiDelete0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof AdminPromoCodesApidelete0
     */
    code: string
}

export interface AdminPromoCodesApiFindAll0Request {
}

export interface AdminPromoCodesApiGetByCode0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof AdminPromoCodesApigetByCode0
     */
    code: string
}

export interface AdminPromoCodesApiRemoveFromProfiles0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof AdminPromoCodesApiremoveFromProfiles0
     */
    code: string
}

export interface AdminPromoCodesApiUpdate0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof AdminPromoCodesApiupdate0
     */
    code: string
    /**
     * 
     * @type UpdatePromoCodeQueryDto
     * @memberof AdminPromoCodesApiupdate0
     */
    updatePromoCodeQueryDto: UpdatePromoCodeQueryDto
}

export class ObjectAdminPromoCodesApi {
    private api: ObservableAdminPromoCodesApi

    public constructor(configuration: Configuration, requestFactory?: AdminPromoCodesApiRequestFactory, responseProcessor?: AdminPromoCodesApiResponseProcessor) {
        this.api = new ObservableAdminPromoCodesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Assign a promo code to profiles
     * @param param the request object
     */
    public assignToProfiles0WithHttpInfo(param: AdminPromoCodesApiAssignToProfiles0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.assignToProfiles0WithHttpInfo(param.assignPromoCodeQueryDto,  options).toPromise();
    }

    /**
     * Assign a promo code to profiles
     * @param param the request object
     */
    public assignToProfiles0(param: AdminPromoCodesApiAssignToProfiles0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.assignToProfiles0(param.assignPromoCodeQueryDto,  options).toPromise();
    }

    /**
     * Create a new promo code
     * @param param the request object
     */
    public create0WithHttpInfo(param: AdminPromoCodesApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<PromoCodeResponseDto>> {
        return this.api.create0WithHttpInfo(param.createPromoCodeQueryDto,  options).toPromise();
    }

    /**
     * Create a new promo code
     * @param param the request object
     */
    public create0(param: AdminPromoCodesApiCreate0Request, options?: ConfigurationOptions): Promise<PromoCodeResponseDto> {
        return this.api.create0(param.createPromoCodeQueryDto,  options).toPromise();
    }

    /**
     * Delete a promo code by code
     * @param param the request object
     */
    public delete0WithHttpInfo(param: AdminPromoCodesApiDelete0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.delete0WithHttpInfo(param.code,  options).toPromise();
    }

    /**
     * Delete a promo code by code
     * @param param the request object
     */
    public delete0(param: AdminPromoCodesApiDelete0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.delete0(param.code,  options).toPromise();
    }

    /**
     * Get all promo codes
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: AdminPromoCodesApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<PromoCodeResponseDto>>> {
        return this.api.findAll0WithHttpInfo( options).toPromise();
    }

    /**
     * Get all promo codes
     * @param param the request object
     */
    public findAll0(param: AdminPromoCodesApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<Array<PromoCodeResponseDto>> {
        return this.api.findAll0( options).toPromise();
    }

    /**
     * Get a promo code by code
     * @param param the request object
     */
    public getByCode0WithHttpInfo(param: AdminPromoCodesApiGetByCode0Request, options?: ConfigurationOptions): Promise<HttpInfo<PromoCodeResponseDto>> {
        return this.api.getByCode0WithHttpInfo(param.code,  options).toPromise();
    }

    /**
     * Get a promo code by code
     * @param param the request object
     */
    public getByCode0(param: AdminPromoCodesApiGetByCode0Request, options?: ConfigurationOptions): Promise<PromoCodeResponseDto> {
        return this.api.getByCode0(param.code,  options).toPromise();
    }

    /**
     * Remove a promo code from profiles
     * @param param the request object
     */
    public removeFromProfiles0WithHttpInfo(param: AdminPromoCodesApiRemoveFromProfiles0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromProfiles0WithHttpInfo(param.code,  options).toPromise();
    }

    /**
     * Remove a promo code from profiles
     * @param param the request object
     */
    public removeFromProfiles0(param: AdminPromoCodesApiRemoveFromProfiles0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromProfiles0(param.code,  options).toPromise();
    }

    /**
     * Update an existing promo code by code
     * @param param the request object
     */
    public update0WithHttpInfo(param: AdminPromoCodesApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<PromoCodeResponseDto>> {
        return this.api.update0WithHttpInfo(param.code, param.updatePromoCodeQueryDto,  options).toPromise();
    }

    /**
     * Update an existing promo code by code
     * @param param the request object
     */
    public update0(param: AdminPromoCodesApiUpdate0Request, options?: ConfigurationOptions): Promise<PromoCodeResponseDto> {
        return this.api.update0(param.code, param.updatePromoCodeQueryDto,  options).toPromise();
    }

}

import { ObservableApplicationApi } from "./ObservableAPI";
import { ApplicationApiRequestFactory, ApplicationApiResponseProcessor} from "../apis/ApplicationApi";

export interface ApplicationApiCreateOneBaseApplicationControllerApplicationRequest {
    /**
     * 
     * @type any
     * @memberof ApplicationApicreateOneBaseApplicationControllerApplication
     */
    body: any
}

export interface ApplicationApiDeleteOneBaseApplicationControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApideleteOneBaseApplicationControllerApplication
     */
    id: number
}

export interface ApplicationApiGetManyBaseApplicationControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    status: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetManyBaseApplicationControllerApplication
     */
    cache?: number
}

export interface ApplicationApiGetOneBaseApplicationControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ApplicationApigetOneBaseApplicationControllerApplication
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetOneBaseApplicationControllerApplication
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetOneBaseApplicationControllerApplication
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ApplicationApigetOneBaseApplicationControllerApplication
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApigetOneBaseApplicationControllerApplication
     */
    cache?: number
}

export interface ApplicationApiGetStats0Request {
}

export interface ApplicationApiUpdateOneBaseApplicationControllerApplicationRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ApplicationApiupdateOneBaseApplicationControllerApplication
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ApplicationApiupdateOneBaseApplicationControllerApplication
     */
    body: any
}

export class ObjectApplicationApi {
    private api: ObservableApplicationApi

    public constructor(configuration: Configuration, requestFactory?: ApplicationApiRequestFactory, responseProcessor?: ApplicationApiResponseProcessor) {
        this.api = new ObservableApplicationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Application
     * @param param the request object
     */
    public createOneBaseApplicationControllerApplicationWithHttpInfo(param: ApplicationApiCreateOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseApplicationControllerApplicationWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Application
     * @param param the request object
     */
    public createOneBaseApplicationControllerApplication(param: ApplicationApiCreateOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseApplicationControllerApplication(param.body,  options).toPromise();
    }

    /**
     * Delete a single Application
     * @param param the request object
     */
    public deleteOneBaseApplicationControllerApplicationWithHttpInfo(param: ApplicationApiDeleteOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseApplicationControllerApplicationWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Application
     * @param param the request object
     */
    public deleteOneBaseApplicationControllerApplication(param: ApplicationApiDeleteOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseApplicationControllerApplication(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Applications
     * @param param the request object
     */
    public getManyBaseApplicationControllerApplicationWithHttpInfo(param: ApplicationApiGetManyBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.getManyBaseApplicationControllerApplicationWithHttpInfo(param.lang, param.status, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Applications
     * @param param the request object
     */
    public getManyBaseApplicationControllerApplication(param: ApplicationApiGetManyBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.getManyBaseApplicationControllerApplication(param.lang, param.status, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Application
     * @param param the request object
     */
    public getOneBaseApplicationControllerApplicationWithHttpInfo(param: ApplicationApiGetOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseApplicationControllerApplicationWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Application
     * @param param the request object
     */
    public getOneBaseApplicationControllerApplication(param: ApplicationApiGetOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseApplicationControllerApplication(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getStats0WithHttpInfo(param: ApplicationApiGetStats0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.getStats0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getStats0(param: ApplicationApiGetStats0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.getStats0( options).toPromise();
    }

    /**
     * Update a single Application
     * @param param the request object
     */
    public updateOneBaseApplicationControllerApplicationWithHttpInfo(param: ApplicationApiUpdateOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseApplicationControllerApplicationWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Application
     * @param param the request object
     */
    public updateOneBaseApplicationControllerApplication(param: ApplicationApiUpdateOneBaseApplicationControllerApplicationRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseApplicationControllerApplication(param.id, param.body,  options).toPromise();
    }

}

import { ObservableArticleApi } from "./ObservableAPI";
import { ArticleApiRequestFactory, ArticleApiResponseProcessor} from "../apis/ArticleApi";

export interface ArticleApiAddToSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApiaddToSaved0
     */
    id: number
}

export interface ArticleApiFindByFriendlyName0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ArticleApifindByFriendlyName0
     */
    url: string
}

export interface ArticleApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApifindById0
     */
    id: number
}

export interface ArticleApiLike0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApilike0
     */
    id: number
}

export interface ArticleApiListByProfile0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApilistByProfile0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApilistByProfile0
     */
    page: number
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleApilistByProfile0
     */
    categories: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleApilistByProfile0
     */
    communities: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ArticleApilistByProfile0
     */
    search: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ArticleApilistByProfile0
     */
    savedByCurrentProfile: string
}

export interface ArticleApiRemoveFromSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApiremoveFromSaved0
     */
    id: number
}

export interface ArticleApiUnLike0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleApiunLike0
     */
    id: number
}

export class ObjectArticleApi {
    private api: ObservableArticleApi

    public constructor(configuration: Configuration, requestFactory?: ArticleApiRequestFactory, responseProcessor?: ArticleApiResponseProcessor) {
        this.api = new ObservableArticleApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: ArticleApiAddToSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0(param: ArticleApiAddToSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findByFriendlyName0WithHttpInfo(param: ArticleApiFindByFriendlyName0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findByFriendlyName0WithHttpInfo(param.url,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findByFriendlyName0(param: ArticleApiFindByFriendlyName0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findByFriendlyName0(param.url,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: ArticleApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: ArticleApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public like0WithHttpInfo(param: ArticleApiLike0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.like0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public like0(param: ArticleApiLike0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.like0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0WithHttpInfo(param: ArticleApiListByProfile0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.listByProfile0WithHttpInfo(param.limit, param.page, param.categories, param.communities, param.search, param.savedByCurrentProfile,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0(param: ArticleApiListByProfile0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.listByProfile0(param.limit, param.page, param.categories, param.communities, param.search, param.savedByCurrentProfile,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: ArticleApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0(param: ArticleApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public unLike0WithHttpInfo(param: ArticleApiUnLike0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.unLike0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public unLike0(param: ArticleApiUnLike0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.unLike0(param.id,  options).toPromise();
    }

}

import { ObservableArticleCategoryApi } from "./ObservableAPI";
import { ArticleCategoryApiRequestFactory, ArticleCategoryApiResponseProcessor} from "../apis/ArticleCategoryApi";

export interface ArticleCategoryApiAddToSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCategoryApiaddToSaved0
     */
    id: number
}

export interface ArticleCategoryApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCategoryApifindById0
     */
    id: number
}

export interface ArticleCategoryApiList0Request {
}

export interface ArticleCategoryApiRemoveFromSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCategoryApiremoveFromSaved0
     */
    id: number
}

export class ObjectArticleCategoryApi {
    private api: ObservableArticleCategoryApi

    public constructor(configuration: Configuration, requestFactory?: ArticleCategoryApiRequestFactory, responseProcessor?: ArticleCategoryApiResponseProcessor) {
        this.api = new ObservableArticleCategoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: ArticleCategoryApiAddToSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0(param: ArticleCategoryApiAddToSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: ArticleCategoryApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<ArticleCategory>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: ArticleCategoryApiFindById0Request, options?: ConfigurationOptions): Promise<ArticleCategory> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: ArticleCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: ArticleCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.list0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: ArticleCategoryApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0(param: ArticleCategoryApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0(param.id,  options).toPromise();
    }

}

import { ObservableArticleCommunityApi } from "./ObservableAPI";
import { ArticleCommunityApiRequestFactory, ArticleCommunityApiResponseProcessor} from "../apis/ArticleCommunityApi";

export interface ArticleCommunityApiCreateOneBaseArticleCommunityControllerArticleRequest {
    /**
     * 
     * @type any
     * @memberof ArticleCommunityApicreateOneBaseArticleCommunityControllerArticle
     */
    body: any
}

export interface ArticleCommunityApiDeleteOneBaseArticleCommunityControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApideleteOneBaseArticleCommunityControllerArticle
     */
    id: number
}

export interface ArticleCommunityApiGetManyBaseArticleCommunityControllerArticleRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetManyBaseArticleCommunityControllerArticle
     */
    cache?: number
}

export interface ArticleCommunityApiGetOneBaseArticleCommunityControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetOneBaseArticleCommunityControllerArticle
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetOneBaseArticleCommunityControllerArticle
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ArticleCommunityApigetOneBaseArticleCommunityControllerArticle
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApigetOneBaseArticleCommunityControllerArticle
     */
    cache?: number
}

export interface ArticleCommunityApiReplaceOneBaseArticleCommunityControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApireplaceOneBaseArticleCommunityControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ArticleCommunityApireplaceOneBaseArticleCommunityControllerArticle
     */
    body: any
}

export interface ArticleCommunityApiUpdateOneBaseArticleCommunityControllerArticleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ArticleCommunityApiupdateOneBaseArticleCommunityControllerArticle
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ArticleCommunityApiupdateOneBaseArticleCommunityControllerArticle
     */
    body: any
}

export class ObjectArticleCommunityApi {
    private api: ObservableArticleCommunityApi

    public constructor(configuration: Configuration, requestFactory?: ArticleCommunityApiRequestFactory, responseProcessor?: ArticleCommunityApiResponseProcessor) {
        this.api = new ObservableArticleCommunityApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiCreateOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseArticleCommunityControllerArticleWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Article
     * @param param the request object
     */
    public createOneBaseArticleCommunityControllerArticle(param: ArticleCommunityApiCreateOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseArticleCommunityControllerArticle(param.body,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiDeleteOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseArticleCommunityControllerArticleWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Article
     * @param param the request object
     */
    public deleteOneBaseArticleCommunityControllerArticle(param: ArticleCommunityApiDeleteOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseArticleCommunityControllerArticle(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiGetManyBaseArticleCommunityControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        return this.api.getManyBaseArticleCommunityControllerArticleWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Articles
     * @param param the request object
     */
    public getManyBaseArticleCommunityControllerArticle(param: ArticleCommunityApiGetManyBaseArticleCommunityControllerArticleRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.api.getManyBaseArticleCommunityControllerArticle(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiGetOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseArticleCommunityControllerArticleWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Article
     * @param param the request object
     */
    public getOneBaseArticleCommunityControllerArticle(param: ArticleCommunityApiGetOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseArticleCommunityControllerArticle(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiReplaceOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseArticleCommunityControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single Article
     * @param param the request object
     */
    public replaceOneBaseArticleCommunityControllerArticle(param: ArticleCommunityApiReplaceOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseArticleCommunityControllerArticle(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleCommunityControllerArticleWithHttpInfo(param: ArticleCommunityApiUpdateOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseArticleCommunityControllerArticleWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Article
     * @param param the request object
     */
    public updateOneBaseArticleCommunityControllerArticle(param: ArticleCommunityApiUpdateOneBaseArticleCommunityControllerArticleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseArticleCommunityControllerArticle(param.id, param.body,  options).toPromise();
    }

}

import { ObservableAssetApi } from "./ObservableAPI";
import { AssetApiRequestFactory, AssetApiResponseProcessor} from "../apis/AssetApi";

export interface AssetApiDeleteOneBaseAssetControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof AssetApideleteOneBaseAssetControllerAsset
     */
    id: number
}

export interface AssetApiFileRedirect0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof AssetApifileRedirect0
     */
    key: string
}

export interface AssetApiGetManyBaseAssetControllerAssetRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetManyBaseAssetControllerAsset
     */
    cache?: number
}

export interface AssetApiGetOneBaseAssetControllerAssetRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetOneBaseAssetControllerAsset
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetOneBaseAssetControllerAsset
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof AssetApigetOneBaseAssetControllerAsset
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof AssetApigetOneBaseAssetControllerAsset
     */
    cache?: number
}

export interface AssetApiUpload0Request {
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof AssetApiupload0
     */
    file?: HttpFile
}

export class ObjectAssetApi {
    private api: ObservableAssetApi

    public constructor(configuration: Configuration, requestFactory?: AssetApiRequestFactory, responseProcessor?: AssetApiResponseProcessor) {
        this.api = new ObservableAssetApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Delete a single Asset
     * @param param the request object
     */
    public deleteOneBaseAssetControllerAssetWithHttpInfo(param: AssetApiDeleteOneBaseAssetControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseAssetControllerAssetWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Asset
     * @param param the request object
     */
    public deleteOneBaseAssetControllerAsset(param: AssetApiDeleteOneBaseAssetControllerAssetRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseAssetControllerAsset(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public fileRedirect0WithHttpInfo(param: AssetApiFileRedirect0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.fileRedirect0WithHttpInfo(param.key,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public fileRedirect0(param: AssetApiFileRedirect0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.fileRedirect0(param.key,  options).toPromise();
    }

    /**
     * Retrieve multiple Assets
     * @param param the request object
     */
    public getManyBaseAssetControllerAssetWithHttpInfo(param: AssetApiGetManyBaseAssetControllerAssetRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>> {
        return this.api.getManyBaseAssetControllerAssetWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Assets
     * @param param the request object
     */
    public getManyBaseAssetControllerAsset(param: AssetApiGetManyBaseAssetControllerAssetRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseAssetAdminControllerAsset200Response> {
        return this.api.getManyBaseAssetControllerAsset(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Asset
     * @param param the request object
     */
    public getOneBaseAssetControllerAssetWithHttpInfo(param: AssetApiGetOneBaseAssetControllerAssetRequest, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.getOneBaseAssetControllerAssetWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Asset
     * @param param the request object
     */
    public getOneBaseAssetControllerAsset(param: AssetApiGetOneBaseAssetControllerAssetRequest, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.getOneBaseAssetControllerAsset(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public upload0WithHttpInfo(param: AssetApiUpload0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Asset>> {
        return this.api.upload0WithHttpInfo(param.file,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public upload0(param: AssetApiUpload0Request = {}, options?: ConfigurationOptions): Promise<Asset> {
        return this.api.upload0(param.file,  options).toPromise();
    }

}

import { ObservableAuthProfileSocialProviderApi } from "./ObservableAPI";
import { AuthProfileSocialProviderApiRequestFactory, AuthProfileSocialProviderApiResponseProcessor} from "../apis/AuthProfileSocialProviderApi";

export interface AuthProfileSocialProviderApiGet0Request {
}

export class ObjectAuthProfileSocialProviderApi {
    private api: ObservableAuthProfileSocialProviderApi

    public constructor(configuration: Configuration, requestFactory?: AuthProfileSocialProviderApiRequestFactory, responseProcessor?: AuthProfileSocialProviderApiResponseProcessor) {
        this.api = new ObservableAuthProfileSocialProviderApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public get0WithHttpInfo(param: AuthProfileSocialProviderApiGet0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.get0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public get0(param: AuthProfileSocialProviderApiGet0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.get0( options).toPromise();
    }

}

import { ObservableAuthSessionApi } from "./ObservableAPI";
import { AuthSessionApiRequestFactory, AuthSessionApiResponseProcessor} from "../apis/AuthSessionApi";

export interface AuthSessionApiDestroy0Request {
    /**
     * Unique identifier of session to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof AuthSessionApidestroy0
     */
    sessionId: number
}

export interface AuthSessionApiGet0Request {
}

export interface AuthSessionApiGet00Request {
}

export interface AuthSessionApiPush0Request {
    /**
     * 
     * @type AuthProfileSessionPushDTO
     * @memberof AuthSessionApipush0
     */
    authProfileSessionPushDTO: AuthProfileSessionPushDTO
}

export interface AuthSessionApiRefresh0Request {
}

export class ObjectAuthSessionApi {
    private api: ObservableAuthSessionApi

    public constructor(configuration: Configuration, requestFactory?: AuthSessionApiRequestFactory, responseProcessor?: AuthSessionApiResponseProcessor) {
        this.api = new ObservableAuthSessionApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Logs out, completely deletes the session and the tokens bound to it.
     * @param param the request object
     */
    public destroy0WithHttpInfo(param: AuthSessionApiDestroy0Request, options?: ConfigurationOptions): Promise<HttpInfo<AuthProfileSessionDTO>> {
        return this.api.destroy0WithHttpInfo(param.sessionId,  options).toPromise();
    }

    /**
     * Logs out, completely deletes the session and the tokens bound to it.
     * @param param the request object
     */
    public destroy0(param: AuthSessionApiDestroy0Request, options?: ConfigurationOptions): Promise<AuthProfileSessionDTO> {
        return this.api.destroy0(param.sessionId,  options).toPromise();
    }

    /**
     * Returns a list of sessions that are active at the user.
     * @param param the request object
     */
    public get0WithHttpInfo(param: AuthSessionApiGet0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthProfileSessionCurrentDTO>> {
        return this.api.get0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns a list of sessions that are active at the user.
     * @param param the request object
     */
    public get0(param: AuthSessionApiGet0Request = {}, options?: ConfigurationOptions): Promise<AuthProfileSessionCurrentDTO> {
        return this.api.get0( options).toPromise();
    }

    /**
     * Returns a list of sessions that are active at the user.
     * @param param the request object
     */
    public get0_1WithHttpInfo(param: AuthSessionApiGet00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<AuthProfileSessionDTO>>> {
        return this.api.get0_1WithHttpInfo( options).toPromise();
    }

    /**
     * Returns a list of sessions that are active at the user.
     * @param param the request object
     */
    public get0_1(param: AuthSessionApiGet00Request = {}, options?: ConfigurationOptions): Promise<Array<AuthProfileSessionDTO>> {
        return this.api.get0_1( options).toPromise();
    }

    /**
     * Registers new Firebase Push Notification Token.
     * @param param the request object
     */
    public push0WithHttpInfo(param: AuthSessionApiPush0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.push0WithHttpInfo(param.authProfileSessionPushDTO,  options).toPromise();
    }

    /**
     * Registers new Firebase Push Notification Token.
     * @param param the request object
     */
    public push0(param: AuthSessionApiPush0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.push0(param.authProfileSessionPushDTO,  options).toPromise();
    }

    /**
     * Renews a couple of access and refresh keys, old ones become inactive.
     * @param param the request object
     */
    public refresh0WithHttpInfo(param: AuthSessionApiRefresh0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.refresh0WithHttpInfo( options).toPromise();
    }

    /**
     * Renews a couple of access and refresh keys, old ones become inactive.
     * @param param the request object
     */
    public refresh0(param: AuthSessionApiRefresh0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.refresh0( options).toPromise();
    }

}

import { ObservableAuthSocialApi } from "./ObservableAPI";
import { AuthSocialApiRequestFactory, AuthSocialApiResponseProcessor} from "../apis/AuthSocialApi";

export interface AuthSocialApiFacebook0Request {
}

export interface AuthSocialApiFacebook00Request {
}

export interface AuthSocialApiFacebook01Request {
}

export interface AuthSocialApiGoogle0Request {
}

export interface AuthSocialApiGoogle00Request {
}

export interface AuthSocialApiGoogle01Request {
}

export interface AuthSocialApiTwitter0Request {
}

export interface AuthSocialApiTwitter00Request {
}

export interface AuthSocialApiTwitter01Request {
}

export interface AuthSocialApiVk0Request {
}

export interface AuthSocialApiVk00Request {
}

export interface AuthSocialApiVk01Request {
}

export interface AuthSocialApiYandex0Request {
}

export interface AuthSocialApiYandex00Request {
}

export interface AuthSocialApiYandex01Request {
}

export class ObjectAuthSocialApi {
    private api: ObservableAuthSocialApi

    public constructor(configuration: Configuration, requestFactory?: AuthSocialApiRequestFactory, responseProcessor?: AuthSocialApiResponseProcessor) {
        this.api = new ObservableAuthSocialApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Facebook callback.
     * @param param the request object
     */
    public facebook0WithHttpInfo(param: AuthSocialApiFacebook0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.facebook0WithHttpInfo( options).toPromise();
    }

    /**
     * Facebook callback.
     * @param param the request object
     */
    public facebook0(param: AuthSocialApiFacebook0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.facebook0( options).toPromise();
    }

    /**
     * Facebook link.
     * @param param the request object
     */
    public facebook0_1WithHttpInfo(param: AuthSocialApiFacebook00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.facebook0_1WithHttpInfo( options).toPromise();
    }

    /**
     * Facebook link.
     * @param param the request object
     */
    public facebook0_1(param: AuthSocialApiFacebook00Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.facebook0_1( options).toPromise();
    }

    /**
     * Facebook OAUTH2 redirect.
     * @param param the request object
     */
    public facebook0_2WithHttpInfo(param: AuthSocialApiFacebook01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.facebook0_2WithHttpInfo( options).toPromise();
    }

    /**
     * Facebook OAUTH2 redirect.
     * @param param the request object
     */
    public facebook0_2(param: AuthSocialApiFacebook01Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.facebook0_2( options).toPromise();
    }

    /**
     * Google callback.
     * @param param the request object
     */
    public google0WithHttpInfo(param: AuthSocialApiGoogle0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.google0WithHttpInfo( options).toPromise();
    }

    /**
     * Google callback.
     * @param param the request object
     */
    public google0(param: AuthSocialApiGoogle0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.google0( options).toPromise();
    }

    /**
     * Google link.
     * @param param the request object
     */
    public google0_3WithHttpInfo(param: AuthSocialApiGoogle00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.google0_3WithHttpInfo( options).toPromise();
    }

    /**
     * Google link.
     * @param param the request object
     */
    public google0_3(param: AuthSocialApiGoogle00Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.google0_3( options).toPromise();
    }

    /**
     * Google OAUTH2 redirect.
     * @param param the request object
     */
    public google0_4WithHttpInfo(param: AuthSocialApiGoogle01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.google0_4WithHttpInfo( options).toPromise();
    }

    /**
     * Google OAUTH2 redirect.
     * @param param the request object
     */
    public google0_4(param: AuthSocialApiGoogle01Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.google0_4( options).toPromise();
    }

    /**
     * Twitter (X) callback.
     * @param param the request object
     */
    public twitter0WithHttpInfo(param: AuthSocialApiTwitter0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.twitter0WithHttpInfo( options).toPromise();
    }

    /**
     * Twitter (X) callback.
     * @param param the request object
     */
    public twitter0(param: AuthSocialApiTwitter0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.twitter0( options).toPromise();
    }

    /**
     * Twitter link.
     * @param param the request object
     */
    public twitter0_5WithHttpInfo(param: AuthSocialApiTwitter00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.twitter0_5WithHttpInfo( options).toPromise();
    }

    /**
     * Twitter link.
     * @param param the request object
     */
    public twitter0_5(param: AuthSocialApiTwitter00Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.twitter0_5( options).toPromise();
    }

    /**
     * Twitter OAUTH2 redirect.
     * @param param the request object
     */
    public twitter0_6WithHttpInfo(param: AuthSocialApiTwitter01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.twitter0_6WithHttpInfo( options).toPromise();
    }

    /**
     * Twitter OAUTH2 redirect.
     * @param param the request object
     */
    public twitter0_6(param: AuthSocialApiTwitter01Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.twitter0_6( options).toPromise();
    }

    /**
     * VK callback.
     * @param param the request object
     */
    public vk0WithHttpInfo(param: AuthSocialApiVk0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.vk0WithHttpInfo( options).toPromise();
    }

    /**
     * VK callback.
     * @param param the request object
     */
    public vk0(param: AuthSocialApiVk0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.vk0( options).toPromise();
    }

    /**
     * VK link.
     * @param param the request object
     */
    public vk0_7WithHttpInfo(param: AuthSocialApiVk00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.vk0_7WithHttpInfo( options).toPromise();
    }

    /**
     * VK link.
     * @param param the request object
     */
    public vk0_7(param: AuthSocialApiVk00Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.vk0_7( options).toPromise();
    }

    /**
     * VK OAUTH2 redirect.
     * @param param the request object
     */
    public vk0_8WithHttpInfo(param: AuthSocialApiVk01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.vk0_8WithHttpInfo( options).toPromise();
    }

    /**
     * VK OAUTH2 redirect.
     * @param param the request object
     */
    public vk0_8(param: AuthSocialApiVk01Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.vk0_8( options).toPromise();
    }

    /**
     * Yandex callback.
     * @param param the request object
     */
    public yandex0WithHttpInfo(param: AuthSocialApiYandex0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.yandex0WithHttpInfo( options).toPromise();
    }

    /**
     * Yandex callback.
     * @param param the request object
     */
    public yandex0(param: AuthSocialApiYandex0Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.yandex0( options).toPromise();
    }

    /**
     * Yandex link.
     * @param param the request object
     */
    public yandex0_9WithHttpInfo(param: AuthSocialApiYandex00Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.yandex0_9WithHttpInfo( options).toPromise();
    }

    /**
     * Yandex link.
     * @param param the request object
     */
    public yandex0_9(param: AuthSocialApiYandex00Request = {}, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.yandex0_9( options).toPromise();
    }

    /**
     * Yandex OAUTH2 redirect.
     * @param param the request object
     */
    public yandex0_10WithHttpInfo(param: AuthSocialApiYandex01Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.yandex0_10WithHttpInfo( options).toPromise();
    }

    /**
     * Yandex OAUTH2 redirect.
     * @param param the request object
     */
    public yandex0_10(param: AuthSocialApiYandex01Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.yandex0_10( options).toPromise();
    }

}

import { ObservableAuthVerificationApi } from "./ObservableAPI";
import { AuthVerificationApiRequestFactory, AuthVerificationApiResponseProcessor} from "../apis/AuthVerificationApi";

export interface AuthVerificationApiCode0Request {
    /**
     * 
     * @type AuthVerificationCodeDTO
     * @memberof AuthVerificationApicode0
     */
    authVerificationCodeDTO: AuthVerificationCodeDTO
}

export interface AuthVerificationApiVerify0Request {
    /**
     * 
     * @type AuthVerificationVerifyDTO
     * @memberof AuthVerificationApiverify0
     */
    authVerificationVerifyDTO: AuthVerificationVerifyDTO
}

export class ObjectAuthVerificationApi {
    private api: ObservableAuthVerificationApi

    public constructor(configuration: Configuration, requestFactory?: AuthVerificationApiRequestFactory, responseProcessor?: AuthVerificationApiResponseProcessor) {
        this.api = new ObservableAuthVerificationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public code0WithHttpInfo(param: AuthVerificationApiCode0Request, options?: ConfigurationOptions): Promise<HttpInfo<AuthVerificationResponseDTO>> {
        return this.api.code0WithHttpInfo(param.authVerificationCodeDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public code0(param: AuthVerificationApiCode0Request, options?: ConfigurationOptions): Promise<AuthVerificationResponseDTO> {
        return this.api.code0(param.authVerificationCodeDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public verify0WithHttpInfo(param: AuthVerificationApiVerify0Request, options?: ConfigurationOptions): Promise<HttpInfo<AuthResponseDTO>> {
        return this.api.verify0WithHttpInfo(param.authVerificationVerifyDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public verify0(param: AuthVerificationApiVerify0Request, options?: ConfigurationOptions): Promise<AuthResponseDTO> {
        return this.api.verify0(param.authVerificationVerifyDTO,  options).toPromise();
    }

}

import { ObservableBackgroundApi } from "./ObservableAPI";
import { BackgroundApiRequestFactory, BackgroundApiResponseProcessor} from "../apis/BackgroundApi";

export interface BackgroundApiCreate0Request {
    /**
     * 
     * @type any
     * @memberof BackgroundApicreate0
     */
    body: any
}

export interface BackgroundApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof BackgroundApifindById0
     */
    id: number
}

export interface BackgroundApiList0Request {
}

export class ObjectBackgroundApi {
    private api: ObservableBackgroundApi

    public constructor(configuration: Configuration, requestFactory?: BackgroundApiRequestFactory, responseProcessor?: BackgroundApiResponseProcessor) {
        this.api = new ObservableBackgroundApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public create0WithHttpInfo(param: BackgroundApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.create0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0(param: BackgroundApiCreate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.create0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: BackgroundApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: BackgroundApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: BackgroundApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: BackgroundApiList0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.list0( options).toPromise();
    }

}

import { ObservableBackgroundCategoryApi } from "./ObservableAPI";
import { BackgroundCategoryApiRequestFactory, BackgroundCategoryApiResponseProcessor} from "../apis/BackgroundCategoryApi";

export interface BackgroundCategoryApiList0Request {
}

export class ObjectBackgroundCategoryApi {
    private api: ObservableBackgroundCategoryApi

    public constructor(configuration: Configuration, requestFactory?: BackgroundCategoryApiRequestFactory, responseProcessor?: BackgroundCategoryApiResponseProcessor) {
        this.api = new ObservableBackgroundCategoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: BackgroundCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: BackgroundCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.list0( options).toPromise();
    }

}

import { ObservableBannerGetApi } from "./ObservableAPI";
import { BannerGetApiRequestFactory, BannerGetApiResponseProcessor} from "../apis/BannerGetApi";

export interface BannerGetApiGet0Request {
    /**
     * Array of types, that needed to be returned.
     * Defaults to: undefined
     * @type Array&lt;&#39;HERO&#39; | &#39;SIDEBAR&#39; | &#39;TOP&#39; | &#39;LIST&#39;&gt;
     * @memberof BannerGetApiget0
     */
    positions: Array<'HERO' | 'SIDEBAR' | 'TOP' | 'LIST'>
    /**
     * Profile type to filter banners to be returned.
     * Defaults to: undefined
     * @type &#39;employee&#39; | &#39;hirer&#39; | &#39;unknown&#39;
     * @memberof BannerGetApiget0
     */
    profileType: 'employee' | 'hirer' | 'unknown'
    /**
     * Specific language code for query.
     * Defaults to: undefined
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof BannerGetApiget0
     */
    language?: 'en' | 'ru' | 'uk'
    /**
     * Current advertising uuid.
     * Defaults to: undefined
     * @type string
     * @memberof BannerGetApiget0
     */
    uuid?: string
}

export interface BannerGetApiReferral0Request {
    /**
     * Unique id of banner to find.
     * Defaults to: undefined
     * @type number
     * @memberof BannerGetApireferral0
     */
    bannerId: number
    /**
     * Platform type to filter banners to be returned.
     * Defaults to: undefined
     * @type &#39;MOBILE&#39; | &#39;DESKTOP&#39;
     * @memberof BannerGetApireferral0
     */
    platform: 'MOBILE' | 'DESKTOP'
    /**
     * Current advertising uuid.
     * Defaults to: undefined
     * @type string
     * @memberof BannerGetApireferral0
     */
    advertisingId?: string
}

export class ObjectBannerGetApi {
    private api: ObservableBannerGetApi

    public constructor(configuration: Configuration, requestFactory?: BannerGetApiRequestFactory, responseProcessor?: BannerGetApiResponseProcessor) {
        this.api = new ObservableBannerGetApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns banners data.
     * @param param the request object
     */
    public get0WithHttpInfo(param: BannerGetApiGet0Request, options?: ConfigurationOptions): Promise<HttpInfo<BannerResponseDTO>> {
        return this.api.get0WithHttpInfo(param.positions, param.profileType, param.language, param.uuid,  options).toPromise();
    }

    /**
     * Returns banners data.
     * @param param the request object
     */
    public get0(param: BannerGetApiGet0Request, options?: ConfigurationOptions): Promise<BannerResponseDTO> {
        return this.api.get0(param.positions, param.profileType, param.language, param.uuid,  options).toPromise();
    }

    /**
     * Returns banners data.
     * @param param the request object
     */
    public referral0WithHttpInfo(param: BannerGetApiReferral0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.referral0WithHttpInfo(param.bannerId, param.platform, param.advertisingId,  options).toPromise();
    }

    /**
     * Returns banners data.
     * @param param the request object
     */
    public referral0(param: BannerGetApiReferral0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.referral0(param.bannerId, param.platform, param.advertisingId,  options).toPromise();
    }

}

import { ObservableCVApi } from "./ObservableAPI";
import { CVApiRequestFactory, CVApiResponseProcessor} from "../apis/CVApi";

export interface CVApiAddToBlackList0Request {
}

export interface CVApiAddToSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApiaddToSaved0
     */
    favouriteFolderId: number
}

export interface CVApiCreateOneBaseCVControllerCVRequest {
    /**
     * 
     * @type any
     * @memberof CVApicreateOneBaseCVControllerCV
     */
    body: any
}

export interface CVApiDeleteOneBaseCVControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApideleteOneBaseCVControllerCV
     */
    id: number
}

export interface CVApiGetManyBaseCVControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    ids: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    categories: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    skills: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    sources: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    verticals: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    geos: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    countries: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    cities: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    employment: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    schedule: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gender: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    workExperiencePresense: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    experience: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    education: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    relocation: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    nativeLanguage: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    compensation: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    search: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    currency: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gybridurrency: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    pieceworkurrency: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    salaryMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    salaryMax: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    pieceworkSalaryMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    pieceworkSalaryMax: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    commissionMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    commissionMax: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gybridSalaryMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gybridSalaryMax: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gybridCommissionMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    gybridCommissionMax: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    isTop: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    savedByCurrentProfile: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    blackListedByCurrentProfile: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    languageKnowledges: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    withCharacter: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    forLastNumberOfDays: number
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    institutions: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    vacancyLookType: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    ageMin: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    ageMax: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    withImage: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    favouriteFolderId: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CVApigetManyBaseCVControllerCV
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetManyBaseCVControllerCV
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetManyBaseCVControllerCV
     */
    cache?: number
}

export interface CVApiGetOneBaseCVControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetOneBaseCVControllerCV
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetOneBaseCVControllerCV
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CVApigetOneBaseCVControllerCV
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetOneBaseCVControllerCV
     */
    cache?: number
}

export interface CVApiGetViews0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApigetViews0
     */
    id: number
}

export interface CVApiListByCurrentProfile0Request {
}

export interface CVApiRemoveFromBlackList0Request {
}

export interface CVApiRemoveFromSaved0Request {
}

export interface CVApiSuggest0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVApisuggest0
     */
    search: string
}

export interface CVApiToTop0Request {
}

export interface CVApiUpdateOneBaseCVControllerCVRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CVApiupdateOneBaseCVControllerCV
     */
    id: number
    /**
     * 
     * @type any
     * @memberof CVApiupdateOneBaseCVControllerCV
     */
    body: any
}

export class ObjectCVApi {
    private api: ObservableCVApi

    public constructor(configuration: Configuration, requestFactory?: CVApiRequestFactory, responseProcessor?: CVApiResponseProcessor) {
        this.api = new ObservableCVApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public addToBlackList0WithHttpInfo(param: CVApiAddToBlackList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToBlackList0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToBlackList0(param: CVApiAddToBlackList0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToBlackList0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: CVApiAddToSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo(param.favouriteFolderId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0(param: CVApiAddToSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0(param.favouriteFolderId,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCVControllerCVWithHttpInfo(param: CVApiCreateOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCVControllerCVWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CV
     * @param param the request object
     */
    public createOneBaseCVControllerCV(param: CVApiCreateOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCVControllerCV(param.body,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCVControllerCVWithHttpInfo(param: CVApiDeleteOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseCVControllerCVWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CV
     * @param param the request object
     */
    public deleteOneBaseCVControllerCV(param: CVApiDeleteOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseCVControllerCV(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCVControllerCVWithHttpInfo(param: CVApiGetManyBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCVControllerCVWithHttpInfo(param.ids, param.categories, param.skills, param.sources, param.verticals, param.geos, param.countries, param.cities, param.employment, param.schedule, param.gender, param.workExperiencePresense, param.experience, param.education, param.relocation, param.nativeLanguage, param.compensation, param.search, param.currency, param.gybridurrency, param.pieceworkurrency, param.salaryMin, param.salaryMax, param.pieceworkSalaryMin, param.pieceworkSalaryMax, param.commissionMin, param.commissionMax, param.gybridSalaryMin, param.gybridSalaryMax, param.gybridCommissionMin, param.gybridCommissionMax, param.isTop, param.savedByCurrentProfile, param.blackListedByCurrentProfile, param.languageKnowledges, param.withCharacter, param.forLastNumberOfDays, param.institutions, param.vacancyLookType, param.ageMin, param.ageMax, param.withImage, param.favouriteFolderId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CVS
     * @param param the request object
     */
    public getManyBaseCVControllerCV(param: CVApiGetManyBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCVControllerCV(param.ids, param.categories, param.skills, param.sources, param.verticals, param.geos, param.countries, param.cities, param.employment, param.schedule, param.gender, param.workExperiencePresense, param.experience, param.education, param.relocation, param.nativeLanguage, param.compensation, param.search, param.currency, param.gybridurrency, param.pieceworkurrency, param.salaryMin, param.salaryMax, param.pieceworkSalaryMin, param.pieceworkSalaryMax, param.commissionMin, param.commissionMax, param.gybridSalaryMin, param.gybridSalaryMax, param.gybridCommissionMin, param.gybridCommissionMax, param.isTop, param.savedByCurrentProfile, param.blackListedByCurrentProfile, param.languageKnowledges, param.withCharacter, param.forLastNumberOfDays, param.institutions, param.vacancyLookType, param.ageMin, param.ageMax, param.withImage, param.favouriteFolderId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCVControllerCVWithHttpInfo(param: CVApiGetOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCVControllerCVWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CV
     * @param param the request object
     */
    public getOneBaseCVControllerCV(param: CVApiGetOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCVControllerCV(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getViews0WithHttpInfo(param: CVApiGetViews0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.getViews0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getViews0(param: CVApiGetViews0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.getViews0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0WithHttpInfo(param: CVApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.listByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0(param: CVApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.listByCurrentProfile0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromBlackList0WithHttpInfo(param: CVApiRemoveFromBlackList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromBlackList0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromBlackList0(param: CVApiRemoveFromBlackList0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromBlackList0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: CVApiRemoveFromSaved0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0(param: CVApiRemoveFromSaved0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public suggest0WithHttpInfo(param: CVApiSuggest0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.suggest0WithHttpInfo(param.search,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public suggest0(param: CVApiSuggest0Request, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.suggest0(param.search,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public toTop0WithHttpInfo(param: CVApiToTop0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.toTop0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public toTop0(param: CVApiToTop0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.toTop0( options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCVControllerCVWithHttpInfo(param: CVApiUpdateOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCVControllerCVWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CV
     * @param param the request object
     */
    public updateOneBaseCVControllerCV(param: CVApiUpdateOneBaseCVControllerCVRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCVControllerCV(param.id, param.body,  options).toPromise();
    }

}

import { ObservableCVContactsApi } from "./ObservableAPI";
import { CVContactsApiRequestFactory, CVContactsApiResponseProcessor} from "../apis/CVContactsApi";

export interface CVContactsApiAdd0Request {
    /**
     * ID of the CV
     * Defaults to: undefined
     * @type number
     * @memberof CVContactsApiadd0
     */
    cvId: number
    /**
     * 
     * @type AddContactsInCvDto
     * @memberof CVContactsApiadd0
     */
    addContactsInCvDto: AddContactsInCvDto
}

export interface CVContactsApiGetActiveContactAccess0Request {
    /**
     * ID of the CV
     * Defaults to: undefined
     * @type number
     * @memberof CVContactsApigetActiveContactAccess0
     */
    cvId: number
}

export interface CVContactsApiGrantAccess0Request {
    /**
     * ID of the CV
     * Defaults to: undefined
     * @type number
     * @memberof CVContactsApigrantAccess0
     */
    cvId: number
    /**
     * ID of the product
     * Defaults to: undefined
     * @type number
     * @memberof CVContactsApigrantAccess0
     */
    productId: number
}

export interface CVContactsApiUpdate0Request {
    /**
     * ID of the CV
     * Defaults to: undefined
     * @type number
     * @memberof CVContactsApiupdate0
     */
    cvId: number
    /**
     * 
     * @type AddContactsInCvDto
     * @memberof CVContactsApiupdate0
     */
    addContactsInCvDto: AddContactsInCvDto
}

export class ObjectCVContactsApi {
    private api: ObservableCVContactsApi

    public constructor(configuration: Configuration, requestFactory?: CVContactsApiRequestFactory, responseProcessor?: CVContactsApiResponseProcessor) {
        this.api = new ObservableCVContactsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Add contacts to CV
     * @param param the request object
     */
    public add0WithHttpInfo(param: CVContactsApiAdd0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.add0WithHttpInfo(param.cvId, param.addContactsInCvDto,  options).toPromise();
    }

    /**
     * Add contacts to CV
     * @param param the request object
     */
    public add0(param: CVContactsApiAdd0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.add0(param.cvId, param.addContactsInCvDto,  options).toPromise();
    }

    /**
     * Get active contact accesses for CV
     * @param param the request object
     */
    public getActiveContactAccess0WithHttpInfo(param: CVContactsApiGetActiveContactAccess0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.getActiveContactAccess0WithHttpInfo(param.cvId,  options).toPromise();
    }

    /**
     * Get active contact accesses for CV
     * @param param the request object
     */
    public getActiveContactAccess0(param: CVContactsApiGetActiveContactAccess0Request, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.getActiveContactAccess0(param.cvId,  options).toPromise();
    }

    /**
     * Grant access to CV contacts
     * @param param the request object
     */
    public grantAccess0WithHttpInfo(param: CVContactsApiGrantAccess0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.grantAccess0WithHttpInfo(param.cvId, param.productId,  options).toPromise();
    }

    /**
     * Grant access to CV contacts
     * @param param the request object
     */
    public grantAccess0(param: CVContactsApiGrantAccess0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.grantAccess0(param.cvId, param.productId,  options).toPromise();
    }

    /**
     * Update contacts in CV
     * @param param the request object
     */
    public update0WithHttpInfo(param: CVContactsApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.update0WithHttpInfo(param.cvId, param.addContactsInCvDto,  options).toPromise();
    }

    /**
     * Update contacts in CV
     * @param param the request object
     */
    public update0(param: CVContactsApiUpdate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.update0(param.cvId, param.addContactsInCvDto,  options).toPromise();
    }

}

import { ObservableCVDownloadApi } from "./ObservableAPI";
import { CVDownloadApiRequestFactory, CVDownloadApiResponseProcessor} from "../apis/CVDownloadApi";

export interface CVDownloadApiDownloadPdf0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CVDownloadApidownloadPdf0
     */
    lang: string
    /**
     * ID резюме
     * Defaults to: undefined
     * @type number
     * @memberof CVDownloadApidownloadPdf0
     */
    id: number
}

export class ObjectCVDownloadApi {
    private api: ObservableCVDownloadApi

    public constructor(configuration: Configuration, requestFactory?: CVDownloadApiRequestFactory, responseProcessor?: CVDownloadApiResponseProcessor) {
        this.api = new ObservableCVDownloadApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Скачать резюме в формате PDF
     * @param param the request object
     */
    public downloadPdf0WithHttpInfo(param: CVDownloadApiDownloadPdf0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.downloadPdf0WithHttpInfo(param.lang, param.id,  options).toPromise();
    }

    /**
     * Скачать резюме в формате PDF
     * @param param the request object
     */
    public downloadPdf0(param: CVDownloadApiDownloadPdf0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.downloadPdf0(param.lang, param.id,  options).toPromise();
    }

}

import { ObservableCharacterApi } from "./ObservableAPI";
import { CharacterApiRequestFactory, CharacterApiResponseProcessor} from "../apis/CharacterApi";

export interface CharacterApiBuy0Request {
}

export interface CharacterApiCreateOneBaseCharacterControllerCharacterRequest {
}

export interface CharacterApiDeleteOneBaseCharacterControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApideleteOneBaseCharacterControllerCharacter
     */
    id: number
}

export interface CharacterApiGetManyBaseCharacterControllerCharacterRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetManyBaseCharacterControllerCharacter
     */
    cache?: number
}

export interface CharacterApiGetOneBaseCharacterControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetOneBaseCharacterControllerCharacter
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetOneBaseCharacterControllerCharacter
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CharacterApigetOneBaseCharacterControllerCharacter
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApigetOneBaseCharacterControllerCharacter
     */
    cache?: number
}

export interface CharacterApiListByCurrentProfile0Request {
}

export interface CharacterApiUpdateOneBaseCharacterControllerCharacterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterApiupdateOneBaseCharacterControllerCharacter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof CharacterApiupdateOneBaseCharacterControllerCharacter
     */
    body: any
}

export class ObjectCharacterApi {
    private api: ObservableCharacterApi

    public constructor(configuration: Configuration, requestFactory?: CharacterApiRequestFactory, responseProcessor?: CharacterApiResponseProcessor) {
        this.api = new ObservableCharacterApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public buy0WithHttpInfo(param: CharacterApiBuy0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.buy0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public buy0(param: CharacterApiBuy0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.buy0( options).toPromise();
    }

    /**
     * Create a single Character
     * @param param the request object
     */
    public createOneBaseCharacterControllerCharacterWithHttpInfo(param: CharacterApiCreateOneBaseCharacterControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCharacterControllerCharacterWithHttpInfo( options).toPromise();
    }

    /**
     * Create a single Character
     * @param param the request object
     */
    public createOneBaseCharacterControllerCharacter(param: CharacterApiCreateOneBaseCharacterControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCharacterControllerCharacter( options).toPromise();
    }

    /**
     * Delete a single Character
     * @param param the request object
     */
    public deleteOneBaseCharacterControllerCharacterWithHttpInfo(param: CharacterApiDeleteOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseCharacterControllerCharacterWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Character
     * @param param the request object
     */
    public deleteOneBaseCharacterControllerCharacter(param: CharacterApiDeleteOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseCharacterControllerCharacter(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Characters
     * @param param the request object
     */
    public getManyBaseCharacterControllerCharacterWithHttpInfo(param: CharacterApiGetManyBaseCharacterControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCharacterControllerCharacterWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Characters
     * @param param the request object
     */
    public getManyBaseCharacterControllerCharacter(param: CharacterApiGetManyBaseCharacterControllerCharacterRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCharacterControllerCharacter(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Character
     * @param param the request object
     */
    public getOneBaseCharacterControllerCharacterWithHttpInfo(param: CharacterApiGetOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCharacterControllerCharacterWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Character
     * @param param the request object
     */
    public getOneBaseCharacterControllerCharacter(param: CharacterApiGetOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCharacterControllerCharacter(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0WithHttpInfo(param: CharacterApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.listByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0(param: CharacterApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.listByCurrentProfile0( options).toPromise();
    }

    /**
     * Update a single Character
     * @param param the request object
     */
    public updateOneBaseCharacterControllerCharacterWithHttpInfo(param: CharacterApiUpdateOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCharacterControllerCharacterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Character
     * @param param the request object
     */
    public updateOneBaseCharacterControllerCharacter(param: CharacterApiUpdateOneBaseCharacterControllerCharacterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCharacterControllerCharacter(param.id, param.body,  options).toPromise();
    }

}

import { ObservableCharacterItemApi } from "./ObservableAPI";
import { CharacterItemApiRequestFactory, CharacterItemApiResponseProcessor} from "../apis/CharacterItemApi";

export interface CharacterItemApiBuy0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterItemApibuy0
     */
    id: number
}

export interface CharacterItemApiDeselectForCharacter0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterItemApideselectForCharacter0
     */
    id: number
}

export interface CharacterItemApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterItemApifindById0
     */
    id: number
}

export interface CharacterItemApiList0Request {
}

export interface CharacterItemApiSelectForCharacter0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CharacterItemApiselectForCharacter0
     */
    id: number
}

export class ObjectCharacterItemApi {
    private api: ObservableCharacterItemApi

    public constructor(configuration: Configuration, requestFactory?: CharacterItemApiRequestFactory, responseProcessor?: CharacterItemApiResponseProcessor) {
        this.api = new ObservableCharacterItemApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public buy0WithHttpInfo(param: CharacterItemApiBuy0Request, options?: ConfigurationOptions): Promise<HttpInfo<CharacterItem>> {
        return this.api.buy0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public buy0(param: CharacterItemApiBuy0Request, options?: ConfigurationOptions): Promise<CharacterItem> {
        return this.api.buy0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public deselectForCharacter0WithHttpInfo(param: CharacterItemApiDeselectForCharacter0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deselectForCharacter0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public deselectForCharacter0(param: CharacterItemApiDeselectForCharacter0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.deselectForCharacter0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: CharacterItemApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: CharacterItemApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: CharacterItemApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: CharacterItemApiList0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.list0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public selectForCharacter0WithHttpInfo(param: CharacterItemApiSelectForCharacter0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.selectForCharacter0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public selectForCharacter0(param: CharacterItemApiSelectForCharacter0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.selectForCharacter0(param.id,  options).toPromise();
    }

}

import { ObservableCharacterItemCategoryApi } from "./ObservableAPI";
import { CharacterItemCategoryApiRequestFactory, CharacterItemCategoryApiResponseProcessor} from "../apis/CharacterItemCategoryApi";

export interface CharacterItemCategoryApiList0Request {
}

export class ObjectCharacterItemCategoryApi {
    private api: ObservableCharacterItemCategoryApi

    public constructor(configuration: Configuration, requestFactory?: CharacterItemCategoryApiRequestFactory, responseProcessor?: CharacterItemCategoryApiResponseProcessor) {
        this.api = new ObservableCharacterItemCategoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: CharacterItemCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: CharacterItemCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.list0( options).toPromise();
    }

}

import { ObservableChatApi } from "./ObservableAPI";
import { ChatApiRequestFactory, ChatApiResponseProcessor} from "../apis/ChatApi";

export interface ChatApiCreate0Request {
    /**
     * 
     * @type any
     * @memberof ChatApicreate0
     */
    body: any
}

export interface ChatApiDelete0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApidelete0
     */
    id: number
}

export interface ChatApiDeleteChats0Request {
    /**
     * 
     * @type any
     * @memberof ChatApideleteChats0
     */
    body: any
}

export interface ChatApiFindDialog0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApifindDialog0
     */
    toId: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApifindDialog0
     */
    applicationId: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApifindDialog0
     */
    proposalId: number
}

export interface ChatApiIndexAllChatsContacts0Request {
}

export interface ChatApiIndexAllChatsVacancies0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApiindexAllChatsVacancies0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApiindexAllChatsVacancies0
     */
    page: number
}

export interface ChatApiIndexDialogs0Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatApiindexDialogs0
     */
    vacanciesIds: Array<string>
}

export interface ChatApiListMedia0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistMedia0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistMedia0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistMedia0
     */
    page: number
}

export interface ChatApiListUrl0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistUrl0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistUrl0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApilistUrl0
     */
    page: number
}

export interface ChatApiMoveChatsToFolder0Request {
    /**
     * 
     * @type any
     * @memberof ChatApimoveChatsToFolder0
     */
    body: any
}

export interface ChatApiSetRead0Request {
    /**
     * 
     * @type any
     * @memberof ChatApisetRead0
     */
    body: any
}

export interface ChatApiShow0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApishow0
     */
    id: number
}

export interface ChatApiUpdate0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatApiupdate0
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ChatApiupdate0
     */
    body: any
}

export class ObjectChatApi {
    private api: ObservableChatApi

    public constructor(configuration: Configuration, requestFactory?: ChatApiRequestFactory, responseProcessor?: ChatApiResponseProcessor) {
        this.api = new ObservableChatApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public create0WithHttpInfo(param: ChatApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.create0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0(param: ChatApiCreate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.create0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public delete0WithHttpInfo(param: ChatApiDelete0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.delete0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public delete0(param: ChatApiDelete0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.delete0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public deleteChats0WithHttpInfo(param: ChatApiDeleteChats0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteChats0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public deleteChats0(param: ChatApiDeleteChats0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteChats0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findDialog0WithHttpInfo(param: ChatApiFindDialog0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findDialog0WithHttpInfo(param.toId, param.applicationId, param.proposalId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findDialog0(param: ChatApiFindDialog0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findDialog0(param.toId, param.applicationId, param.proposalId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexAllChatsContacts0WithHttpInfo(param: ChatApiIndexAllChatsContacts0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.indexAllChatsContacts0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexAllChatsContacts0(param: ChatApiIndexAllChatsContacts0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.indexAllChatsContacts0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexAllChatsVacancies0WithHttpInfo(param: ChatApiIndexAllChatsVacancies0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.indexAllChatsVacancies0WithHttpInfo(param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexAllChatsVacancies0(param: ChatApiIndexAllChatsVacancies0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.indexAllChatsVacancies0(param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexDialogs0WithHttpInfo(param: ChatApiIndexDialogs0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.indexDialogs0WithHttpInfo(param.vacanciesIds,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public indexDialogs0(param: ChatApiIndexDialogs0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.indexDialogs0(param.vacanciesIds,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listMedia0WithHttpInfo(param: ChatApiListMedia0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.listMedia0WithHttpInfo(param.id, param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listMedia0(param: ChatApiListMedia0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.listMedia0(param.id, param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listUrl0WithHttpInfo(param: ChatApiListUrl0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.listUrl0WithHttpInfo(param.id, param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listUrl0(param: ChatApiListUrl0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.listUrl0(param.id, param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public moveChatsToFolder0WithHttpInfo(param: ChatApiMoveChatsToFolder0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.moveChatsToFolder0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public moveChatsToFolder0(param: ChatApiMoveChatsToFolder0Request, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.moveChatsToFolder0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public setRead0WithHttpInfo(param: ChatApiSetRead0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.setRead0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public setRead0(param: ChatApiSetRead0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.setRead0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public show0WithHttpInfo(param: ChatApiShow0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.show0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public show0(param: ChatApiShow0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.show0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public update0WithHttpInfo(param: ChatApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.update0WithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public update0(param: ChatApiUpdate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.update0(param.id, param.body,  options).toPromise();
    }

}

import { ObservableChatFolderApi } from "./ObservableAPI";
import { ChatFolderApiRequestFactory, ChatFolderApiResponseProcessor} from "../apis/ChatFolderApi";

export interface ChatFolderApiCreateOneBaseChatFolderControllerChatFolderRequest {
    /**
     * 
     * @type any
     * @memberof ChatFolderApicreateOneBaseChatFolderControllerChatFolder
     */
    body: any
}

export interface ChatFolderApiDeleteOneBaseChatFolderControllerChatFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApideleteOneBaseChatFolderControllerChatFolder
     */
    id: number
}

export interface ChatFolderApiGetManyBaseChatFolderControllerChatFolderRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetManyBaseChatFolderControllerChatFolder
     */
    cache?: number
}

export interface ChatFolderApiGetOneBaseChatFolderControllerChatFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetOneBaseChatFolderControllerChatFolder
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetOneBaseChatFolderControllerChatFolder
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatFolderApigetOneBaseChatFolderControllerChatFolder
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApigetOneBaseChatFolderControllerChatFolder
     */
    cache?: number
}

export interface ChatFolderApiUpdateOneBaseChatFolderControllerChatFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatFolderApiupdateOneBaseChatFolderControllerChatFolder
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ChatFolderApiupdateOneBaseChatFolderControllerChatFolder
     */
    body: any
}

export class ObjectChatFolderApi {
    private api: ObservableChatFolderApi

    public constructor(configuration: Configuration, requestFactory?: ChatFolderApiRequestFactory, responseProcessor?: ChatFolderApiResponseProcessor) {
        this.api = new ObservableChatFolderApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single ChatFolder
     * @param param the request object
     */
    public createOneBaseChatFolderControllerChatFolderWithHttpInfo(param: ChatFolderApiCreateOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseChatFolderControllerChatFolderWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single ChatFolder
     * @param param the request object
     */
    public createOneBaseChatFolderControllerChatFolder(param: ChatFolderApiCreateOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseChatFolderControllerChatFolder(param.body,  options).toPromise();
    }

    /**
     * Delete a single ChatFolder
     * @param param the request object
     */
    public deleteOneBaseChatFolderControllerChatFolderWithHttpInfo(param: ChatFolderApiDeleteOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseChatFolderControllerChatFolderWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ChatFolder
     * @param param the request object
     */
    public deleteOneBaseChatFolderControllerChatFolder(param: ChatFolderApiDeleteOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseChatFolderControllerChatFolder(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatFolders
     * @param param the request object
     */
    public getManyBaseChatFolderControllerChatFolderWithHttpInfo(param: ChatFolderApiGetManyBaseChatFolderControllerChatFolderRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseChatFolderControllerChatFolderWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatFolders
     * @param param the request object
     */
    public getManyBaseChatFolderControllerChatFolder(param: ChatFolderApiGetManyBaseChatFolderControllerChatFolderRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseChatFolderControllerChatFolder(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatFolder
     * @param param the request object
     */
    public getOneBaseChatFolderControllerChatFolderWithHttpInfo(param: ChatFolderApiGetOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseChatFolderControllerChatFolderWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatFolder
     * @param param the request object
     */
    public getOneBaseChatFolderControllerChatFolder(param: ChatFolderApiGetOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseChatFolderControllerChatFolder(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Update a single ChatFolder
     * @param param the request object
     */
    public updateOneBaseChatFolderControllerChatFolderWithHttpInfo(param: ChatFolderApiUpdateOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseChatFolderControllerChatFolderWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatFolder
     * @param param the request object
     */
    public updateOneBaseChatFolderControllerChatFolder(param: ChatFolderApiUpdateOneBaseChatFolderControllerChatFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseChatFolderControllerChatFolder(param.id, param.body,  options).toPromise();
    }

}

import { ObservableChatMessageApi } from "./ObservableAPI";
import { ChatMessageApiRequestFactory, ChatMessageApiResponseProcessor} from "../apis/ChatMessageApi";

export interface ChatMessageApiChangeProfileState0Request {
    /**
     * 
     * @type any
     * @memberof ChatMessageApichangeProfileState0
     */
    body: any
}

export interface ChatMessageApiCreate0Request {
    /**
     * 
     * @type any
     * @memberof ChatMessageApicreate0
     */
    body: any
}

export interface ChatMessageApiDelete0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageApidelete0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ChatMessageApidelete0
     */
    deleteType: string
}

export interface ChatMessageApiExtractUrls0Request {
}

export interface ChatMessageApiIndex0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageApiindex0
     */
    chatId: number
}

export interface ChatMessageApiSearch0Request {
}

export interface ChatMessageApiSetPinned0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageApisetPinned0
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ChatMessageApisetPinned0
     */
    body: any
}

export interface ChatMessageApiShow0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageApishow0
     */
    id: number
}

export class ObjectChatMessageApi {
    private api: ObservableChatMessageApi

    public constructor(configuration: Configuration, requestFactory?: ChatMessageApiRequestFactory, responseProcessor?: ChatMessageApiResponseProcessor) {
        this.api = new ObservableChatMessageApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public changeProfileState0WithHttpInfo(param: ChatMessageApiChangeProfileState0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.changeProfileState0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public changeProfileState0(param: ChatMessageApiChangeProfileState0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.changeProfileState0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0WithHttpInfo(param: ChatMessageApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.create0WithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0(param: ChatMessageApiCreate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.create0(param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public delete0WithHttpInfo(param: ChatMessageApiDelete0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.delete0WithHttpInfo(param.id, param.deleteType,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public delete0(param: ChatMessageApiDelete0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.delete0(param.id, param.deleteType,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public extractUrls0WithHttpInfo(param: ChatMessageApiExtractUrls0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.extractUrls0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public extractUrls0(param: ChatMessageApiExtractUrls0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.extractUrls0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public index0WithHttpInfo(param: ChatMessageApiIndex0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.index0WithHttpInfo(param.chatId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public index0(param: ChatMessageApiIndex0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.index0(param.chatId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public search0WithHttpInfo(param: ChatMessageApiSearch0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.search0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public search0(param: ChatMessageApiSearch0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.search0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public setPinned0WithHttpInfo(param: ChatMessageApiSetPinned0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.setPinned0WithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public setPinned0(param: ChatMessageApiSetPinned0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.setPinned0(param.id, param.body,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public show0WithHttpInfo(param: ChatMessageApiShow0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.show0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public show0(param: ChatMessageApiShow0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.show0(param.id,  options).toPromise();
    }

}

import { ObservableChatMessageUrlApi } from "./ObservableAPI";
import { ChatMessageUrlApiRequestFactory, ChatMessageUrlApiResponseProcessor} from "../apis/ChatMessageUrlApi";

export interface ChatMessageUrlApiCreateManyBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * @type CreateManyChatMessageUrlDto
     * @memberof ChatMessageUrlApicreateManyBaseChatMessageUrlControllerChatMessageUrl
     */
    createManyChatMessageUrlDto: CreateManyChatMessageUrlDto
}

export interface ChatMessageUrlApiCreateOneBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * @type any
     * @memberof ChatMessageUrlApicreateOneBaseChatMessageUrlControllerChatMessageUrl
     */
    body: any
}

export interface ChatMessageUrlApiDeleteOneBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApideleteOneBaseChatMessageUrlControllerChatMessageUrl
     */
    id: number
}

export interface ChatMessageUrlApiGetManyBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetManyBaseChatMessageUrlControllerChatMessageUrl
     */
    cache?: number
}

export interface ChatMessageUrlApiGetOneBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetOneBaseChatMessageUrlControllerChatMessageUrl
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetOneBaseChatMessageUrlControllerChatMessageUrl
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ChatMessageUrlApigetOneBaseChatMessageUrlControllerChatMessageUrl
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApigetOneBaseChatMessageUrlControllerChatMessageUrl
     */
    cache?: number
}

export interface ChatMessageUrlApiReplaceOneBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApireplaceOneBaseChatMessageUrlControllerChatMessageUrl
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ChatMessageUrlApireplaceOneBaseChatMessageUrlControllerChatMessageUrl
     */
    body: any
}

export interface ChatMessageUrlApiUpdateOneBaseChatMessageUrlControllerChatMessageUrlRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ChatMessageUrlApiupdateOneBaseChatMessageUrlControllerChatMessageUrl
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ChatMessageUrlApiupdateOneBaseChatMessageUrlControllerChatMessageUrl
     */
    body: any
}

export class ObjectChatMessageUrlApi {
    private api: ObservableChatMessageUrlApi

    public constructor(configuration: Configuration, requestFactory?: ChatMessageUrlApiRequestFactory, responseProcessor?: ChatMessageUrlApiResponseProcessor) {
        this.api = new ObservableChatMessageUrlApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ChatMessageUrls
     * @param param the request object
     */
    public createManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiCreateManyBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.createManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.createManyChatMessageUrlDto,  options).toPromise();
    }

    /**
     * Create multiple ChatMessageUrls
     * @param param the request object
     */
    public createManyBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiCreateManyBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.createManyBaseChatMessageUrlControllerChatMessageUrl(param.createManyChatMessageUrlDto,  options).toPromise();
    }

    /**
     * Create a single ChatMessageUrl
     * @param param the request object
     */
    public createOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiCreateOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single ChatMessageUrl
     * @param param the request object
     */
    public createOneBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiCreateOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseChatMessageUrlControllerChatMessageUrl(param.body,  options).toPromise();
    }

    /**
     * Delete a single ChatMessageUrl
     * @param param the request object
     */
    public deleteOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiDeleteOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ChatMessageUrl
     * @param param the request object
     */
    public deleteOneBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiDeleteOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseChatMessageUrlControllerChatMessageUrl(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param param the request object
     */
    public getManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiGetManyBaseChatMessageUrlControllerChatMessageUrlRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>> {
        return this.api.getManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param param the request object
     */
    public getManyBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiGetManyBaseChatMessageUrlControllerChatMessageUrlRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response> {
        return this.api.getManyBaseChatMessageUrlControllerChatMessageUrl(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param param the request object
     */
    public getOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiGetOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param param the request object
     */
    public getOneBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiGetOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseChatMessageUrlControllerChatMessageUrl(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ChatMessageUrl
     * @param param the request object
     */
    public replaceOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiReplaceOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single ChatMessageUrl
     * @param param the request object
     */
    public replaceOneBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiReplaceOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseChatMessageUrlControllerChatMessageUrl(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessageUrl
     * @param param the request object
     */
    public updateOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param: ChatMessageUrlApiUpdateOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single ChatMessageUrl
     * @param param the request object
     */
    public updateOneBaseChatMessageUrlControllerChatMessageUrl(param: ChatMessageUrlApiUpdateOneBaseChatMessageUrlControllerChatMessageUrlRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseChatMessageUrlControllerChatMessageUrl(param.id, param.body,  options).toPromise();
    }

}

import { ObservableCommunityApi } from "./ObservableAPI";
import { CommunityApiRequestFactory, CommunityApiResponseProcessor} from "../apis/CommunityApi";

export interface CommunityApiAddToSaved0Request {
}

export interface CommunityApiCreateOneBaseCommunityControllerCommunityRequest {
    /**
     * 
     * @type any
     * @memberof CommunityApicreateOneBaseCommunityControllerCommunity
     */
    body: any
}

export interface CommunityApiDeleteOneBaseCommunityControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApideleteOneBaseCommunityControllerCommunity
     */
    id: number
}

export interface CommunityApiGetManyBaseCommunityControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    search: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetManyBaseCommunityControllerCommunity
     */
    cache?: number
}

export interface CommunityApiGetOneBaseCommunityControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetOneBaseCommunityControllerCommunity
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetOneBaseCommunityControllerCommunity
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CommunityApigetOneBaseCommunityControllerCommunity
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApigetOneBaseCommunityControllerCommunity
     */
    cache?: number
}

export interface CommunityApiListByCurrentProfile0Request {
}

export interface CommunityApiListSubscribers0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApilistSubscribers0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CommunityApilistSubscribers0
     */
    search: string
}

export interface CommunityApiRemoveFromSaved0Request {
}

export interface CommunityApiUpdateOneBaseCommunityControllerCommunityRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CommunityApiupdateOneBaseCommunityControllerCommunity
     */
    id: number
    /**
     * 
     * @type any
     * @memberof CommunityApiupdateOneBaseCommunityControllerCommunity
     */
    body: any
}

export class ObjectCommunityApi {
    private api: ObservableCommunityApi

    public constructor(configuration: Configuration, requestFactory?: CommunityApiRequestFactory, responseProcessor?: CommunityApiResponseProcessor) {
        this.api = new ObservableCommunityApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: CommunityApiAddToSaved0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0(param: CommunityApiAddToSaved0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0( options).toPromise();
    }

    /**
     * Create a single Community
     * @param param the request object
     */
    public createOneBaseCommunityControllerCommunityWithHttpInfo(param: CommunityApiCreateOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCommunityControllerCommunityWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Community
     * @param param the request object
     */
    public createOneBaseCommunityControllerCommunity(param: CommunityApiCreateOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCommunityControllerCommunity(param.body,  options).toPromise();
    }

    /**
     * Delete a single Community
     * @param param the request object
     */
    public deleteOneBaseCommunityControllerCommunityWithHttpInfo(param: CommunityApiDeleteOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseCommunityControllerCommunityWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Community
     * @param param the request object
     */
    public deleteOneBaseCommunityControllerCommunity(param: CommunityApiDeleteOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseCommunityControllerCommunity(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Communities
     * @param param the request object
     */
    public getManyBaseCommunityControllerCommunityWithHttpInfo(param: CommunityApiGetManyBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCommunityControllerCommunityWithHttpInfo(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Communities
     * @param param the request object
     */
    public getManyBaseCommunityControllerCommunity(param: CommunityApiGetManyBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCommunityControllerCommunity(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Community
     * @param param the request object
     */
    public getOneBaseCommunityControllerCommunityWithHttpInfo(param: CommunityApiGetOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCommunityControllerCommunityWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Community
     * @param param the request object
     */
    public getOneBaseCommunityControllerCommunity(param: CommunityApiGetOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCommunityControllerCommunity(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0WithHttpInfo(param: CommunityApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.listByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0(param: CommunityApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.listByCurrentProfile0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listSubscribers0WithHttpInfo(param: CommunityApiListSubscribers0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.listSubscribers0WithHttpInfo(param.id, param.search,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listSubscribers0(param: CommunityApiListSubscribers0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.listSubscribers0(param.id, param.search,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: CommunityApiRemoveFromSaved0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0(param: CommunityApiRemoveFromSaved0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0( options).toPromise();
    }

    /**
     * Update a single Community
     * @param param the request object
     */
    public updateOneBaseCommunityControllerCommunityWithHttpInfo(param: CommunityApiUpdateOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCommunityControllerCommunityWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Community
     * @param param the request object
     */
    public updateOneBaseCommunityControllerCommunity(param: CommunityApiUpdateOneBaseCommunityControllerCommunityRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCommunityControllerCommunity(param.id, param.body,  options).toPromise();
    }

}

import { ObservableCourseApi } from "./ObservableAPI";
import { CourseApiRequestFactory, CourseApiResponseProcessor} from "../apis/CourseApi";

export interface CourseApiAddToSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseApiaddToSaved0
     */
    id: number
}

export interface CourseApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseApifindById0
     */
    id: number
}

export interface CourseApiListByProfile0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseApilistByProfile0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseApilistByProfile0
     */
    page: number
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseApilistByProfile0
     */
    categories: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseApilistByProfile0
     */
    languages: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseApilistByProfile0
     */
    savedByCurrentProfile: string
}

export interface CourseApiRemoveFromSaved0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseApiremoveFromSaved0
     */
    id: number
}

export class ObjectCourseApi {
    private api: ObservableCourseApi

    public constructor(configuration: Configuration, requestFactory?: CourseApiRequestFactory, responseProcessor?: CourseApiResponseProcessor) {
        this.api = new ObservableCourseApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: CourseApiAddToSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public addToSaved0(param: CourseApiAddToSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: CourseApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: CourseApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0WithHttpInfo(param: CourseApiListByProfile0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.listByProfile0WithHttpInfo(param.limit, param.page, param.categories, param.languages, param.savedByCurrentProfile,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0(param: CourseApiListByProfile0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.listByProfile0(param.limit, param.page, param.categories, param.languages, param.savedByCurrentProfile,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: CourseApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removeFromSaved0(param: CourseApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0(param.id,  options).toPromise();
    }

}

import { ObservableCourseBlockApi } from "./ObservableAPI";
import { CourseBlockApiRequestFactory, CourseBlockApiResponseProcessor} from "../apis/CourseBlockApi";

export interface CourseBlockApiGetManyBaseCourseBlockControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetManyBaseCourseBlockControllerCourseBlock
     */
    cache?: number
}

export interface CourseBlockApiGetOneBaseCourseBlockControllerCourseBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockApigetOneBaseCourseBlockControllerCourseBlock
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetOneBaseCourseBlockControllerCourseBlock
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetOneBaseCourseBlockControllerCourseBlock
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockApigetOneBaseCourseBlockControllerCourseBlock
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockApigetOneBaseCourseBlockControllerCourseBlock
     */
    cache?: number
}

export class ObjectCourseBlockApi {
    private api: ObservableCourseBlockApi

    public constructor(configuration: Configuration, requestFactory?: CourseBlockApiRequestFactory, responseProcessor?: CourseBlockApiResponseProcessor) {
        this.api = new ObservableCourseBlockApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param param the request object
     */
    public getManyBaseCourseBlockControllerCourseBlockWithHttpInfo(param: CourseBlockApiGetManyBaseCourseBlockControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCourseBlockControllerCourseBlockWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param param the request object
     */
    public getManyBaseCourseBlockControllerCourseBlock(param: CourseBlockApiGetManyBaseCourseBlockControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCourseBlockControllerCourseBlock(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlock
     * @param param the request object
     */
    public getOneBaseCourseBlockControllerCourseBlockWithHttpInfo(param: CourseBlockApiGetOneBaseCourseBlockControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockControllerCourseBlockWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlock
     * @param param the request object
     */
    public getOneBaseCourseBlockControllerCourseBlock(param: CourseBlockApiGetOneBaseCourseBlockControllerCourseBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockControllerCourseBlock(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableCourseBlockStepApi } from "./ObservableAPI";
import { CourseBlockStepApiRequestFactory, CourseBlockStepApiResponseProcessor} from "../apis/CourseBlockStepApi";

export interface CourseBlockStepApiGetManyBaseCourseBlockStepControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetManyBaseCourseBlockStepControllerCourseBlockStep
     */
    cache?: number
}

export interface CourseBlockStepApiGetOneBaseCourseBlockStepControllerCourseBlockStepRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockStepApigetOneBaseCourseBlockStepControllerCourseBlockStep
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetOneBaseCourseBlockStepControllerCourseBlockStep
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetOneBaseCourseBlockStepControllerCourseBlockStep
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepApigetOneBaseCourseBlockStepControllerCourseBlockStep
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepApigetOneBaseCourseBlockStepControllerCourseBlockStep
     */
    cache?: number
}

export class ObjectCourseBlockStepApi {
    private api: ObservableCourseBlockStepApi

    public constructor(configuration: Configuration, requestFactory?: CourseBlockStepApiRequestFactory, responseProcessor?: CourseBlockStepApiResponseProcessor) {
        this.api = new ObservableCourseBlockStepApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param param the request object
     */
    public getManyBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(param: CourseBlockStepApiGetManyBaseCourseBlockStepControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param param the request object
     */
    public getManyBaseCourseBlockStepControllerCourseBlockStep(param: CourseBlockStepApiGetManyBaseCourseBlockStepControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCourseBlockStepControllerCourseBlockStep(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param param the request object
     */
    public getOneBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(param: CourseBlockStepApiGetOneBaseCourseBlockStepControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param param the request object
     */
    public getOneBaseCourseBlockStepControllerCourseBlockStep(param: CourseBlockStepApiGetOneBaseCourseBlockStepControllerCourseBlockStepRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockStepControllerCourseBlockStep(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableCourseBlockStepAnswerApi } from "./ObservableAPI";
import { CourseBlockStepAnswerApiRequestFactory, CourseBlockStepAnswerApiResponseProcessor} from "../apis/CourseBlockStepAnswerApi";

export interface CourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * @type any
     * @memberof CourseBlockStepAnswerApicreateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    body: any
}

export interface CourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    cache?: number
}

export interface CourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApigetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    cache?: number
}

export interface CourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseBlockStepAnswerApiupdateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    id: number
    /**
     * 
     * @type any
     * @memberof CourseBlockStepAnswerApiupdateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer
     */
    body: any
}

export class ObjectCourseBlockStepAnswerApi {
    private api: ObservableCourseBlockStepAnswerApi

    public constructor(configuration: Configuration, requestFactory?: CourseBlockStepAnswerApiRequestFactory, responseProcessor?: CourseBlockStepAnswerApiResponseProcessor) {
        this.api = new ObservableCourseBlockStepAnswerApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param: CourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param param the request object
     */
    public createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param: CourseBlockStepAnswerApiCreateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param.body,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param: CourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param param the request object
     */
    public getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param: CourseBlockStepAnswerApiGetManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param: CourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param param the request object
     */
    public getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param: CourseBlockStepAnswerApiGetOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param: CourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param param the request object
     */
    public updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param: CourseBlockStepAnswerApiUpdateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(param.id, param.body,  options).toPromise();
    }

}

import { ObservableCourseModuleApi } from "./ObservableAPI";
import { CourseModuleApiRequestFactory, CourseModuleApiResponseProcessor} from "../apis/CourseModuleApi";

export interface CourseModuleApiGetManyBaseCourseModuleControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetManyBaseCourseModuleControllerCourseModule
     */
    cache?: number
}

export interface CourseModuleApiGetOneBaseCourseModuleControllerCourseModuleRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CourseModuleApigetOneBaseCourseModuleControllerCourseModule
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetOneBaseCourseModuleControllerCourseModule
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetOneBaseCourseModuleControllerCourseModule
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CourseModuleApigetOneBaseCourseModuleControllerCourseModule
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CourseModuleApigetOneBaseCourseModuleControllerCourseModule
     */
    cache?: number
}

export class ObjectCourseModuleApi {
    private api: ObservableCourseModuleApi

    public constructor(configuration: Configuration, requestFactory?: CourseModuleApiRequestFactory, responseProcessor?: CourseModuleApiResponseProcessor) {
        this.api = new ObservableCourseModuleApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple CourseModules
     * @param param the request object
     */
    public getManyBaseCourseModuleControllerCourseModuleWithHttpInfo(param: CourseModuleApiGetManyBaseCourseModuleControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCourseModuleControllerCourseModuleWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CourseModules
     * @param param the request object
     */
    public getManyBaseCourseModuleControllerCourseModule(param: CourseModuleApiGetManyBaseCourseModuleControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCourseModuleControllerCourseModule(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseModule
     * @param param the request object
     */
    public getOneBaseCourseModuleControllerCourseModuleWithHttpInfo(param: CourseModuleApiGetOneBaseCourseModuleControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCourseModuleControllerCourseModuleWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CourseModule
     * @param param the request object
     */
    public getOneBaseCourseModuleControllerCourseModule(param: CourseModuleApiGetOneBaseCourseModuleControllerCourseModuleRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCourseModuleControllerCourseModule(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableCoverLetterApi } from "./ObservableAPI";
import { CoverLetterApiRequestFactory, CoverLetterApiResponseProcessor} from "../apis/CoverLetterApi";

export interface CoverLetterApiCreateOneBaseCoverLetterControllerCoverLetterRequest {
    /**
     * 
     * @type any
     * @memberof CoverLetterApicreateOneBaseCoverLetterControllerCoverLetter
     */
    body: any
}

export interface CoverLetterApiDeleteOneBaseCoverLetterControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApideleteOneBaseCoverLetterControllerCoverLetter
     */
    id: number
}

export interface CoverLetterApiGetManyBaseCoverLetterControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    type: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    cvId: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    vacancyId: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetManyBaseCoverLetterControllerCoverLetter
     */
    cache?: number
}

export interface CoverLetterApiGetOneBaseCoverLetterControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetOneBaseCoverLetterControllerCoverLetter
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetOneBaseCoverLetterControllerCoverLetter
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof CoverLetterApigetOneBaseCoverLetterControllerCoverLetter
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApigetOneBaseCoverLetterControllerCoverLetter
     */
    cache?: number
}

export interface CoverLetterApiUpdateOneBaseCoverLetterControllerCoverLetterRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof CoverLetterApiupdateOneBaseCoverLetterControllerCoverLetter
     */
    id: number
    /**
     * 
     * @type any
     * @memberof CoverLetterApiupdateOneBaseCoverLetterControllerCoverLetter
     */
    body: any
}

export class ObjectCoverLetterApi {
    private api: ObservableCoverLetterApi

    public constructor(configuration: Configuration, requestFactory?: CoverLetterApiRequestFactory, responseProcessor?: CoverLetterApiResponseProcessor) {
        this.api = new ObservableCoverLetterApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single CoverLetter
     * @param param the request object
     */
    public createOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param: CoverLetterApiCreateOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single CoverLetter
     * @param param the request object
     */
    public createOneBaseCoverLetterControllerCoverLetter(param: CoverLetterApiCreateOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseCoverLetterControllerCoverLetter(param.body,  options).toPromise();
    }

    /**
     * Delete a single CoverLetter
     * @param param the request object
     */
    public deleteOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param: CoverLetterApiDeleteOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single CoverLetter
     * @param param the request object
     */
    public deleteOneBaseCoverLetterControllerCoverLetter(param: CoverLetterApiDeleteOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseCoverLetterControllerCoverLetter(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple CoverLetters
     * @param param the request object
     */
    public getManyBaseCoverLetterControllerCoverLetterWithHttpInfo(param: CoverLetterApiGetManyBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseCoverLetterControllerCoverLetterWithHttpInfo(param.type, param.cvId, param.vacancyId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple CoverLetters
     * @param param the request object
     */
    public getManyBaseCoverLetterControllerCoverLetter(param: CoverLetterApiGetManyBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseCoverLetterControllerCoverLetter(param.type, param.cvId, param.vacancyId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CoverLetter
     * @param param the request object
     */
    public getOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param: CoverLetterApiGetOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single CoverLetter
     * @param param the request object
     */
    public getOneBaseCoverLetterControllerCoverLetter(param: CoverLetterApiGetOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseCoverLetterControllerCoverLetter(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Update a single CoverLetter
     * @param param the request object
     */
    public updateOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param: CoverLetterApiUpdateOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseCoverLetterControllerCoverLetterWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single CoverLetter
     * @param param the request object
     */
    public updateOneBaseCoverLetterControllerCoverLetter(param: CoverLetterApiUpdateOneBaseCoverLetterControllerCoverLetterRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseCoverLetterControllerCoverLetter(param.id, param.body,  options).toPromise();
    }

}

import { ObservableFavouriteFolderApi } from "./ObservableAPI";
import { FavouriteFolderApiRequestFactory, FavouriteFolderApiResponseProcessor} from "../apis/FavouriteFolderApi";

export interface FavouriteFolderApiCreateOneBaseFavouriteFolderControllerFavouriteFolderRequest {
    /**
     * 
     * @type any
     * @memberof FavouriteFolderApicreateOneBaseFavouriteFolderControllerFavouriteFolder
     */
    body: any
}

export interface FavouriteFolderApiDeleteOneBaseFavouriteFolderControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApideleteOneBaseFavouriteFolderControllerFavouriteFolder
     */
    id: number
}

export interface FavouriteFolderApiGetDefaultFolder0Request {
}

export interface FavouriteFolderApiGetManyBaseFavouriteFolderControllerFavouriteFolderRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetManyBaseFavouriteFolderControllerFavouriteFolder
     */
    cache?: number
}

export interface FavouriteFolderApiGetOneBaseFavouriteFolderControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetOneBaseFavouriteFolderControllerFavouriteFolder
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetOneBaseFavouriteFolderControllerFavouriteFolder
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FavouriteFolderApigetOneBaseFavouriteFolderControllerFavouriteFolder
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApigetOneBaseFavouriteFolderControllerFavouriteFolder
     */
    cache?: number
}

export interface FavouriteFolderApiUpdateOneBaseFavouriteFolderControllerFavouriteFolderRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FavouriteFolderApiupdateOneBaseFavouriteFolderControllerFavouriteFolder
     */
    id: number
    /**
     * 
     * @type any
     * @memberof FavouriteFolderApiupdateOneBaseFavouriteFolderControllerFavouriteFolder
     */
    body: any
}

export class ObjectFavouriteFolderApi {
    private api: ObservableFavouriteFolderApi

    public constructor(configuration: Configuration, requestFactory?: FavouriteFolderApiRequestFactory, responseProcessor?: FavouriteFolderApiResponseProcessor) {
        this.api = new ObservableFavouriteFolderApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single FavouriteFolder
     * @param param the request object
     */
    public createOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param: FavouriteFolderApiCreateOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single FavouriteFolder
     * @param param the request object
     */
    public createOneBaseFavouriteFolderControllerFavouriteFolder(param: FavouriteFolderApiCreateOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseFavouriteFolderControllerFavouriteFolder(param.body,  options).toPromise();
    }

    /**
     * Delete a single FavouriteFolder
     * @param param the request object
     */
    public deleteOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param: FavouriteFolderApiDeleteOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single FavouriteFolder
     * @param param the request object
     */
    public deleteOneBaseFavouriteFolderControllerFavouriteFolder(param: FavouriteFolderApiDeleteOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseFavouriteFolderControllerFavouriteFolder(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getDefaultFolder0WithHttpInfo(param: FavouriteFolderApiGetDefaultFolder0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getDefaultFolder0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getDefaultFolder0(param: FavouriteFolderApiGetDefaultFolder0Request = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getDefaultFolder0( options).toPromise();
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param param the request object
     */
    public getManyBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param: FavouriteFolderApiGetManyBaseFavouriteFolderControllerFavouriteFolderRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param param the request object
     */
    public getManyBaseFavouriteFolderControllerFavouriteFolder(param: FavouriteFolderApiGetManyBaseFavouriteFolderControllerFavouriteFolderRequest = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseFavouriteFolderControllerFavouriteFolder(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param param the request object
     */
    public getOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param: FavouriteFolderApiGetOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param param the request object
     */
    public getOneBaseFavouriteFolderControllerFavouriteFolder(param: FavouriteFolderApiGetOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseFavouriteFolderControllerFavouriteFolder(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Update a single FavouriteFolder
     * @param param the request object
     */
    public updateOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param: FavouriteFolderApiUpdateOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single FavouriteFolder
     * @param param the request object
     */
    public updateOneBaseFavouriteFolderControllerFavouriteFolder(param: FavouriteFolderApiUpdateOneBaseFavouriteFolderControllerFavouriteFolderRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseFavouriteFolderControllerFavouriteFolder(param.id, param.body,  options).toPromise();
    }

}

import { ObservableFeedbackApi } from "./ObservableAPI";
import { FeedbackApiRequestFactory, FeedbackApiResponseProcessor} from "../apis/FeedbackApi";

export interface FeedbackApiCreateOneBaseFeedbackControllerFeedbackRequest {
    /**
     * 
     * @type any
     * @memberof FeedbackApicreateOneBaseFeedbackControllerFeedback
     */
    body: any
}

export interface FeedbackApiDeleteOneBaseFeedbackControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApideleteOneBaseFeedbackControllerFeedback
     */
    id: number
}

export interface FeedbackApiGetManyBaseFeedbackControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetManyBaseFeedbackControllerFeedback
     */
    cache?: number
}

export interface FeedbackApiGetOneBaseFeedbackControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof FeedbackApigetOneBaseFeedbackControllerFeedback
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetOneBaseFeedbackControllerFeedback
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetOneBaseFeedbackControllerFeedback
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof FeedbackApigetOneBaseFeedbackControllerFeedback
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApigetOneBaseFeedbackControllerFeedback
     */
    cache?: number
}

export interface FeedbackApiGetStats0Request {
}

export interface FeedbackApiUpdateOneBaseFeedbackControllerFeedbackRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof FeedbackApiupdateOneBaseFeedbackControllerFeedback
     */
    id: number
    /**
     * 
     * @type any
     * @memberof FeedbackApiupdateOneBaseFeedbackControllerFeedback
     */
    body: any
}

export class ObjectFeedbackApi {
    private api: ObservableFeedbackApi

    public constructor(configuration: Configuration, requestFactory?: FeedbackApiRequestFactory, responseProcessor?: FeedbackApiResponseProcessor) {
        this.api = new ObservableFeedbackApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Feedback
     * @param param the request object
     */
    public createOneBaseFeedbackControllerFeedbackWithHttpInfo(param: FeedbackApiCreateOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseFeedbackControllerFeedbackWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Feedback
     * @param param the request object
     */
    public createOneBaseFeedbackControllerFeedback(param: FeedbackApiCreateOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseFeedbackControllerFeedback(param.body,  options).toPromise();
    }

    /**
     * Delete a single Feedback
     * @param param the request object
     */
    public deleteOneBaseFeedbackControllerFeedbackWithHttpInfo(param: FeedbackApiDeleteOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseFeedbackControllerFeedbackWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Feedback
     * @param param the request object
     */
    public deleteOneBaseFeedbackControllerFeedback(param: FeedbackApiDeleteOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseFeedbackControllerFeedback(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Feedbacks
     * @param param the request object
     */
    public getManyBaseFeedbackControllerFeedbackWithHttpInfo(param: FeedbackApiGetManyBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseFeedbackControllerFeedbackWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Feedbacks
     * @param param the request object
     */
    public getManyBaseFeedbackControllerFeedback(param: FeedbackApiGetManyBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseFeedbackControllerFeedback(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Feedback
     * @param param the request object
     */
    public getOneBaseFeedbackControllerFeedbackWithHttpInfo(param: FeedbackApiGetOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseFeedbackControllerFeedbackWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Feedback
     * @param param the request object
     */
    public getOneBaseFeedbackControllerFeedback(param: FeedbackApiGetOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseFeedbackControllerFeedback(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getStats0WithHttpInfo(param: FeedbackApiGetStats0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.getStats0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getStats0(param: FeedbackApiGetStats0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.getStats0( options).toPromise();
    }

    /**
     * Update a single Feedback
     * @param param the request object
     */
    public updateOneBaseFeedbackControllerFeedbackWithHttpInfo(param: FeedbackApiUpdateOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseFeedbackControllerFeedbackWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Feedback
     * @param param the request object
     */
    public updateOneBaseFeedbackControllerFeedback(param: FeedbackApiUpdateOneBaseFeedbackControllerFeedbackRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseFeedbackControllerFeedback(param.id, param.body,  options).toPromise();
    }

}

import { ObservableGeoApi } from "./ObservableAPI";
import { GeoApiRequestFactory, GeoApiResponseProcessor} from "../apis/GeoApi";

export interface GeoApiGetManyBaseGeoControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    search: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetManyBaseGeoControllerGeo
     */
    cache?: number
}

export interface GeoApiGetOneBaseGeoControllerGeoRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetOneBaseGeoControllerGeo
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetOneBaseGeoControllerGeo
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof GeoApigetOneBaseGeoControllerGeo
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof GeoApigetOneBaseGeoControllerGeo
     */
    cache?: number
}

export class ObjectGeoApi {
    private api: ObservableGeoApi

    public constructor(configuration: Configuration, requestFactory?: GeoApiRequestFactory, responseProcessor?: GeoApiResponseProcessor) {
        this.api = new ObservableGeoApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple Geos
     * @param param the request object
     */
    public getManyBaseGeoControllerGeoWithHttpInfo(param: GeoApiGetManyBaseGeoControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseGeoControllerGeoWithHttpInfo(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Geos
     * @param param the request object
     */
    public getManyBaseGeoControllerGeo(param: GeoApiGetManyBaseGeoControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseGeoControllerGeo(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geo
     * @param param the request object
     */
    public getOneBaseGeoControllerGeoWithHttpInfo(param: GeoApiGetOneBaseGeoControllerGeoRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseGeoControllerGeoWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Geo
     * @param param the request object
     */
    public getOneBaseGeoControllerGeo(param: GeoApiGetOneBaseGeoControllerGeoRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseGeoControllerGeo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableHealthApi } from "./ObservableAPI";
import { HealthApiRequestFactory, HealthApiResponseProcessor} from "../apis/HealthApi";

export interface HealthApiCheck0Request {
}

export class ObjectHealthApi {
    private api: ObservableHealthApi

    public constructor(configuration: Configuration, requestFactory?: HealthApiRequestFactory, responseProcessor?: HealthApiResponseProcessor) {
        this.api = new ObservableHealthApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public check0WithHttpInfo(param: HealthApiCheck0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<HealthControllerCheck0200Response>> {
        return this.api.check0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public check0(param: HealthApiCheck0Request = {}, options?: ConfigurationOptions): Promise<HealthControllerCheck0200Response> {
        return this.api.check0( options).toPromise();
    }

}

import { ObservableInfluenceCategoryApi } from "./ObservableAPI";
import { InfluenceCategoryApiRequestFactory, InfluenceCategoryApiResponseProcessor} from "../apis/InfluenceCategoryApi";

export interface InfluenceCategoryApiPaginate0Request {
    /**
     * Page.
     * Defaults to: 0
     * @type number
     * @memberof InfluenceCategoryApipaginate0
     */
    page: number
    /**
     * Amount of items to take.
     * Defaults to: 10
     * @type number
     * @memberof InfluenceCategoryApipaginate0
     */
    limit: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceCategoryApipaginate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * Search string to filter items.
     * Defaults to: undefined
     * @type string
     * @memberof InfluenceCategoryApipaginate0
     */
    search?: string
}

export class ObjectInfluenceCategoryApi {
    private api: ObservableInfluenceCategoryApi

    public constructor(configuration: Configuration, requestFactory?: InfluenceCategoryApiRequestFactory, responseProcessor?: InfluenceCategoryApiResponseProcessor) {
        this.api = new ObservableInfluenceCategoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns a set of category, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0WithHttpInfo(param: InfluenceCategoryApiPaginate0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceCategoryControllerPaginate0200Response>> {
        return this.api.paginate0WithHttpInfo(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

    /**
     * Returns a set of category, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0(param: InfluenceCategoryApiPaginate0Request, options?: ConfigurationOptions): Promise<InfluenceCategoryControllerPaginate0200Response> {
        return this.api.paginate0(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

}

import { ObservableInfluenceContactsApi } from "./ObservableAPI";
import { InfluenceContactsApiRequestFactory, InfluenceContactsApiResponseProcessor} from "../apis/InfluenceContactsApi";

export interface InfluenceContactsApiOpen0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceContactsApiopen0
     */
    resumeId: number
}

export class ObjectInfluenceContactsApi {
    private api: ObservableInfluenceContactsApi

    public constructor(configuration: Configuration, requestFactory?: InfluenceContactsApiRequestFactory, responseProcessor?: InfluenceContactsApiResponseProcessor) {
        this.api = new ObservableInfluenceContactsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Open contacts for resume.
     * @param param the request object
     */
    public open0WithHttpInfo(param: InfluenceContactsApiOpen0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.open0WithHttpInfo(param.resumeId,  options).toPromise();
    }

    /**
     * Open contacts for resume.
     * @param param the request object
     */
    public open0(param: InfluenceContactsApiOpen0Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.open0(param.resumeId,  options).toPromise();
    }

}

import { ObservableInfluenceDirectionApi } from "./ObservableAPI";
import { InfluenceDirectionApiRequestFactory, InfluenceDirectionApiResponseProcessor} from "../apis/InfluenceDirectionApi";

export interface InfluenceDirectionApiPaginate0Request {
    /**
     * Page.
     * Defaults to: 0
     * @type number
     * @memberof InfluenceDirectionApipaginate0
     */
    page: number
    /**
     * Amount of items to take.
     * Defaults to: 10
     * @type number
     * @memberof InfluenceDirectionApipaginate0
     */
    limit: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceDirectionApipaginate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * Search string to filter items.
     * Defaults to: undefined
     * @type string
     * @memberof InfluenceDirectionApipaginate0
     */
    search?: string
}

export class ObjectInfluenceDirectionApi {
    private api: ObservableInfluenceDirectionApi

    public constructor(configuration: Configuration, requestFactory?: InfluenceDirectionApiRequestFactory, responseProcessor?: InfluenceDirectionApiResponseProcessor) {
        this.api = new ObservableInfluenceDirectionApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns a set of direction, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0WithHttpInfo(param: InfluenceDirectionApiPaginate0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceDirectionControllerPaginate0200Response>> {
        return this.api.paginate0WithHttpInfo(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

    /**
     * Returns a set of direction, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0(param: InfluenceDirectionApiPaginate0Request, options?: ConfigurationOptions): Promise<InfluenceDirectionControllerPaginate0200Response> {
        return this.api.paginate0(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

}

import { ObservableInfluenceFavouriteApi } from "./ObservableAPI";
import { InfluenceFavouriteApiRequestFactory, InfluenceFavouriteApiResponseProcessor} from "../apis/InfluenceFavouriteApi";

export interface InfluenceFavouriteApiAddToFavourite0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceFavouriteApiaddToFavourite0
     */
    resumeId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceFavouriteApiaddToFavourite0
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceFavouriteApiRemoveFromFavourite0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceFavouriteApiremoveFromFavourite0
     */
    resumeId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceFavouriteApiremoveFromFavourite0
     */
    lang?: 'en' | 'ru' | 'uk'
}

export class ObjectInfluenceFavouriteApi {
    private api: ObservableInfluenceFavouriteApi

    public constructor(configuration: Configuration, requestFactory?: InfluenceFavouriteApiRequestFactory, responseProcessor?: InfluenceFavouriteApiResponseProcessor) {
        this.api = new ObservableInfluenceFavouriteApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Add to favourite.
     * @param param the request object
     */
    public addToFavourite0WithHttpInfo(param: InfluenceFavouriteApiAddToFavourite0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.addToFavourite0WithHttpInfo(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Add to favourite.
     * @param param the request object
     */
    public addToFavourite0(param: InfluenceFavouriteApiAddToFavourite0Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.addToFavourite0(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Remove from favourite.
     * @param param the request object
     */
    public removeFromFavourite0WithHttpInfo(param: InfluenceFavouriteApiRemoveFromFavourite0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.removeFromFavourite0WithHttpInfo(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Remove from favourite.
     * @param param the request object
     */
    public removeFromFavourite0(param: InfluenceFavouriteApiRemoveFromFavourite0Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.removeFromFavourite0(param.resumeId, param.lang,  options).toPromise();
    }

}

import { ObservableInfluencePlatformApi } from "./ObservableAPI";
import { InfluencePlatformApiRequestFactory, InfluencePlatformApiResponseProcessor} from "../apis/InfluencePlatformApi";

export interface InfluencePlatformApiPaginate0Request {
    /**
     * Page.
     * Defaults to: 0
     * @type number
     * @memberof InfluencePlatformApipaginate0
     */
    page: number
    /**
     * Amount of items to take.
     * Defaults to: 10
     * @type number
     * @memberof InfluencePlatformApipaginate0
     */
    limit: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluencePlatformApipaginate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * Search string to filter items.
     * Defaults to: undefined
     * @type string
     * @memberof InfluencePlatformApipaginate0
     */
    search?: string
}

export class ObjectInfluencePlatformApi {
    private api: ObservableInfluencePlatformApi

    public constructor(configuration: Configuration, requestFactory?: InfluencePlatformApiRequestFactory, responseProcessor?: InfluencePlatformApiResponseProcessor) {
        this.api = new ObservableInfluencePlatformApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns a set of platform, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0WithHttpInfo(param: InfluencePlatformApiPaginate0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluencePlatformControllerPaginate0200Response>> {
        return this.api.paginate0WithHttpInfo(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

    /**
     * Returns a set of platform, according to the given limit, page number and search query.
     * @param param the request object
     */
    public paginate0(param: InfluencePlatformApiPaginate0Request, options?: ConfigurationOptions): Promise<InfluencePlatformControllerPaginate0200Response> {
        return this.api.paginate0(param.page, param.limit, param.lang, param.search,  options).toPromise();
    }

}

import { ObservableInfluenceResumeApi } from "./ObservableAPI";
import { InfluenceResumeApiRequestFactory, InfluenceResumeApiResponseProcessor} from "../apis/InfluenceResumeApi";

export interface InfluenceResumeApiCreate0Request {
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApicreate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof InfluenceResumeApicreate0
     */
    avatar?: HttpFile
}

export interface InfluenceResumeApiDestroy0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApidestroy0
     */
    resumeId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApidestroy0
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceResumeApiDestroy00Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApidestroy0_1
     */
    resumeId: number
    /**
     * 
     * @type Array&lt;InfluenceResumeChannelDestroyDTO&gt;
     * @memberof InfluenceResumeApidestroy0_1
     */
    influenceResumeChannelDestroyDTO: Array<InfluenceResumeChannelDestroyDTO>
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApidestroy0_1
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceResumeApiDestroy01Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApidestroy0_2
     */
    resumeId: number
    /**
     * 
     * @type Array&lt;InfluenceResumeChannelPriceDestroyDTO&gt;
     * @memberof InfluenceResumeApidestroy0_2
     */
    influenceResumeChannelPriceDestroyDTO: Array<InfluenceResumeChannelPriceDestroyDTO>
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApidestroy0_2
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceResumeApiFindById0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApifindById0
     */
    resumeId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApifindById0
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceResumeApiPaginate0Request {
    /**
     * Page.
     * Defaults to: 0
     * @type number
     * @memberof InfluenceResumeApipaginate0
     */
    page: number
    /**
     * Amount of items to take.
     * Defaults to: 10
     * @type number
     * @memberof InfluenceResumeApipaginate0
     */
    limit: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApipaginate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * Search string to filter items.
     * Defaults to: undefined
     * @type string
     * @memberof InfluenceResumeApipaginate0
     */
    search?: string
    /**
     * Returns only owned resumes.
     * Defaults to: undefined
     * @type boolean
     * @memberof InfluenceResumeApipaginate0
     */
    self?: boolean
    /**
     * Returns only favourite resumes.
     * Defaults to: undefined
     * @type boolean
     * @memberof InfluenceResumeApipaginate0
     */
    favourite?: boolean
}

export interface InfluenceResumeApiUpdate0Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApiupdate0
     */
    resumeId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApiupdate0
     */
    lang?: 'en' | 'ru' | 'uk'
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof InfluenceResumeApiupdate0
     */
    avatar?: HttpFile
}

export interface InfluenceResumeApiUpdate00Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApiupdate0_3
     */
    resumeId: number
    /**
     * 
     * @type Array&lt;InfluenceResumeChannelMutableDTO&gt;
     * @memberof InfluenceResumeApiupdate0_3
     */
    influenceResumeChannelMutableDTO: Array<InfluenceResumeChannelMutableDTO>
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApiupdate0_3
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface InfluenceResumeApiUpdate01Request {
    /**
     * Unique id of resume to find.
     * Defaults to: undefined
     * @type number
     * @memberof InfluenceResumeApiupdate0_4
     */
    resumeId: number
    /**
     * 
     * @type Array&lt;InfluenceResumeChannelPriceMutableDTO&gt;
     * @memberof InfluenceResumeApiupdate0_4
     */
    influenceResumeChannelPriceMutableDTO: Array<InfluenceResumeChannelPriceMutableDTO>
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof InfluenceResumeApiupdate0_4
     */
    lang?: 'en' | 'ru' | 'uk'
}

export class ObjectInfluenceResumeApi {
    private api: ObservableInfluenceResumeApi

    public constructor(configuration: Configuration, requestFactory?: InfluenceResumeApiRequestFactory, responseProcessor?: InfluenceResumeApiResponseProcessor) {
        this.api = new ObservableInfluenceResumeApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Creates new resume.
     * @param param the request object
     */
    public create0WithHttpInfo(param: InfluenceResumeApiCreate0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.create0WithHttpInfo(param.lang, param.avatar,  options).toPromise();
    }

    /**
     * Creates new resume.
     * @param param the request object
     */
    public create0(param: InfluenceResumeApiCreate0Request = {}, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.create0(param.lang, param.avatar,  options).toPromise();
    }

    /**
     * Deletes resume, according to the given unique id query.
     * @param param the request object
     */
    public destroy0WithHttpInfo(param: InfluenceResumeApiDestroy0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.destroy0WithHttpInfo(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Deletes resume, according to the given unique id query.
     * @param param the request object
     */
    public destroy0(param: InfluenceResumeApiDestroy0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.destroy0(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Deletes channel.
     * @param param the request object
     */
    public destroy0_1WithHttpInfo(param: InfluenceResumeApiDestroy00Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.destroy0_1WithHttpInfo(param.resumeId, param.influenceResumeChannelDestroyDTO, param.lang,  options).toPromise();
    }

    /**
     * Deletes channel.
     * @param param the request object
     */
    public destroy0_1(param: InfluenceResumeApiDestroy00Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.destroy0_1(param.resumeId, param.influenceResumeChannelDestroyDTO, param.lang,  options).toPromise();
    }

    /**
     * Deletes price.
     * @param param the request object
     */
    public destroy0_2WithHttpInfo(param: InfluenceResumeApiDestroy01Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.destroy0_2WithHttpInfo(param.resumeId, param.influenceResumeChannelPriceDestroyDTO, param.lang,  options).toPromise();
    }

    /**
     * Deletes price.
     * @param param the request object
     */
    public destroy0_2(param: InfluenceResumeApiDestroy01Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.destroy0_2(param.resumeId, param.influenceResumeChannelPriceDestroyDTO, param.lang,  options).toPromise();
    }

    /**
     * Returns resume, according to the given unique id query.
     * @param param the request object
     */
    public findById0WithHttpInfo(param: InfluenceResumeApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.findById0WithHttpInfo(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Returns resume, according to the given unique id query.
     * @param param the request object
     */
    public findById0(param: InfluenceResumeApiFindById0Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.findById0(param.resumeId, param.lang,  options).toPromise();
    }

    /**
     * Returns a set of resume, according to the given limit and page number query.
     * @param param the request object
     */
    public paginate0WithHttpInfo(param: InfluenceResumeApiPaginate0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumePaginateControllerPaginate0200Response>> {
        return this.api.paginate0WithHttpInfo(param.page, param.limit, param.lang, param.search, param.self, param.favourite,  options).toPromise();
    }

    /**
     * Returns a set of resume, according to the given limit and page number query.
     * @param param the request object
     */
    public paginate0(param: InfluenceResumeApiPaginate0Request, options?: ConfigurationOptions): Promise<InfluenceResumePaginateControllerPaginate0200Response> {
        return this.api.paginate0(param.page, param.limit, param.lang, param.search, param.self, param.favourite,  options).toPromise();
    }

    /**
     * Updates resume, according to the given unique id query.
     * @param param the request object
     */
    public update0WithHttpInfo(param: InfluenceResumeApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.update0WithHttpInfo(param.resumeId, param.lang, param.avatar,  options).toPromise();
    }

    /**
     * Updates resume, according to the given unique id query.
     * @param param the request object
     */
    public update0(param: InfluenceResumeApiUpdate0Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.update0(param.resumeId, param.lang, param.avatar,  options).toPromise();
    }

    /**
     * Creates or updates channel.
     * @param param the request object
     */
    public update0_3WithHttpInfo(param: InfluenceResumeApiUpdate00Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.update0_3WithHttpInfo(param.resumeId, param.influenceResumeChannelMutableDTO, param.lang,  options).toPromise();
    }

    /**
     * Creates or updates channel.
     * @param param the request object
     */
    public update0_3(param: InfluenceResumeApiUpdate00Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.update0_3(param.resumeId, param.influenceResumeChannelMutableDTO, param.lang,  options).toPromise();
    }

    /**
     * Creates or updates price.
     * @param param the request object
     */
    public update0_4WithHttpInfo(param: InfluenceResumeApiUpdate01Request, options?: ConfigurationOptions): Promise<HttpInfo<InfluenceResumeDTO>> {
        return this.api.update0_4WithHttpInfo(param.resumeId, param.influenceResumeChannelPriceMutableDTO, param.lang,  options).toPromise();
    }

    /**
     * Creates or updates price.
     * @param param the request object
     */
    public update0_4(param: InfluenceResumeApiUpdate01Request, options?: ConfigurationOptions): Promise<InfluenceResumeDTO> {
        return this.api.update0_4(param.resumeId, param.influenceResumeChannelPriceMutableDTO, param.lang,  options).toPromise();
    }

}

import { ObservableLocationApi } from "./ObservableAPI";
import { LocationApiRequestFactory, LocationApiResponseProcessor} from "../apis/LocationApi";

export interface LocationApiFindAll0Request {
}

export interface LocationApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof LocationApifindById0
     */
    geonameid: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof LocationApifindById0
     */
    lang: string
}

export interface LocationApiFindCountries0Request {
}

export class ObjectLocationApi {
    private api: ObservableLocationApi

    public constructor(configuration: Configuration, requestFactory?: LocationApiRequestFactory, responseProcessor?: LocationApiResponseProcessor) {
        this.api = new ObservableLocationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: LocationApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.findAll0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findAll0(param: LocationApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<void> {
        return this.api.findAll0( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: LocationApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.geonameid, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: LocationApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.geonameid, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findCountries0WithHttpInfo(param: LocationApiFindCountries0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.findCountries0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findCountries0(param: LocationApiFindCountries0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.findCountries0( options).toPromise();
    }

}

import { ObservableManagerApi } from "./ObservableAPI";
import { ManagerApiRequestFactory, ManagerApiResponseProcessor} from "../apis/ManagerApi";

export interface ManagerApiCreate0Request {
    /**
     * 
     * @type ManagerCreateDTO
     * @memberof ManagerApicreate0
     */
    managerCreateDTO: ManagerCreateDTO
}

export interface ManagerApiDestroy0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ManagerApidestroy0
     */
    profileId: number
}

export interface ManagerApiList0Request {
    /**
     * Items count.
     * Defaults to: 10
     * @type number
     * @memberof ManagerApilist0
     */
    limit: number
    /**
     * Page number.
     * Defaults to: 0
     * @type number
     * @memberof ManagerApilist0
     */
    page: number
    /**
     * Preferred language.
     * Defaults to: &#39;ru&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof ManagerApilist0
     */
    lang: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
}

export interface ManagerApiUpdatePost0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ManagerApiupdatePost0
     */
    profileId: number
    /**
     * 
     * @type ManagerUpdateDTO
     * @memberof ManagerApiupdatePost0
     */
    managerUpdateDTO: ManagerUpdateDTO
}

export interface ManagerApiUpdatePut0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ManagerApiupdatePut0
     */
    profileId: number
    /**
     * 
     * @type ManagerUpdateDTO
     * @memberof ManagerApiupdatePut0
     */
    managerUpdateDTO: ManagerUpdateDTO
}

export class ObjectManagerApi {
    private api: ObservableManagerApi

    public constructor(configuration: Configuration, requestFactory?: ManagerApiRequestFactory, responseProcessor?: ManagerApiResponseProcessor) {
        this.api = new ObservableManagerApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public create0WithHttpInfo(param: ManagerApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.create0WithHttpInfo(param.managerCreateDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public create0(param: ManagerApiCreate0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.create0(param.managerCreateDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public destroy0WithHttpInfo(param: ManagerApiDestroy0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.destroy0WithHttpInfo(param.profileId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public destroy0(param: ManagerApiDestroy0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.destroy0(param.profileId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: ManagerApiList0Request, options?: ConfigurationOptions): Promise<HttpInfo<ManagerResponseDTO>> {
        return this.api.list0WithHttpInfo(param.limit, param.page, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: ManagerApiList0Request, options?: ConfigurationOptions): Promise<ManagerResponseDTO> {
        return this.api.list0(param.limit, param.page, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public updatePost0WithHttpInfo(param: ManagerApiUpdatePost0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updatePost0WithHttpInfo(param.profileId, param.managerUpdateDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public updatePost0(param: ManagerApiUpdatePost0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updatePost0(param.profileId, param.managerUpdateDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public updatePut0WithHttpInfo(param: ManagerApiUpdatePut0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updatePut0WithHttpInfo(param.profileId, param.managerUpdateDTO,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public updatePut0(param: ManagerApiUpdatePut0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updatePut0(param.profileId, param.managerUpdateDTO,  options).toPromise();
    }

}

import { ObservableNotificationCategorySettingsApi } from "./ObservableAPI";
import { NotificationCategorySettingsApiRequestFactory, NotificationCategorySettingsApiResponseProcessor} from "../apis/NotificationCategorySettingsApi";

export interface NotificationCategorySettingsApiDisable0Request {
    /**
     * 
     * @type NotificationProfileCategorySettingsDTO
     * @memberof NotificationCategorySettingsApidisable0
     */
    notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO
}

export interface NotificationCategorySettingsApiDisable00Request {
    /**
     * 
     * @type NotificationProfileCategorySettingsDTO
     * @memberof NotificationCategorySettingsApidisable0_1
     */
    notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO
}

export interface NotificationCategorySettingsApiFindAllCategories0Request {
}

export class ObjectNotificationCategorySettingsApi {
    private api: ObservableNotificationCategorySettingsApi

    public constructor(configuration: Configuration, requestFactory?: NotificationCategorySettingsApiRequestFactory, responseProcessor?: NotificationCategorySettingsApiResponseProcessor) {
        this.api = new ObservableNotificationCategorySettingsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Enables notification category.
     * @param param the request object
     */
    public disable0WithHttpInfo(param: NotificationCategorySettingsApiDisable0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.disable0WithHttpInfo(param.notificationProfileCategorySettingsDTO,  options).toPromise();
    }

    /**
     * Enables notification category.
     * @param param the request object
     */
    public disable0(param: NotificationCategorySettingsApiDisable0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.disable0(param.notificationProfileCategorySettingsDTO,  options).toPromise();
    }

    /**
     * Disables notification category.
     * @param param the request object
     */
    public disable0_1WithHttpInfo(param: NotificationCategorySettingsApiDisable00Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.disable0_1WithHttpInfo(param.notificationProfileCategorySettingsDTO,  options).toPromise();
    }

    /**
     * Disables notification category.
     * @param param the request object
     */
    public disable0_1(param: NotificationCategorySettingsApiDisable00Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.disable0_1(param.notificationProfileCategorySettingsDTO,  options).toPromise();
    }

    /**
     * Returns array of current categories status.
     * @param param the request object
     */
    public findAllCategories0WithHttpInfo(param: NotificationCategorySettingsApiFindAllCategories0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<NotificationProfileCategoryDTO>>> {
        return this.api.findAllCategories0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns array of current categories status.
     * @param param the request object
     */
    public findAllCategories0(param: NotificationCategorySettingsApiFindAllCategories0Request = {}, options?: ConfigurationOptions): Promise<Array<NotificationProfileCategoryDTO>> {
        return this.api.findAllCategories0( options).toPromise();
    }

}

import { ObservableNotificationProviderSettingsApi } from "./ObservableAPI";
import { NotificationProviderSettingsApiRequestFactory, NotificationProviderSettingsApiResponseProcessor} from "../apis/NotificationProviderSettingsApi";

export interface NotificationProviderSettingsApiDisable0Request {
    /**
     * 
     * @type NotificationProfileProviderSettingsDTO
     * @memberof NotificationProviderSettingsApidisable0
     */
    notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO
}

export interface NotificationProviderSettingsApiDisable00Request {
    /**
     * 
     * @type NotificationProfileProviderSettingsDTO
     * @memberof NotificationProviderSettingsApidisable0_1
     */
    notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO
}

export interface NotificationProviderSettingsApiFindAllCategories0Request {
}

export class ObjectNotificationProviderSettingsApi {
    private api: ObservableNotificationProviderSettingsApi

    public constructor(configuration: Configuration, requestFactory?: NotificationProviderSettingsApiRequestFactory, responseProcessor?: NotificationProviderSettingsApiResponseProcessor) {
        this.api = new ObservableNotificationProviderSettingsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Enables notification provider.
     * @param param the request object
     */
    public disable0WithHttpInfo(param: NotificationProviderSettingsApiDisable0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.disable0WithHttpInfo(param.notificationProfileProviderSettingsDTO,  options).toPromise();
    }

    /**
     * Enables notification provider.
     * @param param the request object
     */
    public disable0(param: NotificationProviderSettingsApiDisable0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.disable0(param.notificationProfileProviderSettingsDTO,  options).toPromise();
    }

    /**
     * Disables notification provider.
     * @param param the request object
     */
    public disable0_1WithHttpInfo(param: NotificationProviderSettingsApiDisable00Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.disable0_1WithHttpInfo(param.notificationProfileProviderSettingsDTO,  options).toPromise();
    }

    /**
     * Disables notification provider.
     * @param param the request object
     */
    public disable0_1(param: NotificationProviderSettingsApiDisable00Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.disable0_1(param.notificationProfileProviderSettingsDTO,  options).toPromise();
    }

    /**
     * Returns array of current providers status.
     * @param param the request object
     */
    public findAllCategories0WithHttpInfo(param: NotificationProviderSettingsApiFindAllCategories0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<NotificationProfileProviderDTO>>> {
        return this.api.findAllCategories0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns array of current providers status.
     * @param param the request object
     */
    public findAllCategories0(param: NotificationProviderSettingsApiFindAllCategories0Request = {}, options?: ConfigurationOptions): Promise<Array<NotificationProfileProviderDTO>> {
        return this.api.findAllCategories0( options).toPromise();
    }

}

import { ObservableNotificationProvidersApi } from "./ObservableAPI";
import { NotificationProvidersApiRequestFactory, NotificationProvidersApiResponseProcessor} from "../apis/NotificationProvidersApi";

export interface NotificationProvidersApiFindAll0Request {
}

export interface NotificationProvidersApiGenerate0Request {
}

export interface NotificationProvidersApiUnLink0Request {
    /**
     * 
     * @type NotificationProfileProviderUnLinkDTO
     * @memberof NotificationProvidersApiunLink0
     */
    notificationProfileProviderUnLinkDTO: NotificationProfileProviderUnLinkDTO
}

export class ObjectNotificationProvidersApi {
    private api: ObservableNotificationProvidersApi

    public constructor(configuration: Configuration, requestFactory?: NotificationProvidersApiRequestFactory, responseProcessor?: NotificationProvidersApiResponseProcessor) {
        this.api = new ObservableNotificationProvidersApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns all available providers
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: NotificationProvidersApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.findAll0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns all available providers
     * @param param the request object
     */
    public findAll0(param: NotificationProvidersApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.findAll0( options).toPromise();
    }

    /**
     * Generate new link for telegram.
     * @param param the request object
     */
    public generate0WithHttpInfo(param: NotificationProvidersApiGenerate0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<NotificationProfileProviderGenerateDTO>> {
        return this.api.generate0WithHttpInfo( options).toPromise();
    }

    /**
     * Generate new link for telegram.
     * @param param the request object
     */
    public generate0(param: NotificationProvidersApiGenerate0Request = {}, options?: ConfigurationOptions): Promise<NotificationProfileProviderGenerateDTO> {
        return this.api.generate0( options).toPromise();
    }

    /**
     * Remove linking to provider.
     * @param param the request object
     */
    public unLink0WithHttpInfo(param: NotificationProvidersApiUnLink0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.unLink0WithHttpInfo(param.notificationProfileProviderUnLinkDTO,  options).toPromise();
    }

    /**
     * Remove linking to provider.
     * @param param the request object
     */
    public unLink0(param: NotificationProvidersApiUnLink0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.unLink0(param.notificationProfileProviderUnLinkDTO,  options).toPromise();
    }

}

import { ObservableNotificationUserApi } from "./ObservableAPI";
import { NotificationUserApiRequestFactory, NotificationUserApiResponseProcessor} from "../apis/NotificationUserApi";

export interface NotificationUserApiFindAll0Request {
}

export interface NotificationUserApiRead0Request {
    /**
     * 
     * @type NotificationProfileReadDTO
     * @memberof NotificationUserApiread0
     */
    notificationProfileReadDTO: NotificationProfileReadDTO
}

export interface NotificationUserApiStats0Request {
}

export class ObjectNotificationUserApi {
    private api: ObservableNotificationUserApi

    public constructor(configuration: Configuration, requestFactory?: NotificationUserApiRequestFactory, responseProcessor?: NotificationUserApiResponseProcessor) {
        this.api = new ObservableNotificationUserApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns paginated notifications.
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: NotificationUserApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<NotificationProfileRootDTO>> {
        return this.api.findAll0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns paginated notifications.
     * @param param the request object
     */
    public findAll0(param: NotificationUserApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<NotificationProfileRootDTO> {
        return this.api.findAll0( options).toPromise();
    }

    /**
     * Reads notifications by notification ids.
     * @param param the request object
     */
    public read0WithHttpInfo(param: NotificationUserApiRead0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.read0WithHttpInfo(param.notificationProfileReadDTO,  options).toPromise();
    }

    /**
     * Reads notifications by notification ids.
     * @param param the request object
     */
    public read0(param: NotificationUserApiRead0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.read0(param.notificationProfileReadDTO,  options).toPromise();
    }

    /**
     * Returns notification stats.
     * @param param the request object
     */
    public stats0WithHttpInfo(param: NotificationUserApiStats0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<NotificationProfileRootDTO>> {
        return this.api.stats0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns notification stats.
     * @param param the request object
     */
    public stats0(param: NotificationUserApiStats0Request = {}, options?: ConfigurationOptions): Promise<NotificationProfileRootDTO> {
        return this.api.stats0( options).toPromise();
    }

}

import { ObservableOrderApi } from "./ObservableAPI";
import { OrderApiRequestFactory, OrderApiResponseProcessor} from "../apis/OrderApi";

export interface OrderApiCanUseProduct0Request {
    /**
     * 
     * Defaults to: &#39;en&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof OrderApicanUseProduct0
     */
    locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
}

export interface OrderApiCheckCanUseProduct0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof OrderApicheckCanUseProduct0
     */
    productId: number
}

export interface OrderApiCreateOrder0Request {
    /**
     * 
     * Defaults to: &#39;en&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof OrderApicreateOrder0
     */
    locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof OrderApicreateOrder0
     */
    id: number
    /**
     * 
     * @type CreateOrderQueryDto
     * @memberof OrderApicreateOrder0
     */
    createOrderQueryDto: CreateOrderQueryDto
}

export interface OrderApiFindAllOrdersOwned0Request {
    /**
     * 
     * Defaults to: &#39;en&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof OrderApifindAllOrdersOwned0
     */
    locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
    /**
     * 
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof OrderApifindAllOrdersOwned0
     */
    cvId?: number
}

export class ObjectOrderApi {
    private api: ObservableOrderApi

    public constructor(configuration: Configuration, requestFactory?: OrderApiRequestFactory, responseProcessor?: OrderApiResponseProcessor) {
        this.api = new ObservableOrderApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns an order that can be used with requested features
     * @param param the request object
     */
    public canUseProduct0WithHttpInfo(param: OrderApiCanUseProduct0Request, options?: ConfigurationOptions): Promise<HttpInfo<OrderEntity | void>> {
        return this.api.canUseProduct0WithHttpInfo(param.locale,  options).toPromise();
    }

    /**
     * Returns an order that can be used with requested features
     * @param param the request object
     */
    public canUseProduct0(param: OrderApiCanUseProduct0Request, options?: ConfigurationOptions): Promise<OrderEntity | void> {
        return this.api.canUseProduct0(param.locale,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public checkCanUseProduct0WithHttpInfo(param: OrderApiCheckCanUseProduct0Request, options?: ConfigurationOptions): Promise<HttpInfo<OrderEntity>> {
        return this.api.checkCanUseProduct0WithHttpInfo(param.productId,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public checkCanUseProduct0(param: OrderApiCheckCanUseProduct0Request, options?: ConfigurationOptions): Promise<OrderEntity> {
        return this.api.checkCanUseProduct0(param.productId,  options).toPromise();
    }

    /**
     * Creates order
     * @param param the request object
     */
    public createOrder0WithHttpInfo(param: OrderApiCreateOrder0Request, options?: ConfigurationOptions): Promise<HttpInfo<OrderEntity | any>> {
        return this.api.createOrder0WithHttpInfo(param.locale, param.id, param.createOrderQueryDto,  options).toPromise();
    }

    /**
     * Creates order
     * @param param the request object
     */
    public createOrder0(param: OrderApiCreateOrder0Request, options?: ConfigurationOptions): Promise<OrderEntity | any> {
        return this.api.createOrder0(param.locale, param.id, param.createOrderQueryDto,  options).toPromise();
    }

    /**
     * Returns an array of owned orders
     * @param param the request object
     */
    public findAllOrdersOwned0WithHttpInfo(param: OrderApiFindAllOrdersOwned0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<OrderEntity>>> {
        return this.api.findAllOrdersOwned0WithHttpInfo(param.locale, param.cvId,  options).toPromise();
    }

    /**
     * Returns an array of owned orders
     * @param param the request object
     */
    public findAllOrdersOwned0(param: OrderApiFindAllOrdersOwned0Request, options?: ConfigurationOptions): Promise<Array<OrderEntity>> {
        return this.api.findAllOrdersOwned0(param.locale, param.cvId,  options).toPromise();
    }

}

import { ObservableOrderTransactionApi } from "./ObservableAPI";
import { OrderTransactionApiRequestFactory, OrderTransactionApiResponseProcessor} from "../apis/OrderTransactionApi";

export interface OrderTransactionApiFindAllTransactions0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof OrderTransactionApifindAllTransactions0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type &#39;employee&#39; | &#39;hirer&#39; | &#39;unknown&#39;
     * @memberof OrderTransactionApifindAllTransactions0
     */
    type: 'employee' | 'hirer' | 'unknown'
}

export class ObjectOrderTransactionApi {
    private api: ObservableOrderTransactionApi

    public constructor(configuration: Configuration, requestFactory?: OrderTransactionApiRequestFactory, responseProcessor?: OrderTransactionApiResponseProcessor) {
        this.api = new ObservableOrderTransactionApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns an array of all transactions by owner type and id.
     * @param param the request object
     */
    public findAllTransactions0WithHttpInfo(param: OrderTransactionApiFindAllTransactions0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<OrderTransactionEntity>>> {
        return this.api.findAllTransactions0WithHttpInfo(param.id, param.type,  options).toPromise();
    }

    /**
     * Returns an array of all transactions by owner type and id.
     * @param param the request object
     */
    public findAllTransactions0(param: OrderTransactionApiFindAllTransactions0Request, options?: ConfigurationOptions): Promise<Array<OrderTransactionEntity>> {
        return this.api.findAllTransactions0(param.id, param.type,  options).toPromise();
    }

}

import { ObservablePageApi } from "./ObservableAPI";
import { PageApiRequestFactory, PageApiResponseProcessor} from "../apis/PageApi";

export interface PageApiGetManyBasePageControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    language: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetManyBasePageControllerPageHTMLBlock
     */
    cache?: number
}

export interface PageApiGetOneBasePageControllerPageHTMLBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageApigetOneBasePageControllerPageHTMLBlock
     */
    language: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetOneBasePageControllerPageHTMLBlock
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetOneBasePageControllerPageHTMLBlock
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PageApigetOneBasePageControllerPageHTMLBlock
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof PageApigetOneBasePageControllerPageHTMLBlock
     */
    cache?: number
}

export class ObjectPageApi {
    private api: ObservablePageApi

    public constructor(configuration: Configuration, requestFactory?: PageApiRequestFactory, responseProcessor?: PageApiResponseProcessor) {
        this.api = new ObservablePageApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param param the request object
     */
    public getManyBasePageControllerPageHTMLBlockWithHttpInfo(param: PageApiGetManyBasePageControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBasePageControllerPageHTMLBlockWithHttpInfo(param.language, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param param the request object
     */
    public getManyBasePageControllerPageHTMLBlock(param: PageApiGetManyBasePageControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBasePageControllerPageHTMLBlock(param.language, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param param the request object
     */
    public getOneBasePageControllerPageHTMLBlockWithHttpInfo(param: PageApiGetOneBasePageControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBasePageControllerPageHTMLBlockWithHttpInfo(param.language, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param param the request object
     */
    public getOneBasePageControllerPageHTMLBlock(param: PageApiGetOneBasePageControllerPageHTMLBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBasePageControllerPageHTMLBlock(param.language, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservablePageJsonBlockApi } from "./ObservableAPI";
import { PageJsonBlockApiRequestFactory, PageJsonBlockApiResponseProcessor} from "../apis/PageJsonBlockApi";

export interface PageJsonBlockApiCreate0Request {
    /**
     * 
     * @type CreatePageJsonBlockDto
     * @memberof PageJsonBlockApicreate0
     */
    createPageJsonBlockDto: CreatePageJsonBlockDto
}

export interface PageJsonBlockApiDelete0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageJsonBlockApidelete0
     */
    key: string
}

export interface PageJsonBlockApiGetByKey0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageJsonBlockApigetByKey0
     */
    key: string
}

export interface PageJsonBlockApiUpdate0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageJsonBlockApiupdate0
     */
    key: string
    /**
     * 
     * @type UpdatePageJsonBlockDto
     * @memberof PageJsonBlockApiupdate0
     */
    updatePageJsonBlockDto: UpdatePageJsonBlockDto
}

export class ObjectPageJsonBlockApi {
    private api: ObservablePageJsonBlockApi

    public constructor(configuration: Configuration, requestFactory?: PageJsonBlockApiRequestFactory, responseProcessor?: PageJsonBlockApiResponseProcessor) {
        this.api = new ObservablePageJsonBlockApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a new page JSON block
     * @param param the request object
     */
    public create0WithHttpInfo(param: PageJsonBlockApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<PageJsonBlock>> {
        return this.api.create0WithHttpInfo(param.createPageJsonBlockDto,  options).toPromise();
    }

    /**
     * Create a new page JSON block
     * @param param the request object
     */
    public create0(param: PageJsonBlockApiCreate0Request, options?: ConfigurationOptions): Promise<PageJsonBlock> {
        return this.api.create0(param.createPageJsonBlockDto,  options).toPromise();
    }

    /**
     * Delete a page JSON block by key
     * @param param the request object
     */
    public delete0WithHttpInfo(param: PageJsonBlockApiDelete0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.delete0WithHttpInfo(param.key,  options).toPromise();
    }

    /**
     * Delete a page JSON block by key
     * @param param the request object
     */
    public delete0(param: PageJsonBlockApiDelete0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.delete0(param.key,  options).toPromise();
    }

    /**
     * Get a page JSON block by key
     * @param param the request object
     */
    public getByKey0WithHttpInfo(param: PageJsonBlockApiGetByKey0Request, options?: ConfigurationOptions): Promise<HttpInfo<PageJsonBlock>> {
        return this.api.getByKey0WithHttpInfo(param.key,  options).toPromise();
    }

    /**
     * Get a page JSON block by key
     * @param param the request object
     */
    public getByKey0(param: PageJsonBlockApiGetByKey0Request, options?: ConfigurationOptions): Promise<PageJsonBlock> {
        return this.api.getByKey0(param.key,  options).toPromise();
    }

    /**
     * Update an existing page JSON block by key
     * @param param the request object
     */
    public update0WithHttpInfo(param: PageJsonBlockApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<PageJsonBlock>> {
        return this.api.update0WithHttpInfo(param.key, param.updatePageJsonBlockDto,  options).toPromise();
    }

    /**
     * Update an existing page JSON block by key
     * @param param the request object
     */
    public update0(param: PageJsonBlockApiUpdate0Request, options?: ConfigurationOptions): Promise<PageJsonBlock> {
        return this.api.update0(param.key, param.updatePageJsonBlockDto,  options).toPromise();
    }

}

import { ObservablePageJsonBlockTranslationApi } from "./ObservableAPI";
import { PageJsonBlockTranslationApiRequestFactory, PageJsonBlockTranslationApiResponseProcessor} from "../apis/PageJsonBlockTranslationApi";

export interface PageJsonBlockTranslationApiCreate0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof PageJsonBlockTranslationApicreate0
     */
    key: string
    /**
     * 
     * @type CreatePageJsonBlockTranslationDto
     * @memberof PageJsonBlockTranslationApicreate0
     */
    createPageJsonBlockTranslationDto: CreatePageJsonBlockTranslationDto
}

export class ObjectPageJsonBlockTranslationApi {
    private api: ObservablePageJsonBlockTranslationApi

    public constructor(configuration: Configuration, requestFactory?: PageJsonBlockTranslationApiRequestFactory, responseProcessor?: PageJsonBlockTranslationApiResponseProcessor) {
        this.api = new ObservablePageJsonBlockTranslationApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a new translation for a page JSON block
     * @param param the request object
     */
    public create0WithHttpInfo(param: PageJsonBlockTranslationApiCreate0Request, options?: ConfigurationOptions): Promise<HttpInfo<PageJsonBlockTranslation>> {
        return this.api.create0WithHttpInfo(param.key, param.createPageJsonBlockTranslationDto,  options).toPromise();
    }

    /**
     * Create a new translation for a page JSON block
     * @param param the request object
     */
    public create0(param: PageJsonBlockTranslationApiCreate0Request, options?: ConfigurationOptions): Promise<PageJsonBlockTranslation> {
        return this.api.create0(param.key, param.createPageJsonBlockTranslationDto,  options).toPromise();
    }

}

import { ObservablePaymentMethodApi } from "./ObservableAPI";
import { PaymentMethodApiRequestFactory, PaymentMethodApiResponseProcessor} from "../apis/PaymentMethodApi";

export interface PaymentMethodApiGetPaymentMethods0Request {
    /**
     * 
     * @type GetPaymentMethodsRequestDto
     * @memberof PaymentMethodApigetPaymentMethods0
     */
    getPaymentMethodsRequestDto: GetPaymentMethodsRequestDto
}

export class ObjectPaymentMethodApi {
    private api: ObservablePaymentMethodApi

    public constructor(configuration: Configuration, requestFactory?: PaymentMethodApiRequestFactory, responseProcessor?: PaymentMethodApiResponseProcessor) {
        this.api = new ObservablePaymentMethodApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public getPaymentMethods0WithHttpInfo(param: PaymentMethodApiGetPaymentMethods0Request, options?: ConfigurationOptions): Promise<HttpInfo<GetPaymentMethodsResponseDto>> {
        return this.api.getPaymentMethods0WithHttpInfo(param.getPaymentMethodsRequestDto,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getPaymentMethods0(param: PaymentMethodApiGetPaymentMethods0Request, options?: ConfigurationOptions): Promise<GetPaymentMethodsResponseDto> {
        return this.api.getPaymentMethods0(param.getPaymentMethodsRequestDto,  options).toPromise();
    }

}

import { ObservablePaymentPassimPayCallbackApi } from "./ObservableAPI";
import { PaymentPassimPayCallbackApiRequestFactory, PaymentPassimPayCallbackApiResponseProcessor} from "../apis/PaymentPassimPayCallbackApi";

export interface PaymentPassimPayCallbackApiCallback0Request {
}

export class ObjectPaymentPassimPayCallbackApi {
    private api: ObservablePaymentPassimPayCallbackApi

    public constructor(configuration: Configuration, requestFactory?: PaymentPassimPayCallbackApiRequestFactory, responseProcessor?: PaymentPassimPayCallbackApiResponseProcessor) {
        this.api = new ObservablePaymentPassimPayCallbackApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * PassimPay callback
     * @param param the request object
     */
    public callback0WithHttpInfo(param: PaymentPassimPayCallbackApiCallback0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<CallbackResponseDto>> {
        return this.api.callback0WithHttpInfo( options).toPromise();
    }

    /**
     * PassimPay callback
     * @param param the request object
     */
    public callback0(param: PaymentPassimPayCallbackApiCallback0Request = {}, options?: ConfigurationOptions): Promise<CallbackResponseDto> {
        return this.api.callback0( options).toPromise();
    }

}

import { ObservablePaymentPassimPayDepositApi } from "./ObservableAPI";
import { PaymentPassimPayDepositApiRequestFactory, PaymentPassimPayDepositApiResponseProcessor} from "../apis/PaymentPassimPayDepositApi";

export interface PaymentPassimPayDepositApiCreateDeposit0Request {
    /**
     * 
     * @type CreateDepositPassimPayRequestDto
     * @memberof PaymentPassimPayDepositApicreateDeposit0
     */
    createDepositPassimPayRequestDto: CreateDepositPassimPayRequestDto
}

export class ObjectPaymentPassimPayDepositApi {
    private api: ObservablePaymentPassimPayDepositApi

    public constructor(configuration: Configuration, requestFactory?: PaymentPassimPayDepositApiRequestFactory, responseProcessor?: PaymentPassimPayDepositApiResponseProcessor) {
        this.api = new ObservablePaymentPassimPayDepositApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public createDeposit0WithHttpInfo(param: PaymentPassimPayDepositApiCreateDeposit0Request, options?: ConfigurationOptions): Promise<HttpInfo<CreatePassimPayDepositResponseDto>> {
        return this.api.createDeposit0WithHttpInfo(param.createDepositPassimPayRequestDto,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public createDeposit0(param: PaymentPassimPayDepositApiCreateDeposit0Request, options?: ConfigurationOptions): Promise<CreatePassimPayDepositResponseDto> {
        return this.api.createDeposit0(param.createDepositPassimPayRequestDto,  options).toPromise();
    }

}

import { ObservablePaymentPassimPayGetLinkApi } from "./ObservableAPI";
import { PaymentPassimPayGetLinkApiRequestFactory, PaymentPassimPayGetLinkApiResponseProcessor} from "../apis/PaymentPassimPayGetLinkApi";

export interface PaymentPassimPayGetLinkApiGetLink0Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof PaymentPassimPayGetLinkApigetLink0
     */
    orderIds: Array<number>
}

export class ObjectPaymentPassimPayGetLinkApi {
    private api: ObservablePaymentPassimPayGetLinkApi

    public constructor(configuration: Configuration, requestFactory?: PaymentPassimPayGetLinkApiRequestFactory, responseProcessor?: PaymentPassimPayGetLinkApiResponseProcessor) {
        this.api = new ObservablePaymentPassimPayGetLinkApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Get link an deposit
     * @param param the request object
     */
    public getLink0WithHttpInfo(param: PaymentPassimPayGetLinkApiGetLink0Request, options?: ConfigurationOptions): Promise<HttpInfo<GetDepositLinkResponseDto>> {
        return this.api.getLink0WithHttpInfo(param.orderIds,  options).toPromise();
    }

    /**
     * Get link an deposit
     * @param param the request object
     */
    public getLink0(param: PaymentPassimPayGetLinkApiGetLink0Request, options?: ConfigurationOptions): Promise<GetDepositLinkResponseDto> {
        return this.api.getLink0(param.orderIds,  options).toPromise();
    }

}

import { ObservablePaymentPassimPayTestDepositApi } from "./ObservableAPI";
import { PaymentPassimPayTestDepositApiRequestFactory, PaymentPassimPayTestDepositApiResponseProcessor} from "../apis/PaymentPassimPayTestDepositApi";

export interface PaymentPassimPayTestDepositApiCreateTestDeposit0Request {
    /**
     * 
     * @type CreateTestDepositPassimPayRequestDto
     * @memberof PaymentPassimPayTestDepositApicreateTestDeposit0
     */
    createTestDepositPassimPayRequestDto: CreateTestDepositPassimPayRequestDto
}

export class ObjectPaymentPassimPayTestDepositApi {
    private api: ObservablePaymentPassimPayTestDepositApi

    public constructor(configuration: Configuration, requestFactory?: PaymentPassimPayTestDepositApiRequestFactory, responseProcessor?: PaymentPassimPayTestDepositApiResponseProcessor) {
        this.api = new ObservablePaymentPassimPayTestDepositApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create deposit link method
     * @param param the request object
     */
    public createTestDeposit0WithHttpInfo(param: PaymentPassimPayTestDepositApiCreateTestDeposit0Request, options?: ConfigurationOptions): Promise<HttpInfo<CreatePassimPayTestDepositResponseDto>> {
        return this.api.createTestDeposit0WithHttpInfo(param.createTestDepositPassimPayRequestDto,  options).toPromise();
    }

    /**
     * Create deposit link method
     * @param param the request object
     */
    public createTestDeposit0(param: PaymentPassimPayTestDepositApiCreateTestDeposit0Request, options?: ConfigurationOptions): Promise<CreatePassimPayTestDepositResponseDto> {
        return this.api.createTestDeposit0(param.createTestDepositPassimPayRequestDto,  options).toPromise();
    }

}

import { ObservablePersonalPageApi } from "./ObservableAPI";
import { PersonalPageApiRequestFactory, PersonalPageApiResponseProcessor} from "../apis/PersonalPageApi";

export interface PersonalPageApiCreateOneBasePersonalPageControllerPersonalPageRequest {
    /**
     * 
     * @type any
     * @memberof PersonalPageApicreateOneBasePersonalPageControllerPersonalPage
     */
    body: any
}

export interface PersonalPageApiDeleteOneBasePersonalPageControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApideleteOneBasePersonalPageControllerPersonalPage
     */
    id: number
}

export interface PersonalPageApiGetManyBasePersonalPageControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    profileId: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetManyBasePersonalPageControllerPersonalPage
     */
    cache?: number
}

export interface PersonalPageApiGetOneBasePersonalPageControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetOneBasePersonalPageControllerPersonalPage
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetOneBasePersonalPageControllerPersonalPage
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof PersonalPageApigetOneBasePersonalPageControllerPersonalPage
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApigetOneBasePersonalPageControllerPersonalPage
     */
    cache?: number
}

export interface PersonalPageApiListByCurrentProfile0Request {
}

export interface PersonalPageApiUpdateOneBasePersonalPageControllerPersonalPageRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof PersonalPageApiupdateOneBasePersonalPageControllerPersonalPage
     */
    id: number
    /**
     * 
     * @type any
     * @memberof PersonalPageApiupdateOneBasePersonalPageControllerPersonalPage
     */
    body: any
}

export class ObjectPersonalPageApi {
    private api: ObservablePersonalPageApi

    public constructor(configuration: Configuration, requestFactory?: PersonalPageApiRequestFactory, responseProcessor?: PersonalPageApiResponseProcessor) {
        this.api = new ObservablePersonalPageApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single PersonalPage
     * @param param the request object
     */
    public createOneBasePersonalPageControllerPersonalPageWithHttpInfo(param: PersonalPageApiCreateOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBasePersonalPageControllerPersonalPageWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single PersonalPage
     * @param param the request object
     */
    public createOneBasePersonalPageControllerPersonalPage(param: PersonalPageApiCreateOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBasePersonalPageControllerPersonalPage(param.body,  options).toPromise();
    }

    /**
     * Delete a single PersonalPage
     * @param param the request object
     */
    public deleteOneBasePersonalPageControllerPersonalPageWithHttpInfo(param: PersonalPageApiDeleteOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBasePersonalPageControllerPersonalPageWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single PersonalPage
     * @param param the request object
     */
    public deleteOneBasePersonalPageControllerPersonalPage(param: PersonalPageApiDeleteOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBasePersonalPageControllerPersonalPage(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple PersonalPages
     * @param param the request object
     */
    public getManyBasePersonalPageControllerPersonalPageWithHttpInfo(param: PersonalPageApiGetManyBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBasePersonalPageControllerPersonalPageWithHttpInfo(param.profileId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple PersonalPages
     * @param param the request object
     */
    public getManyBasePersonalPageControllerPersonalPage(param: PersonalPageApiGetManyBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBasePersonalPageControllerPersonalPage(param.profileId, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PersonalPage
     * @param param the request object
     */
    public getOneBasePersonalPageControllerPersonalPageWithHttpInfo(param: PersonalPageApiGetOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBasePersonalPageControllerPersonalPageWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single PersonalPage
     * @param param the request object
     */
    public getOneBasePersonalPageControllerPersonalPage(param: PersonalPageApiGetOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBasePersonalPageControllerPersonalPage(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0WithHttpInfo(param: PersonalPageApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.listByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByCurrentProfile0(param: PersonalPageApiListByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<any> {
        return this.api.listByCurrentProfile0( options).toPromise();
    }

    /**
     * Update a single PersonalPage
     * @param param the request object
     */
    public updateOneBasePersonalPageControllerPersonalPageWithHttpInfo(param: PersonalPageApiUpdateOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBasePersonalPageControllerPersonalPageWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single PersonalPage
     * @param param the request object
     */
    public updateOneBasePersonalPageControllerPersonalPage(param: PersonalPageApiUpdateOneBasePersonalPageControllerPersonalPageRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBasePersonalPageControllerPersonalPage(param.id, param.body,  options).toPromise();
    }

}

import { ObservableProductApi } from "./ObservableAPI";
import { ProductApiRequestFactory, ProductApiResponseProcessor} from "../apis/ProductApi";

export interface ProductApiFindAll0Request {
    /**
     * 
     * Defaults to: undefined
     * @type &#39;VACANCY&#39; | &#39;PROFILE&#39; | &#39;CV_CONTACTS_OPEN&#39;
     * @memberof ProductApifindAll0
     */
    type: 'VACANCY' | 'PROFILE' | 'CV_CONTACTS_OPEN'
    /**
     * 
     * Defaults to: &#39;en&#39;
     * @type &#39;af&#39; | &#39;ak&#39; | &#39;am&#39; | &#39;ar&#39; | &#39;as&#39; | &#39;az&#39; | &#39;be&#39; | &#39;bg&#39; | &#39;bm&#39; | &#39;bn&#39; | &#39;bo&#39; | &#39;br&#39; | &#39;bs&#39; | &#39;ca&#39; | &#39;ce&#39; | &#39;co&#39; | &#39;cs&#39; | &#39;cu&#39; | &#39;cy&#39; | &#39;da&#39; | &#39;de&#39; | &#39;de_AT&#39; | &#39;de_CH&#39; | &#39;dz&#39; | &#39;ee&#39; | &#39;el&#39; | &#39;en&#39; | &#39;en_AU&#39; | &#39;en_CA&#39; | &#39;en_GB&#39; | &#39;en_US&#39; | &#39;eo&#39; | &#39;es&#39; | &#39;es_ES&#39; | &#39;es_MX&#39; | &#39;et&#39; | &#39;eu&#39; | &#39;fa&#39; | &#39;fa_AF&#39; | &#39;ff&#39; | &#39;fi&#39; | &#39;fo&#39; | &#39;fr&#39; | &#39;fr_CA&#39; | &#39;fr_CH&#39; | &#39;fy&#39; | &#39;ga&#39; | &#39;gd&#39; | &#39;gl&#39; | &#39;gu&#39; | &#39;gv&#39; | &#39;ha&#39; | &#39;he&#39; | &#39;hi&#39; | &#39;hr&#39; | &#39;ht&#39; | &#39;hu&#39; | &#39;hy&#39; | &#39;ia&#39; | &#39;id&#39; | &#39;ig&#39; | &#39;ii&#39; | &#39;is&#39; | &#39;it&#39; | &#39;ja&#39; | &#39;jv&#39; | &#39;ka&#39; | &#39;ki&#39; | &#39;kk&#39; | &#39;kl&#39; | &#39;km&#39; | &#39;kn&#39; | &#39;ko&#39; | &#39;ks&#39; | &#39;ku&#39; | &#39;kw&#39; | &#39;ky&#39; | &#39;la&#39; | &#39;lb&#39; | &#39;lg&#39; | &#39;ln&#39; | &#39;lo&#39; | &#39;lt&#39; | &#39;lu&#39; | &#39;lv&#39; | &#39;mg&#39; | &#39;mi&#39; | &#39;mk&#39; | &#39;ml&#39; | &#39;mn&#39; | &#39;mr&#39; | &#39;ms&#39; | &#39;mt&#39; | &#39;my&#39; | &#39;nb&#39; | &#39;nd&#39; | &#39;ne&#39; | &#39;nl&#39; | &#39;nl_BE&#39; | &#39;nn&#39; | &#39;ny&#39; | &#39;om&#39; | &#39;or&#39; | &#39;os&#39; | &#39;pa&#39; | &#39;pl&#39; | &#39;ps&#39; | &#39;pt&#39; | &#39;pt_BR&#39; | &#39;pt_PT&#39; | &#39;qu&#39; | &#39;rm&#39; | &#39;rn&#39; | &#39;ro&#39; | &#39;ro_MD&#39; | &#39;ru&#39; | &#39;rw&#39; | &#39;sa&#39; | &#39;sd&#39; | &#39;se&#39; | &#39;sg&#39; | &#39;si&#39; | &#39;sk&#39; | &#39;sl&#39; | &#39;sm&#39; | &#39;sn&#39; | &#39;so&#39; | &#39;sq&#39; | &#39;sr&#39; | &#39;st&#39; | &#39;su&#39; | &#39;sv&#39; | &#39;sw&#39; | &#39;sw_CD&#39; | &#39;ta&#39; | &#39;te&#39; | &#39;tg&#39; | &#39;th&#39; | &#39;ti&#39; | &#39;tk&#39; | &#39;to&#39; | &#39;tr&#39; | &#39;tt&#39; | &#39;ug&#39; | &#39;uk&#39; | &#39;ur&#39; | &#39;uz&#39; | &#39;vi&#39; | &#39;vo&#39; | &#39;wo&#39; | &#39;xh&#39; | &#39;yi&#39; | &#39;yo&#39; | &#39;zh&#39; | &#39;zh_Hans&#39; | &#39;zh_Hant&#39; | &#39;zu&#39;
     * @memberof ProductApifindAll0
     */
    locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu'
}

export interface ProductApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ProductApifindById0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProductApifindById0
     */
    promoCode?: string
}

export interface ProductApiFindLocalization0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProductApifindLocalization0
     */
    language: string
}

export interface ProductApiGetGiftPromotionAvailability0Request {
}

export class ObjectProductApi {
    private api: ObservableProductApi

    public constructor(configuration: Configuration, requestFactory?: ProductApiRequestFactory, responseProcessor?: ProductApiResponseProcessor) {
        this.api = new ObservableProductApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns an array of product that can buy current user
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: ProductApiFindAll0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<ProductEntity>>> {
        return this.api.findAll0WithHttpInfo(param.type, param.locale,  options).toPromise();
    }

    /**
     * Returns an array of product that can buy current user
     * @param param the request object
     */
    public findAll0(param: ProductApiFindAll0Request, options?: ConfigurationOptions): Promise<Array<ProductEntity>> {
        return this.api.findAll0(param.type, param.locale,  options).toPromise();
    }

    /**
     * Returns a product that can buy current user
     * @param param the request object
     */
    public findById0WithHttpInfo(param: ProductApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProductEntity>> {
        return this.api.findById0WithHttpInfo(param.id, param.promoCode,  options).toPromise();
    }

    /**
     * Returns a product that can buy current user
     * @param param the request object
     */
    public findById0(param: ProductApiFindById0Request, options?: ConfigurationOptions): Promise<ProductEntity> {
        return this.api.findById0(param.id, param.promoCode,  options).toPromise();
    }

    /**
     * Returns localization for requested product types
     * @param param the request object
     */
    public findLocalization0WithHttpInfo(param: ProductApiFindLocalization0Request, options?: ConfigurationOptions): Promise<HttpInfo<Array<ProductLocalizationDTO>>> {
        return this.api.findLocalization0WithHttpInfo(param.language,  options).toPromise();
    }

    /**
     * Returns localization for requested product types
     * @param param the request object
     */
    public findLocalization0(param: ProductApiFindLocalization0Request, options?: ConfigurationOptions): Promise<Array<ProductLocalizationDTO>> {
        return this.api.findLocalization0(param.language,  options).toPromise();
    }

    /**
     * Returns the availability of gift promotion for the current user
     * @param param the request object
     */
    public getGiftPromotionAvailability0WithHttpInfo(param: ProductApiGetGiftPromotionAvailability0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<GiftPromotionAvailabilityDTO>> {
        return this.api.getGiftPromotionAvailability0WithHttpInfo( options).toPromise();
    }

    /**
     * Returns the availability of gift promotion for the current user
     * @param param the request object
     */
    public getGiftPromotionAvailability0(param: ProductApiGetGiftPromotionAvailability0Request = {}, options?: ConfigurationOptions): Promise<GiftPromotionAvailabilityDTO> {
        return this.api.getGiftPromotionAvailability0( options).toPromise();
    }

}

import { ObservableProfilePromoCodesApi } from "./ObservableAPI";
import { ProfilePromoCodesApiRequestFactory, ProfilePromoCodesApiResponseProcessor} from "../apis/ProfilePromoCodesApi";

export interface ProfilePromoCodesApiCancelPromoCode0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProfilePromoCodesApicancelPromoCode0
     */
    code: string
}

export interface ProfilePromoCodesApiGetAvailablePromoCodes0Request {
    /**
     * 
     * Defaults to: 20
     * @type number
     * @memberof ProfilePromoCodesApigetAvailablePromoCodes0
     */
    limit?: number
    /**
     * 
     * Defaults to: 1
     * @type number
     * @memberof ProfilePromoCodesApigetAvailablePromoCodes0
     */
    page?: number
    /**
     * 
     * Defaults to: undefined
     * @type PromoCodeListQueryPaginationDTO
     * @memberof ProfilePromoCodesApigetAvailablePromoCodes0
     */
    query?: PromoCodeListQueryPaginationDTO
}

export interface ProfilePromoCodesApiGetPromoCode0Request {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProfilePromoCodesApigetPromoCode0
     */
    code: string
}

export class ObjectProfilePromoCodesApi {
    private api: ObservableProfilePromoCodesApi

    public constructor(configuration: Configuration, requestFactory?: ProfilePromoCodesApiRequestFactory, responseProcessor?: ProfilePromoCodesApiResponseProcessor) {
        this.api = new ObservableProfilePromoCodesApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Cancel a promo code
     * @param param the request object
     */
    public cancelPromoCode0WithHttpInfo(param: ProfilePromoCodesApiCancelPromoCode0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.cancelPromoCode0WithHttpInfo(param.code,  options).toPromise();
    }

    /**
     * Cancel a promo code
     * @param param the request object
     */
    public cancelPromoCode0(param: ProfilePromoCodesApiCancelPromoCode0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.cancelPromoCode0(param.code,  options).toPromise();
    }

    /**
     * Get available promo codes for the user
     * @param param the request object
     */
    public getAvailablePromoCodes0WithHttpInfo(param: ProfilePromoCodesApiGetAvailablePromoCodes0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<PromoCodeListResponseDto>> {
        return this.api.getAvailablePromoCodes0WithHttpInfo(param.limit, param.page, param.query,  options).toPromise();
    }

    /**
     * Get available promo codes for the user
     * @param param the request object
     */
    public getAvailablePromoCodes0(param: ProfilePromoCodesApiGetAvailablePromoCodes0Request = {}, options?: ConfigurationOptions): Promise<PromoCodeListResponseDto> {
        return this.api.getAvailablePromoCodes0(param.limit, param.page, param.query,  options).toPromise();
    }

    /**
     * Get promo code
     * @param param the request object
     */
    public getPromoCode0WithHttpInfo(param: ProfilePromoCodesApiGetPromoCode0Request, options?: ConfigurationOptions): Promise<HttpInfo<PromoCodeResponseDto>> {
        return this.api.getPromoCode0WithHttpInfo(param.code,  options).toPromise();
    }

    /**
     * Get promo code
     * @param param the request object
     */
    public getPromoCode0(param: ProfilePromoCodesApiGetPromoCode0Request, options?: ConfigurationOptions): Promise<PromoCodeResponseDto> {
        return this.api.getPromoCode0(param.code,  options).toPromise();
    }

}

import { ObservableProfileStatsApi } from "./ObservableAPI";
import { ProfileStatsApiRequestFactory, ProfileStatsApiResponseProcessor} from "../apis/ProfileStatsApi";

export interface ProfileStatsApiGetProfileStats0Request {
}

export class ObjectProfileStatsApi {
    private api: ObservableProfileStatsApi

    public constructor(configuration: Configuration, requestFactory?: ProfileStatsApiRequestFactory, responseProcessor?: ProfileStatsApiResponseProcessor) {
        this.api = new ObservableProfileStatsApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public getProfileStats0WithHttpInfo(param: ProfileStatsApiGetProfileStats0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<ProfileStatsDTO>> {
        return this.api.getProfileStats0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getProfileStats0(param: ProfileStatsApiGetProfileStats0Request = {}, options?: ConfigurationOptions): Promise<ProfileStatsDTO> {
        return this.api.getProfileStats0( options).toPromise();
    }

}

import { ObservableProfilesManagingApi } from "./ObservableAPI";
import { ProfilesManagingApiRequestFactory, ProfilesManagingApiResponseProcessor} from "../apis/ProfilesManagingApi";

export interface ProfilesManagingApiFindOne0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProfilesManagingApifindOne0
     */
    profileId: number
    /**
     * Specific language code for query.
     * Defaults to: &#39;en&#39;
     * @type &#39;en&#39; | &#39;ru&#39; | &#39;uk&#39;
     * @memberof ProfilesManagingApifindOne0
     */
    lang?: 'en' | 'ru' | 'uk'
}

export interface ProfilesManagingApiUpdateOne0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProfilesManagingApiupdateOne0
     */
    profileId: number
    /**
     * 
     * @type ProfileUpdateDTO
     * @memberof ProfilesManagingApiupdateOne0
     */
    profileUpdateDTO: ProfileUpdateDTO
}

export interface ProfilesManagingApiUpdateOneAvatar0Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProfilesManagingApiupdateOneAvatar0
     */
    profileId: number
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof ProfilesManagingApiupdateOneAvatar0
     */
    file?: HttpFile
}

export interface ProfilesManagingApiUpdateOneAvatar00Request {
    /**
     * Unique identifier of profile to process.
     * Minimum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProfilesManagingApiupdateOneAvatar0_1
     */
    profileId: number
    /**
     * File to upload
     * Defaults to: undefined
     * @type HttpFile
     * @memberof ProfilesManagingApiupdateOneAvatar0_1
     */
    file?: HttpFile
}

export class ObjectProfilesManagingApi {
    private api: ObservableProfilesManagingApi

    public constructor(configuration: Configuration, requestFactory?: ProfilesManagingApiRequestFactory, responseProcessor?: ProfilesManagingApiResponseProcessor) {
        this.api = new ObservableProfilesManagingApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Returns an existing profile.
     * @param param the request object
     */
    public findOne0WithHttpInfo(param: ProfilesManagingApiFindOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.findOne0WithHttpInfo(param.profileId, param.lang,  options).toPromise();
    }

    /**
     * Returns an existing profile.
     * @param param the request object
     */
    public findOne0(param: ProfilesManagingApiFindOne0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.findOne0(param.profileId, param.lang,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOne0WithHttpInfo(param: ProfilesManagingApiUpdateOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updateOne0WithHttpInfo(param.profileId, param.profileUpdateDTO,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOne0(param: ProfilesManagingApiUpdateOne0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updateOne0(param.profileId, param.profileUpdateDTO,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOneAvatar0WithHttpInfo(param: ProfilesManagingApiUpdateOneAvatar0Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updateOneAvatar0WithHttpInfo(param.profileId, param.file,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOneAvatar0(param: ProfilesManagingApiUpdateOneAvatar0Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updateOneAvatar0(param.profileId, param.file,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOneAvatar0_1WithHttpInfo(param: ProfilesManagingApiUpdateOneAvatar00Request, options?: ConfigurationOptions): Promise<HttpInfo<ProfileResponseDTO>> {
        return this.api.updateOneAvatar0_1WithHttpInfo(param.profileId, param.file,  options).toPromise();
    }

    /**
     * Updates an existing profile.
     * @param param the request object
     */
    public updateOneAvatar0_1(param: ProfilesManagingApiUpdateOneAvatar00Request, options?: ConfigurationOptions): Promise<ProfileResponseDTO> {
        return this.api.updateOneAvatar0_1(param.profileId, param.file,  options).toPromise();
    }

}

import { ObservableProposalApi } from "./ObservableAPI";
import { ProposalApiRequestFactory, ProposalApiResponseProcessor} from "../apis/ProposalApi";

export interface ProposalApiCreateOneBaseProposalControllerProposalRequest {
    /**
     * 
     * @type any
     * @memberof ProposalApicreateOneBaseProposalControllerProposal
     */
    body: any
}

export interface ProposalApiDeleteOneBaseProposalControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApideleteOneBaseProposalControllerProposal
     */
    id: number
}

export interface ProposalApiGetManyBaseProposalControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    lang: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetManyBaseProposalControllerProposal
     */
    cache?: number
}

export interface ProposalApiGetOneBaseProposalControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ProposalApigetOneBaseProposalControllerProposal
     */
    lang: string
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetOneBaseProposalControllerProposal
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetOneBaseProposalControllerProposal
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ProposalApigetOneBaseProposalControllerProposal
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApigetOneBaseProposalControllerProposal
     */
    cache?: number
}

export interface ProposalApiUpdateOneBaseProposalControllerProposalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ProposalApiupdateOneBaseProposalControllerProposal
     */
    id: number
    /**
     * 
     * @type any
     * @memberof ProposalApiupdateOneBaseProposalControllerProposal
     */
    body: any
}

export class ObjectProposalApi {
    private api: ObservableProposalApi

    public constructor(configuration: Configuration, requestFactory?: ProposalApiRequestFactory, responseProcessor?: ProposalApiResponseProcessor) {
        this.api = new ObservableProposalApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Proposal
     * @param param the request object
     */
    public createOneBaseProposalControllerProposalWithHttpInfo(param: ProposalApiCreateOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseProposalControllerProposalWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Proposal
     * @param param the request object
     */
    public createOneBaseProposalControllerProposal(param: ProposalApiCreateOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseProposalControllerProposal(param.body,  options).toPromise();
    }

    /**
     * Delete a single Proposal
     * @param param the request object
     */
    public deleteOneBaseProposalControllerProposalWithHttpInfo(param: ProposalApiDeleteOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.deleteOneBaseProposalControllerProposalWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single Proposal
     * @param param the request object
     */
    public deleteOneBaseProposalControllerProposal(param: ProposalApiDeleteOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.deleteOneBaseProposalControllerProposal(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple Proposals
     * @param param the request object
     */
    public getManyBaseProposalControllerProposalWithHttpInfo(param: ProposalApiGetManyBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.getManyBaseProposalControllerProposalWithHttpInfo(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Proposals
     * @param param the request object
     */
    public getManyBaseProposalControllerProposal(param: ProposalApiGetManyBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.getManyBaseProposalControllerProposal(param.lang, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Proposal
     * @param param the request object
     */
    public getOneBaseProposalControllerProposalWithHttpInfo(param: ProposalApiGetOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseProposalControllerProposalWithHttpInfo(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Proposal
     * @param param the request object
     */
    public getOneBaseProposalControllerProposal(param: ProposalApiGetOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseProposalControllerProposal(param.lang, param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Update a single Proposal
     * @param param the request object
     */
    public updateOneBaseProposalControllerProposalWithHttpInfo(param: ProposalApiUpdateOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseProposalControllerProposalWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single Proposal
     * @param param the request object
     */
    public updateOneBaseProposalControllerProposal(param: ProposalApiUpdateOneBaseProposalControllerProposalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseProposalControllerProposal(param.id, param.body,  options).toPromise();
    }

}

import { ObservableServiceCategoryApi } from "./ObservableAPI";
import { ServiceCategoryApiRequestFactory, ServiceCategoryApiResponseProcessor} from "../apis/ServiceCategoryApi";

export interface ServiceCategoryApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryApifindById0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof ServiceCategoryApifindById0
     */
    lang: string
}

export interface ServiceCategoryApiList0Request {
}

export class ObjectServiceCategoryApi {
    private api: ObservableServiceCategoryApi

    public constructor(configuration: Configuration, requestFactory?: ServiceCategoryApiRequestFactory, responseProcessor?: ServiceCategoryApiResponseProcessor) {
        this.api = new ObservableServiceCategoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: ServiceCategoryApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<ServiceCategory>> {
        return this.api.findById0WithHttpInfo(param.id, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: ServiceCategoryApiFindById0Request, options?: ConfigurationOptions): Promise<ServiceCategory> {
        return this.api.findById0(param.id, param.lang,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0WithHttpInfo(param: ServiceCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.list0WithHttpInfo( options).toPromise();
    }

    /**
     * @param param the request object
     */
    public list0(param: ServiceCategoryApiList0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.list0( options).toPromise();
    }

}

import { ObservableServiceCategoryAdminApi } from "./ObservableAPI";
import { ServiceCategoryAdminApiRequestFactory, ServiceCategoryAdminApiResponseProcessor} from "../apis/ServiceCategoryAdminApi";

export interface ServiceCategoryAdminApiCreateManyBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * @type CreateManyServiceCategoryDto
     * @memberof ServiceCategoryAdminApicreateManyBaseServiceCategoryAdminControllerServiceCategory
     */
    createManyServiceCategoryDto: CreateManyServiceCategoryDto
}

export interface ServiceCategoryAdminApiCreateOneBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * @type ServiceCategory
     * @memberof ServiceCategoryAdminApicreateOneBaseServiceCategoryAdminControllerServiceCategory
     */
    serviceCategory: ServiceCategory
}

export interface ServiceCategoryAdminApiDeleteOneBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApideleteOneBaseServiceCategoryAdminControllerServiceCategory
     */
    id: number
}

export interface ServiceCategoryAdminApiGetManyBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetManyBaseServiceCategoryAdminControllerServiceCategory
     */
    cache?: number
}

export interface ServiceCategoryAdminApiGetOneBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetOneBaseServiceCategoryAdminControllerServiceCategory
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetOneBaseServiceCategoryAdminControllerServiceCategory
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof ServiceCategoryAdminApigetOneBaseServiceCategoryAdminControllerServiceCategory
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApigetOneBaseServiceCategoryAdminControllerServiceCategory
     */
    cache?: number
}

export interface ServiceCategoryAdminApiReplaceOneBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApireplaceOneBaseServiceCategoryAdminControllerServiceCategory
     */
    id: number
    /**
     * 
     * @type ServiceCategory
     * @memberof ServiceCategoryAdminApireplaceOneBaseServiceCategoryAdminControllerServiceCategory
     */
    serviceCategory: ServiceCategory
}

export interface ServiceCategoryAdminApiUpdateOneBaseServiceCategoryAdminControllerServiceCategoryRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof ServiceCategoryAdminApiupdateOneBaseServiceCategoryAdminControllerServiceCategory
     */
    id: number
    /**
     * 
     * @type ServiceCategory
     * @memberof ServiceCategoryAdminApiupdateOneBaseServiceCategoryAdminControllerServiceCategory
     */
    serviceCategory: ServiceCategory
}

export class ObjectServiceCategoryAdminApi {
    private api: ObservableServiceCategoryAdminApi

    public constructor(configuration: Configuration, requestFactory?: ServiceCategoryAdminApiRequestFactory, responseProcessor?: ServiceCategoryAdminApiResponseProcessor) {
        this.api = new ObservableServiceCategoryAdminApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create multiple ServiceCategories
     * @param param the request object
     */
    public createManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiCreateManyBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<Array<ServiceCategory>>> {
        return this.api.createManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.createManyServiceCategoryDto,  options).toPromise();
    }

    /**
     * Create multiple ServiceCategories
     * @param param the request object
     */
    public createManyBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiCreateManyBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<Array<ServiceCategory>> {
        return this.api.createManyBaseServiceCategoryAdminControllerServiceCategory(param.createManyServiceCategoryDto,  options).toPromise();
    }

    /**
     * Create a single ServiceCategory
     * @param param the request object
     */
    public createOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiCreateOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ServiceCategory>> {
        return this.api.createOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.serviceCategory,  options).toPromise();
    }

    /**
     * Create a single ServiceCategory
     * @param param the request object
     */
    public createOneBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiCreateOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<ServiceCategory> {
        return this.api.createOneBaseServiceCategoryAdminControllerServiceCategory(param.serviceCategory,  options).toPromise();
    }

    /**
     * Delete a single ServiceCategory
     * @param param the request object
     */
    public deleteOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiDeleteOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single ServiceCategory
     * @param param the request object
     */
    public deleteOneBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiDeleteOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseServiceCategoryAdminControllerServiceCategory(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple ServiceCategories
     * @param param the request object
     */
    public getManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiGetManyBaseServiceCategoryAdminControllerServiceCategoryRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseServiceCategoryAdminControllerServiceCategory200Response>> {
        return this.api.getManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple ServiceCategories
     * @param param the request object
     */
    public getManyBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiGetManyBaseServiceCategoryAdminControllerServiceCategoryRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseServiceCategoryAdminControllerServiceCategory200Response> {
        return this.api.getManyBaseServiceCategoryAdminControllerServiceCategory(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ServiceCategory
     * @param param the request object
     */
    public getOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiGetOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ServiceCategory>> {
        return this.api.getOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single ServiceCategory
     * @param param the request object
     */
    public getOneBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiGetOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<ServiceCategory> {
        return this.api.getOneBaseServiceCategoryAdminControllerServiceCategory(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single ServiceCategory
     * @param param the request object
     */
    public replaceOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiReplaceOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ServiceCategory>> {
        return this.api.replaceOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.id, param.serviceCategory,  options).toPromise();
    }

    /**
     * Replace a single ServiceCategory
     * @param param the request object
     */
    public replaceOneBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiReplaceOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<ServiceCategory> {
        return this.api.replaceOneBaseServiceCategoryAdminControllerServiceCategory(param.id, param.serviceCategory,  options).toPromise();
    }

    /**
     * Update a single ServiceCategory
     * @param param the request object
     */
    public updateOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param: ServiceCategoryAdminApiUpdateOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<HttpInfo<ServiceCategory>> {
        return this.api.updateOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(param.id, param.serviceCategory,  options).toPromise();
    }

    /**
     * Update a single ServiceCategory
     * @param param the request object
     */
    public updateOneBaseServiceCategoryAdminControllerServiceCategory(param: ServiceCategoryAdminApiUpdateOneBaseServiceCategoryAdminControllerServiceCategoryRequest, options?: ConfigurationOptions): Promise<ServiceCategory> {
        return this.api.updateOneBaseServiceCategoryAdminControllerServiceCategory(param.id, param.serviceCategory,  options).toPromise();
    }

}

import { ObservableSkillApi } from "./ObservableAPI";
import { SkillApiRequestFactory, SkillApiResponseProcessor} from "../apis/SkillApi";

export interface SkillApiCreateOneBaseSkillControllerSkillRequest {
    /**
     * 
     * @type any
     * @memberof SkillApicreateOneBaseSkillControllerSkill
     */
    body: any
}

export interface SkillApiGetManyBaseSkillControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    categories: Array<string>
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetManyBaseSkillControllerSkill
     */
    cache?: number
}

export interface SkillApiGetOneBaseSkillControllerSkillRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetOneBaseSkillControllerSkill
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetOneBaseSkillControllerSkill
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SkillApigetOneBaseSkillControllerSkill
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof SkillApigetOneBaseSkillControllerSkill
     */
    cache?: number
}

export class ObjectSkillApi {
    private api: ObservableSkillApi

    public constructor(configuration: Configuration, requestFactory?: SkillApiRequestFactory, responseProcessor?: SkillApiResponseProcessor) {
        this.api = new ObservableSkillApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single Skill
     * @param param the request object
     */
    public createOneBaseSkillControllerSkillWithHttpInfo(param: SkillApiCreateOneBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseSkillControllerSkillWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single Skill
     * @param param the request object
     */
    public createOneBaseSkillControllerSkill(param: SkillApiCreateOneBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseSkillControllerSkill(param.body,  options).toPromise();
    }

    /**
     * Retrieve multiple Skills
     * @param param the request object
     */
    public getManyBaseSkillControllerSkillWithHttpInfo(param: SkillApiGetManyBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseSkillControllerSkillWithHttpInfo(param.categories, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Skills
     * @param param the request object
     */
    public getManyBaseSkillControllerSkill(param: SkillApiGetManyBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseSkillControllerSkill(param.categories, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Skill
     * @param param the request object
     */
    public getOneBaseSkillControllerSkillWithHttpInfo(param: SkillApiGetOneBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseSkillControllerSkillWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Skill
     * @param param the request object
     */
    public getOneBaseSkillControllerSkill(param: SkillApiGetOneBaseSkillControllerSkillRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseSkillControllerSkill(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableSourceApi } from "./ObservableAPI";
import { SourceApiRequestFactory, SourceApiResponseProcessor} from "../apis/SourceApi";

export interface SourceApiGetManyBaseSourceControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    search: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetManyBaseSourceControllerSource
     */
    cache?: number
}

export interface SourceApiGetOneBaseSourceControllerSourceRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetOneBaseSourceControllerSource
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetOneBaseSourceControllerSource
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof SourceApigetOneBaseSourceControllerSource
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof SourceApigetOneBaseSourceControllerSource
     */
    cache?: number
}

export class ObjectSourceApi {
    private api: ObservableSourceApi

    public constructor(configuration: Configuration, requestFactory?: SourceApiRequestFactory, responseProcessor?: SourceApiResponseProcessor) {
        this.api = new ObservableSourceApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple Sources
     * @param param the request object
     */
    public getManyBaseSourceControllerSourceWithHttpInfo(param: SourceApiGetManyBaseSourceControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseSourceControllerSourceWithHttpInfo(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Sources
     * @param param the request object
     */
    public getManyBaseSourceControllerSource(param: SourceApiGetManyBaseSourceControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseSourceControllerSource(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Source
     * @param param the request object
     */
    public getOneBaseSourceControllerSourceWithHttpInfo(param: SourceApiGetOneBaseSourceControllerSourceRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseSourceControllerSourceWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Source
     * @param param the request object
     */
    public getOneBaseSourceControllerSource(param: SourceApiGetOneBaseSourceControllerSourceRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseSourceControllerSource(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}

import { ObservableStoryApi } from "./ObservableAPI";
import { StoryApiRequestFactory, StoryApiResponseProcessor} from "../apis/StoryApi";

export interface StoryApiFindById0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryApifindById0
     */
    id: number
}

export interface StoryApiListByProfile0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryApilistByProfile0
     */
    limit: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryApilistByProfile0
     */
    page: number
}

export class ObjectStoryApi {
    private api: ObservableStoryApi

    public constructor(configuration: Configuration, requestFactory?: StoryApiRequestFactory, responseProcessor?: StoryApiResponseProcessor) {
        this.api = new ObservableStoryApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public findById0WithHttpInfo(param: StoryApiFindById0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findById0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public findById0(param: StoryApiFindById0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findById0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0WithHttpInfo(param: StoryApiListByProfile0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.listByProfile0WithHttpInfo(param.limit, param.page,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public listByProfile0(param: StoryApiListByProfile0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.listByProfile0(param.limit, param.page,  options).toPromise();
    }

}

import { ObservableStoryBlockAdminApi } from "./ObservableAPI";
import { StoryBlockAdminApiRequestFactory, StoryBlockAdminApiResponseProcessor} from "../apis/StoryBlockAdminApi";

export interface StoryBlockAdminApiCreateOneBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * 
     * @type any
     * @memberof StoryBlockAdminApicreateOneBaseStoryBlockAdminControllerStoryBlock
     */
    body: any
}

export interface StoryBlockAdminApiDeleteOneBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApideleteOneBaseStoryBlockAdminControllerStoryBlock
     */
    id: number
}

export interface StoryBlockAdminApiGetManyBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetManyBaseStoryBlockAdminControllerStoryBlock
     */
    cache?: number
}

export interface StoryBlockAdminApiGetOneBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetOneBaseStoryBlockAdminControllerStoryBlock
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetOneBaseStoryBlockAdminControllerStoryBlock
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof StoryBlockAdminApigetOneBaseStoryBlockAdminControllerStoryBlock
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApigetOneBaseStoryBlockAdminControllerStoryBlock
     */
    cache?: number
}

export interface StoryBlockAdminApiReplaceOneBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApireplaceOneBaseStoryBlockAdminControllerStoryBlock
     */
    id: number
    /**
     * 
     * @type any
     * @memberof StoryBlockAdminApireplaceOneBaseStoryBlockAdminControllerStoryBlock
     */
    body: any
}

export interface StoryBlockAdminApiUpdateOneBaseStoryBlockAdminControllerStoryBlockRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof StoryBlockAdminApiupdateOneBaseStoryBlockAdminControllerStoryBlock
     */
    id: number
    /**
     * 
     * @type any
     * @memberof StoryBlockAdminApiupdateOneBaseStoryBlockAdminControllerStoryBlock
     */
    body: any
}

export class ObjectStoryBlockAdminApi {
    private api: ObservableStoryBlockAdminApi

    public constructor(configuration: Configuration, requestFactory?: StoryBlockAdminApiRequestFactory, responseProcessor?: StoryBlockAdminApiResponseProcessor) {
        this.api = new ObservableStoryBlockAdminApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Create a single StoryBlock
     * @param param the request object
     */
    public createOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiCreateOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.body,  options).toPromise();
    }

    /**
     * Create a single StoryBlock
     * @param param the request object
     */
    public createOneBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiCreateOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOneBaseStoryBlockAdminControllerStoryBlock(param.body,  options).toPromise();
    }

    /**
     * Delete a single StoryBlock
     * @param param the request object
     */
    public deleteOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiDeleteOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.deleteOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a single StoryBlock
     * @param param the request object
     */
    public deleteOneBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiDeleteOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<void> {
        return this.api.deleteOneBaseStoryBlockAdminControllerStoryBlock(param.id,  options).toPromise();
    }

    /**
     * Retrieve multiple StoryBlocks
     * @param param the request object
     */
    public getManyBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiGetManyBaseStoryBlockAdminControllerStoryBlockRequest = {}, options?: ConfigurationOptions): Promise<HttpInfo<GetManyBaseStoryBlockAdminControllerStoryBlock200Response>> {
        return this.api.getManyBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple StoryBlocks
     * @param param the request object
     */
    public getManyBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiGetManyBaseStoryBlockAdminControllerStoryBlockRequest = {}, options?: ConfigurationOptions): Promise<GetManyBaseStoryBlockAdminControllerStoryBlock200Response> {
        return this.api.getManyBaseStoryBlockAdminControllerStoryBlock(param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single StoryBlock
     * @param param the request object
     */
    public getOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiGetOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single StoryBlock
     * @param param the request object
     */
    public getOneBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiGetOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseStoryBlockAdminControllerStoryBlock(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Replace a single StoryBlock
     * @param param the request object
     */
    public replaceOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiReplaceOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.replaceOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Replace a single StoryBlock
     * @param param the request object
     */
    public replaceOneBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiReplaceOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.replaceOneBaseStoryBlockAdminControllerStoryBlock(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single StoryBlock
     * @param param the request object
     */
    public updateOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param: StoryBlockAdminApiUpdateOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.updateOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(param.id, param.body,  options).toPromise();
    }

    /**
     * Update a single StoryBlock
     * @param param the request object
     */
    public updateOneBaseStoryBlockAdminControllerStoryBlock(param: StoryBlockAdminApiUpdateOneBaseStoryBlockAdminControllerStoryBlockRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.updateOneBaseStoryBlockAdminControllerStoryBlock(param.id, param.body,  options).toPromise();
    }

}

import { ObservableTransactionGetTotalAmountApi } from "./ObservableAPI";
import { TransactionGetTotalAmountApiRequestFactory, TransactionGetTotalAmountApiResponseProcessor} from "../apis/TransactionGetTotalAmountApi";

export interface TransactionGetTotalAmountApiGetTransactionGetTotalAmount0Request {
    /**
     * 
     * @type GetTransactionTotalAmountRequestDto
     * @memberof TransactionGetTotalAmountApigetTransactionGetTotalAmount0
     */
    getTransactionTotalAmountRequestDto: GetTransactionTotalAmountRequestDto
}

export class ObjectTransactionGetTotalAmountApi {
    private api: ObservableTransactionGetTotalAmountApi

    public constructor(configuration: Configuration, requestFactory?: TransactionGetTotalAmountApiRequestFactory, responseProcessor?: TransactionGetTotalAmountApiResponseProcessor) {
        this.api = new ObservableTransactionGetTotalAmountApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public getTransactionGetTotalAmount0WithHttpInfo(param: TransactionGetTotalAmountApiGetTransactionGetTotalAmount0Request, options?: ConfigurationOptions): Promise<HttpInfo<GetTransactionTotalAmountResponseDto>> {
        return this.api.getTransactionGetTotalAmount0WithHttpInfo(param.getTransactionTotalAmountRequestDto,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public getTransactionGetTotalAmount0(param: TransactionGetTotalAmountApiGetTransactionGetTotalAmount0Request, options?: ConfigurationOptions): Promise<GetTransactionTotalAmountResponseDto> {
        return this.api.getTransactionGetTotalAmount0(param.getTransactionTotalAmountRequestDto,  options).toPromise();
    }

}

import { ObservableUtilsProfileApi } from "./ObservableAPI";
import { UtilsProfileApiRequestFactory, UtilsProfileApiResponseProcessor} from "../apis/UtilsProfileApi";

export interface UtilsProfileApiGet0Request {
    /**
     * Profile email.
     * Defaults to: undefined
     * @type string
     * @memberof UtilsProfileApiget0
     */
    email: string
}

export class ObjectUtilsProfileApi {
    private api: ObservableUtilsProfileApi

    public constructor(configuration: Configuration, requestFactory?: UtilsProfileApiRequestFactory, responseProcessor?: UtilsProfileApiResponseProcessor) {
        this.api = new ObservableUtilsProfileApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * @param param the request object
     */
    public get0WithHttpInfo(param: UtilsProfileApiGet0Request, options?: ConfigurationOptions): Promise<HttpInfo<UtilsProfileCompletedDTO>> {
        return this.api.get0WithHttpInfo(param.email,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public get0(param: UtilsProfileApiGet0Request, options?: ConfigurationOptions): Promise<UtilsProfileCompletedDTO> {
        return this.api.get0(param.email,  options).toPromise();
    }

}

import { ObservableVacancyApi } from "./ObservableAPI";
import { VacancyApiRequestFactory, VacancyApiResponseProcessor} from "../apis/VacancyApi";

export interface VacancyApiAddToBlacklist0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiaddToBlacklist0
     */
    id: number
}

export interface VacancyApiAddToSaved0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiaddToSaved0
     */
    id: number
}

export interface VacancyApiCreateOne0Request {
    /**
     * 
     * @type VacancyBodyDTO
     * @memberof VacancyApicreateOne0
     */
    vacancyBodyDTO: VacancyBodyDTO
}

export interface VacancyApiDelete0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApidelete0
     */
    id: number
}

export interface VacancyApiFindAll0Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    ids?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    sort?: string
    /**
     * 
     * Defaults to: undefined
     * @type any
     * @memberof VacancyApifindAll0
     */
    savedByCurrentProfile?: any
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    categories?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    skills?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    verticals?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    geos?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    sources?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    countries?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;number&gt;
     * @memberof VacancyApifindAll0
     */
    cities?: Array<number>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    search?: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    searchCompany?: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    exclude?: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    currency?: string
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;fullTime&#39; | &#39;partTime&#39; | &#39;project&#39;&gt;
     * @memberof VacancyApifindAll0
     */
    employment?: Array<'fullTime' | 'partTime' | 'project'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;fullDay&#39; | &#39;flexible&#39; | &#39;remote&#39;&gt;
     * @memberof VacancyApifindAll0
     */
    schedule?: Array<'fullDay' | 'flexible' | 'remote'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;noExperience&#39; | &#39;from1to3&#39; | &#39;from3to6&#39; | &#39;from6&#39;&gt;
     * @memberof VacancyApifindAll0
     */
    experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;salary&#39; | &#39;commission&#39; | &#39;gybrid&#39; | &#39;piecework&#39; | &#39;contract&#39;&gt;
     * @memberof VacancyApifindAll0
     */
    compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    gybridCurrency?: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApifindAll0
     */
    pieceworkCurrency?: string
    /**
     * 
     * Defaults to: undefined
     * @type any
     * @memberof VacancyApifindAll0
     */
    searchIn?: any
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    salaryMin?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    salaryMax?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    pieceworkSalaryMin?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    pieceworkSalaryMax?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    commissionMin?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    commissionMax?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    gybridSalaryMin?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    gybridSalaryMax?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    gybridCommissionMin?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    gybridCommissionMax?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    forLastNumberOfDays?: number
    /**
     * 
     * Defaults to: undefined
     * @type boolean
     * @memberof VacancyApifindAll0
     */
    isRemote?: boolean
    /**
     * 
     * Defaults to: undefined
     * @type any
     * @memberof VacancyApifindAll0
     */
    s?: any
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    limit?: number
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindAll0
     */
    page?: number
    /**
     * 
     * Defaults to: undefined
     * @type VacancyQueryManyDTO
     * @memberof VacancyApifindAll0
     */
    query?: VacancyQueryManyDTO
}

export interface VacancyApiFindAllByCurrentProfile0Request {
}

export interface VacancyApiFindOne0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApifindOne0
     */
    id: number
}

export interface VacancyApiGetFromSaved0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApigetFromSaved0
     */
    id: number
}

export interface VacancyApiGetViews0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApigetViews0
     */
    id: number
    /**
     * 
     * Defaults to: undefined
     * @type any
     * @memberof VacancyApigetViews0
     */
    data?: any
}

export interface VacancyApiPublish0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApipublish0
     */
    id: number
    /**
     * Product id
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApipublish0
     */
    productId: number
    /**
     * date auto publication
     * Defaults to: undefined
     * @type Date
     * @memberof VacancyApipublish0
     */
    schedulePublishAt?: Date
}

export interface VacancyApiRemoveFromBlacklist0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiremoveFromBlacklist0
     */
    id: number
}

export interface VacancyApiRemoveFromSaved0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiremoveFromSaved0
     */
    id: number
}

export interface VacancyApiRemovePublish0Request {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiremovePublish0
     */
    id: number
}

export interface VacancyApiSalaryStats0Request {
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VacancyApisalaryStats0
     */
    categories?: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VacancyApisalaryStats0
     */
    skills?: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VacancyApisalaryStats0
     */
    countries?: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VacancyApisalaryStats0
     */
    cities?: Array<string>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;fullTime&#39; | &#39;partTime&#39; | &#39;project&#39;&gt;
     * @memberof VacancyApisalaryStats0
     */
    employment?: Array<'fullTime' | 'partTime' | 'project'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;fullDay&#39; | &#39;flexible&#39; | &#39;remote&#39;&gt;
     * @memberof VacancyApisalaryStats0
     */
    schedule?: Array<'fullDay' | 'flexible' | 'remote'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;salary&#39; | &#39;commission&#39; | &#39;gybrid&#39; | &#39;piecework&#39; | &#39;contract&#39;&gt;
     * @memberof VacancyApisalaryStats0
     */
    compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>
    /**
     * 
     * Defaults to: undefined
     * @type Array&lt;&#39;noExperience&#39; | &#39;from1to3&#39; | &#39;from3to6&#39; | &#39;from6&#39;&gt;
     * @memberof VacancyApisalaryStats0
     */
    experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApisalaryStats0
     */
    search?: string
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApisalaryStats0
     */
    currency?: string
    /**
     * 
     * Defaults to: undefined
     * @type boolean
     * @memberof VacancyApisalaryStats0
     */
    isRemote?: boolean
    /**
     * 
     * Defaults to: undefined
     * @type any
     * @memberof VacancyApisalaryStats0
     */
    s?: any
    /**
     * 
     * Defaults to: undefined
     * @type VacancyQueryStatsDTO
     * @memberof VacancyApisalaryStats0
     */
    query?: VacancyQueryStatsDTO
}

export interface VacancyApiStatsByCurrentProfile0Request {
}

export interface VacancyApiSuggest0Request {
    /**
     * Search query
     * Defaults to: undefined
     * @type string
     * @memberof VacancyApisuggest0
     */
    search: string
}

export interface VacancyApiUpdate0Request {
    /**
     * Vacancy ID
     * Defaults to: undefined
     * @type number
     * @memberof VacancyApiupdate0
     */
    id: number
    /**
     * 
     * @type VacancyBodyDTO
     * @memberof VacancyApiupdate0
     */
    vacancyBodyDTO: VacancyBodyDTO
}

export class ObjectVacancyApi {
    private api: ObservableVacancyApi

    public constructor(configuration: Configuration, requestFactory?: VacancyApiRequestFactory, responseProcessor?: VacancyApiResponseProcessor) {
        this.api = new ObservableVacancyApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Add a vacancy to blacklist
     * @param param the request object
     */
    public addToBlacklist0WithHttpInfo(param: VacancyApiAddToBlacklist0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToBlacklist0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Add a vacancy to blacklist
     * @param param the request object
     */
    public addToBlacklist0(param: VacancyApiAddToBlacklist0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToBlacklist0(param.id,  options).toPromise();
    }

    /**
     * Save a vacancy
     * @param param the request object
     */
    public addToSaved0WithHttpInfo(param: VacancyApiAddToSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.addToSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Save a vacancy
     * @param param the request object
     */
    public addToSaved0(param: VacancyApiAddToSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.addToSaved0(param.id,  options).toPromise();
    }

    /**
     * Create a new vacancy
     * @param param the request object
     */
    public createOne0WithHttpInfo(param: VacancyApiCreateOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.createOne0WithHttpInfo(param.vacancyBodyDTO,  options).toPromise();
    }

    /**
     * Create a new vacancy
     * @param param the request object
     */
    public createOne0(param: VacancyApiCreateOne0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.createOne0(param.vacancyBodyDTO,  options).toPromise();
    }

    /**
     * Delete a vacancy
     * @param param the request object
     */
    public delete0WithHttpInfo(param: VacancyApiDelete0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.delete0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Delete a vacancy
     * @param param the request object
     */
    public delete0(param: VacancyApiDelete0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.delete0(param.id,  options).toPromise();
    }

    /**
     * Get all vacancies
     * @param param the request object
     */
    public findAll0WithHttpInfo(param: VacancyApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<VacancyPaginationDTO>> {
        return this.api.findAll0WithHttpInfo(param.ids, param.sort, param.savedByCurrentProfile, param.categories, param.skills, param.verticals, param.geos, param.sources, param.countries, param.cities, param.search, param.searchCompany, param.exclude, param.currency, param.employment, param.schedule, param.experience, param.compensation, param.gybridCurrency, param.pieceworkCurrency, param.searchIn, param.salaryMin, param.salaryMax, param.pieceworkSalaryMin, param.pieceworkSalaryMax, param.commissionMin, param.commissionMax, param.gybridSalaryMin, param.gybridSalaryMax, param.gybridCommissionMin, param.gybridCommissionMax, param.forLastNumberOfDays, param.isRemote, param.s, param.limit, param.page, param.query,  options).toPromise();
    }

    /**
     * Get all vacancies
     * @param param the request object
     */
    public findAll0(param: VacancyApiFindAll0Request = {}, options?: ConfigurationOptions): Promise<VacancyPaginationDTO> {
        return this.api.findAll0(param.ids, param.sort, param.savedByCurrentProfile, param.categories, param.skills, param.verticals, param.geos, param.sources, param.countries, param.cities, param.search, param.searchCompany, param.exclude, param.currency, param.employment, param.schedule, param.experience, param.compensation, param.gybridCurrency, param.pieceworkCurrency, param.searchIn, param.salaryMin, param.salaryMax, param.pieceworkSalaryMin, param.pieceworkSalaryMax, param.commissionMin, param.commissionMax, param.gybridSalaryMin, param.gybridSalaryMax, param.gybridCommissionMin, param.gybridCommissionMax, param.forLastNumberOfDays, param.isRemote, param.s, param.limit, param.page, param.query,  options).toPromise();
    }

    /**
     * Get vacancies for current user
     * @param param the request object
     */
    public findAllByCurrentProfile0WithHttpInfo(param: VacancyApiFindAllByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.findAllByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * Get vacancies for current user
     * @param param the request object
     */
    public findAllByCurrentProfile0(param: VacancyApiFindAllByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.findAllByCurrentProfile0( options).toPromise();
    }

    /**
     * Get a vacancy by ID
     * @param param the request object
     */
    public findOne0WithHttpInfo(param: VacancyApiFindOne0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.findOne0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Get a vacancy by ID
     * @param param the request object
     */
    public findOne0(param: VacancyApiFindOne0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.findOne0(param.id,  options).toPromise();
    }

    /**
     * Remove a vacancy from saved
     * @param param the request object
     */
    public getFromSaved0WithHttpInfo(param: VacancyApiGetFromSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.getFromSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Remove a vacancy from saved
     * @param param the request object
     */
    public getFromSaved0(param: VacancyApiGetFromSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.getFromSaved0(param.id,  options).toPromise();
    }

    /**
     * Get views for a vacancy
     * @param param the request object
     */
    public getViews0WithHttpInfo(param: VacancyApiGetViews0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.getViews0WithHttpInfo(param.id, param.data,  options).toPromise();
    }

    /**
     * Get views for a vacancy
     * @param param the request object
     */
    public getViews0(param: VacancyApiGetViews0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.getViews0(param.id, param.data,  options).toPromise();
    }

    /**
     * Publish a vacancy
     * @param param the request object
     */
    public publish0WithHttpInfo(param: VacancyApiPublish0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.publish0WithHttpInfo(param.id, param.productId, param.schedulePublishAt,  options).toPromise();
    }

    /**
     * Publish a vacancy
     * @param param the request object
     */
    public publish0(param: VacancyApiPublish0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.publish0(param.id, param.productId, param.schedulePublishAt,  options).toPromise();
    }

    /**
     * Remove a vacancy from blacklist
     * @param param the request object
     */
    public removeFromBlacklist0WithHttpInfo(param: VacancyApiRemoveFromBlacklist0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromBlacklist0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Remove a vacancy from blacklist
     * @param param the request object
     */
    public removeFromBlacklist0(param: VacancyApiRemoveFromBlacklist0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromBlacklist0(param.id,  options).toPromise();
    }

    /**
     * Remove a vacancy from saved
     * @param param the request object
     */
    public removeFromSaved0WithHttpInfo(param: VacancyApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removeFromSaved0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * Remove a vacancy from saved
     * @param param the request object
     */
    public removeFromSaved0(param: VacancyApiRemoveFromSaved0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removeFromSaved0(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removePublish0WithHttpInfo(param: VacancyApiRemovePublish0Request, options?: ConfigurationOptions): Promise<HttpInfo<void>> {
        return this.api.removePublish0WithHttpInfo(param.id,  options).toPromise();
    }

    /**
     * @param param the request object
     */
    public removePublish0(param: VacancyApiRemovePublish0Request, options?: ConfigurationOptions): Promise<void> {
        return this.api.removePublish0(param.id,  options).toPromise();
    }

    /**
     * Get salary statistics
     * @param param the request object
     */
    public salaryStats0WithHttpInfo(param: VacancyApiSalaryStats0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.salaryStats0WithHttpInfo(param.categories, param.skills, param.countries, param.cities, param.employment, param.schedule, param.compensation, param.experience, param.search, param.currency, param.isRemote, param.s, param.query,  options).toPromise();
    }

    /**
     * Get salary statistics
     * @param param the request object
     */
    public salaryStats0(param: VacancyApiSalaryStats0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.salaryStats0(param.categories, param.skills, param.countries, param.cities, param.employment, param.schedule, param.compensation, param.experience, param.search, param.currency, param.isRemote, param.s, param.query,  options).toPromise();
    }

    /**
     * Get stats for current user
     * @param param the request object
     */
    public statsByCurrentProfile0WithHttpInfo(param: VacancyApiStatsByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<HttpInfo<Array<any>>> {
        return this.api.statsByCurrentProfile0WithHttpInfo( options).toPromise();
    }

    /**
     * Get stats for current user
     * @param param the request object
     */
    public statsByCurrentProfile0(param: VacancyApiStatsByCurrentProfile0Request = {}, options?: ConfigurationOptions): Promise<Array<any>> {
        return this.api.statsByCurrentProfile0( options).toPromise();
    }

    /**
     * Get vacancy suggestions
     * @param param the request object
     */
    public suggest0WithHttpInfo(param: VacancyApiSuggest0Request, options?: ConfigurationOptions): Promise<HttpInfo<VacancyPaginationDTO>> {
        return this.api.suggest0WithHttpInfo(param.search,  options).toPromise();
    }

    /**
     * Get vacancy suggestions
     * @param param the request object
     */
    public suggest0(param: VacancyApiSuggest0Request, options?: ConfigurationOptions): Promise<VacancyPaginationDTO> {
        return this.api.suggest0(param.search,  options).toPromise();
    }

    /**
     * Update a vacancy
     * @param param the request object
     */
    public update0WithHttpInfo(param: VacancyApiUpdate0Request, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.update0WithHttpInfo(param.id, param.vacancyBodyDTO,  options).toPromise();
    }

    /**
     * Update a vacancy
     * @param param the request object
     */
    public update0(param: VacancyApiUpdate0Request, options?: ConfigurationOptions): Promise<any> {
        return this.api.update0(param.id, param.vacancyBodyDTO,  options).toPromise();
    }

}

import { ObservableVerticalApi } from "./ObservableAPI";
import { VerticalApiRequestFactory, VerticalApiResponseProcessor} from "../apis/VerticalApi";

export interface VerticalApiGetManyBaseVerticalControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type string
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    search: string
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    fields?: Array<string>
    /**
     * Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type string
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    s?: string
    /**
     * Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    filter?: Array<string>
    /**
     * Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    or?: Array<string>
    /**
     * Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    sort?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    join?: Array<string>
    /**
     * Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    limit?: number
    /**
     * Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    offset?: number
    /**
     * Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    page?: number
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetManyBaseVerticalControllerVertical
     */
    cache?: number
}

export interface VerticalApiGetOneBaseVerticalControllerVerticalRequest {
    /**
     * 
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetOneBaseVerticalControllerVertical
     */
    id: number
    /**
     * Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetOneBaseVerticalControllerVertical
     */
    fields?: Array<string>
    /**
     * Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Defaults to: undefined
     * @type Array&lt;string&gt;
     * @memberof VerticalApigetOneBaseVerticalControllerVertical
     */
    join?: Array<string>
    /**
     * Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * Minimum: 0
     * Maximum: 1
     * Defaults to: undefined
     * @type number
     * @memberof VerticalApigetOneBaseVerticalControllerVertical
     */
    cache?: number
}

export class ObjectVerticalApi {
    private api: ObservableVerticalApi

    public constructor(configuration: Configuration, requestFactory?: VerticalApiRequestFactory, responseProcessor?: VerticalApiResponseProcessor) {
        this.api = new ObservableVerticalApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * Retrieve multiple Verticals
     * @param param the request object
     */
    public getManyBaseVerticalControllerVerticalWithHttpInfo(param: VerticalApiGetManyBaseVerticalControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getManyBaseVerticalControllerVerticalWithHttpInfo(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve multiple Verticals
     * @param param the request object
     */
    public getManyBaseVerticalControllerVertical(param: VerticalApiGetManyBaseVerticalControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getManyBaseVerticalControllerVertical(param.search, param.fields, param.s, param.filter, param.or, param.sort, param.join, param.limit, param.offset, param.page, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vertical
     * @param param the request object
     */
    public getOneBaseVerticalControllerVerticalWithHttpInfo(param: VerticalApiGetOneBaseVerticalControllerVerticalRequest, options?: ConfigurationOptions): Promise<HttpInfo<any>> {
        return this.api.getOneBaseVerticalControllerVerticalWithHttpInfo(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

    /**
     * Retrieve a single Vertical
     * @param param the request object
     */
    public getOneBaseVerticalControllerVertical(param: VerticalApiGetOneBaseVerticalControllerVerticalRequest, options?: ConfigurationOptions): Promise<any> {
        return this.api.getOneBaseVerticalControllerVertical(param.id, param.fields, param.join, param.cache,  options).toPromise();
    }

}
